import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from "../../config";
import { development, SERVICE_RESPONSE, RFC_FORMAT, FINISH_THE_RACE, F1_GRILL, ImageVoucherMIT_dev, ImageVoucherMIT_prod, Datos_Empresa, points_Card, ToolTips, TypeDiscounts, cascoItem, Modules, json, Sections, TipoAlmacen, GlobalTaxes, sellTypeSelect, Granel, Envasados, priceDecimalPrecision, Anticipo, needTransferReference } from "../../libs/utils/Const";
import {
    TimeOut,
    NavBarCashier,
    DetailsItemSale,
    BillModal,
    RefundModal,
    DeliverModal,
    WithdrawalModal,
    InventoryModal,
    SalesModal,
    CashCutModal,
    SavedSalesModal,
    SearchModal,
    ClientsModal,
    InitialCashModal,
    TaxesModal,
    SelectAddressModal,
    ValidationModal,
    InvoiceDataModal,
    FormatQuotationModal,
    FormatOrderSaleModal,
    FormatInvoiceModal,
    RefSaleModal,
    AuthorizationModel,
    PdfViewer,
    SearchStockModal,
    GrossProfitModal,
    FormatDeliveryModal,
    DetailClientModal,
    FormatCanceledTicketModal,
    FormatAdvancePaymentModal,
    CommentsModal,
    BatchSelectionModal,
    AdvancePaymentInvoicesModal,
    RefundTicketModal,
    PaymentStatusListModal,
    CancelCFDI,
    PaymentModal,
    PriceWithTaxesModal,
    NewUpdateModal,
    ValidateDocFieldsModal,
    TerminalFunctions,
    NewCustomerModal,
    AreYouAgreeModal,
    ToolTip,
    WarningModal,
    SetDocsToDelivery,
    CentroCosteModal,
    NavBarCashierResponsive,
    PrinterConfigurationModal,
    ProjectsModal,
} from "../../components";
import { NewOrder, NewItemPayment, PointsCardModel, OxxoReferenceModel, UserFields } from "../../components/NewOrder";
import { DISPATCH_ID, _ROUND, GROSSPROFIT, CURRENCY, FORMAT_NUMBER, SYMBOL, FULLNAME_FORMAT, ZIPCODE, STREET_FORMAT, BLOCK_FORMAT, CITY_FORMAT } from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import printerService from "../../libs/printer/PrinterService";
import "../../css/dashboard.css";
import "./PointOfSaleView.css";
import "../../css/responsive.css";
import {
    BusinessPartnerPS,
    NewItem,
    NewOrderSales,
    Addresses,
    PrintDocument,
    InfoByFolio,
    ResponseHeader,
    BillAddress,
    ShipAddress,
    ItemLine,
    PayMethodCounter,
    DocComments,
    DownPaymentToDraw,
    DocToPDFViewer,
    CashMovement,
    PaymentCardsInfo
} from "../../components/NewOrder";
import $ from "jquery";
import moment from "moment";
import { GeneralFunctions } from "../../components/index";
import packageJson from '../../../package.json';
import socketService from '../../libs/sockets/SocketService';
import FieldsForPS from '../../components/FieldsForPS';
import SeriesAndConsecutiveModal from '../../components/SeriesAndConsecutiveModal';
import CO1UserFieldsModal from '../../components/CO1UserFieldsModal';
import MultipleValidationModal from '../../components/MultipleValidationModal';
import { isAnticipo, roundToDecimals } from '../../libs/utils/GlobalFunc';
import CalculatorModal from '../../components/CalculatorModal';

global.appVersion = packageJson.version;
const currentVersion = global.appVersion;
const _generalFunctions = new GeneralFunctions();
const apiClient = ApiClient.getInstance();
const EMAIL_FORMAT_REGEX = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
const globalTax = false;

class PointOfSaleView extends Component {

    constructor(props) {
        super(props);
        this.hasTicketInCurrentSession = false;
        this.state = {
            PaymentModel: {},
            newOrderModel: new NewOrderSales(),
            itemSearch: "",
            objType: "",
            suggestions: [],
            suggestionsCopy: [],
            itemIndexSuggestion: null,
            itemSelected: {},
            itemIndex: 0,

            partnerSearch: "",
            businessPartner: new BusinessPartnerPS(),
            businessPartners: [],
            partnerIndex: 0,

            groupNumList: [],
            priceList: [],
            groupCodeList: [],

            states: [],
            countries: [],
            showBillModal: false,
            showRefundModal: false,
            showWithdrawalModal: false,
            showInventoryModal: false,
            showSalesModal: false,
            showCashCutModal: false,
            showSavedSalesModal: false,
            showSearchModal: false,
            showTicketModal: false,
            showRefSaleModal: false,
            showRefMoveCashModal: false,
            showClientsModal: false,
            showInitialCashModal: false,
            showTaxesModal: false,
            showSelectAddressModal: false,
            showFormatQuotationModal: false,
            showFormatOrderSaleModal: false,
            isCancel: false,
            showFormatInvoiceModal: false,
            showSearchStockModal: false,
            showBeforeExit: false,
            showVMQuotation: false,
            showDeleteAll: false,
            showCommentsModal: false,
            showBatchDefinitionModal: false,
            showAdvancePaymentInvoicesModal: false,
            showFormatAdvancePayment: false,
            ShowRefundOfPaymentsModal: false,
            showDeliverModal: false,
            printhide: true,
            enableMoneyMovements: false,

            idWorkShift: "",
            lastDaySession: false,
            cashCut: {},
            extraPaymentsCashCut: {},
            objCharge: {},
            totalCashCut: 0,
            TotalAmountSales: 0,
            numSalesCashCut: 0,
            moneyOuts: [],
            moneyEntries: [],

            initialDate: moment(new Date()).format("YYYY-MM-DD"),
            finalDate: moment(new Date()).format("YYYY-MM-DD"),
            viewReport: 1,

            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),

            responseReport: [],
            inventoryData: [],
            inventoryDataTotalRows: 0,
            movements: [],

            taxList: [],
            operationList: [],
            typeOperationList: [],
            igvOperationList: [],
            pedido: '',
            returnPay: false,
            ItsReturnBill: false,
            checkboxDataTables: (new Map()),
            CanChangePartner: false,
            ItsComingOfRebilling: false,

            ordersToAction: 0,
            ordersDocs: [],
            ordersSearchModel: {
                CardCode: '',
                DocNum: ''
            },
            docsToPrint: [],
            showPDFViewer: false,
            editableMode: false,
            detailDoc: {},
            EditableDocModel: {
                street: '',
                county: '',
                city: '',
                block: '',
                zipCode: '',
                rfc: '',
                shipStreet: '',
                shipCounty: '',
                shipCity: '',
                shipBlock: '',
                shipZipCode: ''
            },
            showSaveForLater: false,

            savedSales: [],
            savedSaleSearchCode: '',
            chooseSavedSale: '',
            disableRecover: false,
            disableRecoverQT: false,

            requireInvoice: false,
            typeDocPrint: '',
            EnableEditButton: false,

            editModePartner: false,
            updatebusinessPartner: new BusinessPartnerPS(),
            LinesGrossProfit: [],
            TotalGrossProfit: 0,
            TotPrctGrossProfit: 0,

            deliveryAddresses: [],
            billAddresses: [],
            pointer: 1,
            Action: 1,
            viewOption: 1,
            addressModel: new Addresses(),
            AuxAddressModel: new Addresses(),
            setDHIndex: 0,
            setDeliveryIndex: '',
            setBillIndex: '',

            stockByItem: [],
            //BRACH OFFICE INFO AND PERMISSIONS
            LimitLinesBO: null,
            CounterRol: null,
            AvailablePayments: [],
            creditNotesPay: false,
            creditPay: false,
            PaymentSaleModel: new PayMethodCounter(),
            BankAccounts: [],
            currencyRate: 0,
            EditDiscount: false,
            EditTaxCode: false,
            EditPrice: false,
            FlowDestiny: '',
            FlowOrigin: '',
            NextStepFunction: () => { },
            CacheIndexCardCode: 0,
            isUniversal: false,
            addingPay: true,
            addingMove: true,
            showrefund: false,
            newOrderModelCopia: [],
            DocCommentsModel: {},
            CommentLineIndex: 0,

            actionSale: '',

            showBatchSelectionModal: false,
            DownPayments: [],
            CreditNotes: [],
            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },

            ourInfoForReturn: null,
            infoCondiPagoReturn: {},
            returnFolioAmount: 0,
            extraDocsToShow: [],
            indexTypeDocShow: 0,
            ShowExtraActions: false,
            cashMovementModel: new CashMovement(),
            CFDI: [],
            RegimenFiscal: [],
            AuthorizationComments: [],
            isAuthorization: false,
            canCancelDocument: false,
            isValidCFDI: false,
            PaymentStatus: [],
            CancelFunction: null,
            ItsCreditInvoice: false,
            ItsReserveInvoice: false,
            reserveInvoiceFolio: '',
            createdFromReserve: false,
            showPaymentModal: false,
            showAreYouAgreeModal: false,
            showTemporalData: false,
            blindCashCut: true,
            TypeRecover: '',
            ReturnedBlindCut: [],
            itsShowedItemsTaxesModal: false,
            ShowWithStock: false,
            ContinueWithoutSave: () => { },
            ItsComingFromModifiedPartner: false,
            auxRecoverDocData: null,
            itsCancelCFDIAvailable: false,
            disableRecoverNM: false,
            taxes: [],
            recoverInterOpDoc: false,
            recoverInterOpEntry: '',
            recoverInterOpTypeDoc: '',
            itsInterOpDoc: false,
            ItsRecoverAuthoriInvoice: false,
            RecoverHouseDoc: false,
            recoverDocument: false,
            FailedRequestDocument: false,
            WasUpdatedPartner: false,
            ChoosePriceList: '-2',
            EnableGrossProfitModal: false,
            InitialGrossProfitPriceList: '',
            prioridadVtaCatalog: [],

            // Descuento máximo
            maxDiscount: 0,
            FlagPayWithSantander: false,
            PointsCardModel: new PointsCardModel(),
            showNewCustomerModal: false,
            showAreYouAgreeModal_Join_e_Wallet: false,
            ItemsGroupEWallet: -1,
            relatedDocs: [],
            SpecialPrices: {},
            ScheduleTime: {},
            recoveredQuote: false,
            recoveredQuoteOperation: null, // 1 actualizar, 2 duplicar
            showWarningModal: false,
            handedCasco: 1,
            OxxoRefData: new OxxoReferenceModel(),
            showDeliveryDocsModal: false,
            FISE: null,
            sellType: null,
            showCO1UserFieldsModal: false,
            configHeaderUserFields: [],
            CO1UserFields: [],
            wareHouseTransaction: null,
            centroCostes: [],
            centroCosteId: 0,
            itemOrderModelUpdate: null,
            sellTypeSelection: sellTypeSelect,
            itemProjectIndex: '',
            projects: [],
            showPriceModal: false,
            itemIndex: null,
            totalPriceInput: null,
            bankOptions: []
        };
    }

    //#region ######### component lifecycle methods ######################################
    componentDidMount = async () => {
        await this.GetScheduleSpecialPrice();
        await this.SetDefaultPartner();
        await this.SetBranchOfficeInfo();
        await this.CheckWorkSession();
        await this.GetCurrencies();
        await this.SetCounterPermissions();
        await this.GetDataPartner()
        await this.GetUseCFDI();
        await this.GetRegimenFiscal();
        await this.GetCountriesAndStates();
        await this.GetTaxes('deliveries');
        await this.GetPrioridadVenta();
        await this.GetItmGroupEWallet();
        await this.searchBanksOptions();
        await this.searchToleranceInfo();
        Sections['CO1UserFields'] && await this.setUserFields();
        this.DeterminatePayWithTerminalPermission();
        document.addEventListener("keydown", this.handleKeyDown);
        this._handelBack();
        this.SetMaxDiscount();
    };

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }
    SetWareHouseVta = (sellType) => {
        const { _user } = this.state
        const { notificationReducer: { showAlert } } = this.props
        const { sellTypeSelection } = this.state

        const tipoVentaText = sellTypeSelection?.find(vta => vta.value == sellType) ?? null
        if (tipoVentaText?.whsType || false) {
            const availableWhs = _user?.Branch?.AvailableWhs ?? [];
            const currWhsCode = availableWhs.find(whs => whs.TipoAlmacen === tipoVentaText?.whsType)
            if (currWhsCode) {
                this.setState({
                    wareHouseTransaction: currWhsCode
                })
            } else {
                return showAlert({ type: 'error', message: 'No tienes almacen asignado para la venta' + tipoVentaText?.tipoVta ?? '' });
            }
        } else {
            return showAlert({ type: 'error', message: 'No tienes almacen asignado para la venta' + tipoVentaText?.tipoVta ?? '' });
        }

    }
    SetSellType = (data) => {
        const { _user, sellTypeSelection } = this.state
        if ((data?.SellType ?? null) != null) {
            this.SetWareHouseVta(data?.SellType)
            this.setState({ sellType: data?.SellType })
        } else {
            const branchType = Number(_user?.Branch?.Type ?? -1);
            const allowedByBranch = {
                2: ['VPU', 'VPL'],           // PLANTA
                3: ['VPU', 'VPL', 'VPP'],    // MESTRA
            };
            const allowedSellTypes = allowedByBranch[branchType];
            if (allowedSellTypes) {
                for (let index = 0; index < sellTypeSelection.length; index++) {
                    const selection = sellTypeSelection[index];
                    if (allowedSellTypes.includes(selection.value)) {
                        selection.active = true
                        selection.onClickEvent = async () => this.selectSellType(selection.value)
                    }

                }
                this.setState({ sellTypeSelection });
                $("#sellTypeModal").modal("show");
            } else {
                this.selectSellType('VPP');
            }
        }

    }
    selectSellType = async (val) => {
        const { enableSpinner, } = this.props;
        const { idWorkShift } = this.state
        if (idWorkShift) {
            const data = {
                idWorkShift, sellType: val
            }
            enableSpinner(true);
            const responseApi = await apiClient.sellTypeSession(data);
            enableSpinner(false);
            if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
                this.SetWareHouseVta(val)
                this.setState({ sellType: val }, () => {
                    $("#sellTypeModal").modal("hide");
                })
            }
        }
    }

    GetScheduleSpecialPrice = async () => {
        const { enableSpinner } = this.props
        enableSpinner(true)
        const response = await apiClient.getScheduleSpecialPrice('S');
        enableSpinner(false)
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                ScheduleTime: response?.data ?? {}
            })
        }
    }

    GetPrioridadVenta = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        enableSpinner(true)
        const prioridadVentaResponse = await apiClient.getPrioridadVenta();
        enableSpinner(false)

        if (prioridadVentaResponse.status)
            this.setState({ prioridadVtaCatalog: prioridadVentaResponse?.data || [] })
        else
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar el grupo para monedero Electrónico' });
    }

    GetItmGroupEWallet = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        enableSpinner(true)
        const responseItmGrpWallet = await apiClient.getItmGrpEWallet();
        enableSpinner(false)
        if (responseItmGrpWallet.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                ItemsGroupEWallet: responseItmGrpWallet?.data ?? -1
            })
        } else {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar el grupo para monedero Electrónico' });
        }
    }

    searchBanksOptions = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let banksRes = await apiClient.getBanksOptions();
        enableSpinner(false);
        if (!banksRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: banksRes?.message || "Ocurrió un error al obtener el listado de bancos dispobiles para los depósitos" });
        } else {
            this.setState({
                bankOptions: banksRes?.data ?? []
            })
        }
    }

    searchToleranceInfo = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        let toleranceRes = await apiClient.getToleranceInfo();
        enableSpinner(false);
        if (!toleranceRes?.status) {
            showAlert({ type: 'warning', timeOut: 5000, message: toleranceRes?.message || "Ocurrió un error al obtener la información de tolerancias permitidas" });
        } else {
            this.setState({
                toleranceInfo: toleranceRes?.data ?? []
            })
        }
    }

    handleKeyDown = async (event) => {
        // PRECIOS DE ARTÍCULOS CON IVA Y SIN IVA
        if (event.altKey && event.key.toLowerCase() === "b" && !this.state.itsShowedItemsTaxesModal) {
            $("#priceWithTaxesModal").modal("show");
            this.setState({
                itsShowedItemsTaxesModal: true
            })
        }
        if (event.altKey && event.key.toLowerCase() === "b" && this.state.itsShowedItemsTaxesModal) {
            $("#priceWithTaxesModal").modal("hide");
            this.setState({
                itsShowedItemsTaxesModal: false
            })
        }
        // NO SE DE QUIEN SEA ESTE
        if (event.altKey && event.key.toLowerCase() === "l" && !this.state.showBatchSelectionModal) {
            this.ShowBatch();
        }
        if (event.altKey && event.key.toLowerCase() === "l" && this.state.showBatchSelectionModal) {
            $('#batchSelectionModal').modal('hide');
            this.setState({
                showBatchSelectionModal: false
            })
        }
        // SHOW HISTORY WORK SHIFT DOCS
        if (event.altKey && event.key.toLowerCase() === "c") {
            this.ShowWorkShiftHistory();
        }

        // if (event.shiftKey && event.altKey && ["Digit1", "Digit2", "Digit4", "Digit5"].includes(event.code)) {
        //     const id = event?.code?.slice(-1);
        //     this.showHistoryDocsAdmin(id);
        // }

    };
    //#endregion

    //#region ######### Taxes Delivery ###################################################
    GetTaxes = async type => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        let groupCodeResponse = await apiClient.getTaxesList();
        enableSpinner(false);

        if (!Array.isArray(groupCodeResponse.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información de impuestos' });
            return;
        }

        if (groupCodeResponse.data.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            taxes: groupCodeResponse.data,
            countryIndexSelected: type,
        });

    };

    //#endregion

    //#region ######### GENERAL FUNCTIONS ################################################
    DecryptInfoByUser = async () => {
        const auxDecrypt = await FINISH_THE_RACE(JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')), F1_GRILL.MAX_VERSTAPPEN);
        await this.setState({
            user: auxDecrypt
        })
    }

    _handelBack = () => {
        window.location.hash = "no-back-button";
        window.location.hash = "Again-No-back-button";
        window.onhashchange = function () { window.location.hash = "no-back-button"; }
    };

    OpenDashBoard = (answer) => {
        // const { props } = this.props;
        if (answer === true) {
            this.SaveForLater();
        }
        this.GotoDashboard();
        // history.push('/');
    };

    CheckIfItsUniversalPartner = async () => {
        const { _user, newOrderModel } = this.state;
        const genericCardCode = _user?.Partner?.CardCode || '';
        const selectedCardCode = newOrderModel?.CardCode || '';
        const isUniversal = genericCardCode !== '' && selectedCardCode !== '' && genericCardCode === selectedCardCode;
        await this.setState({ isUniversal });
        return isUniversal;
    };

    UnitType = (unit) => {
        let simbol = '';
        switch (Number(unit)) {
            case 2:
                simbol = 'g'
                break;
            case 3:
                simbol = 'Kg'
                break;

            default:
                break;
        }
        return simbol
    }

    findInName(word, name) {
        let response = name.toUpperCase().includes(word)
        return (response)
    }

    shortName(name) {
        if (this.findInName("EFECTIVO", name)) { return ("EFECTIVO") }
        if (this.findInName("CHEQUE", name)) { return ("CHEQUE") }
        if (this.findInName("TRANS", name)) { return ("TRANSFERENCIA") }
        if (this.findInName("NOTA", name)) { return ("NOTA DE CRÉDITO") }
        if (this.findInName("TARJ", name)) { return ("TARJETA") }
        // if(this.findInName("CRÉDITO", name)){ return("CRÉDITO")}
        return (name)
    }

    shortTypeName(type) {
        if (type == 0) { return ("EFECTIVO") }
        if (type == 1) { return ("CHEQUE") }
        if (type == 3) { return ("TRANSFERENCIA") }
        if (type == 4) { return ("NOTA DE CRÉDITO") }
        if (type == 2) { return ("TARJETA") }
        // if(this.findInName("CRÉDITO", name)){ return("CRÉDITO")}
        return (type)
    }

    PrintDocuments = async (type, paperSize, order) => {
        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let items = [];
        let payments = [];
        let payments2 = [];
        for (let index = 0; index < order.Items.length; index++) {
            items[index] = {
                ItemCode: order.Items[index].ItemCode || "",
                ItemName: (order.Items[index].ItemName ? order.Items[index].ItemName : order.Items[index].ItemDescription) || "",
                Price: (order.Items[index].Total ? (Number(order.Items[index].Total) / Number(order.Items[index].Quantity)).toFixed(2).toString() : order.Items[index].HomePrice ? Number(order.Items[index].HomePrice).toFixed(2).toString() : Number(order.Items[index].UnitPrice).toFixed(2).toString()) || "",
                Quantity: Number(order.Items[index].Quantity).toFixed(4).toString() || "",
                UM: order.Items[index].InvntryUom ? order.Items[index].InvntryUom : "" || ""
            }
        }
        if (order.hasOwnProperty("PaymentsToReturn")) {
            for (let index = 0; index < order.PaymentsToReturn.length; index++) {
                payments[index] = {
                    Payment: /*order.PaymentsToReturn[index].PM_Name ||*/ "",
                    Amount: order.PaymentsToReturn[index].Amount || "",
                    Ref: order.PaymentsToReturn[index].AcctCode || "",
                    Type: this.shortName(order.PaymentsToReturn[index].PM_Name) || "",
                    Account: order.PaymentsToReturn[index].PayAccountNum || order.PaymentsToReturn[index].PaycheckNum || order.PaymentsToReturn[index].PaymentAccountNum || order.PaymentsToReturn[index].TransferNum || "",
                }
            }
        }
        if (order.hasOwnProperty("PaymentsToSale")) {
            for (let index = 0; index < order.PaymentsToSale.length; index++) {
                payments2[index] = {
                    Payment: /*order.PaymentsToReturn[index].PM_Name ||*/ "",
                    Amount: order.PaymentsToSale[index].amount || "",

                    Type: this.shortTypeName(order.PaymentsToSale[index].typeMethod) || "",
                    Account: order.PaymentsToSale[index].PayAccountNum || order.PaymentsToSale[index].PaycheckNum || order.PaymentsToSale[index].PaymentAccountNum || order.PaymentsToSale[index].TransferNum || "",
                }
            }
        }
        // const PaymentDoc = order?.PaymentsToPrint?.reduce((max, pay) => (parseFloat(pay?.amount || 0) > parseFloat(max?.amount || 0) ? pay : max), order?.PaymentsToPrint?.[0] || {});

        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: "",
                Footer: "Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración. * Precios Sujetos a Cambio Sin Previo Aviso. ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.*** Maniobras de descarga a cargo del cliente. Toda cancelación o devolución sólo será efectiva presentando la nota y en un plazo no mayor a 7 días. Si se requiere factura, es en un plazo no mayor a 7 días, y/o en los casos que aplique, antes de cierre de mes.",
                Consecutive: order.next_Folio_Cons && order.next_Folio_Cons != "" ? order.next_Folio_Cons : order.NextFolio && order.NextFolio != "" ? order.NextFolio : !!order.docHeader && order.NextFolio != "" ? order.docHeader.infoByFolio.nextFolio : ""
            },
            BusinessPartner: {
                CardCode: order.CardCode || "",
                CardName: order.CardName || "",
                RFC: order.LicTradNum || user.Partner.LicTradNum || "",
                Regime: "PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL",
                Phone: user.Partner.Phone1 || "",
                AddressInvoice: (order.Address || "").toUpperCase() || "",
                AddressDelivery: (order.Address2 || "").toUpperCase() || "",
            },
            OrderSale: {
                DocNum: order.folio || "",// `${order.folio || ""}\n${PaymentDoc && PaymentDoc?.PM_Name ? `Forma Pago:${PaymentDoc?.PM_Name || ''}` : ''}`,
                DocDate: order.DocDate + " " + order.DocTime || "",
                DocOrigen: order.NextFolio || "XXXXX",
                Seller: (order.SlpName || "").substring(30, 0) || "",
                Cashier: user.USER_CODE || "",
                DocTotal: order.Total || "0.00",
                Subtotal: order.Subtotal || "0.00",
                TaxTotal: order.Taxes || "0.00",
                TaxRate: Math.trunc(Number(order.TaxRate || "")) || "",
                DocCur: order.DocCur,
                Items: items || "",
                Payments: payments || "",
                Payments2: payments2 || "",
            },
            CashCut: {
                Type: "",
                DocNum: "",
                DocDate: "",
                Cashier: "",
                DocTotal: "",
                DocCur: "",
                NumSales: "",
                NumReturns: "",
                NumCollects: "",
                TotalSale: "",
                TotalCash: "",
                TotalReturn: "",
                TotalCashIn: "",
                TotalCashOut: "",
                TotalCard: "",
                TotalTransfer: "",
                TotalCheck: "",
                TotalReturnAsPayment: "",
                TotalCredit: "",
                TotalCreditNote: "",
                TotalCollect: "",
                CashIns: [],
                CashOuts: [],
                Cards: [],
                Transfers: [],
                Checks: [],
                ReturnsAsPayment: [],
                Credits: [],
                CreditNotes: []
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);
    };

    PrintCashMovements = async (type, paperSize, order) => {
        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let items = [];
        let payments = [];
        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: "",
                Phone: "",
                Logo: "",
                Footer: order.comment || order.comments || "",
                Consecutive: order.nextFolio || ""
            },
            BusinessPartner: {
                CardCode: "",
                CardName: "",
                RFC: "",
                Regime: "",
                Phone: "",
                AddressInvoice: "",
                AddressDelivery: ""
            },
            OrderSale: {
                DocNum: (order.id || order.folio || "").toString(),
                DocDate: moment(order.docDate).format('DD-MM-YYYY') + "  " + order.docTime.substring(11, 19) || "",
                DocOrigen: order.type || order.type || "",
                Seller: user.U_NAME || "",
                Cashier: user.USER_CODE || "",
                DocTotal: (CURRENCY + " " + Number(order.docTotal || (order.cashAmount ?? order.cashSum ?? 0)).toFixed(2)) || "",
                Subtotal: "",
                TaxTotal: "",
                TaxRate: "",
                DocCur: "",
                Items: items || "",
                Payments: payments || ""
            },
            CashCut: {
                Type: "",
                DocNum: "",
                DocDate: "",
                Cashier: "",
                DocTotal: "",
                DocCur: "",
                NumSales: "",
                NumReturns: "",
                NumCollects: "",
                TotalSale: "",
                TotalCash: "",
                TotalReturn: "",
                TotalCashIn: "",
                TotalCashOut: "",
                TotalCard: "",
                TotalTransfer: "",
                TotalCheck: "",
                TotalReturnAsPayment: "",
                TotalCredit: "",
                TotalCreditNote: "",
                TotalCollect: "",
                CashIns: [],
                CashOuts: [],
                Cards: [],
                Transfers: [],
                Checks: [],
                ReturnsAsPayment: [],
                Credits: [],
                CreditNotes: []
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);
    };

    PrintRefSale = async (type, paperSize, folio) => {
        let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        let items = [];
        let payments = [];
        const today = new Date();
        const date = moment(new Date(today.getFullYear(), today.getMonth(), today.getDate())).format('YYYY-MM-DD');
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

        let data = {
            Config: {
                TicketType: type,
                PaperSize: paperSize
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: user.Branch.Address || "",
                RFC: "",
                Phone: "",
                Logo: "",
                Footer: "",
                Consecutive: ""
            },
            BusinessPartner: {
                CardCode: "",
                CardName: "",
                RFC: "",
                Regime: "",
                Phone: "",
                AddressInvoice: "",
                AddressDelivery: ""
            },
            OrderSale: {
                DocNum: folio || "XXXX",
                DocDate: date + " " + time || "",
                DocOrigen: "",
                Seller: user.U_NAME || "",
                Cashier: user.USER_CODE || "",
                DocTotal: "",
                Subtotal: "",
                TaxTotal: "",
                TaxRate: "",
                DocCur: "",
                Items: items || "",
                Payments: payments || ""
            },
            CashCut: {
                Type: "",
                DocNum: "",
                DocDate: "",
                Cashier: "",
                DocTotal: "",
                DocCur: "",
                NumSales: "",
                NumReturns: "",
                NumCollects: "",
                TotalSale: "",
                TotalCash: "",
                TotalReturn: "",
                TotalCashIn: "",
                TotalCashOut: "",
                TotalCard: "",
                TotalTransfer: "",
                TotalCheck: "",
                TotalReturnAsPayment: "",
                TotalCredit: "",
                TotalCreditNote: "",
                TotalCollect: "",
                CashIns: [],
                CashOuts: [],
                Cards: [],
                Transfers: [],
                Checks: [],
                ReturnsAsPayment: [],
                Credits: [],
                CreditNotes: []
            }
        }
        data.Store.Logo = development == true ? "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"
            : Datos_Empresa.LogoBase64;

        let print = await apiClient.PrintDocuments(data);
    };

    ChangeCreditCheck = () => {
        const { newOrderModel } = this.state;
        newOrderModel.IsCredit = !newOrderModel.IsCredit;
        this.setState({
            newOrderModel
        });
    }

    GetUseCFDI = async () => {
        let cfdi = await apiClient.getUsoCFDI();
        if (Array.isArray(cfdi.data) && cfdi.data.length) {
            this.setState({
                CFDI: cfdi.data,
            });
        }
    };

    GetRegimenFiscal = async () => {
        let regimenFiscal = await apiClient.getRegimenFiscal();

        if (Array.isArray(regimenFiscal.data) && regimenFiscal.data.length) {
            this.setState({
                RegimenFiscal: regimenFiscal.data,
            });
        }
    };

    ChangeUSOCFDI = async (value) => {
        const { newOrderModel, updatebusinessPartner } = this.state;
        updatebusinessPartner.U_FMB_USO_CFDI = value;
        newOrderModel.USOCFDI = value;
        await this.setState({ newOrderModel, updatebusinessPartner });
    };

    ChangeRegimenFiscal = async (value) => {
        const { newOrderModel, updatebusinessPartner } = this.state;
        updatebusinessPartner.U_FMB_REGIMEN_FISCAL = value
        newOrderModel.RegimenFiscal = value;
        await this.setState({ newOrderModel, updatebusinessPartner });
    };

    Change_MetodoPago = async (value) => {
        const { newOrderModel } = this.state;
        newOrderModel.U_SO1_02METODOPAGO = value;
        newOrderModel.U_SO1_02FORMAPAGO = value === 'PPD' ? '99' : '';
        await this.setState({ newOrderModel });
    };

    ChangeOfUUIDRelation = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        const uuidRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;

        if (/\s/.test(value)) {
            showAlert({ type: 'error', message: 'El UUID no debe contener espacios.' });
            return;
        }

        newOrderModel.UUID_RELACIONADO = value.toUpperCase();

        if (uuidRegex.test(newOrderModel.UUID_RELACIONADO)) {
            newOrderModel.U_FMB_TIPO_REL = '04';
        }

        await this.setState({ newOrderModel });
    };

    changeOrderField = async (field, value, maxLength = 0) => {
        let newOrderModelAux = Object.assign({}, this.state.newOrderModel);
        if (maxLength) { if (value.length > maxLength) return; }
        newOrderModelAux[field] = value;
        await this.setState({ newOrderModel: newOrderModelAux });
    };

    Change_FormaPago = async (value) => {
        const { newOrderModel } = this.state;
        newOrderModel.U_SO1_02FORMAPAGO = value;
        await this.setState({ newOrderModel });
    };

    Change_Tipo_Relacion_CFDI = async (value) => {
        const { newOrderModel } = this.state;
        newOrderModel.U_FMB_TIPO_REL = value;
        await this.setState({ newOrderModel });
    };

    ChangeTaxes = async (value) => {
        const { newOrderModel, updatebusinessPartner, taxes } = this.state;
        for (let index = 0; index < taxes.length; index++) {
            if (taxes[index].Code === value) {
                updatebusinessPartner.TaxCode = value;
                updatebusinessPartner.TaxName = taxes[index].Name;
                updatebusinessPartner.TaxRate = taxes[index].Rate;
                newOrderModel.TaxCode = value;
                newOrderModel.TaxName = taxes[index].Name;
                newOrderModel.TaxRate = taxes[index].Rate;
            }
        }
        await this.setState({ newOrderModel, updatebusinessPartner });
    };

    GetReportSalesPayments = async () => {
        await this.setState({
            docsToPrint: [null],
            typeDocPrint: 'ReportSalesPayments',
        })

        await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    UpdateStateField = async (key, value) => {
        await this.setState({
            [key]: value
        })
    }
    //#endregion

    //#region ######### INITIAL CONFIG ###################################################
    SetDefaultPartner = async () => {
        const { _user, newOrderModel } = this.state;
        const { notificationReducer: { showAlert } } = this.props;
        const partner = _user.Partner;

        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.TaxCode = partner.TaxCode;
        newOrderModel.TaxName = partner.TaxName;
        newOrderModel.TaxRate = partner.Rate;
        newOrderModel.PriceListNum = partner.ListNum;
        newOrderModel.ShipToDef = partner.ShipToDef;
        newOrderModel.BillToDef = partner.BillToDef;
        newOrderModel.LicTradNum = partner.LicTradNum;
        newOrderModel.SlpCode = partner.SlpCode;
        newOrderModel.U_FMB_USO_CFDI = partner.U_FMB_USO_CFDI || '';
        newOrderModel.GroupCode = partner.GroupCode || '';
        newOrderModel.GroupCodeName = partner.GroupCodeName || '';
        //#region ################## PERCEPCION ################ ✔
        newOrderModel.U_BPP_BPTD = partner.U_BPP_BPTD;
        newOrderModel.U_STR_AR = partner.U_STR_AR;
        newOrderModel.U_STR_AP = partner.U_STR_AP;
        newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = partner.U_LLG_EXCEPTUADO_PERCEPCION;
        //#endregion ################## PERCEPCION ################ ✔
        //#region DIMENSIONS
        newOrderModel.Dimension1 = await this.getDimension1(newOrderModel);
        if (newOrderModel.Dimension1) {
            for (const item of newOrderModel?.Items) {
                item.OcrCode = newOrderModel.Dimension1;
            }
            if (newOrderModel?.Items?.length) {
                showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al socio` });
            }
        }
        //#endregion DIMENSIONS


        await this.setState({
            newOrderModel
        });
    }

    SetBranchOfficeInfo = async () => {
        const { _user, newOrderModel } = this.state
        const { enableSpinner } = this.props;
        const auxArrayMethods = (_user?.Branch?.PaymentMethods || [])
            .filter(paymentMethod =>
                Number(paymentMethod.TipoUso) === 2 ||
                Number(paymentMethod.TipoUso) === 3
            );
        const indexNC = auxArrayMethods.findIndex(object => { return object.code === 'NC'; });
        if (indexNC !== -1) auxArrayMethods.splice(indexNC, 1);

        const indexCD = auxArrayMethods.findIndex(object => { return object.code === 'CD'; });
        if (indexCD !== -1) auxArrayMethods.splice(indexCD, 1);

        //#region Flujo de caja
        let accounts = '';
        let accountRes = [];
        let CFWOptions = [];
        if (Sections['FlujoCaja'] && auxArrayMethods?.length) {
            enableSpinner(true);
            CFWOptions = await apiClient.getOCFW();
            CFWOptions = CFWOptions?.data ?? [];
            enableSpinner(false);

            accounts = [...new Set(
                auxArrayMethods
                    ?.map(item => item?.AcctCode)
                    ?.filter(Boolean)
            )]
                ?.map(account => `''${account}''`)
                ?.join(', ');

            enableSpinner(true);
            accountRes = await apiClient.accountInfo({ accounts });
            enableSpinner(false);
            if (accountRes?.status) {
                accountRes = accountRes?.data ?? [];

                for (const element of auxArrayMethods) {
                    const accountInfo = accountRes?.find(row => row.AcctCode === element.AcctCode);
                    if (accountInfo?.AcctCode) {
                        element.CfwRlvnt = accountInfo?.CfwRlvnt || null;
                        element.Finanse = accountInfo?.Finanse || null;
                        const needCFW = element.CfwRlvnt === 'Y' && element.Finanse === 'Y';
                        switch (Number(element.type)) {
                            case 0:
                                element.cashCFWId = null; // Para efectivo
                                element.needCashCFW = needCFW; // Para efectivo
                                element.cashCFWOptions = CFWOptions ?? []; // Para efectivo
                                break;
                            case 1:
                                element.checkCFWId = null; // Para cheques
                                element.needCheckCFW = needCFW; // Para cheques
                                element.checkCFWOptions = CFWOptions ?? []; // Para cheques
                                break;
                            case 3:
                                element.transferCFWId = null; // Para transferencias
                                element.needTransferCFW = needCFW; // Para transferencias
                                element.transferCFWOptions = CFWOptions ?? []; // Para transferencias
                                break;
                            default:
                                element.transferCFWId = null; // Para transferencias
                                element.needTransferCFW = false; // Para transferencias
                                element.transferCFWOptions = []; // Para transferencias

                                element.cashCFWId = null; // Para efectivo
                                element.needCashCFW = false; // Para efectivo
                                element.cashCFWOptions = []; // Para efectivo

                                element.checkCFWId = null; // Para cheques
                                element.needCheckCFW = false; // Para cheques
                                element.checkCFWOptions = []; // Para cheques
                                break;
                        }
                    }
                }
            }
        }
        //#endregion Flujo de caja

        await this.setState({
            LimitLinesBO: _user?.Branch.LimitLines || 50,
            CounterRol: _user?.U_FMB_CounterRol || null,
            AvailablePayments: auxArrayMethods || [],
            creditNotesPay: indexNC !== -1 ? true : false,
            creditPay: indexCD !== -1 ? true : false
        })

        if (_user?.U_FMB_CounterRol === 'storer') {
            await this.ChangeObjectype(this.state.newOrderModel, 'quotations', false);
        }
        if (_user?.U_FMB_CounterRol === 'counter') {
            await this.ChangeObjectype(this.state.newOrderModel, 'deliveries2', false);
        }
        await this.SetBranchOfficeTaxes(newOrderModel);
        await this.SetBranchOfficeBillingCatalogs();
    }

    SetCounterPermissions = () => {
        const { _user } = this.state
        this.setState({
            EditDiscount: _user?.CounterPermission.EditDiscount || false,
            EditPrice: _user?.CounterPermission.EditPrice || false,
            EditTaxCode: _user?.CounterPermission.EditTaxCode || false,
        })
    }

    GetCountriesAndStates = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getDataEmployee();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: responseApi.message });
            return;
        }
        await this.setState({
            states: responseApi.data.states || [],
            countries: responseApi.data.country || []
        })
    }

    SetMaxDiscount = () => {
        let user = undefined;//JSON.parse(localStorage.getItem('Timbra1currentUser'));
        if (user?.U_Discount && Number(user?.U_Discount) > 0) { this.setState({ maxDiscount: Number(user?.U_Discount) }); }
        else { this.setState({ maxDiscount: 100 }); }
    }
    //#endregion

    //#region ########## INIT WORKSHIFT ##################################################
    CheckWorkSession = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.checkWorkSession();
        enableSpinner(false);

        if (responseApi.status === 1) {
            if (!responseApi.data.sessionStatus) {
                await this.ShowInitialCash();
            } else {
                if (responseApi.data.NotCashCut === true) {
                    showAlert({ type: "info", message: `${responseApi.message}. Realiza tu corte para continuar`, timeout: 10000 });
                    await this.setState({
                        idWorkShift: responseApi.data.idSession,
                        lastDaySession: true,
                    });
                    await this.ShowCashCutModal();
                    $("#cashCutModal").modal("show");
                } else {
                    this.setState({ idWorkShift: responseApi.data.idSession }, () => {
                        this.SetSellType(responseApi.data);
                    });
                }
            }
        } else if (responseApi.status === 2) {
            showAlert({ type: "info", message: `${responseApi.message}`, timeout: 10000 });
            this.GotoDashboard();
        }
    };

    InsertWorkShiftT = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const responseApi = await apiClient.insertWorkShiftT();
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        if (responseApi.status === 0) {
            await this.GotoDashboard();
        }
        this.setState({ idWorkShift: responseApi.data.idSession }, () => {
            this.SetSellType(responseApi.data);
        });
    };

    CancelWorkShift = () => {
        this.GotoDashboard();
    };

    CloseWorkShift = async (blindInfoModel) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        const data = {
            idWorkShift,
            blindInfoModel
        }

        enableSpinner(true);
        const responseApi = await apiClient.closeWorkShiftT(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return false;
        }

        showAlert({ type: "info", message: `${responseApi.message}` });
        $("#totalModal").modal("show");
        await this.setState({
            lastDaySession: false,
            ReturnedBlindCut: responseApi.ReturnedBlindCut || [],
        })
        return true;
    };

    GotoDashboard = () => {
        this.props.history.push("/");
    };

    SendToLogin = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        showAlert({ type: "info", message: `ESTAS SIENDO REDIRIGIDO AL LOGIN. ESTO ES PLANEADO.`, timeOut: 99999 });
        localStorage.removeItem(config.localStorageNamed + 'Token');
        localStorage.removeItem(config.localStorageNamed + 'currentUser');
        localStorage.removeItem(config.localStorageNamed + 'toogleNavBarItem');
        // const existStorage = localStorage.getItem(config.localStorageNamed + 'currentUser');
        socketService.emit('logout', '');
        this.props.history.push('/');
        this.props.history.push('/login');
        window.location.reload(true);

    }

    //#endregion

    //#region ########## CASH CUT ########################################################
    GetBoxCut = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;

        enableSpinner(true);
        const responseApi = await apiClient.partialCut(idWorkShift);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            this.CheckWorkSession();
            return;
        }

        $("#cashCutModal").modal("show");

        await this.setState({
            cashCut: responseApi.data.reportcashCut || "",
            totalCashCut: Number(responseApi.data.totalCashCut) || 0,
            TotalAmountSales: Number(responseApi.data.totalAmountSales) || 0,
            numSalesCashCut: Number(responseApi.data.numSales) || 0,
            objCharge: responseApi.data.objCharge || {},
            extraPaymentsCashCut: responseApi.data.extraPayments,
            moneyOuts: responseApi.data.moneyOuts,
            moneyEntries: responseApi.data.moneyEntries
        });
    };

    //#endregion

    //#region ########## REFRESH MODELS ##################################################
    RefreshOrder = async (newOrderModel) => {
        await this.setState({ newOrderModel });
    };

    RefreshBusinessPartner = async (newBusinessPartner) => {
        this.setState({ newBusinessPartner });
    };
    calculatePerceptionV1 = (newOrderModel) => {
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            let item = newOrderModel.Items[index];
            if (item.isTemporary) continue;
            if (newOrderModel.U_BPP_BPTD == '6') {
                switch (newOrderModel?.U_STR_AR ?? 'N') {//AGENTE DE RETENCION
                    case 'Y':
                        if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') == 'Y') {//NO SE COBRA PERCEPCION
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                        } else {
                            if ((newOrderModel?.U_STR_AP ?? 'N') == 'Y') {//PERCECION + 5%
                                item.TaxCode = 'IGVPER05'
                                item.TaxName = 'IGV + 0.5%'
                                item.TaxeRate = 18.59
                            } else {//PERCECPION +2%
                                item.TaxCode = 'IGVPER'
                                item.TaxName = 'IGV + 2%'
                                item.TaxeRate = 20.36
                            }
                        }
                        break;
                    case 'N':
                        if ((newOrderModel?.U_STR_AP ?? 'N') == 'Y') {//PERCECION + 5%
                            item.TaxCode = 'IGVPER05'
                            item.TaxName = 'IGV + 0.5%'
                            item.TaxeRate = 18.59
                        } else {//PERCECPION +2%
                            item.TaxCode = 'IGVPER'
                            item.TaxName = 'IGV + 2%'
                            item.TaxeRate = 20.36
                        }
                        break;

                    default:
                        item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                        item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                        item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                        break;
                }
            } else {
                let tempItem = { ...item };
                let discount = parseFloat(tempItem.Price).toFixed(2) * tempItem.Quantity * (tempItem.DiscountPercent / 100);

                discount = parseFloat(discount.toFixed(2));

                tempItem.Discount = discount || 0;
                let impuesto = tempItem.TaxStatus == 'N' ? 0 : _ROUND(parseFloat((tempItem.Price * tempItem.Quantity - tempItem.Discount).toFixed(2)) * (tempItem.TaxeRate / 100));

                tempItem.TaxeResult = impuesto.toFixed(2);
                let total = 0;
                total = (tempItem.Price / newOrderModel.ChangeRate) * tempItem.Quantity - tempItem.Discount / newOrderModel.ChangeRate;
                tempItem.Total = _ROUND(total) == 0 ? 0.1 : _ROUND(total);
                tempItem.TotalAndTax = Number(tempItem.TaxeResult || 0) + Number(tempItem.Total || 0);
                if (tempItem.Total > 1500) {//PERCECPION +2%
                    item.TaxCode = 'IGVPER'
                    item.TaxName = 'IGV + 2%'
                    item.TaxeRate = 20.36

                } else if (tempItem.Quantity > 2) {//PERCECPION +2%
                    item.TaxCode = 'IGVPER'
                    item.TaxName = 'IGV + 2%'
                    item.TaxeRate = 20.36

                } else {//NO SE COBRA PERCEPCION
                    item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                    item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                    item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                }
            }
        }
        return newOrderModel
    }

    calculatePerceptionV2 = (newOrderModel, keepOrLines = false) => { // VERSION 2
        if (keepOrLines) {//AL CARGAR EL DOCUMENTO DE INTEROPERABILIDAD, NO DEBE CALCULAR, SOLO SI SE EDITA ALGUN VALOR
            return newOrderModel
        }
        const isCredit = Number(newOrderModel.GroupNum) != -1
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            let item = newOrderModel.Items[index];
            if (item.isTemporary) continue;
            if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) {//PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                if (newOrderModel.U_BPP_BPTD == '6') {
                    switch (newOrderModel?.U_STR_AR ?? 'N') { //AGENTE DE RETENCION
                        case 'Y': //NO SE COBRA PERCEPCION
                            item.Perception = null
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                            break;

                        case 'N':
                            if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') == 'Y') { //NO SE COBRA PERCEPCION
                                item.Perception = null
                                item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                                item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                                item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);

                            } else {
                                if ((newOrderModel?.U_STR_AP ?? 'N') == 'Y') { //PERCECION + 5%
                                    item.Perception = 'Y'
                                    item.TaxCode = 'IGVPER05';
                                    item.TaxName = 'IGV + 0.5%';
                                    item.TaxeRate = 18.59;

                                } else { //PERCECPION +2%
                                    item.Perception = 'Y'
                                    item.TaxCode = 'IGVPER';
                                    item.TaxName = 'IGV + 2%';
                                    item.TaxeRate = 20.36;
                                }
                            }
                            break;

                        default:
                            item.Perception = null
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                            break;
                    }
                } else {
                    let tempItem = { ...item };
                    let discount = parseFloat(tempItem.Price).toFixed(2) * tempItem.Quantity * (tempItem.DiscountPercent / 100);

                    discount = parseFloat(discount.toFixed(2));

                    tempItem.Discount = discount || 0;
                    let impuesto = tempItem.TaxStatus == 'N' ? 0 : _ROUND(parseFloat((tempItem.Price * tempItem.Quantity - tempItem.Discount).toFixed(2)) * (tempItem.TaxeRate / 100));

                    tempItem.TaxeResult = impuesto.toFixed(2);
                    let total = 0;
                    total = (tempItem.Price / newOrderModel.ChangeRate) * tempItem.Quantity - tempItem.Discount / newOrderModel.ChangeRate;
                    tempItem.Total = _ROUND(total) == 0 ? 0.1 : _ROUND(total);
                    tempItem.TotalAndTax = Number(tempItem.TaxeResult || 0) + Number(tempItem.Total || 0);

                    if (Granel?.includes(Number(tempItem?.ItmsGrpCod))) { //GLP GRANEL
                        if (Number(tempItem?.Total) > 1500) { //PERCECPION +2%
                            item.Perception = 'Y'
                            item.TaxCode = 'IGVPER';
                            item.TaxName = 'IGV + 2%';
                            item.TaxeRate = 20.36;

                        } else { //NO SE COBRA PERCEPCION
                            item.Perception = null
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                        }

                    } else if (Number(tempItem?.Quantity) > 2) { //PERCECPION +2%
                        item.Perception = 'Y'
                        item.TaxCode = 'IGVPER';
                        item.TaxName = 'IGV + 2%';
                        item.TaxeRate = 20.36;

                    } else { //NO SE COBRA PERCEPCION
                        item.Perception = null
                        item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                        item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                        item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                    }
                }
                if (isCredit) {
                    //GUARDAMOS EL CALCULO DE PERCEPCION PARA SER COBRADO POSTERIORMENTE
                    item.TaxCodeCredit = item.TaxCode
                    item.TaxNameCredit = item.TaxName
                    item.TaxeRateCredit = item.TaxeRate
                    //COLOCAR EL CODIGO DE IMPUESTO POR DEFECTO
                    item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                    item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                    item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                }
                if ((item?.Perception ?? null) == null) {
                    item.TaxCodeCredit = null
                    item.TaxNameCredit = null
                    item.TaxeRateCredit = null
                }
            }
        }
        return newOrderModel
    }

    calculatePerceptionV3 = (newOrderModel, keepOrLines = false) => { // VERSION 3
        if (keepOrLines) {//AL CARGAR EL DOCUMENTO DE INTEROPERABILIDAD, NO DEBE CALCULAR, SOLO SI SE EDITA ALGUN VALOR
            return newOrderModel
        }
        const isCredit = Number(newOrderModel.GroupNum) !== -1;

        if (String(newOrderModel?.U_BPP_BPTD) === '6') { // LADO IZQUIERDO
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                let item = newOrderModel.Items[index];
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    switch (newOrderModel?.U_STR_AR ?? 'N') { // AGENTE DE RETENCION
                        case 'Y': //NO SE COBRA PERCEPCION
                            item.Perception = null
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                            break;

                        case 'N':
                            if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // NO SE COBRA PERCEPCION
                                item.Perception = null
                                item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                                item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                                item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);

                            } else {
                                if ((newOrderModel?.U_STR_AP ?? 'N') === 'Y') { // PERCEPCION + 0.5%
                                    item.Perception = 'Y'
                                    item.TaxCode = 'IGVPER05';
                                    item.TaxName = 'IGV + 0.5%';
                                    item.TaxeRate = 18.59;

                                } else { // PERCEPCION + 2%
                                    item.Perception = 'Y'
                                    item.TaxCode = 'IGVPER';
                                    item.TaxName = 'IGV + 2%';
                                    item.TaxeRate = 20.36;
                                }
                            }
                            break;

                        default:
                            item.Perception = null
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                            break;
                    }
                }
            }
        } else { // LADO DERECHO - Revisar en General
            let SumTotal = 0; // Sumatoria de todos los totales de las lineas de GLP
            let SumQuantity = 0; // Sumatoria de todas las cantidades de las lineas que no son GLP

            for (const item of newOrderModel?.Items) {
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    let tempItem = { ...item };
                    let discount = parseFloat(tempItem.Price).toFixed(2) * tempItem.Quantity * (tempItem.DiscountPercent / 100);

                    discount = parseFloat(discount.toFixed(2));

                    tempItem.Discount = discount || 0;
                    let impuesto = tempItem.TaxStatus == 'N' ? 0 : _ROUND(parseFloat((tempItem.Price * tempItem.Quantity - tempItem.Discount).toFixed(2)) * (tempItem.TaxeRate / 100));

                    tempItem.TaxeResult = impuesto.toFixed(2);
                    let total = 0;
                    total = (tempItem.Price / newOrderModel.ChangeRate) * tempItem.Quantity - tempItem.Discount / newOrderModel.ChangeRate;
                    tempItem.Total = _ROUND(total) == 0 ? 0.1 : _ROUND(total);
                    tempItem.TotalAndTax = Number(tempItem.TaxeResult || 0) + Number(tempItem.Total || 0);
                    if (Granel?.includes(Number(tempItem?.ItmsGrpCod))) { // GLP GRANEL - SUMAR TOTALES
                        SumTotal += Number(tempItem?.TotalAndTax ?? 0);
                    } else { // NO ES GLP GRANEL - SUMAR CANTIDADES
                        SumQuantity += Number(tempItem?.Quantity ?? 0);
                    }
                }
            }

            for (const item of newOrderModel?.Items) {
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS

                    if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // VERSION 3.1 - NO SE COBRA PERCEPCION
                        item.Perception = null;
                        item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                        item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                        item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);

                    } else if (Granel?.includes(Number(item?.ItmsGrpCod))) { // GLP GRANEL
                        if (Number(SumTotal) > 1500) { // PERCEPCION + 2%
                            item.Perception = 'Y';
                            item.TaxCode = 'IGVPER';
                            item.TaxName = 'IGV + 2%';
                            item.TaxeRate = 20.36;

                        } else { // NO SE COBRA PERCEPCION
                            item.Perception = null;
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                        }

                    } else if (Number(SumQuantity) > 2) { // PERCEPCION + 2%
                        item.Perception = 'Y';
                        item.TaxCode = 'IGVPER';
                        item.TaxName = 'IGV + 2%';
                        item.TaxeRate = 20.36;

                    } else { // NO SE COBRA PERCEPCION
                        item.Perception = null;
                        item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                        item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                        item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                    }
                }
            }

        }

        for (const item of newOrderModel?.Items) {
            if (item.isTemporary) continue;
            if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                if (isCredit) {
                    // GUARDAMOS EL CALCULO DE PERCEPCION PARA SER COBRADO POSTERIORMENTE
                    item.TaxCodeCredit = item.TaxCode;
                    item.TaxNameCredit = item.TaxName;
                    item.TaxeRateCredit = item.TaxeRate;
                    // COLOCAR EL CODIGO DE IMPUESTO POR DEFECTO
                    item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                    item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                    item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                }
                if ((item?.Perception ?? null) == null) {
                    item.TaxCodeCredit = null;
                    item.TaxNameCredit = null;
                    item.TaxeRateCredit = null;
                }
            }
        }
        return newOrderModel
    }

    calculatePerception = (newOrderModel, keepOrLines = false) => { // VERSION 4
        if (keepOrLines) {//AL CARGAR EL DOCUMENTO DE INTEROPERABILIDAD, NO DEBE CALCULAR, SOLO SI SE EDITA ALGUN VALOR
            return newOrderModel
        }
        const isCredit = Number(newOrderModel.GroupNum) !== -1;

        if (String(newOrderModel?.U_BPP_BPTD) === '6') { // LADO IZQUIERDO
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                let item = newOrderModel.Items[index];
                const anticipo = isAnticipo(item.ItemCode)//NO HAY FACTURAS DE ANTICIPO A CREDITO
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    switch (newOrderModel?.U_STR_AR ?? 'N') { // AGENTE DE RETENCION
                        case 'Y': //NO SE COBRA PERCEPCION
                            item.Perception = null
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                            break;

                        case 'N':
                            if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // NO SE COBRA PERCEPCION
                                item.Perception = null
                                item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                                item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                                item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);

                            } else {
                                if ((newOrderModel?.U_STR_AP ?? 'N') === 'Y') { // PERCEPCION + 0.5%
                                    item.Perception = 'Y';
                                    item.TaxCode = 'IGVPER05';
                                    item.TaxName = 'IGV + 0.5%';
                                    item.TaxeRate = 18.59;
                                    if (isCredit && !anticipo) {
                                        item.TaxCodeCredit = item.TaxCode;
                                        item.TaxNameCredit = item.TaxName;
                                        item.TaxeRateCredit = item.TaxeRate;
                                        item.TaxCode = 'IGV';
                                        item.TaxName = 'IGV (18%)';
                                        item.TaxeRate = 18;
                                        item.isCreditPerception = true;
                                        item.PerceptionRate = 0.5;
                                    } else {
                                        item.TaxCodeCredit = '';
                                        item.TaxNameCredit = '';
                                        item.TaxeRateCredit = 0;
                                        item.isCreditPerception = false;
                                        item.PerceptionRate = 0;
                                    }

                                } else { // PERCEPCION + 2%
                                    item.Perception = 'Y';
                                    item.TaxCode = 'IGVPER';
                                    item.TaxName = 'IGV + 2%';
                                    item.TaxeRate = 20.36;
                                    if (isCredit && !anticipo) {
                                        item.TaxCodeCredit = item.TaxCode;
                                        item.TaxNameCredit = item.TaxName;
                                        item.TaxeRateCredit = item.TaxeRate;
                                        item.TaxCode = 'IGV';
                                        item.TaxName = 'IGV (18%)';
                                        item.TaxeRate = 18;
                                        item.isCreditPerception = true;
                                        item.PerceptionRate = 2;
                                    } else {
                                        item.TaxCodeCredit = '';
                                        item.TaxNameCredit = '';
                                        item.TaxeRateCredit = 0;
                                        item.isCreditPerception = false;
                                        item.PerceptionRate = 0;
                                    }
                                }
                            }
                            break;

                        default:
                            item.Perception = null
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                            break;
                    }
                }
            }
        } else { // LADO DERECHO - Revisar en General
            let SumTotal = 0; // Sumatoria de todos los totales de las lineas de GLP
            let SumTotalPLCredit = 0;
            let SumQuantity = 0; // Sumatoria de todas las cantidades de las lineas que no son GLP

            for (const item of newOrderModel?.Items) {
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS
                    let tempItem = { ...item };
                    let discount = parseFloat(tempItem.Price).toFixed(priceDecimalPrecision) * tempItem.Quantity * (tempItem.DiscountPercent / 100);

                    discount = parseFloat(discount.toFixed(priceDecimalPrecision));

                    tempItem.Discount = discount || 0;
                    let impuesto = tempItem.TaxStatus === 'N' ? 0 : roundToDecimals(parseFloat((tempItem.Price * tempItem.Quantity - tempItem.Discount).toFixed(priceDecimalPrecision)) * (tempItem.TaxeRate / 100), priceDecimalPrecision);
                    let impuestoCredit = !item.isCreditPerception ? 0 : tempItem.TaxStatus === 'N' ? 0 : roundToDecimals(parseFloat((tempItem.Price * tempItem.Quantity - tempItem.Discount).toFixed(priceDecimalPrecision)) * (tempItem?.TaxeRateCredit / 100), priceDecimalPrecision);

                    tempItem.TaxeResult = impuesto.toFixed(priceDecimalPrecision);
                    tempItem.TaxeResultCredit = impuestoCredit?.toFixed(priceDecimalPrecision);
                    let total = 0;
                    total = item.TaxOnly === 'Y' ? 0 : (tempItem.Price / newOrderModel.ChangeRate) * tempItem.Quantity - tempItem.Discount / newOrderModel.ChangeRate;
                    // tempItem.Total = _ROUND(total) == 0 ? 0.1 : _ROUND(total);
                    tempItem.Total = roundToDecimals(total, priceDecimalPrecision);
                    tempItem.TotalAndTax = Number(tempItem.TaxeResult || 0) + Number(tempItem.Total || 0);
                    if (Granel?.includes(Number(tempItem?.ItmsGrpCod))) { // GLP GRANEL - SUMAR TOTALES
                        SumTotal += Number(tempItem?.TotalAndTax ?? 0);
                        SumTotalPLCredit += !item.isCreditPerception ? 0 : Number(tempItem.TaxeResultCredit || 0) + Number(tempItem.TotalCredit || 0);
                    } else { // NO ES GLP GRANEL - SUMAR CANTIDADES
                        SumQuantity += Number(tempItem?.Quantity ?? 0);
                    }
                }
            }

            for (const item of newOrderModel?.Items) {
                const anticipo = isAnticipo(item.ItemCode)//NO HAY FACTURAS DE ANTICIPO A CREDITO
                if (item.isTemporary) continue;
                if (Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod))) { // PERCEPCIONES SOLO APLICA A ITEMS GLP ENVASADO, GRANEL Y SOLO PARA VENTAS

                    if ((newOrderModel?.U_LLG_EXCEPTUADO_PERCEPCION ?? 'N') === 'Y') { // VERSION 3.1 - NO SE COBRA PERCEPCION
                        item.Perception = null;
                        item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                        item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                        item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);

                    } else if (Granel?.includes(Number(item?.ItmsGrpCod))) { // GLP GRANEL
                        if (Number(SumTotal) > 1500 || Number(SumTotalPLCredit) > 1500) { // PERCEPCION + 2%
                            item.Perception = 'Y';
                            item.TaxCode = 'IGVPER';
                            item.TaxName = 'IGV + 2%';
                            item.TaxeRate = 20.36;
                            if (isCredit && !anticipo) {
                                item.TaxCodeCredit = item.TaxCode;
                                item.TaxNameCredit = item.TaxName;
                                item.TaxeRateCredit = item.TaxeRate;
                                item.TaxCode = 'IGV';
                                item.TaxName = 'IGV (18%)';
                                item.TaxeRate = 18;
                                item.isCreditPerception = true;
                                item.PerceptionRate = 2;
                            } else {
                                item.TaxCodeCredit = '';
                                item.TaxNameCredit = '';
                                item.TaxeRateCredit = 0;
                                item.isCreditPerception = false;
                                item.PerceptionRate = 0;
                            }

                        } else { // NO SE COBRA PERCEPCION
                            item.Perception = null;
                            item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                            item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                            item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                        }

                    } else if (Number(SumQuantity) > 2) { // PERCEPCION + 2%
                        item.Perception = 'Y';
                        item.TaxCode = 'IGVPER';
                        item.TaxName = 'IGV + 2%';
                        item.TaxeRate = 20.36;
                        if (isCredit && !anticipo) {
                            item.TaxCodeCredit = item.TaxCode;
                            item.TaxNameCredit = item.TaxName;
                            item.TaxeRateCredit = item.TaxeRate;
                            item.TaxCode = 'IGV';
                            item.TaxName = 'IGV (18%)';
                            item.TaxeRate = 18;
                            item.isCreditPerception = true;
                            item.PerceptionRate = 2;
                        } else {
                            item.TaxCodeCredit = '';
                            item.TaxNameCredit = '';
                            item.TaxeRateCredit = 0;
                            item.isCreditPerception = false;
                            item.PerceptionRate = 0;
                        }

                    } else { // NO SE COBRA PERCEPCION
                        item.Perception = null;
                        item.TaxCode = globalTax ? (newOrderModel.TaxCode || item.ItemTaxCode) : (item.ItemTaxCode || newOrderModel.TaxCode);
                        item.TaxName = globalTax ? (newOrderModel.TaxName || item.ItemTaxCodeName) : (item.ItemTaxCodeName || newOrderModel.TaxName);
                        item.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.ItemRate) : (item.ItemRate || newOrderModel.TaxRate);
                    }
                }
            }

        }

        return newOrderModel
    }

    reorderItems = (newOrderModel) => {
        const items = JSON.parse(JSON.stringify(newOrderModel.Items));
        let result = [];

        const parents = items.filter(i => !i.isTemporary);
        const temporaries = items.filter(i => i.isTemporary);

        parents.forEach(parent => {


            if (parent.isAdministrativeExpenseParent) {//SI TIENE GA Y CU
                let maxLineNum = (result?.length ?? 0) + 1
                let child1LineNum = maxLineNum + 1;
                const temporalesItems = []
                for (let index = 0; index < temporaries.length; index++) {
                    const temporal = temporaries[index];
                    if (temporal.ParentLineNum === parent.LineNum) {
                        parent.isAdministrativeExpenseParent = `${maxLineNum}_${child1LineNum}_${child1LineNum + 1}_${temporal.ItemCode}`;

                        maxLineNum++
                        child1LineNum++
                    }

                }
                result.push(parent)
                if (temporalesItems.length > 0) {
                    result = result.concat(temporalesItems)
                }
            } else {
                result.push(parent);
            }
        });
        // newOrderModel.Items = result
        // this.refreshModel(newOrderModel)

    };

    RefreshTotal = async (newOrderModel, keepOrLines = false) => {
        //#region CREDIT PERCEPTIONS
        newOrderModel.SumTotalPLCredit = 0;
        newOrderModel.U_STR_FE_Tasa_Percepcion = 0; // Tasa
        newOrderModel.U_BPP_TtPc = 0;  // Total
        let PerceptionLocalCredit = 0;
        //#endregion CREDIT PERCEPTIONS
        newOrderModel = this.calculatePerception(newOrderModel, keepOrLines);
        for (let index = 0; index < newOrderModel.Items.length; index++) {
            let item = newOrderModel.Items[index];
            let discount = parseFloat(item.Price).toFixed(priceDecimalPrecision) * item.Quantity * (item.DiscountPercent / 100);

            discount = parseFloat(discount.toFixed(priceDecimalPrecision));

            item.Discount = discount || 0;
            let impuesto = item.TaxStatus == 'N' ? 0 : roundToDecimals(parseFloat((item.Price * item.Quantity - item.Discount).toFixed(priceDecimalPrecision)) * (item.TaxeRate / 100), priceDecimalPrecision);

            item.TaxeResult = impuesto.toFixed(priceDecimalPrecision);
            let total = 0;
            total = (item.Price / newOrderModel.ChangeRate) * item.Quantity - item.Discount / newOrderModel.ChangeRate;
            // item.Total = _ROUND(total) == 0 ? 0.1 : _ROUND(total);
            item.Total = roundToDecimals(total, priceDecimalPrecision);
            item.TotalAndTax = Number(item.TaxeResult || 0) + Number(item.Total || 0);

            //#region CREDIT PERCEPTIONS
            if (item.isCreditPerception) {
                const perceptionRate = Number(item.TaxeRateCredit) - 18;
                let rawPerception = 0; // CREDIT PERCEPTIONS: Only Perception
                rawPerception = Number(item.Total || 0) * (perceptionRate / 100);
                const perceptionLocal = roundToDecimals(rawPerception, priceDecimalPrecision);
                PerceptionLocalCredit += perceptionLocal;
            }
            //#endregion CREDIT PERCEPTIONS

        }

        let subTotal = 0;
        let impuestos = 0;
        let discount = 0;
        let total = 0;
        let subTotalTaxStatus = 0;

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            let discount = (Number(item.Total) * (Number(newOrderModel.DiscountPercent) / 100)).toFixed(priceDecimalPrecision);

            let priceBefDi = (Number(item.Total) - Number(discount)).toFixed(priceDecimalPrecision);
            let impuesto = globalTax ? (Number(priceBefDi) * (Number(newOrderModel.TaxRate) / 100)).toFixed(priceDecimalPrecision) : (Number(priceBefDi) * (Number(item.TaxeRate) / 100)).toFixed(priceDecimalPrecision);

            subTotalTaxStatus += item.TaxStatus === 'N' ? Number(impuesto) : 0
            item.TaxeResult = Number(impuesto).toFixed(priceDecimalPrecision);

            subTotal += item.TaxOnly === 'Y' ? 0 : Number(item.Total);
            impuestos += Number(impuesto);
        }

        discount = subTotal * (newOrderModel.DiscountPercent / 100);

        total = parseFloat(parseFloat(subTotal).toFixed(priceDecimalPrecision) - parseFloat(discount).toFixed(priceDecimalPrecision)) + parseFloat(parseFloat(impuestos).toFixed(priceDecimalPrecision));
        total -= subTotalTaxStatus;
        total = Math.round(total * 100) / 100
        const restaPrecision = (Math.round(impuestos * 1000) - Math.round(subTotalTaxStatus * 1000)) / 1000;
        impuestos = Math.round(restaPrecision * 100) / 100;

        newOrderModel.Subtotal = parseFloat(subTotal).toFixed(priceDecimalPrecision);
        newOrderModel.Discount = parseFloat(discount).toFixed(priceDecimalPrecision);
        newOrderModel.Taxes = parseFloat(impuestos).toFixed(priceDecimalPrecision);

        newOrderModel.Total = parseFloat(total).toFixed(priceDecimalPrecision);
        newOrderModel.auxTotal = parseFloat(total).toFixed(priceDecimalPrecision);
        //#region CREDIT PERCEPTIONS
        const PerceptionRate = Number(newOrderModel?.Items?.find(line => line.isCreditPerception)?.PerceptionRate ?? 0);
        newOrderModel.U_STR_FE_Tasa_Percepcion = Number(PerceptionRate) || 0; // VERSION 4: De acuerdo al diagrama solo entra a 1 valor (lado izquierdo o lado derecho)
        newOrderModel.U_BPP_TtPc = roundToDecimals(PerceptionLocalCredit, 2);

        newOrderModel.Total = Number((Number(newOrderModel.Total) + Number(newOrderModel.U_BPP_TtPc))?.toFixed(priceDecimalPrecision));
        //#endregion CREDIT PERCEPTIONS

        await this.setState({
            newOrderModel,
        });
    };

    RefreshPaymentSaleModel = (PaymentSaleModel) => {
        this.setState({ PaymentSaleModel })
    };

    RefreshReturnFolioAmount = (value) => {
        this.setState({
            returnFolioAmount: value || 0,
        })
    };

    RefreshCommentsModel = async (DocCommentsModel) => {
        await this.setState({ DocCommentsModel })
    }
    //#endregion

    //#region ########## SEARCH BAR ######################################################
    ChangeSearchItem = (value) => {
        this.setState({
            itemSearch: value,
        });
    };

    SearchItems = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { itemSearch, newOrderModel, objType, wareHouseTransaction } = this.state;
        if (!itemSearch || itemSearch.length < 3) {
            showAlert({ type: "warning", message: "Producto no encontrado" });
            await this.setState({
                suggestions: [],
            });
            return;
        }

        const data = {
            ItemCode: itemSearch,
            CardCode: newOrderModel.CardCode || "",
            objType: objType,
            PriceListNum: newOrderModel.PriceListNum || '',
            WhsCode: wareHouseTransaction?.WhsCode ?? null
        };

        enableSpinner(true);
        const getItemsResponse = await apiClient.SearchItems(data);
        enableSpinner(false);
        if (!Array.isArray(getItemsResponse.data)) {
            showAlert({ type: "error", message: getItemsResponse.message });
            return;
        }

        if (getItemsResponse.data.length === 0) {
            showAlert({ type: "info", message: "No hay Información por mostrar" });
            return;
        }

        let itemList = getItemsResponse.data || [];

        if (itemList.length === 1) {
            await this.AddItem(itemList[0]);
        } else {
            await this.setState({
                suggestions: itemList,
                suggestionsCopy: itemList,
                ShowWithStock: false,
                showSearchModal: true,
            });
            $("#searchModal").modal("show");
        }
    };

    SearchAdministrativeExpenses = async (item) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { newOrderModel, wareHouseTransaction } = this.state;
        const data = {
            CardCode: newOrderModel.CardCode || "",
            ItemCode: item.ItemCode || "",
            WhsCode: wareHouseTransaction.WhsCode || '',
            TipoVta: newOrderModel?.userFields?.userFields28 || ''
        };

        enableSpinner(true);
        const response = await apiClient.getAdministrativeExpenses(data);
        enableSpinner(false);

        if (!response.data || typeof response.data !== 'object') {
            showAlert({ type: "error", message: "No hay Información por mostrar" });
            return;
        }

        const { itemAdminExpen, itemcertCUItm } = response.data;

        if ((!Array.isArray(itemAdminExpen) || itemAdminExpen.length === 0) && (!Array.isArray(itemcertCUItm) || itemcertCUItm.length === 0)) {
            showAlert({ type: "error", message: response.message || "No hay hijos" });
            return;
        }

        if (itemAdminExpen.length === 1 && itemcertCUItm.length === 1) {
            newOrderModel = { ...this.state.newOrderModel };

            const parent = newOrderModel.Items.find(i => i.LineNum === item.LineNum) || newOrderModel.Items[item.LineNum];

            if (!parent) {
                showAlert({ type: "error", message: "No se encontró el artículo padre." });
                return;
            }

            const maxLineNum = newOrderModel.Items.length
                ? Math.max(...newOrderModel.Items.map(i => Number(i.LineNum || 0)))
                : -1;
            const child1LineNum = maxLineNum + 1;
            const child2LineNum = maxLineNum + 2;

            // Campos heredados del padre
            const inheritedFields = {
                OcrCode: parent.OcrCode || '',
                OcrCode2: parent.OcrCode2 || '',
                OcrCode3: parent.OcrCode3 || '',
                OcrCode4: parent.OcrCode4 || '',
                OcrCode5: parent.OcrCode5 || '',
                Project: parent.Project || '',
                U_tipoOpT12: parent.U_tipoOpT12 || '-',
                U_BPP_OPER: parent.U_BPP_OPER || '-',
                U_STR_FECodAfect: parent.U_STR_FECodAfect || '',
                TaxStatus: parent.TaxStatus || 'N',
                U_RML_ENTCLNDRO: parent.U_RML_ENTCLNDRO || '',
                U_RML_TIPO_CU: parent.U_RML_TIPO_CU || '-',
                U_RML_CU: parent.U_RML_CU || '0',
            };

            const child1 = { ...itemAdminExpen[0], ...inheritedFields, Quantity: ((parent.Quantity || 1) - (Number(parent.U_RML_CU || 0))), LineNum: child1LineNum, ParentLineNum: parent.LineNum, WhsCode: parent.WhsCode };
            const child2 = { ...itemcertCUItm[0], ...inheritedFields, Quantity: ((parent.Quantity || 1) - (Number(parent.U_RML_CU || 0))), LineNum: child2LineNum, ParentLineNum: parent.LineNum, WhsCode: parent.WhsCode };

            parent.isAdministrativeExpenseParent = `${parent.LineNum}_${child1LineNum}_${child2LineNum}_${itemAdminExpen[0].ItemCode}`;

            await this.AddItem(child1, false, false, 0, true);
            await this.AddItem(child2, false, false, 0, true);

            await this.RefreshTotal(newOrderModel, true);
        } else {
            showAlert({ type: "error", message: itemAdminExpen.message || "Error al obtener hijos" });
            return;
        }
    };

    ChangeQuantitySuggestions = async (value, index) => {
        const {
            notificationReducer: { showAlert },
        } = this.props;
        const { suggestions } = this.state;
        if (isNaN(value)) {
            showAlert({
                type: "warning",
                message: "Cantidad invalida",
                timeOut: 2000,
            });
            return;
        }
        suggestions[index].Quantity = value;
        this.setState({
            suggestions,
        });
    };

    SelectItemSuggestion = (index) => {
        this.setState({
            itemIndexSuggestion: index,
        });
    };

    UpdateItemsPrice = async (ComingFromGrossProfit = false) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;

        let newOrder = JSON.parse(JSON.stringify(newOrderModel));
        if (newOrder.Items.length === 0) {
            return;
        }

        let actual = null;
        let newItemsArray = [];
        let counter = 0;
        let itemCounter = newOrder.Items;
        for (let i = 0; i < itemCounter.length; i++) {
            if (itemCounter[i].ItemCode !== actual && itemCounter[i].InvntItem === 'Y') {
                if (counter > 0) {
                    newItemsArray.push({
                        ItemCode: actual,
                    });
                }
                actual = itemCounter[i].ItemCode;
                counter = 1;
            } else {
                counter++;
            }
        }
        if (counter > 0) {
            newItemsArray.push({
                ItemCode: actual,
            });
        }
        const data = {
            Items: newItemsArray,
            PriceListNum: newOrderModel.PriceListNum || "",
        };

        enableSpinner(true);
        const getItemsResponse = await apiClient.SearchPriceItems(data);
        enableSpinner(false);

        if (!Array.isArray(getItemsResponse.data)) {
            showAlert({ type: "error", message: getItemsResponse.message });
            return;
        }

        let arrayItems = getItemsResponse.data;
        for (let indexz = 0; indexz < newOrder.Items.length; indexz++) {
            const item = newOrder.Items[indexz];
            if (item.InvntItem === 'Y') {
                for (let index = 0; index < arrayItems.length; index++) {
                    const element = arrayItems[index];
                    if (element.ItemCode === item.ItemCode) {
                        if (!ComingFromGrossProfit) { // this condition its only to get price for GrossProfit
                            item.HomePrice = element.Price || 0;
                            item.Price = item.Gallons ? Number(item.Price || 0)  // En conversion de galones conservar el valor calculado
                                : element.Price || 0;
                            if (globalTax) {
                                item.TaxCode = newOrderModel.TaxCode || item.TaxCodeAR;
                                item.TaxeRate = newOrderModel.TaxRate || item.Rate;
                            }

                            item.DISCOUNT_PERIOD_QTY = element.DISCOUNT_PERIOD_QTY || []
                            const lastDiscount = item.DiscountPercent
                            this.SetSpecialPrices(item);
                            if (!item.SpecialDiscount) {
                                this.SetDiscountPeriodAndQuantity(item)
                                if (!item.U_FMB_TypeDiscount) {
                                    item.DiscountPercent = lastDiscount
                                }
                            }
                        } else {
                            item.AlternativePriceGP = element.Price;
                        }
                    }
                }
            } else if (globalTax) {
                item.TaxCode = newOrderModel.TaxCode || item.TaxCodeAR;
                item.TaxeRate = newOrderModel.TaxRate || item.Rate;
            }
        }
        await this.RefreshTotal(newOrder);
    };
    //#endregion

    //#region ########## SEARCH MODAL ####################################################
    SearchItemsModal = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { itemSearch, newOrderModel, objType, wareHouseTransaction } = this.state;
        if (!itemSearch || itemSearch.length < 2) {
            showAlert({ type: "warning", message: "Producto no encontrado" });
            await this.setState({
                suggestions: [],
            });
            return;
        }
        const data = {
            ItemCode: itemSearch,
            CardCode: newOrderModel.CardCode || "",
            objType: objType,
            PriceListNum: newOrderModel.PriceListNum || '',
            WhsCode: wareHouseTransaction?.WhsCode ?? null
        };

        enableSpinner(true);
        const getItemsResponse = await apiClient.SearchItems(data);
        enableSpinner(false);
        if (!Array.isArray(getItemsResponse.data)) {
            showAlert({ type: "error", message: getItemsResponse.message });
            return;
        }

        if (getItemsResponse.data.length === 0) {
            showAlert({ type: "info", message: "No hay Información por mostrar" });
            return;
        }
        let itemList = getItemsResponse.data || [];
        await this.setState({
            suggestions: itemList,
            suggestionsCopy: itemList,
            ShowWithStock: false,
        });
    };

    //#endregion

    //#region ########## TABLE ITEMS #####################################################
    AddItem = async (itemSelected, isDraft = false, ItemFromRecover = false, index = 0, keepOrLines = false) => {
        await this.SetBranchOfficeBillingCatalogs();

        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, LimitLinesBO, _user, wareHouseTransaction, operationList } = this.state;
        if (LimitLinesBO !== null && newOrderModel.Items.length >= LimitLinesBO) {
            showAlert({ type: "warning", message: `EL MÁXIMO DE LINEAS CONFIGURADAS ES DE: ${LimitLinesBO}`, timeOut: 5000 });
            return
        }
        const item = itemSelected;
        const newItemModel = new NewItem();
        newItemModel.LineNum = itemSelected.LineNum ? itemSelected.LineNum : newOrderModel.Items.length;
        if (!isDraft) {
            newItemModel.BaseEntry = item.DocEntry || null;
            newItemModel.BaseType = Number(item.ObjType) || -1;
            newItemModel.BaseLine = item.LineNum || 0;
        }

        newItemModel.ItemCode = item.ItemCode;
        newItemModel.ItemName = item.ItemName || item.Description || item.Dscription;
        newItemModel.PicturName = item.PicturName;
        newItemModel.UserText = item.UserText;
        newItemModel.CodeBars = item.CodeBars || "";
        newItemModel.HomePrice = Number(item.Price);
        newItemModel.Price = Number(item.Price);
        newItemModel.PriceByPLMin = Number(item.PriceByPLMin);
        newItemModel.DiscountPercent = Number(item?.DiscountPercent ?? 0);
        newItemModel.NumInSale = Number(item.NumInSale || 0);
        newItemModel.OnHand = Number(item.OnHand || 0);
        newItemModel.Quantity = Number(item.Quantity || 1);
        newItemModel.RevenuesAc = item.RevenuesAc;
        newItemModel.WhsCode = keepOrLines ? item.WhsCode : wareHouseTransaction?.WhsCode || _user?.Branch.ProjectCode;
        newItemModel.SWeight1 = Number(item.SWeight1 || 0);
        newItemModel.SWght1Unit = item.SWght1Unit || 3;
        // newItemModel.OnHand = item.OnHand || 0;
        newItemModel.InvntItem = item.InvntItem || 'Y';
        newItemModel.ManBtchNum = item.ManBtchNum || 'M';
        newItemModel.SalUnitMsr = item.SalUnitMsr || '';

        newItemModel.OpenQty = item.OpenQty ? item.OpenQty : '';
        newItemModel.AvgPrice = item.AvgPrice || 0;
        newItemModel.U_FMB_LineComment = item?.LineComment ?? '';
        newItemModel.ItmsGrpCod = item?.ItmsGrpCod ?? '';
        if (newItemModel.ManBtchNum === 'Y') { // Establecer los lotes al recuperar
            newItemModel.BatchNumbers = item.BatchNumbers ?? [];
        }
        newItemModel.Project = item?.Project || '';

        //#region CENTROS DE COSTOS

        //CENTRO DE COSTO 1
        // newItemModel.OcrCode = item.OcrdCode || '';
        newItemModel.OcrCode = item.OcrCode || '';
        //CENTRO DE COSTO 2
        // newItemModel.OcrCode2 = newOrderModel.OcrCode2 || '';
        newItemModel.OcrCode2 = item.OcrCode2 || '';
        //CENTRO DE COSTO 3
        newItemModel.OcrCode3 = item.OcrCode3 || '';
        //CENTRO DE COSTO 4
        newItemModel.OcrCode4 = item.OcrCode4 || '';
        //CENTRO DE COSTO 5
        newItemModel.OcrCode5 = item.OcrCode5 || '';

        // CAMPO PARA GASTOS ADMINISTRATIVOS Y GASTOS 
        newItemModel.isTemporary = item.isTemporary || false;
        newItemModel.ParentLineNum = item.ParentLineNum === 0 ? 0 : item.ParentLineNum || null;
        //#endregion CENTROS DE COSTOS

        //#region ######################## IVA DEFAULT ################################################
        // this its to try fix the issues that the price show with another tax 
        if ((!newOrderModel.TaxCode || newOrderModel.TaxCode === '') || (newOrderModel.TaxRate)) {
            await this.SetBranchOfficeTaxes(newOrderModel);
        }
        newItemModel.TaxCode = globalTax ? (newOrderModel.TaxCode || item.TaxCodeAR) : (item.TaxCodeAR || newOrderModel.TaxCode);
        newItemModel.TaxName = globalTax ? (newOrderModel.TaxName || item.TaxName) : (item.TaxName || newOrderModel.TaxName);
        newItemModel.TaxeRate = globalTax ? (newOrderModel.TaxRate || item.Rate) : (item.Rate || newOrderModel.TaxRate);
        newItemModel.U_FMB_AplicaMonedero = item.U_FMB_AplicaMonedero || 'N';
        newItemModel.U_FMB_VentaMonedero = item.U_FMB_VentaMonedero || 'N';
        newItemModel.U_FMB_ArtPromo = item.U_FMB_ArtPromo || 'N';

        //#endregion
        if (newItemModel.InvntItem === 'Y' && newItemModel.OnHand < newItemModel.NumInSale * newItemModel.Quantity) {
            showAlert({ type: "warning", message: "El artículo " + newItemModel.ItemCode + " ya no tiene existencia en el almacén seleccionado", timeOut: 5000 });
        }
        newItemModel.U_FMB_TypeDiscount = item.U_FMB_TypeDiscount || null;
        newItemModel.DISCOUNT_PERIOD_QTY = item.DISCOUNT_PERIOD_QTY || [];
        //#region ################## POINTS CARD ################ ✔

        if (points_Card && !newOrderModel.flagPointsCard && newItemModel.U_FMB_ArtPromo === 'Y' && newOrderModel.U_FMB_ValidoMonedero === 'Y') {
            showAlert({ type: "error", message: "Este es un artículo promocional y solo puede pagarse con puntos de monedero electrónico.", timeOut: 5000 });
            return;
        }
        if (points_Card && newOrderModel.flagPointsCard && newOrderModel.U_FMB_ValidoMonedero === 'Y') {
            if (newItemModel.U_FMB_ArtPromo === 'Y') {
                showAlert({ type: "warning", message: "Este es un artículo promocional. Solo se puede pagar con puntos de monedero electrónico.", timeOut: 5000 });
            }
            const isMonedero = newItemModel.U_FMB_VentaMonedero === 'Y';
            const hasMonedero = newOrderModel.Items.some(item => item.U_FMB_VentaMonedero === 'Y');
            const hasNormal = newOrderModel.Items.some(item => item.U_FMB_VentaMonedero !== 'Y');

            if (isMonedero && hasNormal) {
                showAlert({ type: "warning", message: "No puedes mezclar artículos de regalo con artículos normales. Retira los artículos actuales antes de agregar un artículo de regalo.", timeOut: 12000 });
                return;
            }

            if (!isMonedero && hasMonedero) {
                showAlert({ type: "warning", message: "No puedes mezclar artículos normales con artículos de regalo. Retira los artículos de regalo antes de agregar artículos normales.", timeOut: 12000 });
                return;
            }
        }
        //#endregion ################## POINTS CARD ################ ✔
        if (!ItemFromRecover) {
            const lastDiscount = newItemModel.DiscountPercent
            this.SetSpecialPrices(newItemModel)
            if (!newItemModel.SpecialDiscount) {
                this.SetDiscountPeriodAndQuantity(newItemModel)
                if (!newItemModel.U_FMB_TypeDiscount) {
                    newItemModel.DiscountPercent = lastDiscount
                }
            }
        }

        //#region Gas Cylinder Management
        newItemModel.U_RML_ENTCLNDRO = item.U_RML_ENTCLNDRO || "";
        newItemModel.U_RML_TIPO_CU = item.U_RML_TIPO_CU || "-";
        newItemModel.U_RML_CU = item.U_RML_CU || "0";
        //#endregion

        //#region ########## Billing Fields ##########
        newItemModel.U_BPP_OPER = item.U_BPP_OPER || "-";
        newItemModel.U_tipoOpT12 = item.U_tipoOpT12 || "-";
        let auxItemInfo = this.setItemIgvOptions(newItemModel);

        newItemModel.availableIgvOperationList = auxItemInfo?.availableIgvOperationList || [];
        newItemModel.U_STR_FECodAfect = item.U_STR_FECodAfect || "";
        newItemModel.U_tipoOpT12 = newItemModel.TaxCode === 'IGV' ? "01" : newItemModel.U_tipoOpT12;
        newItemModel.TaxStatus = ItemFromRecover ? (item?.TaxStatus ?? item?.VATLiable ?? 'N') : newItemModel.TaxCode === 'EXO' ? 'N' : item.VATLiable || 'N';
        newItemModel.TaxOnly = item.TaxOnly || 'N';
        //#endregion

        //#region Codigos de afectación
        let isIGV = !newItemModel?.TaxCode?.includes("EXO") && (newItemModel?.TaxCode?.includes("IGV") || newItemModel?.TaxName?.toUpperCase()?.includes("IGV"));
        let isEXO = newItemModel?.TaxCode?.includes("EXO") || newItemModel?.TaxName?.toUpperCase()?.includes("EXO") || newItemModel?.TaxName?.toUpperCase()?.includes("EXENTO");
        if (!ItemFromRecover && (isIGV || isEXO)) {
            newItemModel.U_BPP_OPER = operationList?.find(oper => isIGV ? oper?.Name?.toUpperCase() === 'AFECTA' : oper?.Name?.toUpperCase() === 'GRATUITA')?.Code || '-'; // Tipo de Operación
            let auxCode = null;
            if (isEXO && newItemModel?.U_BPP_OPER === 'G') { // Al ser exento el Código de Afectación debe de ser 15
                auxCode = 15;
            }
            const newOperation = await this.setItemIgvOptions(newItemModel, auxCode);
            newItemModel.availableIgvOperationList = newOperation?.availableIgvOperationList || [];
            newItemModel.U_STR_FECodAfect = newOperation?.U_STR_FECodAfect || ''; // Código de Afectación IGV
            newItemModel.U_tipoOpT12 = "01"; // Tipo de operacion
            newItemModel.TaxStatus = isIGV ? 'Y' : 'N'; // Sólo Impuesto
        }
        //#endregion Codigos de afectación

        //#region ########## DEFAULT TAXCODE ITEM ##########
        newItemModel.ItemTaxCodeName = item.ItemTaxCodeName
        newItemModel.ItemTaxCode = item.ItemTaxCode
        newItemModel.ItemRate = item.ItemRate
        //#endregion ########## DEFAULT TAXCODE ITEM ##########

        //#region Precio Llamagas
        try {
            const envasado = Envasados?.includes(Number(newItemModel?.ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(newItemModel?.ItmsGrpCod));

            if (!newItemModel?.isTemporary && !ItemFromRecover && (envasado || glpGranel)) {
                let data = {
                    CardCode: newOrderModel?.CardCode || "",
                    ItemCode: newItemModel?.ItemCode || "",
                    WhsCode: newItemModel.WhsCode || "",
                    ShipToCode: newOrderModel?.ShipToCode || newOrderModel?.ShipToDef || "", // Se manda el por defecto por la selección se hace al cobrar o crear el docuento
                    userFields: newOrderModel?.userFields || {},
                    Quantity: newItemModel?.Quantity || 0,
                    U_RS_CANTG: newItemModel?.U_RS_CANTG || 0,
                    U_RS_UMED: newItemModel?.U_RS_UMED || "",
                    U_RS_PRECIOGL: newItemModel?.U_RS_PRECIOGL || 0,
                    gallonsPrice: true,
                };

                //#region GALLON PRICE
                enableSpinner(true);
                let apiGallonsResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);
                const U_RS_PRECIO = apiGallonsResponse?.status === 1 ? Number(apiGallonsResponse?.data?.U_RS_PRECIO || 0) : 0;
                data.U_RS_PRECIOGL = U_RS_PRECIO;
                data.gallonsPrice = false;
                newItemModel.U_RS_PRECIOGL = U_RS_PRECIO;
                newItemModel.U_RS_TOTALGL = Number((Number(newItemModel?.U_RS_PRECIOGL || 0) * Number(newItemModel?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                //#endregion GALLON PRICE

                enableSpinner(true);
                const apiResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);
                if (apiResponse.status === 1) {
                    newItemModel.Price = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                    newItemModel.HomePrice = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                    showAlert({ type: 'info', message: `El precio del artículo ${newItemModel.ItemCode || newItemModel.ItemName} ha sido ajustado por el grupo de artículos al que pertenece`, timeOut: 5000 });
                } else {
                    newItemModel.Price = 0;
                    newItemModel.HomePrice = 0;
                    showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + item?.ItemCode, timeOut: 10000 });
                }
            }
        } catch (err) { }
        //#endregion Precio Llamagas

        //#region GALLONS CONVERSION
        newItemModel.U_RS_UMED = item.U_RS_UMED || '';
        newItemModel.U_RS_CANTG = Number(item.U_RS_CANTG || 0);
        newItemModel.U_RS_PRECIOGL = Number(item.U_RS_PRECIOGL || 0);
        if (development && !newItemModel?.U_RS_PRECIOGL) { // Temporal en lo que dicen como determinar el Precio Galones
            newItemModel.U_RS_PRECIOGL = 100;
        }
        newItemModel.U_RS_TOTALGL = Number(item.U_RS_TOTALGL || 0);
        newItemModel.U_RS_DENS = Number(item.U_RS_DENS || 0);
        try {
            if (newItemModel?.WhsCode && Granel?.includes(Number(newItemModel?.ItmsGrpCod))) {
                enableSpinner(true);
                const data = {
                    WhsCode: newItemModel?.WhsCode,
                };
                const apiResponse = await apiClient.getFactorConversion(data);
                enableSpinner(false);

                if (apiResponse?.status === 1) {
                    newItemModel.U_RS_DENS = Number(apiResponse?.data?.U_FMB_Factor_Conversion || 0);
                }
            }
        } catch (err) { }
        newItemModel.Gallons = item.U_RS_UMED === 'GLN';
        //#endregion GALLONS CONVERSION

        //#region DIMENSIONS
        if (!ItemFromRecover) {
            newItemModel.OcrCode = newOrderModel.Dimension1 || newItemModel.OcrCode || ''; // Determinado por el newOrderModel.GroupCode
            newItemModel.Dimension1 = newOrderModel.Dimension1 ? true : false;

            try {
                enableSpinner(true);
                const data = {
                    Type: 6,
                    filter1: newItemModel.WhsCode || '',
                    filter2: newItemModel.ItemCode || '',
                };
                const apiResponse = await apiClient.getDimensions(data);
                enableSpinner(false);

                if (apiResponse?.status === 1) {
                    newItemModel.OcrCode2 = apiResponse?.data?.Dimension2 || newItemModel.OcrCode2 || ''; // Determinado desde el almacén
                    newItemModel.OcrCode3 = apiResponse?.data?.Dimension3 || newItemModel.OcrCode3 || ''; // Determinado desde el almacén
                    newItemModel.OcrCode4 = apiResponse?.data?.Dimension4 || newItemModel.OcrCode4 || ''; // Determinado desde el artículo
                    newItemModel.OcrCode5 = apiResponse?.data?.Dimension5 || newItemModel.OcrCode5 || ''; // Determinado desde el artículo

                    newItemModel.Dimension2 = apiResponse?.data?.Dimension2 ? true : false;
                    newItemModel.Dimension3 = apiResponse?.data?.Dimension3 ? true : false;
                    newItemModel.Dimension4 = apiResponse?.data?.Dimension4 ? true : false;
                    newItemModel.Dimension5 = apiResponse?.data?.Dimension5 ? true : false;
                }
            } catch (err) { }
        } else {
            // Al recuperar si tiene un valor que no se cambie
            newItemModel.Dimension1 = newItemModel.OcrCode ? true : false;
            newItemModel.Dimension2 = newItemModel.OcrCode2 ? true : false;
            newItemModel.Dimension3 = newItemModel.OcrCode3 ? true : false;
            newItemModel.Dimension4 = newItemModel.OcrCode4 ? true : false;
            newItemModel.Dimension5 = newItemModel.OcrCode5 ? true : false;
        }
        //#region DIMENSIONS

        //#region OTHER CUFDS
        newItemModel.U_RS_GRUPO = item.U_RS_GRUPO ?? '';
        //#endregion OTHER CUFDS

        newOrderModel.Items.push(newItemModel);
        this.RefreshTotal(newOrderModel, keepOrLines);
        this.setState({
            itemSearch: "",
            itemSelected: newItemModel,
        });
        if (ItemFromRecover && newItemModel.ManBtchNum === 'Y') {
            this.ChangeQuantity(index, item.Quantity, newItemModel?.Gallons)
        }
    };
    isDateInRange = (current, start, end) => {
        const currentDate = new Date(current);
        const startDate = new Date(start);
        const endDate = new Date(end);

        currentDate.setHours(0, 0, 0, 0);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        return currentDate >= startDate && currentDate <= endDate;
    }

    isTimeInRange = (current, start, end) => {
        const currentTime = current.getHours() * 3600 + current.getMinutes() * 60 + current.getSeconds();
        const startTime = start.getHours() * 3600 + start.getMinutes() * 60 + start.getSeconds();
        const endTime = end.getHours() * 3600 + end.getMinutes() * 60 + end.getSeconds();

        return currentTime >= startTime && currentTime <= endTime;
    }
    isValidScheduleSpecialPrice = () => {
        const { ScheduleTime } = this.state
        let isValidSchedule = false
        if (!ScheduleTime.Active) return isValidSchedule
        const initDateTime = new Date(`${ScheduleTime.InitDate}T${ScheduleTime.InitTime}`);
        const endDateTime = new Date(`${ScheduleTime.EndDate}T${ScheduleTime.EndTime}`);
        const currentDateTime = new Date();
        const isInDateRange = this.isDateInRange(currentDateTime, initDateTime, endDateTime);
        const isInTimeRange = this.isTimeInRange(currentDateTime, initDateTime, endDateTime);

        if (isInDateRange && isInTimeRange) {
            isValidSchedule = true
        } else {
            isValidSchedule = false
        }

        return isValidSchedule
    }
    convertirHora(horaStr) {
        const [hh, mm, ss] = horaStr.split(":").map(Number);
        const ahora = new Date();
        ahora.setHours(hh, mm, ss, 0);
        return ahora;
    }
    SetDiscountPeriodAndQuantity = (newItemModel, fromChangeQty) => {
        const { notificationReducer: { showAlert } } = this.props;
        // return
        // newItemModel.U_FMB_TypeDiscount = null

        // if (newItemModel.DataChanged) return; //SI SE MODIFICA EL DESCUENTO SE DEBE MANTENER--QUE SIEMPRE NO

        if (newItemModel?.DISCOUNT_PERIOD_QTY?.length === 0 ?? true) {
            //AL CAMBIAR LA LISTA Y NO TIENE ESTE DESCUENTO, SE DEBE REINICIAR
            newItemModel.U_FMB_TypeDiscount = "";
            if (!fromChangeQty) { newItemModel.DiscountPercent = 0; }
            return;
        }
        const currDate = new Date();
        currDate.setHours(0, 0, 0, 0);

        newItemModel.DISCOUNT_PERIOD_QTY.forEach(period => {
            if (period?.LINENUM === -1 || !period?.FromDate || period?.Discount === 0 || period?.AutoUpdt !== 'Y') {
                return;
            }

            if (this.IsDateInRangeToDiscount(currDate, period.FromDate, period.ToDate)) {
                newItemModel.U_FMB_TypeDiscount = 'P';//DISCOUNT BY PERIOD
                newItemModel.DiscountPercent = parseFloat(period.Discount ?? 0);
                newItemModel.SpecPrice = 'P';

                const qtyDiscount = period.SPP2_Discount?.find(
                    qtyDiscount => qtyDiscount?.Amount > 0 && parseFloat(newItemModel.Quantity ?? 0) >= qtyDiscount.Amount
                );

                if (qtyDiscount) {
                    newItemModel.DiscountPercent = parseFloat(qtyDiscount.Discount ?? 0);
                    newItemModel.U_FMB_TypeDiscount = 'QTY';//DISCOUNT BY QUANTITY
                    newItemModel.SpecPrice = 'P';
                }
                if (fromChangeQty) {
                    showAlert({ type: "info", message: "Se ha aplicado un descuento por periodo o cantidad" });
                }
            }
        });
    }

    IsDateInRangeToDiscount(date, initDate, endDate) {
        const startDate = new Date(initDate.replace(/-/g, '/'));
        const finalDate = endDate ? new Date(endDate.replace(/-/g, '/')) : null;
        return date >= startDate && (!finalDate || date <= finalDate);
    }
    SetSpecialPrices = (newItemModel, fromChangeQty) => {
        newItemModel.U_FMB_TypeDiscount = "";
        if (!fromChangeQty) { newItemModel.DiscountPercent = 0; }

        const { SpecialPrices } = this.state
        const ItemCode = newItemModel.ItemCode

        // if (newItemModel.DataChanged) {
        //     newItemModel.SpecialDiscount = false;
        //     return;
        // }

        // if (newItemModel.SpecialDiscount) {
        //     newItemModel.DiscountPercent = 0;
        // }
        newItemModel.SpecialDiscount = false
        if (!SpecialPrices.OSPP) return
        if (!this.isValidScheduleSpecialPrice()) return
        const findOSPP = SpecialPrices.OSPP.find(ospp => ospp.ItemCode === ItemCode)

        if (findOSPP) {
            const findSPP1 = SpecialPrices.SPP1.find(spp1 => spp1.ItemCode === ItemCode)
            if (findSPP1) {
                const filteredItems = SpecialPrices.SPP2.filter(spp2 => spp2.ItemCode === ItemCode);
                const findSPP2Discount = filteredItems.find(filtered => newItemModel.Quantity >= filtered.Amount)
                if (findSPP2Discount) {
                    newItemModel.DiscountPercent = parseFloat(findSPP2Discount.Discount)
                    newItemModel.SpecialDiscount = true
                    newItemModel.SpecPrice = 'Y';
                } else {
                    newItemModel.DiscountPercent = parseFloat(findSPP1.Discount)
                    newItemModel.SpecialDiscount = true
                    newItemModel.SpecPrice = 'Y';
                }
            } else {
                newItemModel.DiscountPercent = parseFloat(findOSPP.Discount)
                newItemModel.SpecialDiscount = true
                newItemModel.SpecPrice = 'Y';
            }
        }
    }
    DeleteItem = async (itemIndex) => {
        const { newOrderModel } = this.state;
        let newOrder = JSON.parse(JSON.stringify(newOrderModel));
        if (!!newOrder.Items) {
            const item = newOrder.Items[itemIndex];
            const itemLineNum = Number(item.LineNum);
            const isChild = item.ParentLineNum !== undefined && item.ParentLineNum !== null && item.ParentLineNum !== '';
            let newItems = [];
            for (let index = 0; index < newOrder.Items.length; index++) {
                const current = newOrder.Items[index];
                const ln = Number(current.LineNum);
                const parentLn = current.ParentLineNum ?? null;

                if (isChild) {
                    if (ln !== itemLineNum) {
                        newItems.push(current);
                    }
                } else {
                    if (ln === itemLineNum || parentLn === itemLineNum) {
                        continue;
                    }
                    newItems.push(current);
                }
            }
            if (newItems.length === 0) {//CASO ESPECIAL, RECUPERA NM - ELIMINAS ITEMS - YA NO CAMBIA LOS PRECIOS
                await this.setState({
                    disableRecoverNM: false,
                });
            }
            newOrder.Items = newItems;
            await this.RefreshTotal(newOrder);
        }

        if (!newOrder.Items.length) {
            await this.setState({
                itemSelected: {},
                disableRecoverNM: false,
            });
        }
    };

    SelectItem = (index) => {
        const { newOrderModel } = this.state;
        let newItemModel = new NewItem();

        if (!!newOrderModel.Items) {
            newItemModel = newOrderModel.Items[index];
        }

        this.setState({
            itemSelected: newItemModel,
            itemIndex: index,
        });
    };
    ClearTypeDiscount = index => {
        const { newOrderModel } = this.state;
        newOrderModel.Items[index].DiscountPercentCopy = newOrderModel.Items[index].DiscountPercent
        newOrderModel.Items[index].TypeDiscountCopy = newOrderModel.Items[index].U_FMB_TypeDiscount
        newOrderModel.Items[index].U_FMB_TypeDiscount = null
        newOrderModel.Items[index].EditDiscount = true
    }
    ChangeQuantity = (index, value, Gallons = false) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        if (newOrderModel.Items[index].U_FMB_TypeDiscount && (newOrderModel.Items[index].BaseLine === null || newOrderModel.Items[index].BaseLine === undefined)) {
            showAlert({ type: "warning", message: 'No se puede modificar porque el artículo proviene de un documento recuperado y tiene un descuento por período o cantidad.', timeOut: 5000 });
            return;
        }
        if (isNaN(value)) {
            showAlert({ type: "warning", message: "Cantidad invalida", timeOut: 2000 });
            return;
        }
        if (Number(value) < 0) {
            showAlert({ type: "warning", message: `No puedes vender negativos`, timeOut: 2000 });
            return;
        }
        newOrderModel.Items[index].Quantity = value;
        // newOrderModel.Items[index].Price = Gallons ? Number(value || 0) > 0 ? Number(newOrderModel.Items[index].U_RS_TOTALGL || 0) / Number(value) : 0
        //     : newOrderModel.Items[index].Price;

        const parentLineNum = newOrderModel.Items[index].LineNum;
        const CU = newOrderModel.Items[index].U_RML_CU || 0;

        const childItems = newOrderModel.Items.filter(i => i.ParentLineNum === parentLineNum);

        childItems.forEach(child => {
            child.Quantity = Number(value) - Number(CU);
        });
        if (newOrderModel.Items[index].ParentLineNum !== null && newOrderModel.Items[index].ParentLineNum !== undefined) {
            const parentItem = newOrderModel.Items.find(i => i.LineNum === Number(newOrderModel.Items[index].ParentLineNum));
            if (parentItem) parentItem.Quantity = Number(value);
        }
        if (newOrderModel.Items[index].ManBtchNum === 'Y') {
            newOrderModel.Items[index].DocUoMQty = Number(value);
            newOrderModel.Items[index].OpenLneQty = Number(value) - Number(newOrderModel.Items[index].SnBUoMQty);
        }

        if (newOrderModel.Items[index].U_RML_ENTCLNDRO === "1") {
            newOrderModel.Items[index].U_RML_CU = Number(value || 0).toString();
        }

        const lastDiscount = newOrderModel.Items[index].DiscountPercent
        this.SetSpecialPrices(newOrderModel.Items[index])
        if (!newOrderModel.Items[index].SpecialDiscount) {
            this.SetDiscountPeriodAndQuantity(newOrderModel.Items[index])
            if (!newOrderModel.Items[index].U_FMB_TypeDiscount) {
                newOrderModel.Items[index].DiscountPercent = lastDiscount
            }
        } else { showAlert({ type: "info", message: "Se ha aplicado un descuento especial" }); }
        this.RefreshTotal(newOrderModel);
    };

    CheckQuantity = async (index) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { newOrderModel } = this.state;
        let itemQty = newOrderModel.Items[index].Quantity;
        let whitoutQ = false;
        if (itemQty === '') {
            showAlert({ type: "warning", message: `No puedes dejar la cantidad en vacía.`, timeOut: 2000 });
            newOrderModel.Items[index].Quantity = 1;
            whitoutQ = true;
        }
        if (Number(itemQty) === 0) {
            showAlert({ type: "warning", message: `No puedes dejar la cantidad en 0.`, timeOut: 2000 });
            newOrderModel.Items[index].Quantity = 1;
            whitoutQ = true;
        }
        if (whitoutQ && newOrderModel?.Items?.[index]?.Gallons) {
            newOrderModel.Items[index].U_RS_UMED = '';
            // newOrderModel.Items[index].U_RS_DENS = 0;
            newOrderModel.Items[index].U_RS_CANTG = 0;
            newOrderModel.Items[index].U_RS_TOTALGL = 0;
            newOrderModel.Items[index].Gallons = false;
            newOrderModel.Items[index].Price = newOrderModel.Items[index].HomePrice;
            showAlert({ type: "warning", message: `Al artículo ${newOrderModel.Items[index].ItemCode || ''} se le ha quitado la conversión de galones ya que no se puede dejar la cantidad en 0.`, timeOut: 10000 });
        }

        const item = newOrderModel.Items[index];
        const finalQuantity = Number(newOrderModel.Items[index].Quantity || 0);

        if (item.U_RML_ENTCLNDRO === "2") {
            const currentCU = Number(item.U_RML_CU || 0);
            if (currentCU >= finalQuantity) {
                item.U_RML_ENTCLNDRO = "1";
                item.U_RML_CU = finalQuantity.toString();
                await this.changeContract(index, "-", true);
                showAlert({ type: 'info', message: 'Al cambiar la cantidad se ha ajustado la cantidad de cilindros vacíos devueltos, ¿entrega cilindro? se cambió a SI.', timeOut: 6000 });
            }
        } else if (item.U_RML_ENTCLNDRO === "1") {
            item.U_RML_CU = finalQuantity.toString();
        }

        const parentLineNum = newOrderModel.Items[index].LineNum;
        const CU = newOrderModel.Items[index].U_RML_CU || 0;

        const childItems = newOrderModel.Items.filter(i => i.ParentLineNum === parentLineNum);

        childItems.forEach(child => {
            child.Quantity = Number(itemQty) - Number(CU);
        });
        if (newOrderModel.Items[index].ParentLineNum !== null && newOrderModel.Items[index].ParentLineNum !== undefined) {
            const parentItem = newOrderModel.Items.find(i => i.LineNum === Number(newOrderModel.Items[index].ParentLineNum));
            if (parentItem) parentItem.Quantity = itemQty;
        }
        //#region Precio Llamagas
        try {
            const envasado = Envasados?.includes(Number(newOrderModel.Items[index]?.ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(newOrderModel.Items[index]?.ItmsGrpCod));
            const anticipo = isAnticipo(newOrderModel.Items[index].ItemCode)
            if (!newOrderModel.Items[index]?.isTemporary && (envasado || glpGranel) && !anticipo) {
                let data = {
                    CardCode: newOrderModel?.CardCode || "",
                    ItemCode: newOrderModel.Items[index]?.ItemCode || "",
                    WhsCode: newOrderModel.Items[index].WhsCode || "",
                    ShipToCode: newOrderModel?.ShipToCode || newOrderModel?.ShipToDef || "", // Se manda el por defecto por la selección se hace al cobrar o crear el docuento
                    userFields: newOrderModel?.userFields || {},
                    Quantity: Number(itemQty ?? 0),
                    U_RS_CANTG: newOrderModel.Items[index]?.U_RS_CANTG || 0,
                    U_RS_UMED: newOrderModel.Items[index]?.U_RS_UMED || "",
                    U_RS_PRECIOGL: newOrderModel.Items[index]?.U_RS_PRECIOGL || 0,
                    gallonsPrice: true,
                };

                //#region GALLON PRICE
                enableSpinner(true);
                let apiGallonsResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);
                const U_RS_PRECIO = apiGallonsResponse?.status === 1 ? Number(apiGallonsResponse?.data?.U_RS_PRECIO || 0) : 0;
                data.U_RS_PRECIOGL = U_RS_PRECIO;
                data.gallonsPrice = false;
                newOrderModel.Items[index].U_RS_PRECIOGL = U_RS_PRECIO;
                newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                //#endregion GALLON PRICE

                enableSpinner(true);
                const apiResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);

                if (apiResponse.status === 1) {
                    newOrderModel.Items[index].Price = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                    newOrderModel.Items[index].HomePrice = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                    showAlert({ type: 'info', message: `El precio del artículo ${newOrderModel.Items[index].ItemCode || newOrderModel.Items[index].ItemName} ha sido ajustado al cambiar la cantidad`, timeOut: 5000 });
                } else {
                    newOrderModel.Items[index].Price = 0;
                    newOrderModel.Items[index].HomePrice = 0;
                    showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + newOrderModel.Items[index]?.ItemCode, timeOut: 10000 });
                }
            }
        } catch (err) { }
        //#endregion Precio Llamagas
        this.RefreshTotal(newOrderModel);
    }
    changeVatPrice = async (index, value) => {
        const { newOrderModel } = this.state;
        newOrderModel.Items[index].PriceAfterVAT = value;
        await this.refreshModel(newOrderModel)
    }
    ChangeItemPrice = async (index, value, onblurPrice) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        if (newOrderModel.Items[index].U_FMB_TypeDiscount) {
            showAlert({ type: "warning", message: 'No se puede modificar porque el artículo cuenta con descuento por período o cantidad', timeOut: 5000 });
            return;
        }
        if (isNaN(value) || Number(value) < 0) {
            showAlert({ type: "error", message: 'Ingresa un valor valido.', timeOut: 5000 });
            return;
        }
        const cachePrice = newOrderModel.Items[index].HomePrice;
        if (Number(value) <= Number(cachePrice)) {
            newOrderModel.Items[index].Price = cachePrice;
            this.RefreshTotal(newOrderModel);
            return
        }
        if (onblurPrice) {
            value = Number(value).toFixed(2);
        }
        newOrderModel.Items[index].Price = value == 0 ? 0.1 : value;
        newOrderModel.Items[index].DataChanged = true;
        newOrderModel.Items[index].SpecPrice = 'N';
        newOrderModel.Items[index].PriceAfterVAT = null;
        this.RefreshTotal(newOrderModel);
    };


    ChangeDiscountPercent = async (index, value, onblurPrice) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, maxDiscount } = this.state;
        if (newOrderModel.Items[index].U_FMB_TypeDiscount) {
            showAlert({ type: "warning", message: 'No se puede modificar porque el artículo cuenta con descuento por período o cantidad', timeOut: 5000 });
            return;
        }
        if (isNaN(value) || Number(value) < 0) {
            showAlert({ type: "error", message: 'Ingresa un valor valido.', timeOut: 5000 });
            return;
        }
        if (onblurPrice) {

            value = Number(value).toFixed(2);

        }
        newOrderModel.Items[index].DiscountPercent = Number(value) > maxDiscount ? maxDiscount : Number(value);
        newOrderModel.Items[index].DataChanged = true
        newOrderModel.Items[index].SpecPrice = 'N';
        this.RefreshTotal(newOrderModel);
    }

    ChangeItemName = async (value, index) => {
        const { newOrderModel } = this.state;
        newOrderModel.Items[index].ItemName = value;
        await this.setState({
            newOrderModel
        });
    }

    ChangeShowWithStock = async () => {
        await this.setState({
            ShowWithStock: !this.state.ShowWithStock
        })
        await this.FilterStockSuggestions(this.state.ShowWithStock)
    }

    ChanceTemporalDataToFalse = async () => {
        await this.setState({
            showTemporalData: false
        })
    }

    ChangeShowTemporalData = async () => {
        const { updatebusinessPartner, newOrderModel, auxNewOrderModel } = this.state
        await this.setState({
            showTemporalData: !this.state.showTemporalData
        })
        if (!this.state.showTemporalData && this.state.showTemporalData !== null) {
            // back info to origin
            //RFC
            newOrderModel.LicTradNum = updatebusinessPartner.LicTradNum;
            updatebusinessPartner.LicTradNum = this.state.auxNewOrderModel.LicTradNum;
            //CARD_NAME
            newOrderModel.CardName = auxNewOrderModel.CardName;
            updatebusinessPartner.CardName = this.state.auxNewOrderModel.CardName;
            //USO_CFDI
            newOrderModel.USOCFDI = auxNewOrderModel.USOCFDI;
            updatebusinessPartner.U_FMB_USO_CFDI = this.state.auxNewOrderModel.USOCFDI;
            //REGIMEN FISCAL
            newOrderModel.RegimenFiscal = auxNewOrderModel.RegimenFiscal;
            updatebusinessPartner.U_FMB_REGIMEN_FISCAL = this.state.auxNewOrderModel.RegimenFiscal;
            //TAXES
            newOrderModel.TaxCode = auxNewOrderModel.TaxCode;
            updatebusinessPartner.TaxCode = this.state.auxNewOrderModel.TaxCode;
            newOrderModel.TaxName = auxNewOrderModel.TaxName;
            updatebusinessPartner.TaxName = this.state.auxNewOrderModel.TaxName;
            newOrderModel.TaxRate = auxNewOrderModel.TaxRate;
            updatebusinessPartner.TaxRate = this.state.auxNewOrderModel.TaxRate;
            //MÉTODO DE PAGO
            newOrderModel.GroupNum = auxNewOrderModel.GroupNum;
            updatebusinessPartner.GroupNum = this.state.auxNewOrderModel.GroupNum;
            //CREDITO
            newOrderModel.CreditLine = auxNewOrderModel.CreditLine;
            updatebusinessPartner.CreditLine = this.state.auxNewOrderModel.CreditLine;
            //TELEFONO
            newOrderModel.Cellular = auxNewOrderModel.Cellular;
            updatebusinessPartner.Cellular = this.state.auxNewOrderModel.Cellular;
            //EMAIL
            newOrderModel.E_mail = auxNewOrderModel.E_mail;
            updatebusinessPartner.E_mail = this.state.auxNewOrderModel.E_mail;
            await this.setState({
                updatebusinessPartner,
                newOrderModel: newOrderModel
            })


        }
    }

    FilterStockSuggestions = async (onlyWithStock) => {
        const { suggestionsCopy } = this.state
        const withStock = suggestionsCopy.filter((element) => Number(element.OnHand) !== 0);

        await this.setState({
            suggestions: onlyWithStock ? withStock : suggestionsCopy,
        })
    }

    checkItemPrices = async (changeDireciton = false, changePartner = false, changeTypeofSell = false, flagU_FMB_AttentionType = false, U_FMB_AttentionType = '', flagU_RS_TIPOV = false, U_RS_TIPOV = '') => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { newOrderModel, } = this.state;
        let checkPrice = false;
        if (!newOrderModel?.CardCode) {
            return;
        }
        for (let index = 0; index < newOrderModel?.Items?.length; index++) {
            let newItemModel = newOrderModel?.Items[index];
            let searchItem = newItemModel?.ItemCode;
            const envasado = Envasados?.includes(Number(newItemModel?.ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(newItemModel?.ItmsGrpCod));

            if (newItemModel?.isTemporary || !searchItem || (!envasado && !glpGranel)) {
                continue;
            }

            let data = {
                CardCode: newOrderModel?.CardCode || "",
                ItemCode: searchItem || "",
                WhsCode: newItemModel?.WhsCode || "",
                ShipToCode: newOrderModel?.ShipToCode || newOrderModel?.ShipToDef || "",
                userFields: newOrderModel?.userFields || {},
                Quantity: newItemModel?.Quantity || 0,
                U_RS_CANTG: newItemModel?.U_RS_CANTG || 0,
                U_RS_UMED: newItemModel?.U_RS_UMED || "",
                U_RS_PRECIOGL: newItemModel?.U_RS_PRECIOGL || 0,
                gallonsPrice: true,
            };

            //#region GALLON PRICE
            enableSpinner(true);
            let apiGallonsResponse = await apiClient.getPriceListLlama(data);
            enableSpinner(false);
            const U_RS_PRECIO = apiGallonsResponse?.status === 1 ? Number(apiGallonsResponse?.data?.U_RS_PRECIO || 0) : 0;
            data.U_RS_PRECIOGL = U_RS_PRECIO;
            data.gallonsPrice = false;
            newItemModel.U_RS_PRECIOGL = U_RS_PRECIO;
            newItemModel.U_RS_TOTALGL = Number((Number(newItemModel?.U_RS_PRECIOGL || 0) * Number(newItemModel?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
            //#endregion GALLON PRICE

            enableSpinner(true);
            const apiResponse = await apiClient.getPriceListLlama(data);
            enableSpinner(false);

            const U_RS_CALCULADO = apiResponse?.status === 1 ? Number(apiResponse?.data?.U_RS_CALCULADO || 0) : 0;
            checkPrice = true;
            newItemModel.HomePrice = U_RS_CALCULADO;
            newItemModel.Price = U_RS_CALCULADO;
            if (glpGranel && newItemModel?.U_RS_UMED === 'GLN' && Number(newItemModel?.U_RS_CANTG) > 0) {
                newItemModel = await this.checkGallons(newItemModel, index)
            } else {
                if (apiResponse?.status === 1) {
                    showAlert({ type: 'info', message: `El precio del artículo ${searchItem || newItemModel?.ItemName || ''} ha sido ajustado al cambiar ${changeDireciton ? 'la dirección' : changePartner ? 'de socio' : changeTypeofSell ? 'el Tipo de Venta' : 'el Tipo de Atención'}.`, timeOut: 10000 });
                } else {
                    showAlert({ type: 'error', message: `No se pudo determinar el precio del artículo ${searchItem || newItemModel?.ItemName || ''} al cambiar ${changeDireciton ? 'la dirección' : changePartner ? 'de socio' : changeTypeofSell ? 'el Tipo de Venta' : 'el Tipo de Atención'}.`, timeOut: 10000 });
                }
            }
        }
        if (checkPrice) {
            await this.RefreshTotal(newOrderModel);
        }
        return checkPrice;
    }

    //#endregion

    //#region ########## SHOW MODALS #####################################################
    ShowInitialCash = async () => {
        await this.setState({
            showInitialCashModal: !this.state.showInitialCashModal,
        });

        $("#initialCashModal").modal("show");
    };

    ShowBillModal = async () => {
        const { isCancel } = this.state;
        await this.setState({ showBillModal: isCancel || !this.state.showBillModal });
    };

    CloseBillModal = async (ticket) => {
        let { newOrderModel, _user } = this.state;
        const partner = _user.Partner;
        newOrderModel.TotalRestante = 0;

        if (ticket) {
            newOrderModel = new NewOrderSales();
            newOrderModel.TaxCode = partner.TaxCode;
            newOrderModel.TaxName = partner.TaxName;
            newOrderModel.TaxRate = partner.Rate;
            newOrderModel.CardCode = partner.CardCode;
            newOrderModel.CardName = partner.CardName;
            newOrderModel.PriceListNum = partner.ListNum;
            newOrderModel.ShipToDef = partner.ShipToDef;
            newOrderModel.BillToDef = partner.BillToDef;
            newOrderModel.LicTradNum = partner.LicTradNum;
            newOrderModel.userFields = this.resetUserFields();
        }

        await this.setState({
            newOrderModel,
            showBillModal: false,
            itemSelected: {},
            showrefund: false,
            disableRecover: false,
            disableRecoverQT: false,
            editModePartner: false,
            ItsComingFromModifiedPartner: false,
            handedCasco: 1,

        });
    };

    RestartCounter = async () => {
        let { newOrderModel, _user } = this.state;
        const partner = _user?.Partner;

        newOrderModel = new NewOrderSales();
        newOrderModel.TaxCode = partner.TaxCode;
        newOrderModel.TaxName = partner.TaxName;
        newOrderModel.TaxRate = partner.Rate;
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;
        newOrderModel.PriceListNum = partner.ListNum;
        newOrderModel.ShipToDef = partner.ShipToDef;
        newOrderModel.BillToDef = partner.BillToDef;
        newOrderModel.LicTradNum = partner.LicTradNum;
        newOrderModel.userFields = this.resetUserFields();

        await this.setState({
            newOrderModel,
            showBillModal: false,
            itemSelected: {},
            showrefund: false,
            disableRecover: false,
            disableRecoverQT: false,
            editModePartner: false,
            ItsComingFromModifiedPartner: false,
            RelatedPayMethodsByDoc: [],
            // 
            DownPayments: [],  // no esta 
            isCancel: false, // no esta 
            CreditNotes: [], //
            itsInterOpDoc: false,
            recoverDocument: false,
            ItsRecoverAuthoriInvoice: false,
            showBatchSelectionModal: false,
            recoverInterOpTypeDoc: '',
            FailedRequestDocument: false,
            WasUpdatedPartner: false,
            updatebusinessPartner: new BusinessPartnerPS(),
            auxRecoverDocData: null,
            showTemporalData: false,
            disableRecoverNM: false,
            recoveredQuoteOperation: null,
            recoveredQuote: false,
            handedCasco: 1,
        })
        await this.SetBranchOfficeTaxes(newOrderModel);
    }

    CloseRefundModal = async () => {
        let { newOrderModel, _user } = this.state;
        let partner = _user?.Partner;
        newOrderModel.TotalRestante = 0;

        newOrderModel = new NewOrderSales();
        newOrderModel.TaxCode = partner.TaxCode;
        newOrderModel.TaxName = partner.TaxName;
        newOrderModel.TaxRate = partner.Rate;
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;
        newOrderModel.PriceListNum = partner.ListNum;
        newOrderModel.ShipToDef = partner.ShipToDef;
        newOrderModel.BillToDef = partner.BillToDef;
        newOrderModel.userFields = this.resetUserFields();

        await this.setState({
            newOrderModel,
            showRefundModal: false,
            itemSelected: {},
            pedido: '',
            itsCancelCFDIAvailable: false,
            relatedDocs: [],
        });
        await this.CheckWorkSession();
        await this.SetBranchOfficeInfo();
        await this.SetCounterPermissions();
    };

    ShowRefundModal = async () => {
        let { newOrderModel } = this.state;
        newOrderModel.Items = [];
        newOrderModel.CardCode = '';
        newOrderModel.CardName = '';
        newOrderModel.TotalRestante = 0;
        newOrderModel.AuxViewCounter = 'RefundModal';
        await this.setState({
            showRefundModal: !this.state.showRefundModal,
            pedido: '',
        });
        await this.refreshModel(newOrderModel)
    };

    ShowWithdrawalModal = async () => {
        await this.setState({
            showWithdrawalModal: !this.state.showWithdrawalModal,
        });
    };

    ShowRefMoveCashModal = async () => {
        await this.setState({
            showRefMoveCashModal: !this.state.showRefMoveCashModal
        })
    }

    ShowInventoryModal = async () => {
        await this.setState({
            showInventoryModal: !this.state.showInventoryModal,
        });
    };

    ShowSalesModal = async () => {
        await this.setState({
            showSalesModal: !this.state.showSalesModal,
        });
    };

    ShowCashCutModal = async () => {
        await this.setState({
            showCashCutModal: !this.state.showCashCutModal,
        });
        if (this.state.showCashCutModal) await this.GetBoxCut();
    };

    ShowSavedSalesModal = async () => {
        await this.setState({
            showSavedSalesModal: !this.state.showSavedSalesModal,
        });
        if (this.state.showSavedSalesModal === true) {
            await this.GetSavedSales(2);
        } else {
            this.CleanSavesSale()
        }

    };

    ShowSearchModal = async () => {
        await this.setState({
            showSearchModal: !this.state.showSearchModal,
        });
    };

    EnableClientsModal = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { recoveredQuoteOperation, showClientsModal } = this.state;

        if (recoveredQuoteOperation === 1) {
            showAlert({ type: "warning", message: "¡No puede cambiar de cliente en el modo edición!", timeOut: 5000 });
            return;
        }

        await this.setState({
            showClientsModal: !showClientsModal,
        });
    };

    ShowRefSaleModal = async () => {
        const { enableSpinner } = this.props;
        const { newOrderModel, FailedRequestDocument } = this.state
        await this.setState({
            showRefSaleModal: !this.state.showRefSaleModal,
        });

        if (FailedRequestDocument) {
            await this.setState({
                NextStepFunction: () => {
                    $('#detailClientModal').modal('hide');
                    this.CreateDocument();
                },
                ContinueWithoutSave: () => {
                    $('#detailClientModal').modal('hide');
                    this.CreateDocument();
                }
            });
            $("#detailClientModal").modal("show");

        } else {
            const isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                // the client ask show the info about customer to custom before send to cash register
                enableSpinner(true);
                const getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                await this.GetPartnerAddresses(newOrderModel.CardCode);
                enableSpinner(false);

                await this.setState({
                    updatebusinessPartner: getPartnersResponse.data[0],
                    NextStepFunction: () => {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    },
                    ContinueWithoutSave: () => {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    }
                });
                $("#detailClientModal").modal("show");
            }
        }

    }

    ShowTaxesModal = async () => {
        // const { newOrderModel } = this.state;
        // await this.SetBranchOfficeTaxes(newOrderModel);
        // setTimeout(async () => {
        //     this.RefreshTotal(newOrderModel);
        // }, 1500);
    };

    RequestTaxes = async () => {
        const { enableSpinner } = this.props;
        const { _user } = this.state;
        let taxesList = [];
        enableSpinner(true);
        const getTaxesResponse = await apiClient.getTaxesList('AR');
        enableSpinner(false);


        if (getTaxesResponse.status === 1 && _user?.Branch.IsBorder !== '') {
            let auxTaxes = [];
            if (_user?.Branch.IsBorder === 'Y') { // si eres frontera
                auxTaxes = getTaxesResponse.data.filter((element) => Number(element.Rate) !== 16);
            } else if (_user?.Branch.IsBorder === 'N') { // si no eres frontera
                auxTaxes = getTaxesResponse.data.filter((element) => Number(element.Rate) !== 8);
            }

            taxesList = auxTaxes.length === 0 ? getTaxesResponse.data : auxTaxes
        }


        return taxesList
    }

    ShowSelectAddressModal = async () => {
        await this.setState({
            showSelectAddressModal: !this.state.showSelectAddressModal,
        });
    };

    ShowFormatQuotationModal = async () => {
        await this.setState({
            showFormatQuotationModal: !this.state.showFormatQuotationModal,
        });
    }

    ShowDeliverModal = async () => {
        const { newOrderModel } = this.state
        const { notificationReducer: { showAlert } } = this.props;
        showAlert({
            type: "warning",
            message: "Ahora las entregas se realizan desde aquí",
            timeOut: 2000,
        });
        this.props.history.push('/deliver');
        // if (!this.state.showDeliverModal === true) {
        //     newOrderModel.CardCode = '';
        //     newOrderModel.CardName = '';
        //     newOrderModel.Items = [];
        //     await this.RefreshOrder(newOrderModel)
        // }
        // await this.setState({
        //     showDeliverModal: !this.state.showDeliverModal,
        // });
    }

    ShowFormatOrderSaleModal = async () => {
        await this.setState({
            showFormatOrderSaleModal: !this.state.showFormatOrderSaleModal,
        });

    }

    ShowFormatInvoiceModal = async () => {
        await this.setState({
            showFormatInvoiceModal: !this.state.showFormatInvoiceModal,
        });
    }

    ShowPDFViewer = async () => {
        await this.setState({
            showPDFViewer: !this.state.showPDFViewer,
        });
        this.CloseBillModal()
    };

    ShowSearchStockModal = async (boolValue) => {
        await this.setState({
            showSearchStockModal: boolValue
        });
    }

    ShowBeforeExit = async () => {
        const { newOrderModel } = this.state;
        if (newOrderModel.Items.length !== 0) {
            await this.setState({
                showBeforeExit: !this.state.showBeforeExit
            });
        } else {
            this.props.history.push('/');
        }

    }

    ShowDeleteAll = async () => {
        const { newOrderModel } = this.state;
        if (newOrderModel.Items.length !== 0) {
            await this.setState({
                showDeleteAll: !this.state.showDeleteAll,
            });
        } else {
            this.RestartCounter();
        }
    }

    EnableCommentsModal = async () => {
        await this.setState({
            showCommentsModal: !this.state.showCommentsModal,
        });
    };

    EnableShowRefundOfPaymentsModal = async () => {
        await this.setState({
            ShowRefundOfPaymentsModal: !this.state.ShowRefundOfPaymentsModal,
        });
    };

    ShowBatchDefinitionModal = async () => {
        await this.setState({
            showBatchDefinitionModal: !this.state.showBatchDefinitionModal,
        });
    };

    ShowAdvancePaymentInvoicesModal = async () => {
        await this.setState({
            showAdvancePaymentInvoicesModal: !this.state.showAdvancePaymentInvoicesModal,
        });
    };

    ShowFormatAdvancePayment = async () => {
        await this.setState({
            showFormatAdvancePayment: !this.state.showFormatAdvancePayment,
        });
    };

    OpenSendMailModal = () => {
        $("#pdfSendMailModal").modal("show");
    }

    ChangeVMQuotation = async () => {
        await this.setState({
            showVMQuotation: !this.state.showVMQuotation
        })
    }

    EnableMoneyMovementsModal = async () => {
        await this.setState({
            enableMoneyMovements: !this.state.enableMoneyMovements
        })
    }

    EnableGrossProfitModal = async (boolValue) => {
        await this.setState({
            EnableGrossProfitModal: boolValue
        });
    }


    //#region SAVE SALE FOR LATER
    ChangeIconSaveSale = async (iconChange) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;

        if (!newOrderModel.Items.length) {
            showAlert({
                type: "warning",
                message: "No tienes artículos para guardar",
                timeOut: 2000,
            });
            return;
        }

        await this.setState({
            showSaveForLater: !this.state.showSaveForLater,
        });
        let icon = document.getElementById('saveSale');
        if (iconChange === true) {
            icon.classList.add('fa-bookmark');
            icon.classList.add('saved');
            icon.classList.remove('fa-bookmark-o');
            icon.classList.remove('notSaved');
        } else {
            icon.classList.remove('fa-bookmark');
            icon.classList.remove('saved');
            icon.classList.add('fa-bookmark-o');
            icon.classList.add('notSaved');
        }

    }

    SaveForLater = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, idWorkShift } = this.state;
        let icon = document.getElementById('saveSale');
        let table = this.selectTable(newOrderModel.ObjType);
        newOrderModel.idSession = idWorkShift;
        newOrderModel.OriginDoc = 'Counter-SaveForLater';
        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: newOrderModel,
            UserTime: moment().format("HH:mm:ss"),
            isDraft: true,
            ClientVersion: currentVersion
        };

        enableSpinner(true);
        let createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud " + createDocumentResponse.message, timeOut: 5000 });
            await this.setState({
                showSaveForLater: false,
            });
            icon.classList.remove('fa-bookmark');
            icon.classList.remove('saved');
            icon.classList.add('fa-bookmark-o');
            icon.classList.add('notSaved');
            return;
        }

        showAlert({
            type: "success",
            message: "La venta se guardo correctamente para después: " + createDocumentResponse.data.createdFolio,
            timeOut: 5000,
        });

        newOrderModel.DocNum = createDocumentResponse.data.DocNum;
        newOrderModel.DocTime = data.UserTime || createDocumentResponse.data.DocTime;
        newOrderModel.Items = [];
        this.RefreshTotal(newOrderModel);

        icon.classList.remove('fa-bookmark');
        icon.classList.remove('saved');
        icon.classList.add('fa-bookmark-o');
        icon.classList.add('notSaved');

        await this.setState({
            newOrderModel,
            showSaveForLater: false,
            itemSelected: {},
        });

    };
    //#endregion

    ChangeTaxCode = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, taxList, iItemTax } = this.state;

        if (value === '') {
            showAlert({ type: "warning", message: "SELECCIONA UN VALOR VALIDO POR FAVOR" });
            newOrderModel.TaxCode = '';
            await this.RefreshOrder(newOrderModel);
            return;
        } else if (globalTax) {
            const tax = await taxList.find((tax) => tax.Code === value);
            newOrderModel.TaxCode = tax.Code;
            newOrderModel.TaxName = tax.Name;
            newOrderModel.TaxRate = tax.Rate;

            for (let index = 0; index < newOrderModel.Items.length; index++) {
                let item = newOrderModel.Items[index];
                item.TaxeRate = tax.Rate;
                item.TaxCode = tax.Code;
            }
            await this.RefreshOrder(newOrderModel);
            await this.RefreshTotal(newOrderModel);
        } else if (iItemTax === 0 || !!iItemTax) {
            const tax = await taxList.find((tax) => tax.Code === value);
            let item = newOrderModel.Items[iItemTax];

            item.TaxCode = tax.Code;
            item.TaxName = tax.Name;
            item.TaxeRate = tax.Rate;
            item = this.setItemIgvOptions(item);

            await this.RefreshTotal(newOrderModel);
        }

    }

    ChangePriceList = async (value, ComingFromGrossProfit = false) => {
        const { newOrderModel, _user } = this.state;
        if (value === '') return
        let price = _user?.PriceList.find((price) => price.ListNum === Number(value));
        if (price) {
            newOrderModel.PriceListNum = price.ListNum;
            await this.setState({
                newOrderModel
            });
        }
        await this.UpdateItemsPrice(ComingFromGrossProfit);
    }

    CancelPayment = async () => {
        const { newOrderModel } = this.state

        await this.setState({
            isCancel: true,
            DownPayments: [],
            CreditNotes: [],
            showBillModal: false
        });
        // newOrderModel.PaymentsToSale = []; // original line
        // new 2 code lines
        const auxPaymentsArray = newOrderModel.PaymentsToSale.filter((payment) => payment.SuccessTerminal === true);
        newOrderModel.PaymentsToSale = auxPaymentsArray;
        newOrderModel.PaymentsToReturn = [];
        this.RefreshOrder(newOrderModel);
        await this.RefreshTotal(newOrderModel);
        await this.SumOfAmounts();
    };

    SumOfAmounts = async () => {
        const { newOrderModel, PaymentSaleModel } = this.state;
        let totalAmount = 0;
        for (const payAdded of newOrderModel.PaymentsToSale) {
            if (Number(payAdded.TypeMethod) !== 117) {
                totalAmount = totalAmount + Number(payAdded.Amount);
            }
        }

        newOrderModel.TotalRecibido = totalAmount;
        newOrderModel.TotalRestante = totalAmount ? (totalAmount - newOrderModel.Total) > 0 ? totalAmount - newOrderModel.Total : 0 : 0;
        newOrderModel.RemainingAmount = parseFloat(Number(newOrderModel.Total) - Number(totalAmount)).toFixed(2);

        PaymentSaleModel.Amount = Number(newOrderModel.RemainingAmount)

        await this.RefreshOrder(newOrderModel);
        await this.RefreshPaymentSaleModel(PaymentSaleModel);
    }

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    ShowBlindCashCut = async () => {
        await this.setState({
            blindCashCut: !this.state.blindCashCut,
        });
    };

    //#endregion

    //#region ########## PARTNERS ########################################################

    ChangePartnerSearch = async (value) => {
        this.setState({
            partnerSearch: value,
        });
    };

    SearchPartners = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { partnerSearch } = this.state;

        if (!partnerSearch || partnerSearch.length < 2) {
            showAlert({ type: "warning", message: "Cliente no encontrado" });
            await this.setState({
                suggestions: [],
            });
            return;
        }

        enableSpinner(true);
        const getPartnersResponse = await apiClient.SearchPartner(partnerSearch);
        enableSpinner(false);

        if (!Array.isArray(getPartnersResponse.data)) {
            showAlert({ type: "error", message: getPartnersResponse.message });
            return;
        }

        if (getPartnersResponse.data.length === 0) {
            showAlert({ type: "info", message: getPartnersResponse.message ?? '' });
            return;
        }

        if (getPartnersResponse.data.length === 1) {
            $("#clientsModal").modal("hide");
            let updatePartner = getPartnersResponse.data[0] || new BusinessPartnerPS();
            updatePartner.billAddress = new BillAddress();
            updatePartner.shipAddress = new ShipAddress();

            await this.setState({
                businessPartners: getPartnersResponse.data,
                updatebusinessPartner: updatePartner,
                showClientsModal: false,
            });
            await this.SelectBusinessPartner();

        } else {
            this.setState({
                businessPartners: getPartnersResponse.data,
            });
        }
    };

    SelectPartnerIndex = async (index) => {
        const { businessPartners } = this.state;
        businessPartners[index].CreditLine = Number(businessPartners[index].CreditLine).toFixed(2);
        await this.setState({
            partnerIndex: index,
            updatebusinessPartner: businessPartners[index],

        });
        this.GetPartnerAddresses(this.state.updatebusinessPartner.CardCode);
    };
    ResetSpecialPrices = () => {
        const { newOrderModel } = this.state
        const auxModel = { ...newOrderModel }
        const auxItems = auxModel?.Items ?? []
        if (auxItems?.length > 0 ?? false) {
            for (let index = 0; index < auxItems.length; index++) {
                const item = auxItems[index];
                const lastDiscount = item.DiscountPercent
                this.SetSpecialPrices(item)
                if (!item.SpecialDiscount) {
                    this.SetDiscountPeriodAndQuantity(item);
                    if (!item.U_FMB_TypeDiscount) {
                        item.DiscountPercent = lastDiscount
                    }
                }
            }
            auxModel.Items = auxItems
            this.RefreshTotal(auxModel);
        }

    }
    getSpecialPrices = async (CardCode) => {
        const { enableSpinner } = this.props
        const currentDate = new Date();
        const hours = currentDate.getHours();   // Hora local
        const minutes = currentDate.getMinutes(); // Minutos locales
        const seconds = currentDate.getSeconds(); // Segundos locales 

        const Time = {
            hours,
            minutes,
            seconds
        }
        enableSpinner(true)
        let responseSpecPrice = await apiClient.getProductSpecialPrice(CardCode, Time)
        enableSpinner(false)
        if (responseSpecPrice.status === SERVICE_RESPONSE.SUCCESS) {
            responseSpecPrice = responseSpecPrice?.data ?? {}
        } else {
            responseSpecPrice = {}
        }
        return responseSpecPrice;
    }

    SelectBusinessPartner = async (index = 0, opcion = null) => {
        const { businessPartners, newOrderModel, _user, disableRecover, disableRecoverNM, itsInterOpDoc, recoverDocument, groupNumList } = this.state;
        const { notificationReducer: { showAlert } } = this.props;
        $('#clientsModal').modal('hide');
        const cacheCardCode = newOrderModel.CardCode || '';
        if (opcion === 'default') {
            const { Partner } = _user;
            if (!Partner.CardCode) {
                showAlert({ type: 'warning', message: 'No cuenta con un cliente asignado por defecto' });
                return;
            }
            newOrderModel.CardCode = Partner.CardCode;
            newOrderModel.CardName = Partner.CardName;
            newOrderModel.PriceListNum = Partner.ListNum;
            newOrderModel.ShipToDef = Partner.ShipToDef;
            newOrderModel.waitForNewSDirection = false;
            newOrderModel.BillToDef = Partner.BillToDef;
            newOrderModel.SlpCode = Partner.SlpCode;
            newOrderModel.Credit = 0;
            newOrderModel.AvailableCredit = 0;
            newOrderModel.IsCredit = false;
            newOrderModel.LicTradNum = Partner.LicTradNum;
            newOrderModel.ShipToCode = Partner.ShipToDef;
            newOrderModel.U_SO1_02METODOPAGO = '';
            newOrderModel.U_FMB_TIPO_REL = '00';
            newOrderModel.U_FMB_AUX_CARDNAME = Partner.U_FMB_AUX_CARDNAME ?? '';
            newOrderModel.flagPointsCard = false;
            newOrderModel.U_FMB_ValidoMonedero = 'N';
            newOrderModel.GroupCode = Partner.GroupCode || '';
            newOrderModel.GroupCodeName = Partner.GroupCodeName || '';
            //#region ################## PERCEPCION ################ ✔
            newOrderModel.U_BPP_BPTD = Partner.U_BPP_BPTD;
            newOrderModel.U_STR_AR = Partner.U_STR_AR;
            newOrderModel.U_STR_AP = Partner.U_STR_AP;
            newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = Partner.U_LLG_EXCEPTUADO_PERCEPCION;
            //#endregion ################## PERCEPCION ################ ✔
            newOrderModel.Project = '';
            const addresses = await apiClient.getAddressParter(Partner.CardCode);
            //#region DIMENSIONS
            newOrderModel.Dimension1 = await this.getDimension1(newOrderModel);
            if (newOrderModel.Dimension1) {
                for (const item of newOrderModel?.Items) {
                    item.OcrCode = newOrderModel.Dimension1;
                }
                if (newOrderModel?.Items?.length) {
                    showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al socio` });
                }
            }
            //#endregion DIMENSIONS
            this.setState({
                deliveryAddresses: addresses.data.deliveriesAddress,
                billAddresses: addresses.data.invoicesAddress
            })
            await this.SetBranchOfficeTaxes(newOrderModel);


        } else {
            const businessPartner = businessPartners[index]
            newOrderModel.CardCode = businessPartner.CardCode;
            newOrderModel.CardName = businessPartner.CardName;
            newOrderModel.LicTradNum = businessPartner.LicTradNum;
            newOrderModel.SlpCode = businessPartner.SlpCode;
            newOrderModel.PriceListNum = businessPartner.ListNum;
            newOrderModel.USOCFDI = businessPartner.U_FMB_USO_CFDI || '';
            newOrderModel.ShipToDef = businessPartner.ShipToDef;
            newOrderModel.waitForNewSDirection = false;
            newOrderModel.NeedScopCode = businessPartner?.U_FMB_FICHA_OSIN === null || businessPartner?.U_FMB_FICHA_OSIN === '' ? false : true;
            newOrderModel.BillToDef = businessPartner.BillToDef;
            newOrderModel.PayToCode = businessPartner.BillToDef;
            newOrderModel.PartnerAcctCode = businessPartner.AcctCode;
            newOrderModel.Credit = businessPartner.Credit || 0;
            newOrderModel.CreditLine = businessPartner.CreditLine || 0;
            newOrderModel.AvailableCredit = businessPartner.Credit || 0;
            newOrderModel.IsCredit = false;
            newOrderModel.TaxName = (businessPartner.TaxCode === null && businessPartner.Rate === null ? "Seleccione impuestos para continuar" : businessPartner.TaxCode + '.-' + FORMAT_NUMBER.new(businessPartner.Rate) + " %") || (businessPartner.TaxCode === 'C08' ? "IVA Trasladado Tasa 8%" : businessPartner.TaxCode === 'C16' ? "IVA Trasladado Tasa 16%" : businessPartner.TaxCode === 'C16F' ? "IVA Trasladado Tasa 16% Fletes" : businessPartner.TaxCode === 'C16I' ? "IVA Trasladado Tasa 16% Otros ingresos" : businessPartner.TaxCode === 'C0' ? "IVA Trasladado Tasa 0%" : "");
            newOrderModel.U_SO1_02METODOPAGO = businessPartner.GroupNum === '-1' ? 'PUE' : '';
            newOrderModel.GroupNum = businessPartner.GroupNum;
            newOrderModel.RegimenFiscal = businessPartner.U_FMB_REGIMEN_FISCAL ?? '';
            newOrderModel.U_FMB_ValidoMonedero = businessPartner.U_FMB_ValidoMonedero ?? 'N';
            newOrderModel.GroupCode = businessPartner.GroupCode || null;
            newOrderModel.GroupCodeName = businessPartner.GroupCodeName || '';
            if (businessPartner.DpmClear === '' || businessPartner.DpmClear === undefined || businessPartner.DpmClear === null) {
                showAlert({ type: 'warning', message: `EL CLIENTE NO TIENE ASIGNADA UNA CUENTA 'COMPENSACIÓN DE ANTICIPOS' ` });
            }
            if (businessPartner.DpmIntAct === '' || businessPartner.DpmIntAct === undefined || businessPartner.DpmIntAct === null) {
                showAlert({ type: 'warning', message: `EL CLIENTE NO TIENE ASIGNADA UNA CUENTA 'PROVISIONAL DE ANTICIPOS' ` });
            }
            await this.SetBranchOfficeTaxes(newOrderModel);
            //#region ################## POINTS CARD ################ ✔
            if (points_Card && newOrderModel.U_FMB_ValidoMonedero === 'Y') {
                await this.searchPointsCard(newOrderModel);
            }
            //#endregion ################## POINTS CARD ################ ✔
            newOrderModel.PartnerDpmClear = businessPartner.DpmClear;
            newOrderModel.PartnerDpmIntAct = businessPartner.DpmIntAct;
            newOrderModel.U_FMB_AUX_CARDNAME = businessPartner.U_FMB_AUX_CARDNAME ?? '';

            //#region ################## PERCEPCION ################ ✔
            newOrderModel.U_BPP_BPTD = businessPartner.U_BPP_BPTD;
            newOrderModel.U_STR_AR = businessPartner.U_STR_AR;
            newOrderModel.U_STR_AP = businessPartner.U_STR_AP;
            newOrderModel.U_LLG_EXCEPTUADO_PERCEPCION = businessPartner.U_LLG_EXCEPTUADO_PERCEPCION;
            //#endregion ################## PERCEPCION ################ ✔
            newOrderModel.Project = '';

            //#region DIMENSIONS
            newOrderModel.Dimension1 = await this.getDimension1(newOrderModel);
            if (newOrderModel.Dimension1) {
                for (const item of newOrderModel?.Items) {
                    item.OcrCode = newOrderModel.Dimension1;
                }
                if (newOrderModel?.Items?.length) {
                    showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al socio` });
                }
            }
            //#endregion DIMENSIONS
        }

        let SpecialPrices = await this.getSpecialPrices(newOrderModel.CardCode)
        await this.setState({
            SpecialPrices,
            newOrderModel,
            showClientsModal: false,
            partnerSearch: '',
            businessPartners: [],
            partnerIndex: 0
        });

        // BRINCA ESTO CUANDO ES UN DOCUMENTO RECUPERADO PARA QUE RESPETE EL PRECIO DEL BORRADOR
        if (!disableRecover && !disableRecoverNM) {
            await this.UpdateItemsPrice();
        }

        if (itsInterOpDoc || (recoverDocument && (cacheCardCode !== newOrderModel.CardCode))) {
            showAlert({ type: 'info', message: 'CAMBIASTE DE CLIENTE, LA RELACIÓN DEL DOCUMENTO SE HA PERDIDO', timeOut: 3000 });
            await this.BrakeRelationDoc();
            await this.UpdateItemsPrice();
        }
        await this.ResetSpecialPrices();

        //#region Precio Llamagas
        if (cacheCardCode !== newOrderModel?.CardCode) { // Al cambiar de socio consultar precios
            await this.checkItemPrices(false, true)
        }
        //#endregion Precio Llamagas
    }

    //#region ########## DETAIL INFO PARTNERS #########################################################
    SetIndexDeliveryDirection = async (index, addressObject = null, isDefault = false) => {
        const { newOrderModel, deliveryAddresses } = this.state;
        const { notificationReducer: { showAlert } } = this.props;
        let precioLlamagas = newOrderModel?.Items?.some(item => Granel?.includes(Number(item?.ItmsGrpCod)) || Envasados?.includes(Number(item?.ItmsGrpCod)));
        if (precioLlamagas && isDefault && newOrderModel?.ShipToCode && newOrderModel?.waitForNewSDirection) {
            return; // Se bloquea por que el Precio Llamagas depende de la dirección de envío
        }

        let auxShipToCode = newOrderModel?.ShipToCode || '';
        newOrderModel.ShipToCode = deliveryAddresses[index].Address;
        newOrderModel.waitForNewSDirection = precioLlamagas && !isDefault && auxShipToCode && auxShipToCode !== newOrderModel?.ShipToCode; // Cuando tiene mas de 1 direccion, mantener la ultima direccion seleccionada
        await this.setState({
            setDeliveryIndex: index,
        })
        if (addressObject !== null) {
            await this.FillAddressExtensionShipTo(addressObject);
        }

        if (precioLlamagas && newOrderModel?.waitForNewSDirection) {
            let needToCheckAgain = await this.checkItemPrices(true);
            if (needToCheckAgain) {  // Se ajustaron los precios de los artículos, cerrar modal para revisar
                $("#detailClientModal").modal("hide");
                showAlert({ type: 'info', message: `Por favor revisa los ajustes realizados a los precios de los artículos.`, timeOut: 10000 });
            }
        }
    }

    SetIndexBillDirection = async (index, addressObject = null) => {
        const { newOrderModel, billAddresses } = this.state;

        newOrderModel.PayToCode = billAddresses[index].Address
        await this.setState({ setBillIndex: index })

        if (addressObject !== null) {
            await this.FillAddressExtensionBillTo(addressObject);
        }
    }

    EditAddress = async (value, editMode, index, pointer) => {
        const { deliveryAddresses, billAddresses } = this.state
        this.ChangeActionMode(value, editMode);
        $(`#detailClientModal`).modal("hide");
        await this.setState({
            addressModel: Object.assign({}, pointer === 1 ? deliveryAddresses[index] : billAddresses[index]),
            AuxAddressModel: Object.assign({}, pointer === 1 ? deliveryAddresses[index] : billAddresses[index]),
            pointer: pointer
        })
        $(`#newAddressModal`).modal("show");
    }

    NewAddress = async (value, editMode, pointer) => {
        $("#detailClientModal").modal("hide");
        this.ChangeActionMode(value, editMode);
        this.setState({
            addressModel: new Addresses(),
            pointer: pointer
        })
        $("#newAddressModal").modal("show");
    }

    SendAddress = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        const { addressModel, Action, updatebusinessPartner, pointer } = this.state
        if (await this.ValidateAddress() === false) return
        const data = {
            Action: Action,
            CardCode: updatebusinessPartner.CardCode,
            addressModel,
            pointer,
        };

        enableSpinner(true);
        const responseApi = await apiClient.SendAddressCounter(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: responseApi.message });
            return;
        }

        updatebusinessPartner.ShipToDef = ''
        updatebusinessPartner.BillToDef = ''
        await this.setState({
            setDeliveryIndex: '',
            setBillIndex: '',
            updatebusinessPartner,
            WasUpdatedPartner: true,
        })

        showAlert({ type: 'success', message: responseApi.message });
        this.GetPartnerAddresses(updatebusinessPartner.CardCode);
        $("#newAddressModal").modal("hide");
        $(`#detailClientModal`).modal("show");
    }

    SetFlowDestiny = async (idModal) => {
        await this.setState({ FlowDestiny: idModal })
    }

    SetFlowOrigin = async (idModal) => {
        await this.setState({ FlowOrigin: idModal })
    }

    ShowDetailClientModal = async (value) => {

        await this.setState({
            CacheIndexCardCode: value,
            NextStepFunction: async () => {

                const { CacheIndexCardCode, businessPartners, newOrderModel } = this.state

                this.SelectBusinessPartner(value);
                let businessPartner = businessPartners[CacheIndexCardCode];
                newOrderModel.CardCode = businessPartner.CardCode;
                newOrderModel.CardName = businessPartner.CardName;
                newOrderModel.PriceListNum = businessPartner.ListNum;
                newOrderModel.U_FMB_USO_CFDI = businessPartner.U_FMB_USO_CFDI || '';
                newOrderModel.ShipToDef = businessPartner.ShipToDef;
                newOrderModel.BillToDef = businessPartner.BillToDef;
                this.RefreshOrder(newOrderModel);
                await this.UpdateItemsPrice();
            },
            ContinueWithoutSave: async () => {

                const { CacheIndexCardCode, businessPartners, newOrderModel } = this.state
                $('#detailClientModal').modal('hide');
                this.SelectBusinessPartner(value);
                let businessPartner = businessPartners[CacheIndexCardCode];
                newOrderModel.CardCode = businessPartner.CardCode;
                newOrderModel.CardName = businessPartner.CardName;
                newOrderModel.PriceListNum = businessPartner.ListNum;
                newOrderModel.U_FMB_USO_CFDI = businessPartner.U_FMB_USO_CFDI || '';
                newOrderModel.ShipToDef = businessPartner.ShipToDef;
                newOrderModel.BillToDef = businessPartner.BillToDef;
                this.RefreshOrder(newOrderModel);
                await this.UpdateItemsPrice();

            }
        })
        $("#detailClientModal").modal("show");
    }

    ValidateZipCode = async (value) => {
        let responseZipCode = {
            flag: true,
            message: ''
        }
        if (isNaN(value)) {
            responseZipCode.flag = false;
            responseZipCode.message = 'El código postal solo debe contener números ';
            return responseZipCode;
        }
        if (value.length !== 5) {
            responseZipCode.flag = false;
            responseZipCode.message = 'El código postal debe tener solo 5 dígitos';
            return responseZipCode;
        }

        return responseZipCode;

    }

    ValidateAddress = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { addressModel } = this.state;
        let flag = true;
        if (addressModel.Address === '') {
            showAlert({ type: 'warning', message: 'El identificador de la dirección esta vació.' });
            flag = false;
        }
        if (addressModel.Street === '') {
            showAlert({ type: 'warning', message: 'El campo calle y número esta vació.' });
            flag = false;
        }
        if (addressModel.Block === '') {
            showAlert({ type: 'warning', message: 'El campo colonia esta vació.' });
            flag = false;
        }
        if (addressModel.City === '') {
            showAlert({ type: 'warning', message: 'El campo ciudad esta vació.' });
            flag = false;
        }
        if (addressModel.ZipCode === '') {

            showAlert({ type: 'warning', message: 'El campo código postal esta vació.' });
            flag = false;
        }
        const responseZC = await this.ValidateZipCode(addressModel.ZipCode);
        if (!responseZC.flag) {
            showAlert({ type: 'warning', message: `${responseZC.message ?? ''}` });
            flag = false;
        }

        if (addressModel.County === '') {
            showAlert({ type: 'warning', message: 'El campo estado esta vació.' });
            flag = false;
        }
        if (addressModel.Country === '') {
            showAlert({ type: 'warning', message: 'El campo país esta vació.' });
            flag = false;
        }
        if (addressModel.TaxCode === '' && addressModel.TypeOfAddress === 'S') {
            showAlert({ type: 'warning', message: 'El campo indicador de impuestos esta vació.' });
            flag = false;
        }
        return flag;
    }
    //#endregion

    //#endregion

    //#region ########## CATALOGS ########################################################
    GetDataPartner = async () => {
        const { groupNumList, priceList, groupCodeList } = this.state

        if (groupNumList.length === 0) {
            const groupNumResponse = await apiClient.getGroupNum();
            this.setState({
                groupNumList: groupNumResponse.data,
            });
        }

        if (priceList.length === 0) {
            let priceListResponse = await apiClient.getPriceList();
            if (priceListResponse.data.length) {
                this.setState({
                    priceList: priceListResponse.data,
                });
            }
        }

        if (groupCodeList.length === 0) {
            let groupCodeResponse = await apiClient.getGroupCode();
            if (groupCodeResponse.data.length) {
                this.setState({
                    groupCodeList: groupCodeResponse.data,
                });
            }
        }
    };

    GetCurrencies = async () => {
        try {
            const response = await apiClient.getCurrencies();
            if (response.status === SERVICE_RESPONSE.SUCCESS) {
                this.setState({ currencyRate: Number(response.data?.find(currency => currency.CurrCode === 'USD')?.Rate) || 0 });
            }
        } catch (error) {
            this.props.notificationReducer.showAlert({ type: 'warning', message: 'No se pudo consultar el tipo de cambio del día.' });
        }
    };

    GetBankAccounts = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        let responseApi = await apiClient.getCuentaBancosList();
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }
        this.setState({ BankAccounts: responseApi.data || [] })
    };

    GetPartnerAddresses = async (CardCode) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const data = {
            cardCode: CardCode
        }
        enableSpinner(true);
        const responseApi = await apiClient.ValidateBPToDH(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: 'ALGO SALIO MAL AL CONSULTAR LAS DIRECCIONES DISPONIBLES' });
            return;
        }
        if (responseApi.data.deliveriesAddress && responseApi.data.deliveriesAddress.length === 0) {
            showAlert({ type: 'warning', message: 'ESTE SOCIO NO TIENE DIRECCIONES DE ENVIÓ, ANTES DE CONTINUAR REGISTRA UNA DIRECCIÓN PARA CALCULAR EL TOTAL DE VENTA', timeOut: 50000 });
        }
        await this.FillAddressesByBP(responseApi.data.deliveriesAddress, responseApi.data.invoicesAddress);


    }

    GetGroupNumList = async () => {
        const groupNumResponse = await apiClient.getGroupNum();
        if (Array.isArray(groupNumResponse.data) && groupNumResponse.data.length) {
            this.setState({
                groupNumList: groupNumResponse.data,
            });
        }
    }

    GetDownPaymentsByPartner = async (cardCode) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props
        const data = {
            CardCode: cardCode
        }
        enableSpinner(true);
        const responseApi = await apiClient.getDownPaymentsByPartner(data);
        enableSpinner(false);
        if (responseApi.status === 0) {
            showAlert({ type: "error", message: `${responseApi.message}` });
        }

        this.setState({
            DownPayments: responseApi.data.DownPayments || [],
            CreditNotes: responseApi.data.CreditNotes || [],
        })
    }
    //#endregion

    //#region ########## CREATE DOCUMENT #################################################

    ValidateDocument = async () => {
        const { newOrderModel } = this.state;
        const { notificationReducer: { showAlert } } = this.props;
        if (Number(Number(newOrderModel.Total).toFixed(2)) > Number(Number(newOrderModel.TotalRecibido).toFixed(2))) {
            showAlert({ type: "warning", message: "Ingrese el monto total a pagar", timeOut: 2000 });
            return;
        }
        if (Number(Number(newOrderModel.Total).toFixed(2)) < 0) {
            return showAlert({ type: "warning", message: "El total del documento no puede ser menor a cero", timeOut: 2000 });
        }

        let flagNeedReference = false;
        for (let p of newOrderModel?.PaymentsToSale) {
            if (needTransferReference(p, true)) {
                showAlert({ type: "warning", message: `Debe especificar una referencia${p.PM_Name ? ` para la forma de pago "${p.PM_Name}"` : ''}.`, timeOut: 8000 });
                flagNeedReference = true;
            }
        }
        if (flagNeedReference) {
            return;
        }

        //#region Flujo de caja
        if (Sections['FlujoCaja'] && newOrderModel?.PaymentsToSale?.length) {
            let missingCFWId = false;
            for (const element of newOrderModel?.PaymentsToSale) {
                if (element?.AcctCode) {
                    if (element?.needTransferCFW && !element?.transferCFWId) {
                        showAlert({ type: "warning", message: `Debe especificar el "Flujo de caja" de para la forma de pago "${element?.PM_Name || 'transferencia'}"`, timeOut: 8000 });
                        missingCFWId = true;
                    }
                    if (element?.needCashCFW && !element?.cashCFWId) {
                        showAlert({ type: "warning", message: `Debe especificar el "Flujo de caja" para la forma de pago "${element?.PM_Name || 'efectivo'}"`, timeOut: 8000 });
                        missingCFWId = true;
                    }
                    if (false // Este se queda comentado por que en sap no se muestra visualmente
                        && element?.needCheckCFW && !element?.checkCFWId) {
                        showAlert({ type: "warning", message: `Debe especificar el "Flujo de caja" para la forma de pago "${element?.PM_Name || 'cheques'}"`, timeOut: 8000 });
                        missingCFWId = true;
                    }
                }
            }

            if (missingCFWId) { // No se completó la información de Flujo de caja
                return;
            }
        }
        //#endregion Flujo de caja

        $("#billModal").modal("hide");
        await this.seriesAndConsecutiveSelection();
    }
    seriesAndConsecutiveSelection = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props
        const { newOrderModel, requireInvoice } = this.state;
        const requiresSunatSeries = requireInvoice || newOrderModel.ObjType === 'downPayments'
        if (requiresSunatSeries) {
            const data = {
                CardCode: newOrderModel.CardCode
            }
            enableSpinner(true);
            const responseApi = await apiClient.getBPData(data);
            enableSpinner(false);
            if (responseApi?.status === SERVICE_RESPONSE.SUCCESS) {
                const bpdata = responseApi?.data?.[0] ?? {}
                // Version 1: Si U_BPP_BPTD era 1 o 6 crea Boleta o Factura respectivamente
                /*
                newOrderModel.U_BPP_MDTD = Number(bpdata?.U_BPP_BPTD ?? -1) === 1 ? '03' : Number(bpdata?.U_BPP_BPTD ?? -1) === 6 ? '01' : null
                newOrderModel.U_BPP_MDTDName = Number(bpdata?.U_BPP_BPTD ?? -1) === 1 ? 'Boleta de Venta' : Number(bpdata?.U_BPP_BPTD ?? -1) === 6 ? 'Factura' : null
                */

                // Version 2: Si U_BPP_BPTD es 6 entonces crea Factura, cualquier otro valor crea una Boleta
                newOrderModel.U_BPP_MDTD = Number(bpdata?.U_BPP_BPTD ?? -1) === 6 ? '01' : '03';
                newOrderModel.U_BPP_MDTDName = Number(bpdata?.U_BPP_BPTD ?? -1) === 6 ? 'Factura' : 'Boleta de Venta';

                newOrderModel.U_BPP_MDSD = this.setDefaultSerie(newOrderModel.U_BPP_MDTD)
                await this.RefreshOrder(newOrderModel);
                $("#seriesSelection").modal("show");
            } else {
                showAlert({ type: "warning", message: responseApi?.message ?? '', timeOut: 2000 });
            }
        } else {
            $("#validationModal").modal("show");
        }

    }
    changeSerieConsecutive = (newSerie) => {
        const { newOrderModel } = this.state;
        newOrderModel.U_BPP_MDSD = newSerie ?? null
        this.RefreshOrder(newOrderModel);
    }
    setDefaultSerie = (docType) => {
        const { _user, newOrderModel, sellType } = this.state
        const vta = sellTypeSelect.find(vta => vta.value === sellType)
        const documentSeries = _user[vta?.correlative] ?? null
        const currSeries = documentSeries?.[docType]?.split('|') ?? []
        const defSerie = currSeries?.find(serie => serie.includes('~D'))
        let serie = defSerie ? defSerie.split('~D')[0] : null;
        newOrderModel.currSeries = currSeries
        //#region CREDIT PERCEPTIONS
        if (Number(newOrderModel?.U_BPP_TtPc) > 0) { // Buscar serie default para pagos
            const docType = 40;  // 40 es para comprobantes de percepción
            const currSeriesCP = documentSeries?.[docType]?.split('|') ?? [];
            const defSerieCP = currSeriesCP?.find(serie => serie.includes('~D'));
            let serieCP = defSerieCP?.split('~D')?.[0] || null;
            newOrderModel.U_BPP_MDTDPaymentDefault = docType ?? null; // Tipo del documento
            newOrderModel.U_BPP_PTSCPaymentDefault = serieCP ?? null; // Serie del documento
        } else {
            newOrderModel.U_BPP_MDTDPaymentDefault = null; // Tipo del documento
            newOrderModel.U_BPP_PTSCPaymentDefault = null; // Serie del documento
        }
        //#endregion CREDIT PERCEPTIONS
        this.RefreshOrder(newOrderModel);
        return serie
    }

    ValidateDelivery = async () => {
        const { newOrderModel } = this.state;
        newOrderModel.TotalRecibido = newOrderModel.Total;
        this.setState({ newOrderModel, addingPay: true })
        $("#billModal").modal("hide");
        $("#validationModal").modal("show");
        // const isAuthoDoc = this.ValidateAuthorization();
        // if(!isAuthoDoc){
        //     $("#validationModal").modal("show");
        // }
    }

    ValidateInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, requireInvoice } = this.state;
        if (requireInvoice) {
            let requestData = {
                cardCode: newOrderModel.CardCode
            }
            enableSpinner(true);
            let responseAddress = await apiClient.ValidateBPToDH(requestData);
            enableSpinner(false);
            if (responseAddress.status !== 1) {
                showAlert({ type: 'warning', message: 'ALGO SALIO MAL AL CONSULTAR LAS DIRECCIÓNES DISPONIBLES ' });
                return;
            }
            let shipAddressArray = responseAddress.data.deliveriesAddress || [];
            let billAddressArray = responseAddress.data.invoicesAddress || [];

            let infoByFolio = new InfoByFolio();
            let responseHeader = new ResponseHeader();
            let billAddress = new BillAddress();
            let shipAddress = new ShipAddress();

            infoByFolio.CashSum = newOrderModel.CashSum;
            infoByFolio.CheckSum = newOrderModel.CheckSum;
            infoByFolio.CreditSum = newOrderModel.CreditSum;
            infoByFolio.TrsfrSum = newOrderModel.TrsfrSum;
            infoByFolio.cardCode = newOrderModel.CardCode;
            infoByFolio.docDate = newOrderModel.DocDate;
            infoByFolio.docEntry = newOrderModel.DocEntry;
            infoByFolio.docNum = newOrderModel.DocNum;
            infoByFolio.docObjectType = newOrderModel.ObjType;
            infoByFolio.docStatus = newOrderModel.DocStatus;
            infoByFolio.folio = newOrderModel.DocNum;
            infoByFolio.idSale = newOrderModel.DocNum;
            infoByFolio.serie = newOrderModel.SerieCode;
            infoByFolio.taxTotal = Number(newOrderModel.Taxes);

            responseHeader.BillDirection = '';
            responseHeader.CardCode = newOrderModel.CardCode;
            responseHeader.CardName = newOrderModel.CardName;
            responseHeader.Cellular = newOrderModel.Phone;
            responseHeader.DiscPrcnt = newOrderModel.DiscPrcnt;
            responseHeader.DocCur = newOrderModel.DocCur || 'SOL';
            responseHeader.DocDate = newOrderModel.DocDate;
            responseHeader.DocDueDate = newOrderModel.DocDueDate;
            responseHeader.DocEntry = newOrderModel.docEntry;
            responseHeader.DocNum = newOrderModel.NextFolio || 112;
            responseHeader.DocStatus = newOrderModel.DocStatus;
            responseHeader.DocTotal = Number(newOrderModel.Total);
            responseHeader.E_Mail = newOrderModel.Email;
            responseHeader.LicTradNum = newOrderModel.LicTradNum;
            responseHeader.PayToCode = newOrderModel.PymCode;
            responseHeader.ShipDirection = newOrderModel.Address2;
            responseHeader.ShipToCode = newOrderModel.ShipToCode;
            responseHeader.VatSum = newOrderModel.VatSum;
            responseHeader.taxTotal = Number(newOrderModel.Taxes);
            responseHeader.Subtotal = Number(newOrderModel.Subtotal);
            responseHeader.U_FMB_USO_CFDI = newOrderModel.U_FMB_USO_CFDI

            for (let index = 0; index < shipAddressArray.length; index++) {
                const address = shipAddressArray[index];
                if (newOrderModel.ShipToDef === address.Address) {
                    shipAddress.Address = address.Address;
                    shipAddress.AdresType = 'S';
                    shipAddress.Block = address.Block;
                    shipAddress.City = address.City;
                    shipAddress.County = address.County;
                    shipAddress.LineNum = address.LineNum;
                    shipAddress.Street = address.Street;
                    shipAddress.ZipCode = address.ZipCode;
                }
            }
            for (let index = 0; index < billAddressArray.length; index++) {
                const address = billAddressArray[index];
                if (newOrderModel.BillToDef === address.Address) {
                    billAddress.Address = address.Address;
                    billAddress.AdresType = 'B';
                    billAddress.Block = address.Block;
                    billAddress.City = address.City;
                    billAddress.County = address.County;
                    billAddress.LineNum = address.LineNum;
                    billAddress.Street = address.Street;
                    billAddress.ZipCode = address.ZipCode;
                }
            }

            let document = new PrintDocument();
            document.docHeader.billAddress = billAddress;
            document.docHeader.shipAddress = shipAddress;
            document.docHeader.infoByFolio = infoByFolio;
            document.docHeader.responseHeader = responseHeader;

            let ItemArray = [];
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const item = newOrderModel.Items[index];
                let newitem = new ItemLine();
                newitem.ItemCode = item.ItemCode;
                newitem.Dscription = item.ItemName;
                newitem.Quantity = item.Quantity;
                newitem.Rate = item.TaxeRate;
                newitem.Price = item.Price;
                newitem.Total = item.Total;
                newitem.DiscountPercent = item.DiscountPercent;
                ItemArray.push(newitem);
            }
            document.docLines = ItemArray;
            await this.ShowCreatedInvoice(document, true);
        } else {
            await this.CreateDocument();
        }
    }

    FillDataFromPartner = async () => {
        const { updatebusinessPartner, newOrderModel } = this.state;
        newOrderModel.GroupNum = updatebusinessPartner.GroupNum || 0;
        this.RefreshOrder(newOrderModel);
    }

    IsPayedByDownPayment = async () => {
        const { newOrderModel, requireInvoice } = this.state
        let auxArrayPD = [];
        let DpAmount = 0;
        for (let i = 0; i < newOrderModel.PaymentsToSale.length; i++) {
            const payment = newOrderModel.PaymentsToSale[i];
            if (payment.TypeMethod === '117' || Number(payment.TypeMethod) === 117) {
                let auxDownPayToDraw = new DownPaymentToDraw();
                auxDownPayToDraw.DocEntry = payment.DocEntryDP;
                auxDownPayToDraw.AmountToDraw = payment.AmountDP;
                auxDownPayToDraw.DownPaymentType = "dptInvoice";
                auxDownPayToDraw.U_UDF_UUID = payment.U_UDF_UUID ?? '';
                auxDownPayToDraw.FORMA_PAGO = payment.FORMA_PAGO ?? '';
                auxArrayPD.push(auxDownPayToDraw);
                DpAmount += payment.AmountDP || 0;
            }
        }
        newOrderModel.DownPaymentAmount = DpAmount;
        newOrderModel.DownPaymentsToDraw = auxArrayPD;
        newOrderModel.AuxDownPaymentsToDraw = auxArrayPD;

        // If the document is an advance payment, force cash payment; otherwise continue with the normal process.
        if (newOrderModel.GroupNumResp) newOrderModel.GroupNum = newOrderModel.GroupNumResp
        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const item = newOrderModel.Items[i];
            if (item.TaxCodeResp) item.TaxCode = item.TaxCodeResp
            if (item.TaxNameResp) item.TaxName = item.TaxNameResp
            if (item.TaxeRateResp) item.TaxeRate = item.TaxeRateResp
        }
        const isCredit = Number(newOrderModel.GroupNum) !== -1;//CUANDO SE PAGA CON ANTICIPO Y ES A CREDITO, COLOCAR TAX RATE COMO SI FUERA CONTADO
        const isPayedWithCredit = newOrderModel?.PaymentsToSale?.some((pay) => Number(pay.idPMBO) === -1); // Se está pagando con crédito
        if (isCredit && requireInvoice && !isPayedWithCredit && newOrderModel?.PaymentsToSale?.length) {
            newOrderModel.GroupNumResp = newOrderModel.GroupNum
            newOrderModel.GroupNum = -1
            for (let i = 0; i < newOrderModel.Items.length; i++) {
                const item = newOrderModel.Items[i];
                item.TaxCodeResp = item.TaxCode;
                item.TaxNameResp = item.TaxName;
                item.TaxeRateResp = item.TaxeRate;
                item.TaxCode = item.TaxCodeCredit || item.TaxCode;
                item.TaxName = item.TaxNameCredit || item.TaxName;
                item.TaxeRate = item.TaxeRateCredit || item.TaxeRate;
            }
        }


        this.RefreshDocModel(newOrderModel)
    }

    ValidateClientVersion = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props

        const data = {
            ClientVersion: currentVersion
        };

        enableSpinner(true);
        const responseApi = await apiClient.ValidateClientVersion(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return true;
        }

        const difVersion = responseApi.data.version ? ((responseApi.data.version).toString() !== (currentVersion).toString()) : true;
        return difVersion;

    }

    CalculateDocDueDate = async (reserveInvoice) => {
        const { newOrderModel, requireInvoice, groupNumList } = this.state;
        const ItsReserveInvoice = reserveInvoice === "Y";

        if ((requireInvoice || ItsReserveInvoice) && newOrderModel.PaymentsToSale && newOrderModel.PaymentsToSale.length > 0) {
            const isCredit = newOrderModel.PaymentsToSale.find((element) => Number(element.TypeMethod) === -1)
            if (isCredit) {
                const findExtraDays = groupNumList.find((element) => Number(element.GroupNum) === Number(newOrderModel.GroupNum))
                if (findExtraDays) {
                    let DocDueDate = new Date(newOrderModel.DocDate);
                    DocDueDate.setDate(DocDueDate.getDate() + (Number(findExtraDays.ExtraDays) + 1));
                    newOrderModel.DocDueDate = DocDueDate.toISOString();
                    await this.refreshModel(newOrderModel);
                }
            }
        }
    }

    ValidateDocsFieldsForInvoice = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, requireInvoice, _user } = this.state
        let flag = false;
        if (requireInvoice) {
            if (newOrderModel.LicTradNum === '' || !RFC_FORMAT.test(newOrderModel.LicTradNum)) {
                showAlert({ type: 'warning', message: `RUT: No tienen un valor valido.`, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.LicTradNum !== 'XAXX010101000' && (newOrderModel.RegimenFiscal !== '' && Number(newOrderModel.RegimenFiscal) === 616)) { // validación Isra, si el RFC es genérico no debe dejar poner el regimen fiscal en sin obligaciones fiscales
                showAlert({ type: 'warning', message: `Si usas un RUT distinto al genérico no puedes dejar el Regimen fiscal con "Sin obligaciones fiscales", cambia el regimen para continuar`, timeOut: 7000 });
                return flag = true;
            }
            if (newOrderModel.CardName === '' || !FULLNAME_FORMAT.test(newOrderModel.CardName)) {
                showAlert({ type: 'warning', message: `CLIENTE NOMBRE: No tienen un valor valido.`, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.USOCFDI === '') {
                showAlert({ type: 'warning', message: `USOCFDI: No tienen un valor valido.`, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.RegimenFiscal === '') {
                showAlert({ type: 'warning', message: `CLIENTE REGIMEN FISCAL: No tienen un valor valido.`, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.AddressExtension.BillToStreet === '' || !STREET_FORMAT.test(newOrderModel.AddressExtension.BillToStreet)) {
                showAlert({ type: 'warning', message: `Dirección de facturación: (CALLE Y NUMERO) no tienen un valor valido `, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.AddressExtension.BillToBlock === '' || !BLOCK_FORMAT.test(newOrderModel.AddressExtension.BillToBlock)) {
                showAlert({ type: 'warning', message: `Dirección de facturación: (COLONIA) no tienen un valor valido `, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.AddressExtension.BillToCity === '' || !CITY_FORMAT.test(newOrderModel.AddressExtension.BillToCity)) {
                showAlert({ type: 'warning', message: `Dirección de facturación: (CIUDAD) no tienen un valor valido `, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.AddressExtension.BillToZipCode === '' || !ZIPCODE.test(newOrderModel.AddressExtension.BillToZipCode)) {
                showAlert({ type: 'warning', message: `Dirección de facturación: (CÓDIGO POSTAL) no tienen un valor valido `, timeOut: 5000 });
                return flag = true;
            }
            if (newOrderModel.AddressExtension.BillToState === '') {
                showAlert({ type: 'warning', message: `Dirección de facturación: (ESTADO) no tienen un valor valido `, timeOut: 5000 });
                return flag = true;
            }
        }

        if (newOrderModel.LicTradNum === 'XAXX010101000' && _user?.Branch.ZipCode && _user?.Branch.ZipCode !== '') {
            showAlert({ type: 'info', message: `USASTE EL RUT GENÉRICO, SE TOMARA EL CP DE TU SUCURSAL.`, timeOut: 5000 });
            const auxBillToCode = newOrderModel.AddressExtension.BillToZipCode
            newOrderModel.AddressExtension.BillToZipCode = _user?.Branch.ZipCode && _user?.Branch.ZipCode === '' ? _user?.Branch.ZipCode : auxBillToCode
        }


        return flag;
    }

    //#region ######## BATCH ############################

    refreshModel = async newOrderModel => {
        await this.setState({
            newOrderModel
        })
    };

    ShowBatchSelectionModal = async (nextStep) => {
        const { enableSpinner } = this.props;
        const { disableRecover, newOrderModel } = this.state;
        if (nextStep) {
            const isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                await this.setState({
                    showBatchSelectionModal: !this.state.showBatchSelectionModal,
                });

                if (newOrderModel.ObjType === 'deliveries') {
                    await this.ShowBillModal();
                    if (await this.CheckIfItsUniversalPartner() === true) {
                        $("#billModal").modal("show");
                    } else {
                        if (disableRecover) {
                            $("#billModal").modal("show");
                        } else {
                            $("#vmInvoice").modal("show");
                        }
                    }
                } else if (newOrderModel.ObjType === 'deliveries2') {
                    if (await this.CheckIfItsUniversalPartner()) {
                        enableSpinner(true);
                        let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                        this.GetPartnerAddresses(newOrderModel.CardCode);
                        newOrderModel.DeliveryAuthorization = 'I';
                        await this.refreshModel(newOrderModel)
                        enableSpinner(false);
                        await this.setState({
                            updatebusinessPartner: getPartnersResponse.data[0],
                            NextStepFunction: async () => {
                                $('#detailClientModal').modal('hide');
                                const isAuthorization = await this.ValidateAuthorization();
                                if (!isAuthorization) { this.CreateDocument(); }
                            },
                            ContinueWithoutSave: async () => {
                                $('#detailClientModal').modal('hide');
                                let isAuthorization = await this.ValidateAuthorization();
                                if (!isAuthorization) { this.CreateDocument(); }
                            }
                        });
                        $("#detailClientModal").modal("show");
                    } else {
                        await this.ShowBillModal();
                        $("#vmInvoice").modal("show");
                    }
                }
            }

        } else {
            await this.setState({
                showBatchSelectionModal: !this.state.showBatchSelectionModal,
            });
        }
    };

    ValidateBatch = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        if (newOrderModel.DocType === 'I') {
            if (newOrderModel.ObjType === 'deliveries') {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (itemsBatch.length > 0) {
                    let isBatchComplete = true;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        item.SnBUoMQty = 0;
                        for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                            const batch = item.BatchNumbers[indez];
                            item.SnBUoMQty += Number(batch.Quantity);
                        }
                        if (Number(item.SnBUoMQty) !== Number(item.Quantity)) {
                            isBatchComplete = false;
                        }
                    }
                    if (!isBatchComplete) {
                        let itemCode = {};
                        let whs = {}
                        itemsBatch.sort((a, b) => {
                            if (a.ItemCode > b.ItemCode) {
                                return 1;
                            } else if (b.ItemCode > a.ItemCode) {
                                return -1;
                            } else {
                                if (a.WhsCode > b.WhsCode) {
                                    return 1;
                                } else if (b.WhsCode > a.WhsCode) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }
                        });
                        itemsBatch = itemsBatch.filter((item) => {
                            if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                                return false
                            } else {
                                itemCode[item.ItemCode] = true;
                                whs[item.WhsCode] = true;
                                return true;
                            }
                        });
                        let newItemsBatchArray = []
                        for (let index = 0; index < itemsBatch.length; index++) {
                            const item = itemsBatch[index];
                            newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                        }
                        enableSpinner(true);
                        let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                        enableSpinner(false);

                        if (batchsResponse.status === 0) {
                            showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }
                        let isNewBatch = false;
                        for (let index = 0; index < newOrderModel.Items.length; index++) {
                            const item = newOrderModel.Items[index];
                            for (let index = 0; index < batchsResponse.data.length; index++) {
                                const itemBatch = batchsResponse.data[index];
                                if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                    if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                        isNewBatch = true;
                                    }
                                    item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                }
                            }
                        }

                        if (isNewBatch) {
                            await this.setState({
                                newOrderModel,
                                showBatchSelectionModal: true,
                            });
                            $('#batchSelectionModal').modal('show');
                        } else {
                            showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }

                    } else {
                        await this.validateAutorizationModels(newOrderModel);
                    }
                } else {
                    await this.validateAutorizationModels(newOrderModel);
                }
            } else {
                await this.CreateDocument(newOrderModel);
            }
        } else {
            await this.CreateDocument(newOrderModel);
        }
    }

    ShowBatch = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, disableRecover } = this.state;
        if (newOrderModel.DocType === 'I') {
            if ((newOrderModel.ObjType === 'deliveries' || newOrderModel.ObjType === 'deliveries') && !disableRecover) {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');

                if (itemsBatch.length > 0) {
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        item.SnBUoMQty = 0;
                        for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                            const batch = item.BatchNumbers[indez];
                            item.SnBUoMQty += Number(batch.Quantity);
                        }
                    }
                    let itemCode = {};
                    let whs = {}
                    itemsBatch.sort((a, b) => {
                        if (a.ItemCode > b.ItemCode) {
                            return 1;
                        } else if (b.ItemCode > a.ItemCode) {
                            return -1;
                        } else {
                            if (a.WhsCode > b.WhsCode) {
                                return 1;
                            } else if (b.WhsCode > a.WhsCode) {
                                return -1;
                            } else {
                                return 0;
                            }
                        }
                    });
                    itemsBatch = itemsBatch.filter((item) => {
                        if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                            return false
                        } else {
                            itemCode[item.ItemCode] = true;
                            whs[item.WhsCode] = true;
                            return true;
                        }
                    });
                    let newItemsBatchArray = []
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                    }
                    enableSpinner(true);
                    let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                    enableSpinner(false);

                    if (batchsResponse.status === 0) {
                        showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }
                    let isNewBatch = false;
                    for (let index = 0; index < newOrderModel.Items.length; index++) {
                        const item = newOrderModel.Items[index];
                        for (let index = 0; index < batchsResponse.data.length; index++) {
                            const itemBatch = batchsResponse.data[index];
                            if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                    isNewBatch = true;
                                }
                                item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                            }
                        }
                    }

                    if (isNewBatch) {
                        await this.setState({
                            newOrderModel,
                            showBatchSelectionModal: true,
                        });
                        $('#batchSelectionModal').modal('show');
                    } else {
                        showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }
                }
            }
        }
    }

    ValidateQuatations = async () => {
        await this.setState({
            showRefSaleModal: !this.state.showRefSaleModal,
        })

        let isAuthorization = await this.ValidateAuthorization();
        if (!isAuthorization) {
            this.CreateDocument();
        }
    }

    ValidateShipCode = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, deliveryAddresses, setDeliveryIndex } = this.state
        let hasDirection = false
        let setDefaultAddress = false

        if (deliveryAddresses.length !== 0) {
            hasDirection = true
            for (let index = 0; index < deliveryAddresses.length; index++) {
                const element = deliveryAddresses[index].Address;
                if (element === newOrderModel.ShipToCode) {
                    setDefaultAddress = true
                }
            }
        }

        if (!setDefaultAddress) {
            showAlert({ type: 'warning', message: 'La dirección de envió no se encontró, se asignó la dirección de envío por default' })
            newOrderModel.ShipToCode = deliveryAddresses[setDeliveryIndex].Address || deliveryAddresses[0].Address
        }
        if (!hasDirection) {
            showAlert({ type: 'warning', message: 'Agregue una dirección de envío para poder continuar' })
        }
        return { hasDirection };

    }

    VerifyChangeStatesCodes = async () => {
        const { newOrderModel } = this.state
        let findedBill = null;
        findedBill = await this.GetStateCodeByStateName(newOrderModel.AddressExtension.BillToState);
        if (!findedBill) {
            findedBill = await this.GetStateCodeByStateName(newOrderModel.AddressExtension.BillToCounty);
            if (findedBill) {
                newOrderModel.AddressExtension.BillToState = findedBill?.Code ?? '';
                await this.refreshModel(newOrderModel);
            }
        } else {
            newOrderModel.AddressExtension.BillToState = findedBill?.Code ?? '';
            await this.refreshModel(newOrderModel);
        }


        let findedShip = null;
        findedShip = await this.GetStateCodeByStateName(newOrderModel.AddressExtension.ShipToState);
        if (!findedShip) {
            findedShip = await this.GetStateCodeByStateName(newOrderModel.AddressExtension.ShipToCounty);
            if (findedShip) {
                newOrderModel.AddressExtension.ShipToState = findedShip?.Code ?? '';
                await this.refreshModel(newOrderModel);
            }
        } else {
            newOrderModel.AddressExtension.ShipToState = findedShip?.Code ?? '';
            await this.refreshModel(newOrderModel);
        }

    }

    //#endregion

    CreateDocument = async (validateAuthorizarion = false) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, requireInvoice, idWorkShift, disableRecover, AuthorizationComments, updatebusinessPartner, editModePartner, chooseSavedSale, recoverDocument, WasUpdatedPartner, _user } = this.state;
        const { recoveredQuoteOperation } = this.state;
        const { Partner } = _user;

        const isUniversal = await this.CheckIfItsUniversalPartner();
        const isNewCounterSale = !disableRecover && !recoverDocument &&
            (
                newOrderModel.ObjType === 'deliveries' ||
                newOrderModel.ObjType === 'deliveries2' ||
                newOrderModel.ObjType === 'deliveries4' ||
                newOrderModel.ObjType === 'directDelivery'
            );

        if (
            isUniversal &&
            isNewCounterSale &&
            !requireInvoice
        ) {
            if (this.state.showBillModal === false) {
                await this.ShowBillModal();
            }

            $('#billModal').modal('hide');
            $('#detailClientModal').modal('hide');
            $('#vmDeliveryHouse').modal('hide');
            $('#vmInvoice').modal('show');

            return;
        }

        if (newOrderModel.ShipToCode !== '' && !recoverDocument) { //VALIDAR SHIP TO CODE SEA VALIDO
            const hasDirection = await this.ValidateShipCode();
            if (!hasDirection.hasDirection) {
                return;
            }
        }

        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const DocItem = newOrderModel.Items[i];
            if (DocItem.Quantity === '' || DocItem.Quantity === 0) {
                newOrderModel.Items[i].Quantity = 1;
            }
        }

        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const DocItem = newOrderModel.Items[i];
            const cilindrosValue = Number(DocItem.U_RML_CU || 0);
            const quantityValue = Number(DocItem.Quantity || 0);

            if (DocItem.U_RML_ENTCLNDRO === "1") {
                if (cilindrosValue !== quantityValue) {
                    showAlert({ type: 'warning', message: `El artículo ${DocItem.ItemCode || DocItem.ItemName || ''} tiene Entrega Cilindro en SI, la cantidad de cilindros vacíos devueltos debe coincidir con la cantidad del artículo.`, timeOut: 6000 });
                    return;
                }
            } else if (DocItem.U_RML_ENTCLNDRO === "2") {
                if (cilindrosValue >= quantityValue) {
                    showAlert({ type: 'warning', message: `El artículo ${DocItem.ItemCode || DocItem.ItemName || ''} tiene "Entrega Cilindro" en NO, la cantidad de cilindros vacíos devueltos debe ser menor a la cantidad del artículo. Revise el artículo antes de continuar.`, timeOut: 6000 });
                    return;
                }
            }
        }

        if (!newOrderModel.SerieCode) {
            await this.ChangeObjectype(newOrderModel, newOrderModel.ObjType, requireInvoice);
        }

        this.FillDataFromPartner();
        const table = this.selectTable(requireInvoice ? 'invoice' : newOrderModel.ObjType);
        newOrderModel.idSession = idWorkShift;
        newOrderModel.OriginDoc = 'Counter-CreateDocument';

        await this.IsPayedByDownPayment();
        await this.CalculateDocDueDate(table.reserveInvoice);
        // this if sentence its for only firme docs
        if (!validateAuthorizarion && !recoverDocument && (recoverDocument && newOrderModel.isDocumentWithAuthorization) && await this.ValidateDocsFieldsForInvoice()) {
            if (!newOrderModel.LoadDataForDocFields) { // im only need execute this only one time for load data because if it reload many times it will change the data changed
                await this.EditBusinessPartner();
                await this.ChangeShowTemporalData();
            }
            newOrderModel.FailData = true;
            newOrderModel.LoadDataForDocFields = true;
            await this.refreshModel(newOrderModel);
            $('#validateDocFIelds').modal('show');
            return
        } else {
            await this.VerifyChangeStatesCodes()
            await this.refreshModel(newOrderModel);
            $('#validateDocFIelds').modal('hide');
        }

        newOrderModel.recoveredQuoteOperation = recoveredQuoteOperation;

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: newOrderModel,
            isDraft: newOrderModel.ObjType === 'deliveries4' ? true : false,
            ItsDeliveryInvoice: (newOrderModel.ObjType === 'deliveries2' && requireInvoice) ? true : false,
            ItsRecoverDoc: newOrderModel.isDocumentWithAuthorization ? false : disableRecover,
            ItsDeliveryDoc: (newOrderModel.ObjType === 'deliveries2') ? true : false,
            Time: moment().format(),
            UserTime: moment().format("HH:mm:ss"),
            comments: AuthorizationComments,
            validateAuthorizarion,
            TempPartner: (editModePartner || recoverDocument || WasUpdatedPartner || newOrderModel.FailData) ? true : false,
            TmpPartnerModel: updatebusinessPartner,
            ClientVersion: currentVersion,
            GenerateOxxoRef: Modules['oxxoReferences'] ?? false,
        };
        // return
        enableSpinner(true);
        const createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud.", timeOut: 5000 });
            showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 50000 });
            await this.setState({
                showBillModal: false,
                FailedRequestDocument: true,
                WasUpdatedPartner: false,
            });

            return;
        } else if (createDocumentResponse.status === 8) {
            showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 50000 });
            $('#newUpdateModal').modal('show');
            return
        } else if (createDocumentResponse.status === 2) {
            showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 8000 });
            let document = createDocumentResponse.data.serviceLayeResponse;
            let folio = createDocumentResponse.data.createdFolio;

            newOrderModel.DocNum = document.DocNum;
            newOrderModel.DocTime = document.DocTime;
            newOrderModel.DocEntry = document.DocEntry;
            newOrderModel.folio = folio;
            newOrderModel.NumAtCard = '';
            newOrderModel.RecoverIdSale = '';
            newOrderModel.Comments = '';
            newOrderModel.PaymentsToSale = [];
            newOrderModel.Items = [];
            newOrderModel.Total = 0;
            newOrderModel.userFields = this.resetUserFields();

            await this.setState({
                showBillModal: false,
                newOrderModel,
                isCancel: false,
                disableRecover: false,
                DownPayments: [],
                CreditNotes: [],
                showRefSaleModal: !this.state.showRefSaleModal,
                showBatchSelectionModal: false,
                FailedRequestDocument: true,
                WasUpdatedPartner: false,
                editModePartner: false,
                ItsComingFromModifiedPartner: false,
                RelatedPayMethodsByDoc: [],
                itsInterOpDoc: false,
                recoverDocument: false,
                ItsRecoverAuthoriInvoice: false,
                recoverInterOpTypeDoc: '',
                updatebusinessPartner: new BusinessPartnerPS(),
                auxRecoverDocData: null,
                showTemporalData: false,
                handedCasco: 1,
            });
            $("#refSaleModal").modal("show");
            return;
        }

        if (recoveredQuoteOperation === 1) return this.handleQuoteUpdate(createDocumentResponse.data);

        // if (!!createDocumentResponse?.data?.RequestAgainCDNotes) {
        //     showAlert({ type: "success", message: "Factura creada, procesando Nota de Crédito y Débito, por favor espere un momento", timeOut: 5000 });
        //     enableSpinner(true);
        //     const createCreditAndDebitNotesResponse = await apiClient.createCreditAndDebitNotes(createDocumentResponse?.data?.DebNotCreNot || {});
        //     enableSpinner(false);
        //     if (createCreditAndDebitNotesResponse.status === 0) {
        //         showAlert({ type: "error", message: "Ocurrio un error al crear las Notas de Crédito y Débito. " + createCreditAndDebitNotesResponse.message, timeOut: 5000 });
        //     }
        //     createDocumentResponse.data.DebNotCreNot = createCreditAndDebitNotesResponse?.data?.DebNotCreNot || '';
        // }
        //#region ################## POINTS CARD ################ ✔
        // GENERAR PUNTOS PARA MONEDERO ELECTRONICO
        let flagConsumedPoints = false;
        if (points_Card && (newOrderModel.CardCode !== Partner.CardCode) && newOrderModel.U_FMB_ValidoMonedero === 'Y') {
            enableSpinner(true);
            if (newOrderModel.flagPointsCard) showAlert({ type: "info", message: "Validando el documento para determinar si genera puntos en el monedero electrónico...", timeOut: 5000 });
            data.responseNewDocument = createDocumentResponse;

            let validateIfGeneratePoints = await apiClient.validateGeneratePointsCard(data);
            enableSpinner(false);

            if (validateIfGeneratePoints.status === 1 && !newOrderModel.flagPointsCard) {
                createDocumentResponse.data.LostPoints = validateIfGeneratePoints.data.LostPoints || {};
            }
            if (validateIfGeneratePoints.status === 1 && newOrderModel.PaymentsToSale.length === 1 && newOrderModel.PaymentsToSale[0].TypeMethod === '555') {
                flagConsumedPoints = true;
                createDocumentResponse.data.DebNotCreNot = validateIfGeneratePoints.data || '';
            }
        }
        // TE PERDISTE DE ESTOS PUNTOS
        if ((newOrderModel.CardCode !== Partner.CardCode) && Object.keys(createDocumentResponse.data.LostPoints).length !== 0 && points_Card) {
            if (createDocumentResponse.data.LostPoints.puntos !== 0 && !createDocumentResponse.data.LostPoints.isCredit) showAlert({ type: "info", message: "Esta venta hubiera generado: " + createDocumentResponse.data.LostPoints.puntos + " Puntos", timeOut: 10000 });
            // ISRA DIJO QUE SIEMPRE YA NO SE MOSTRARA ALERTA CUANDO SEA A CREDITO
            // if (createDocumentResponse.data.LostPoints.isCredit) showAlert({ type: "info", message: "Esta venta generará " + createDocumentResponse.data.LostPoints.puntos + " Puntos al ser pagada en su totalidad", timeOut: 10000 });
            if (createDocumentResponse.data.LostPoints.isCredit) {
                createDocumentResponse.data.LostPoints.monto = 0;
                createDocumentResponse.data.LostPoints.puntos = 0;
            }
            PointsCardModel.Customer = {
                CardCode: newOrderModel.CardCode,
                CardName: newOrderModel.CardName,
                DocEntry: createDocumentResponse.data.serviceLayeResponse.DocEntry,
                U_FMB_Handel_Email: '',
                U_FMB_Cellular: '',
                U_FMB_Handel_Pass: '',
                LostPoints: createDocumentResponse.data.LostPoints,
            }
            this.setState({
                PointsCardModel,
            })
        }
        //#endregion ################## POINTS CARD ################ ✔
        let folio = createDocumentResponse.data.createdFolio;
        let next_Folio_Cons = createDocumentResponse.data.next_Folio_Cons
        let document = createDocumentResponse.data.serviceLayeResponse;
        showAlert({ type: "success", message: "Gracias por tu compra: " + folio, timeOut: 5000 });

        newOrderModel.DocNum = document.DocNum;
        newOrderModel.DocTime = data.UserTime || document.DocTime;
        newOrderModel.DocEntry = document.DocEntry;
        newOrderModel.folio = folio;
        newOrderModel.next_Folio_Cons = next_Folio_Cons;
        newOrderModel.NumAtCard = '';
        newOrderModel.RecoverIdSale = '';
        newOrderModel.Comments = '';
        newOrderModel.PaymentsToPrint = newOrderModel?.PaymentsToSale || [];
        newOrderModel.PaymentsToSale = [];
        newOrderModel.isDocumentWithAuthorization = false;
        newOrderModel.infoAuthorization = {};
        newOrderModel.Address = document.Address ? document.Address.replace(/\r/g, " ") : '';
        newOrderModel.Address2 = document.Address2 ? document.Address2.replace(/\r/g, " ") : '';
        newOrderModel.userFields = this.resetUserFields();
        if (data.ItsRecoverDoc) {
            newOrderModel.ItsRecoverDoc = 'Y';
        }

        if (newOrderModel.ObjType === 'deliveries4') {
            $("#refSaleModal").modal("show");
            newOrderModel.Items = [];
            newOrderModel.Total = 0;
        }

        if (chooseSavedSale !== '') {
            this.setState({
                showSavedSalesModal: false
            })
            this.DeleteDraft(chooseSavedSale);
            this.ShowSavedSalesModal();
        }

        // this setsState must have the same variables values than the successfully  response status = 1
        await this.setState({
            newOrderModel,
            isCancel: false,
            disableRecover: false,
            DownPayments: [],
            CreditNotes: [],
            editModePartner: false,
            ItsComingFromModifiedPartner: false,
            RelatedPayMethodsByDoc: [],
            itsInterOpDoc: false,
            recoverDocument: false,
            ItsRecoverAuthoriInvoice: false,
            showBatchSelectionModal: false,
            recoverInterOpTypeDoc: '',
            FailedRequestDocument: false,
            WasUpdatedPartner: false,
            updatebusinessPartner: new BusinessPartnerPS(),
            auxRecoverDocData: null,
            showTemporalData: false,
            handedCasco: 1,
        });

        if (requireInvoice || newOrderModel.ObjType === 'invoiceReserve') {
            $("#billModal").modal("hide");
            this.ShowCreatedInvoice(createDocumentResponse.data.createdFolio, false, createDocumentResponse.data.serviceLayeResponse?.timbraResponse);
            // to show a credit note and debit note
            if (createDocumentResponse.data.DebNotCreNot && createDocumentResponse.data.DebNotCreNot !== '') {
                await this.FillExtraDocsShow(createDocumentResponse.data.DebNotCreNot, createDocumentResponse.data.createdFolio, createDocumentResponse.data.serviceLayeResponse?.timbraResponse);
                await this.FillExtraDocsShow(createDocumentResponse.data.DebNotCreNot, createDocumentResponse.data.createdFolio, createDocumentResponse.data.serviceLayeResponse?.timbraResponse);
            }
            if (flagConsumedPoints) {
                // await this.FillExtraDocsShow(createDocumentResponse.data.DebNotCreNot, createDocumentResponse.data.createdFolio, createDocumentResponse.data.serviceLayeResponse?.timbraResponse);
                await this.FillExtraDocsShow(createDocumentResponse.data.DebNotCreNot, createDocumentResponse.data.createdFolio, createDocumentResponse.data.serviceLayeResponse?.timbraResponse);
            }
        } else if (newOrderModel.ObjType === 'deliveries') {
            $("#ticketModal").modal("show");

            this.PrintDocuments(newOrderModel.ItsRecoverDoc === "Y" ? "ComprobantePago" : "NotaCaja", "80", newOrderModel);
        } else if (newOrderModel.ObjType === 'quotations') {
            $('#detailClientModal').modal('hide');
            this.ShowCreatedQuotation(createDocumentResponse.data.createdFolio);
        } else if (newOrderModel.ObjType === 'orderSales') {
            this.ShowCreatedOrder(createDocumentResponse.data.createdFolio);
        } else if (newOrderModel.ObjType === 'deliveries2') {
            this.ShowCreatedDeliveryDoc(createDocumentResponse.data.createdFolio);
        } else if (newOrderModel.ObjType === 'downPayments') {
            this.ShowCreatedDownPayment(createDocumentResponse.data.createdFolio, createDocumentResponse.data.serviceLayeResponse?.timbraResponse);
        }
    }

    handleQuoteUpdate = (data) => {
        const { notificationReducer: { showAlert } } = this.props;
        const Folio = data?.Folio;

        showAlert({ type: "success", message: `La cotización: ${Folio} se ha actualizado correctamente`, timeOut: 5000 });
        this.setState({ recoveredQuoteOperation: null });
        $('#detailClientModal').modal('hide');
        this.ShowCreatedQuotation(Folio);
    }

    ValidateAuthorization = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, idWorkShift, requireInvoice } = this.state;

        if (newOrderModel.isDocumentWithAuthorization) {
            return false;
        }

        if (!newOrderModel.Items.length) {
            showAlert({ type: "warning", message: "Documento sin artículos", timeOut: 2000 });
            return;
        }

        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const DocItem = newOrderModel.Items[i];
            if (DocItem.Quantity === '' || DocItem.Quantity === 0) {
                newOrderModel.Items[i].Quantity = 1;
            }
        }
        this.FillDataFromPartner();

        let table = this.selectTable(requireInvoice ? 'invoice' : newOrderModel.ObjType);
        newOrderModel.idSession = idWorkShift;

        await this.IsPayedByDownPayment();

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            model: newOrderModel,
        };

        enableSpinner(true);
        const response = await apiClient.autorizationModels(data);
        enableSpinner(false);

        let autorization = [];
        if (response.status === 1) {
            let respo = response.autorization;
            for (let i = 0; i < respo.length; i++) {
                const element = respo[i];
                autorization.push({
                    name: element.nameCond,
                    id: element.wtm,
                    comment: '',
                });
            }

            let autho = {};
            autorization = autorization.filter((element) => autho[element.id] ? false : autho[element.id] = true);
            this.setState({
                AuthorizationComments: autorization,
            });

            // if(!isUniversal && requireInvoice && newOrderModel.ObjType === 'deliveries2'){
            //     $('#authorizationModel').modal('false');
            // }else{
            //     $('#authorizationModel').modal('show');
            // }
            $('#authorizationModel').modal('show');
            return true;
        } else {
            return false;
        }
    }

    GetCommentsAuthorization = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const infoFolio = await _generalFunctions.getDocInfoByFolio(folio);
        const data = {
            InfoByFolio: infoFolio
        };

        enableSpinner(true);
        const responseApi = await apiClient.GetCommentsAuthorization(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }
        showAlert({ type: "info", message: `Comentarios autorizadores: ${responseApi.data ?? ''}`, timeOut: 99999 });
    }

    GetBreakAuthoModel = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const infoFolio = await _generalFunctions.getDocInfoByFolio(folio);
        const data = {
            InfoByFolio: infoFolio,
            SearchBreakModel: true
        };
        enableSpinner(true);
        const responseApi = await apiClient.GetCommentsAuthorization(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return
        }
        showAlert({ type: "info", message: `Documento frenado por autorización: ${responseApi.data ?? ''}`, timeOut: 99999 });
    }

    updateCommentsAuthorizationModel = (event, index) => {
        const { AuthorizationComments } = this.state;
        AuthorizationComments[index].comment = event.nativeEvent.target.value;
        this.setState({
            AuthorizationComments
        });
    }

    ChangeActionSale = async (value) => {
        await this.setState({ actionSale: value });
    }

    brokeRelationDocs = (newOrderModel) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { recoveredQuoteOperation } = this.state;
        let relationBroken = false;

        for (let item of newOrderModel.Items) {
            if (item.BaseEntry && recoveredQuoteOperation !== 1) {
                relationBroken = true;
                item.BaseEntry = null;
                item.BaseType = -1;
                item.BaseLine = 0;
            }
        }

        if (relationBroken) { showAlert({ type: "info", message: "Se ha eliminado la relación entre documentos", timeOut: 5000 }); }
        return newOrderModel;
    }

    ChangeObjectype = async (newOrderModel, value, requireInvoice) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { _user, recoveredQuote } = this.state;

        // solo para cotizaciones 
        // if (value === 'quotations' && recoveredQuote) {
        //     await this.setState({ showWarningModal: true });
        //     $('#warningModal').modal('show'); 
        //     return;
        // }

        newOrderModel.ObjType = value;
        if (value !== 'deliveries' && value !== 'deliveries2') {
            newOrderModel.DeliveryAuthorization = 'N'
        }
        // let serieCode = '';
        await this.setState({ objType: value })
        if (value === 'deliveries' || value === 'deliveries2' || value === 'deliveries4' || value === 'directDelivery') {
            if (!requireInvoice) {
                newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesODLN');
            } else {
                newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesOINV');
            }
        } else if (value === 'quotations') {
            newOrderModel = this.brokeRelationDocs(newOrderModel);
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesOQUT');
        } else if (value === 'orderSales') {
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesORDR');
        } else if (value === 'invoiceReserve') {
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesOINV');
        } else if (value === 'creditNote') {
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesORIN');
        } else if (value === 'downPayments') {
            if (!_user?.U_FMB_ValidateSeriesODPI || _user?.U_FMB_ValidateSeriesODPI === '' || _user?.U_FMB_ValidateSeriesODPI === undefined || _user?.U_FMB_ValidateSeriesODPI === null) {
                showAlert({ type: "warning", message: "TU SUCURSAL ASIGNADA NO CUENTA CON SERIES PARA FACTURAS DE ANTICIPO NOTIFIQUE A SU MANAGER", timeOut: 5000 });
            }
            newOrderModel.SerieCode = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesODPI');
            newOrderModel.Items = [];
            await this.setState({ itemSearch: Anticipo?.[0] ?? '' })
            await this.SearchItems();
        }

        // for (let index = 0; index < serieCode.length; index++) {
        //     const serie = serieCode[index];
        //     if (index === 0) {
        //         newOrderModel.SerieCode = serie;
        //         break;
        //     }
        // }
        this.setState({
            newOrderModel,
            requireInvoice,
        });
    }

    handleQuote = (opc = null) => {
        this.setState(
            {
                recoveredQuoteOperation: opc,
                recoveredQuote: false,
                recoverDocument: false,
                editModePartner: false,
                showTemporalData: false,
            },
            () => this.ChangeObjectype({ ...this.state.newOrderModel }, "quotations", false)
        );
    }

    selectTable = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        let reserveInvoice = "N";

        switch (view) {
            case "quotations":
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                reserveInvoice = "N";
                break;
            case "orderSales":
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                reserveInvoice = "N";
                break;
            case "deliveries":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries2":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "deliveries3":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;
            case "invoice":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "invoiceReserve":
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                reserveInvoice = "Y";
                break;
            case "return":
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                reserveInvoice = "N";
                break;
            case "debitNote":
                name = "OINV";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                reserveInvoice = "N";
                break;
            case "creditNote":
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                reserveInvoice = "N";
                break;
            case "downPayments":
                name = "ODPI";
                complement = "DPI1";
                docSubType = "--";
                docType = "203";
                reserveInvoice = "N";
                break;
            case "PurchaseOrder":
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case "purchaseReturn":
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case "GoodsReceipt":
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;
            case "PurchaseRequest":
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;
            case "purchaseInvoice":
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case "purchaseCreditNotes":
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;




            case "transfers":
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case "transfersRequest":
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case "transfersEntry":
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case "transfersOutput":
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case "bussinesPartner":
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case "inventoryRevaluation":
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case "payment":
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case "outgoingPayment":
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "30";
                break;
            case "invoiceBorrador":
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case "invoiceAuthorization":
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;

            case "deliveries4":
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                reserveInvoice = "N";
                break;


            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return {
            name,
            complement,
            docSubType,
            docType,
            name2,
            complement2,
            docSubType2,
            docType2,
            reserveInvoice,
        };
    };

    ShowCommentsModal = async (index) => {
        const { newOrderModel } = this.state
        await this.EnableCommentsModal();
        this.FillCommentModel(newOrderModel.Items[index], newOrderModel, index);
        $("#commentsModal").modal("show");
    }

    CleanDocCommentsActions = () => {
        $("#commentsModal").modal("hide");
        this.setState({
            DocCommentsModel: new DocComments(),
            CommentLineIndex: 0
        })
    }

    FillCommentModel = async (itemLine, newOrderModel, CommentLineIndex) => {
        let auxCommentsModel = new DocComments();
        auxCommentsModel.CommentLine = itemLine.U_FMB_LineComment;
        auxCommentsModel.DocComment = newOrderModel.Comments;
        auxCommentsModel.ItemCode = itemLine.ItemCode;
        this.setState({
            DocCommentsModel: auxCommentsModel,
            CommentLineIndex
        })
    }
    //#endregion

    //#region ########## CREATE BusinessPartner ##########################################

    CreateBusinessPartner = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { businessPartner, newOrderModel } = this.state;

        let data = {
            businessPartner,
        };
        enableSpinner(true);
        let createBusinessPartnerResponse = await apiClient.createNewBusinessPartnerPS(
            data
        );
        enableSpinner(false);

        if (!createBusinessPartnerResponse.status) {
            $("#newClientModal").modal("show");
            showAlert({
                type: "error", message: "Ocurrió un problema a procesar la solicitud " + createBusinessPartnerResponse.message, timeOut: 5000
            });
            return;
        }

        showAlert({
            type: "success",
            message: "Cliente registrado",
            timeOut: 5000,
        });

        let partner = createBusinessPartnerResponse.data;
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;

        await this.setState({
            newOrderModel,
            showClientsModal: false,
            partnerSearch: "",
            partnerIndex: 0,
            groupNumList: [],
            businessPartner: {},
        });

        await this.UpdateItemsPrice();
    };

    //#endregion

    //#region ########## REPORTS SECTION #################################################

    ChangeReportView = async (view) => {
        await this.setState({ viewReport: view });
        this.SearchReports();
    };

    ChangeInitialDate = async (event) => {
        let initialDate = event.nativeEvent.target.value;
        await this.setState({
            initialDate,
        });
    };

    ChangeFinalDate = async (event) => {
        const { initialDate } = this.state;
        let finalDate = event.nativeEvent.target.value;
        if (finalDate < initialDate) {
            return;
        }
        await this.setState({
            finalDate,
        });
    };

    SearchReports = async (option) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { initialDate, finalDate, viewReport } = this.state;
        let data = {
            initialDate,
            finalDate,
            viewReport,
        };
        enableSpinner(true);
        let responseApi = await apiClient.getSPReportData(data);
        enableSpinner(false);
        if (responseApi.status !== 1 || !Array.isArray(responseApi.data)) {
            showAlert({ type: "error", message: "Ocurrió un error al consultar la Información" });
        }
        await this.setState({ responseReport: responseApi.data || [] })
    };
    showHistoryDocsAdmin = async (createdBy) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            'role': 'admin',
            'showType': 'base64',
            createdBy
        }
        enableSpinner(true);
        const responseApi = await apiClient.getHistoryDocs(data);
        enableSpinner(false);
        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            try {

                const base64 = responseApi?.data?.file;

                if (!base64 || typeof base64 !== "string") {
                    return showAlert({ type: 'error', message: 'El documento es inválido' });
                }

                const base64Regex = /^[A-Za-z0-9+/=]+$/;
                if (!base64Regex.test(base64)) {
                    return showAlert({ type: 'error', message: 'No se pudo leer el documento' });
                }

                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/pdf" });

                if (blob.size === 0) {
                    return showAlert({ type: 'error', message: 'El PDF está vacío' });
                }

                const pdfUrl = window.URL.createObjectURL(blob);
                const pdfViewer = document.getElementById('pdfPrinterViewer');

                if (!pdfViewer) {
                    return showAlert({ type: 'error', message: 'No puedes visualizar el PDF' });
                }

                pdfViewer.innerHTML = `
                            <iframe 
                                src="${pdfUrl}" 
                                style="width: 100%; height: 100%; border: none;">
                            </iframe>
                        `;

                $("#printDocumentsModal").modal("show");

            } catch (error) {
                return showAlert({ type: 'error', message: error.message ?? 'No puedes visualizar el PDF CTCH' });

            }
        } else {
            return showAlert({ type: 'error', message: responseApi?.message || "Ocurrió un error inesperado, vuelva a intentarlo en unos minutos", timeOut: 10000 });
        }
    }
    ShowWorkShiftHistory = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift } = this.state;
        if (!this.state.showPDFViewer) {

            if (!idWorkShift) {
                showAlert({ type: "info", message: `POR ALGUNA RAZON NO TIENES ID DE TURNO. VOY A BUSCAR EL TUYO ` });
                this.CheckWorkSession();
                return;
            }
            const data = { idWorkShift }

            enableSpinner(true);
            const responseApi = await apiClient.showWorkShiftHistory(data);
            enableSpinner(false);

            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                return;
            }

            await this.setState({
                showPDFViewer: true,
                docsToPrint: [responseApi.data] || [],
                typeDocPrint: 'ReportSalesPayments',
            })
            $("#pdfViewer").modal("show");

        } else {
            $("#pdfViewer").modal("hide");
            await this.setState({
                showPDFViewer: false,
                docsToPrint: [],
                typeDocPrint: 'ReportSalesPayments',
            })

        }
    }
    //#endregion

    //#region ########## INVENTORY DATA ##################################################
    GetInventoryData = async (page = 1) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        let getInventoryDataResponse = await apiClient.getInventoryData(page);
        enableSpinner(false);

        if (!getInventoryDataResponse.status) {
            showAlert({ type: "error", message: getInventoryDataResponse.message });
            return;
        }

        if (getInventoryDataResponse.data.Items.length === 0) {
            showAlert({ type: "info", message: "No hay Información por mostrar" });
            return;
        }
        await this.setState({
            showInventoryModal: true,
            inventoryData: getInventoryDataResponse.data.Items,
            inventoryDataTotalRows: getInventoryDataResponse.data.TotalRows
        });

        $("#inventoryModal").modal("show");

    }
    //#endregion

    //#region ########## MOVEMENTS CASH ##################################################
    RefreshCashMovementModel = (cashMovementModel) => {
        this.setState({
            cashMovementModel: cashMovementModel
        })
    }

    ShowCashInModal = (show) => {
        if (show) {
            $("#cashInModal").modal("show");
        } else {
            $("#cashInModal").modal("hide");
            this.setState({ cashMovementModel: new CashMovement() })
        }
    }

    ShowCashOutModal = async (show) => {
        if (show) {
            $("#cashOutModal").modal("show");
        } else {
            $("#cashOutModal").modal("hide");
            await this.setState({ cashMovementModel: new CashMovement() })
        }
    }

    ShowTicketCashMovement = async (show) => {
        if (show) {
            $("#refMoveCashModal").modal("show");
        } else {
            $("#refMoveCashModal").modal("hide");
            await this.setState({ cashMovementModel: new CashMovement() })
        }
    }

    ChangeAmount = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { cashMovementModel } = this.state

        if (isNaN(value)) {
            showAlert({ type: "warning", message: `Inserte un valor valido`, timeout: 10000 });
        }
        cashMovementModel.cashAmount = value;
        await this.RefreshCashMovementModel(cashMovementModel)
    }

    ChangeComment = async (value) => {
        const { cashMovementModel } = this.state
        cashMovementModel.comment = value;
        await this.RefreshCashMovementModel(cashMovementModel)
    }

    SendCashMovement = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { cashMovementModel, idWorkShift, showRefMoveCashModal, newOrderModel, Action } = this.state
        let type = "";

        if (newOrderModel.TotalMoneyMovement === '' || Number(newOrderModel.TotalMoneyMovement) === 0) {
            showAlert({ type: "info", message: `Inserte un monto valido`, timeout: 10000 });
            return;
        }

        newOrderModel.ObjType = '';
        newOrderModel.TotalRestante = 0;
        const data = {
            destination: Action,
            cashMovementModel,
            idWorkShift,
            newOrderModel
        }
        enableSpinner(true);
        let createMovementCashResponse = await apiClient.createMovementCash(data);
        enableSpinner(false);

        if (createMovementCashResponse.status !== 1) {
            showAlert({ type: "error", message: createMovementCashResponse.message });
            return;
        }
        if (Action === 1) {
            await this.ShowCashInModal(false);
        } else {
            await this.ShowCashOutModal(false);

        }
        cashMovementModel.id = createMovementCashResponse.data.id || 0;
        cashMovementModel.docDate = createMovementCashResponse.data.docDate || ''
        cashMovementModel.docTime = createMovementCashResponse.data.docTime || ''
        cashMovementModel.cashAmount = createMovementCashResponse.data.cashSum || 0;
        // cashMovementModel.comment = createMovementCashResponse.data.comments || '';
        cashMovementModel.type = Action;
        await this.RefreshCashMovementModel(cashMovementModel);

        const option = Action ? Action : 3;
        await this.GetMovementsCash(option)
        if (!showRefMoveCashModal) {
            await this.ShowRefMoveCashModal()
        }

        this.ShowTicketCashMovement(true);
        type = cashMovementModel.type
        cashMovementModel.cashAmount = newOrderModel.MoneyMovements[0].Amount
        cashMovementModel.docDate = newOrderModel.MoneyMovements[0].DatePaycheck
        cashMovementModel.docTime = ""
        cashMovementModel.id = newOrderModel.MoneyMovements[0].PM_Code
        cashMovementModel.type = newOrderModel.MoneyMovements[0].PM_Name
        this.PrintCashMovements((type === 1 ? "ChashIn" : "ChashOut"), "80", cashMovementModel);
        $("#moneyMovementsModal").modal("hide");
    }

    GetMovementsCash = async (option) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { showWithdrawalModal } = this.state
        if (!showWithdrawalModal) {
            await this.ShowWithdrawalModal();
        }
        $("#withdrawalModal").modal("show");

        const data = {
            idWorkShift: this.state.idWorkShift,
            option
        }

        enableSpinner(true);
        const getMovementsCashResponse = await apiClient.getMovementsCash(data);
        enableSpinner(false);

        if (getMovementsCashResponse.status !== 1) {
            showAlert({ type: "info", message: getMovementsCashResponse.message });
            return;
        }

        if (getMovementsCashResponse.data.length === 0) {
            showAlert({ type: "info", message: "No hay Información registrada" });
        }

        await this.setState({
            movements: getMovementsCashResponse.data || []
        });
    }

    ShowHideMoneyMovements = async (option) => {

        if (option) {
            await this.EnableMoneyMovementsModal();
            $("#moneyMovementsModal").modal("show");
        } else {
            $("#moneyMovementsModal").modal("hide");
            await this.EnableMoneyMovementsModal();
        }
    }

    ChangeActionMoneyMovements = async (value) => {
        await this.setState({
            Action: value
        })
    }

    CancelMoneyMovement = async () => {
        const { newOrderModel } = this.state
        await this.setState({
            isCancel: true,
            DownPayments: [],
            CreditNotes: [],
        });
        newOrderModel.PaymentsToSale = [];
        newOrderModel.PaymentsToReturn = [];
        newOrderModel.TotalMoneyMovement = 0;
        this.RefreshOrder(newOrderModel);
        if (this.state.showBillModal === true) {
            await this.ShowBillModal();
        }
        await this.RefreshTotal(newOrderModel);
        await this.SumOfAmounts();
    }


    //#endregion

    //#region ########## SALES MODAL FUNCTIONS ###########################################

    RefreshSearchOrdersModel = (ordersSearchModel) => {
        this.setState({ ordersSearchModel })
    }

    RefreshDocModel = async (EditableDocModel) => {
        await this.setState({ EditableDocModel })
    }

    ChangeEditableMode = async () => {
        await this.setState({ editableMode: !this.state.editableMode })
    }

    SearchOrders = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ordersSearchModel, finalDate, initialDate } = this.state
        let data = {
            CardCode: ordersSearchModel.CardCode,
            DocNum: ordersSearchModel.DocNum,
            InitialDate: initialDate,
            FinalDate: finalDate
        }
        enableSpinner(true);
        let responseApi = await apiClient.searchOrders(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        if (responseApi.data.length === 0) showAlert({ type: "info", message: `NO EXISTEN REGISTROS VERIFIQUE LOS PARÁMETROS` });
        this.setState({ ordersDocs: responseApi.data ?? [], ordersToAction: 0 })
    }

    GetDocFolio = (value) => {
        this.setState({ ordersToAction: value })
    }

    SendDocsToPdfViewer = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, pedido } = this.state
        let ordersToAction = pedido;

        if (ordersToAction === 0) {
            showAlert({ type: "error", message: `AUN NO HAS SELECCIONADO UN DOCUMENTO` });
            return;
        }

        if (ordersToAction.substring(3, 5) === 'IV') {
            showAlert({ type: "error", message: `HAS SELECCIONADO UNA FACTURA, SELECCIONA UNA VENTA PARA PODER FACTURAR` });
            return;
        }

        enableSpinner(true);
        let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
        enableSpinner(false);

        await this.setState({
            newOrderModel,
            requireInvoice: false,
            updatebusinessPartner: getPartnersResponse.data[0],
        });
        await this.ChangeCanChangePartner();

        $('#detailClientModal').modal('show');

        this.GetPartnerAddresses(newOrderModel.CardCode);
        this.setState({

            NextStepFunction: async () => {
                const { notificationReducer: { showAlert } } = this.props;
                let isUniversal = await this.CheckIfItsUniversalPartner();

                if (!isUniversal) {
                    $('#detailClientModal').modal('hide');
                    this.UploadInvoice();
                } else {
                    showAlert({ type: "error", message: `NO PUEDES FACTURAR CON EL CLIENTE DE MOSTRADOR` });
                }

            }
        })

    }

    SaveChangesOrderInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { EditableDocModel, ordersToAction } = this.state
        let data = { EditableDocModel, ordersToAction }
        enableSpinner(true)
        let responseApi = await apiClient.SaveChangesOrderInvoice(data);
        enableSpinner(false)
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        let docsToPrintIds = [];
        docsToPrintIds.push(ordersToAction)
        let data2 = {
            docsToPrintIds: docsToPrintIds,
            typeDoc: 15
        }
        enableSpinner(true);
        let responseApi2 = await apiClient.getPrintDocsInfo(data2);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        this.ChangeEditableMode()
        await this.setState({ docsToPrint: responseApi2.data ?? [] });
    }

    UploadInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ordersToAction, idWorkShift, pedido, newOrderModel } = this.state

        let infoFolio = await _generalFunctions.getDocInfoByFolio(pedido)
        let data = {
            ordersToAction,
            infoFolio,
            idWorkShift,
            newOrderModel,
            Folio: pedido,
            Time: moment().format(),
        }

        enableSpinner(true);
        let responseApi = await apiClient.createInvoiceCounter(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message}`, timeOut: 10000 });
        await this.CloseRefundModal()
        $("#salesModal").modal("hide");
        await this.ShowCreatedInvoice(responseApi.data.createdFolio, false, responseApi.data.timbraResponse);
    }

    ShowDocInfo = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let infoFolio = await _generalFunctions.getDocInfoByFolio(folio)

        let data = {
            docsToPrintIds: [folio],
            typeDoc: infoFolio.num
        }

        enableSpinner(true);
        const responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        await this.setState({
            detailDoc: responseApi.data[0] ? responseApi.data[0] : {},
            returnsLines: []
        })
        // $("#saleDetailsModal").modal("show");
    }


    IntegrateBatchReturnDocs = async (blockOfCodeSuccess = null, itemPropToUse) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, ShowRefundOfPaymentsModal } = this.state
        let itemsBatch = newOrderModel.Items.filter((item) => item.ManBtchNum === 'Y');
        if (itemsBatch.length > 0) {
            let isBatchComplete = true;
            for (let index = 0; index < itemsBatch.length; index++) {
                const item = itemsBatch[index];
                item.SnBUoMQty = 0;
                for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                    const batch = item.BatchNumbers[indez];
                    item.SnBUoMQty += Number(batch[itemPropToUse]);
                }
                if (Number(item.SnBUoMQty) !== Number(item[itemPropToUse])) {
                    isBatchComplete = false;
                }
            }
            if (!isBatchComplete) {
                let itemCode = {};
                let whs = {}
                itemsBatch.sort((a, b) => {
                    if (a.ItemCode > b.ItemCode) {
                        return 1;
                    } else if (b.ItemCode > a.ItemCode) {
                        return -1;
                    } else {
                        if (a.WhsCode > b.WhsCode) {
                            return 1;
                        } else if (b.WhsCode > a.WhsCode) {
                            return -1;
                        } else {
                            return 0;
                        }
                    }
                });
                itemsBatch = itemsBatch.filter((item) => {
                    if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                        return false
                    } else {
                        itemCode[item.ItemCode] = true;
                        whs[item.WhsCode] = true;
                        return true;
                    }
                });
                let newItemsBatchArray = []
                for (let index = 0; index < itemsBatch.length; index++) {
                    const item = itemsBatch[index];
                    newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                }
                enableSpinner(true);
                let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                enableSpinner(false);

                if (batchsResponse.status === 0) {
                    showAlert({ type: 'error', message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                    return;
                }
                let isNewBatch = false;
                for (let index = 0; index < newOrderModel.Items.length; index++) {
                    const item = newOrderModel.Items[index];
                    for (let index = 0; index < batchsResponse.data.length; index++) {
                        const itemBatch = batchsResponse.data[index];
                        if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                            if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                isNewBatch = true;
                            }
                            item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                        }
                    }
                }

                if (isNewBatch) {
                    await this.setState({
                        newOrderModel,
                        showBatchSelectionModal: true,
                    });
                    $('#batchSelectionModal').modal('show');
                    await this.RefreshReturnTotal(newOrderModel);
                    if (!ShowRefundOfPaymentsModal) {
                        await this.EnableShowRefundOfPaymentsModal();
                    }
                } else {
                    showAlert({ type: 'error', message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                    return;
                }

            } else {
                if (blockOfCodeSuccess !== null) blockOfCodeSuccess();
            }
        } else {
            if (blockOfCodeSuccess !== null) blockOfCodeSuccess();
        }


    }

    ValidateCloseDocument = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { ourInfoForReturn, createdFromReserve, newOrderModel, ShowRefundOfPaymentsModal } = this.state;
        if (ourInfoForReturn === null) {
            showAlert({ type: "warning", message: `AUN NO HAS BUSCADO LA INFORMACIÓN DE ESTE DOCUMENTO, PRESIONA LA LUPA PARA BUSCAR LA INFORMACIÓN Y CONTINUAR` });
            return;
        }
        if (createdFromReserve && createdFromReserve === true) return showAlert({ type: "info", message: `ENTREGA DE FACTURA DE RESERVA. NO ES POSIBLE GENERAR CANCELACIONES` });

        if (ourInfoForReturn.paidOut && ourInfoForReturn.paidOut === 'Y') {
            newOrderModel.Items.forEach((item) => {
                item.Quantity = item.OpenQty;
                item.newQuantity = item.OpenQty;
                item.OpenLneQty = item.OpenQty;
            })
            const successCode = async () => {
                if (!this.state.ShowRefundOfPaymentsModal) {
                    await this.EnableShowRefundOfPaymentsModal();
                }
                $('#refundOfPaymentsModal').modal('show');
            }
            await this.IntegrateBatchReturnDocs(successCode, 'newQuantity')


            newOrderModel.AuxViewCounter = 'RefundModal';
            this.refreshModel(newOrderModel)


            // original
            // if (!this.state.ShowRefundOfPaymentsModal) {
            //     await this.EnableShowRefundOfPaymentsModal();
            // }
            // $('#refundOfPaymentsModal').modal('show');
        } else {

            showAlert({ type: "info", message: `TU DOCUMENTO NO ESTA PAGADO SE ESTA GENERANDO LA INVERSA AL DOCUMENTO INGRESADO. NOTA DE CREDITO SI INGRESASTE UNA FACTURA O DEVOLUCIÓN SI ERA UNA VENTA `, timeOut: 5000 });
            await this.CloseDocument();
        }
    }

    GetSeriesByCurrentUserProp = async (nameProperty) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        if (!_user?.hasOwnProperty(`${nameProperty}`)) {
            return null
        }
        const seriesDocument = _user[nameProperty];
        if (seriesDocument) {
            enableSpinner(true);
            const serieResponse = await apiClient.validateSerialNumbers({ seriesDocument });
            enableSpinner(false);
            if (serieResponse.status === SERVICE_RESPONSE.SUCCESS) {
                return serieResponse.data;
            } else {
                showAlert({ type: "warning", message: serieResponse.message, timeOut: 5000 });
                return null;
            }
        } else {
            return null
        }
    }

    CloseDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { idWorkShift, newOrderModel, pedido, ourInfoForReturn, ItsReserveInvoice } = this.state
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        // GET SERIES FOR DOCUMENTS
        newOrderModel.SerieCN = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesORIN');
        newOrderModel.SerieRT = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesORDN');
        newOrderModel.SerieDL = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesODLN');
        newOrderModel.OriginDoc = 'Counter-CloseDocument';
        newOrderModel.idSession = idWorkShift;
        const data = {
            DocFolio: pedido,
            InfoFolio: infoFolio,
            idWorkShift: idWorkShift,
            ItsOriginDocClose: newOrderModel.DocStatus === 'C' ? true : false,
            Time: moment().format(),
            newOrderModel,
            ItsNotPayed: ourInfoForReturn.paidOut === 'N' ? true : false,
            ItsReserveInvoice: ItsReserveInvoice,
            ClientVersion: currentVersion
        }

        enableSpinner(true);
        const responseApi = await apiClient.ReturnDocument(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        showAlert({ type: "success", message: `${responseApi.message}` });

        this.CloseRefundModal();

        await this.setState({
            ordersToAction: 0,
            ordersDocs: [],
            ordersSearchModel: {
                CardCode: '',
                DocNum: '',
            },
        })
        if (infoFolio.folioID === 'IV') { // facturas  
            this.ShowCreatedAcuseReturn(responseApi.data.createdFolio);
        } else if (infoFolio.folioID === 'DL' || infoFolio.folioID === 'DH') { //entregas normales y domicilio
            if ((infoFolio.folioID === 'DH') && (ourInfoForReturn.paidOut && ourInfoForReturn.paidOut === 'N')) {
                showAlert({ type: "success", message: `Cancelación exitosa.` });
            } else {
                this.ShowCreatedDevolutionDoc(responseApi.data.createdFolio);
            }

        }
    }

    CloseModalActions = async () => {
        this.setState({
            detailDoc: {},
            returnsLines: [],
            ordersDocs: [],
            docsToPrint: [],
            ordersToAction: 0,
            ordersSearchModel: {
                CardCode: '',
                DocNum: ''
            },
            initialDate: moment(new Date()).format("YYYY-MM-DD"),
            finalDate: moment(new Date()).format("YYYY-MM-DD"),
        })
        // this.ShowSalesModal();
    }

    //#endregion

    //#region ########## RETURNS #########################################################
    ChangePedido = async event => {
        const { newOrderModel } = this.state;
        let valor = event.nativeEvent.target.value;
        if (this.state.showRefundModal) {
            newOrderModel.Items = [];
            await this.setState({
                pedido: valor,
                isValidCFDI: false,
                isCancel: false,
                newOrderModel
            });
        }
    }

    ChangeViewReturnOption = async (value) => {
        await this.setState({ viewOption: value })
    }

    ChangeReturnPay = async () => {
        await this.setState({ returnPay: !this.state.returnPay });
    }

    ChangeCanChangePartner = async () => {
        await this.setState({
            CanChangePartner: !this.state.CanChangePartner
        })
    }

    SearchReturnFolioAmount = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { PaymentSaleModel, newOrderModel } = this.state

        if (PaymentSaleModel.ReturnFolio === '') {
            showAlert({ type: "error", message: `EL CAMPO DE FOLIO ESTA VACIÓ` });
            return;
        }
        let infoFolio = await _generalFunctions.getDocInfoByFolio(PaymentSaleModel.ReturnFolio);
        if (infoFolio.folioID !== 'RT') {
            showAlert({ type: "error", message: `DEBES INGRESAR UN FOLIO DE DEVOLUCIÓN, ESTE FOLIO CORRESPONDE A: ${infoFolio.msj}` });
            return;
        }

        const data = {
            ReturnFolio: PaymentSaleModel.ReturnFolio,
        }
        enableSpinner(true);
        const responseApi = await apiClient.getReturnFolioAmount(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: responseApi.message });
            return;
        }
        if (!responseApi.data.infoReturn) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }
        if (responseApi.data.infoReturn.cardCode && responseApi.data.infoReturn.cardCode !== newOrderModel.CardCode) {
            showAlert({ type: 'warning', message: `Este folio le pertenece al cliente con código: ${responseApi.data.infoReturn.cardCode}.`, timeOut: 3000 });
            return;
        }

        let returnAmount = responseApi.data.infoReturn.availableAmount;


        if (Number(returnAmount) === 0) {
            showAlert({ type: "info", message: `Esta devolución ya no tiene saldo disponible`, timeOut: 8000 });
            this.RefreshReturnFolioAmount(0);
            return;
        }

        showAlert({ type: "success", message: `Folio encontrado. Saldo disponible:  ${CURRENCY + ' ' + returnAmount}`, timeOut: 5000 });

        this.RefreshReturnFolioAmount(returnAmount);

    }

    SearchSale = async event => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { pedido, _user } = this.state;

        if (this.state.showRefundModal) {
            const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
            const data = {
                Folio: pedido,
                infoFolio,
            };

            enableSpinner(true);
            const responseSales = await apiClient.getSaleDocuments(data);
            enableSpinner(false);
            if (responseSales.status !== 1) {
                await this.setState({
                    checkboxDataTables: (new Map()),
                });
                await this.SetDefaultPartner();
                await this.CheckWorkSession();
                await this.SetBranchOfficeInfo();
                await this.SetCounterPermissions();
                return showAlert({ type: "error", message: responseSales.message });
            }

            if (responseSales.data.ourInfo && responseSales.data.ourInfo.folio && _user?.Branch.CodeBranchOffice !== infoFolio.codeBO) {
                await this.setState({
                    checkboxDataTables: (new Map()),
                });
                await this.SetDefaultPartner();
                await this.CheckWorkSession();
                await this.SetBranchOfficeInfo();
                await this.SetCounterPermissions();
                showAlert({ type: "warning", message: `LA DEVOLUCIÓN O CANCELACIÓN NO PODRÁ SER PROCESADA. ESTE FOLIO PERTENECE A OTRA SUCURSAL.`, timeOut: 50000 });
                return
            }

            const ItsReserveInvoice = responseSales.data.headerDocument.isIns === 'Y' ? true : false;
            const createdFromReserve = (responseSales.data.headerDocument.U_FMB_CREATEDFROM && responseSales.data.headerDocument.U_FMB_CREATEDFROM !== null && Number(responseSales.data.headerDocument.U_FMB_CREATEDFROM) === 0) ? true : false;
            const itsCancelCFDIAvailable = !!responseSales.data.headerDocument.U_FMB_NUM_CERTIFICADO && responseSales.data.headerDocument.U_FMB_NUM_CERTIFICADO !== null ? true : false;

            if (createdFromReserve) showAlert({ type: 'info', message: `ENTREGA DE FACTURA DE RESERVA DETECTADA. NO ES POSIBLE GENERAR DEVOLUCIONES NI CANCELACIONES`, timeOut: 50000 });

            const ItsCreditInvoice = responseSales.data.relatedPayMethods.find(element => Number(element.typeMethod) === -1);
            const needRelation = ((infoFolio.folioID === 'IV' && ItsCreditInvoice)) ? true : false;
            const OrderSale = await this.FillInfoReturns(responseSales.data.headerDocument, needRelation, responseSales.data.relatedPayMethods, ItsReserveInvoice);

            //Data required for the ambassadors' payment request
            const reqPaymentData = {
                DocEntry: responseSales?.data?.collectData?.DocEntry || -1,
                DocTotal: responseSales?.data?.collectData?.DocTotal || -1,
                ObjType: responseSales?.data?.headerDocument?.ObjType || -1,
                CurrTotalCancel: responseSales?.data?.relatedDocs?.reduce(
                    (total, related) => total + (parseFloat(related.DocTotal || 0)),
                    0
                )
            }
            OrderSale.PaymentRequestAmbassadorData = reqPaymentData

            await this.RefreshReturnTotal(OrderSale);
            if (responseSales.data.relatedDocs && responseSales.data.relatedDocs.length > 0) {
                const related = responseSales.data.relatedDocs[0].NumAtCard;
                let message = infoFolio.folioID === 'IV' ? `ESTA FACTURA ESTA LIGADA A LA NOTA DE CRÉDITO CON FOLIO:  ${related}` : (infoFolio.folioID === 'DL' || infoFolio.folioID === 'DH') ? `ESTA ENTREGA ESTA LIGADA A LA DEVOLUCIÓN CON FOLIO:  ${related}` : '';
                showAlert({ type: "info", message: `Este documento ya sufrió un cambio. ${message}`, timeOut: 10000 });
                await this.setState({
                    canCancelDocument: true
                })
                if (OrderSale.Items.length > 0) {
                    showAlert({ type: "info", message: `Solo se recuperaron las lineas abiertas`, timeOut: 10000 });
                } else {
                    showAlert({ type: "info", message: `Este documento ya no cuenta con lineas abiertas`, timeOut: 10000 });
                    await this.CloseRefundModal();
                    await this.setState({
                        checkboxDataTables: (new Map()),
                    });
                    await this.SetDefaultPartner();
                    await this.CheckWorkSession();
                    await this.SetBranchOfficeInfo();
                    await this.SetCounterPermissions();

                    return;
                }
            } else {
                await this.setState({
                    canCancelDocument: false
                })
            }

            if (responseSales.data.relatedPayMethods && responseSales.data.relatedPayMethods.length > 0) {
                await this.setState({
                    relatedPayMethodsByDoc: responseSales.data.relatedPayMethods || []
                })
                // check if the doc its for credit
                if (ItsCreditInvoice) {
                    if (responseSales.data.collectData !== null) {
                        OrderSale.OutstandingBalance = responseSales.data.collectData.totalPago || 0;
                        OrderSale.AbonadoTotal = responseSales.data.relatedIncomingPayments.relatedPaymentsTotal || 0;
                        OrderSale.payWasCanceled = responseSales.data.ourInfo.paidOut || 'N';
                    }

                    await this.setState({
                        AvailablePayments: responseSales.data.relatedIncomingPayments.paymentsSOS1 || [],
                        ItsCreditInvoice: true,
                    })
                } else {
                    await this.setState({
                        ItsCreditInvoice: false,
                    })
                }
            }

            for (let index = 0; index < OrderSale.Items.length; index++) {
                const element = OrderSale.Items[index];
                element.OnHand = Number(element.OnHand || 0);
                element.SWeight1 = Number(element.SWeight1 || 0);
                element.newQuantity = 0;
            }
            await this.setState({
                newOrderModel: OrderSale,
                // newOrderModel.PaymentsToSale: responseSales.data.relatedPayMethods,
                ourInfoForReturn: responseSales.data.ourInfo || '',
                infoCondiPagoReturn: responseSales.data.infoCondiPago || '',
                relatedIncomingPayments: responseSales.data.relatedIncomingPayments || '',
                checkboxDataTables: (new Map()),
                ItsReturnBill: infoFolio.folioID !== 'IV' ? true : false,
                ItsReserveInvoice: ItsReserveInvoice,
                createdFromReserve: createdFromReserve,
                itsCancelCFDIAvailable: itsCancelCFDIAvailable,
                relatedDocs: responseSales.data.relatedDocs || [],
            });
        }
    };

    FillInfoReturns = async (response, needRelated, payments, ItsReserveInvoice = false) => {
        const { _user, pedido, wareHouseTransaction } = this.state;
        let OrderModel = new NewOrderSales();
        let infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        OrderModel.CardCode = response.CardCode;
        OrderModel.CardName = response.CardName;
        OrderModel.SlpCode = response.SlpCode;
        OrderModel.ObjType = response.ObjType;
        OrderModel.NextFolio = response.NumAtCard;
        OrderModel.DocStatus = response.DocStatus;
        OrderModel.ReceiptNum = response.ReceiptNum;
        OrderModel.DocTotal = response.DocTotal;
        OrderModel.PaymentsToSale = [] //payments
        OrderModel.VatSum = Number(response.VatSum) || 0;
        OrderModel.LicTradNum = response.LicTradNum ?? '';

        // direcciones del documento base
        if (response.AddressExtension) OrderModel.AddressExtension = await this.FillAddressesUpdatePartner(response.AddressExtension, '', true);

        if (needRelated) {
            OrderModel.DocEntry = response.DocEntry || '';
        }
        //#region ########## DOCUMENTOS RELACIONADOS ORIN ######################
        OrderModel.U_UDF_UUID = response.U_UDF_UUID || '';
        // newIntegration
        OrderModel.USOCFDI = response.U_FMB_USO_CFDI || '';
        //#endregion

        let auxItemsArray = [];
        for (let i = 0; i < response.Items.length; i++) {
            const ItemRes = response.Items[i];
            let newItemModel = new NewItem();
            if (needRelated) {
                newItemModel.BaseEntry = response.DocEntry || '';
                newItemModel.BaseType = infoFolio.folioID === 'DL' ? 15 : infoFolio.folioID === 'IV' ? 13 : -1;
                newItemModel.BaseLine = (ItemRes.LineNum || ItemRes.LineNum === 0) ? ItemRes.LineNum : '';
            }
            // it is if the reserveInvoice Base doc the BackEnd create his delivery after create a CreditNote
            if (ItsReserveInvoice) {
                newItemModel.AuxBaseEntry = response.DocEntry || '';
                newItemModel.AuxBaseType = 13;
                newItemModel.AuxBaseLine = ItemRes.LineNum ?? '';
            }

            newItemModel.LineStatus = ItemRes.LineStatus === 'O' ? true : false;
            newItemModel.LineNum = ItemRes?.LineNum ?? '';
            newItemModel.ItemCode = ItemRes.ItemCode;
            newItemModel.ItemName = ItemRes.ItemName !== undefined && ItemRes.ItemName !== '' ? ItemRes.ItemName : ItemRes.Dscription;
            newItemModel.Description = ItemRes.Dscription
            newItemModel.PicturName = ItemRes.PicturName;
            newItemModel.UserText = ItemRes.UserText;
            newItemModel.CodeBars = ItemRes.CodeBars || "";
            newItemModel.HomePrice = Number(ItemRes.Price);
            newItemModel.Price = Number(ItemRes.Price);
            newItemModel.VatSum = Number(ItemRes.ImpuestoRow);
            newItemModel.Total = Number(ItemRes.LineTotal)
            newItemModel.TaxCode = ItemRes.TaxCode;
            newItemModel.TaxRate = ItemRes.Impuesto;
            newItemModel.NumInSale = Number(ItemRes.NumInSale || 0);
            newItemModel.OnHand = Number(ItemRes.OnHand || 0);
            newItemModel.Quantity = Number(ItemRes.Quantity || 1);
            newItemModel.newQuantity = Number(ItemRes.Quantity || 1);
            newItemModel.RevenuesAc = ItemRes.RevenuesAc;
            newItemModel.WhsCode = wareHouseTransaction?.WhsCode || _user?.Branch.ProjectCode;
            newItemModel.SWeight1 = Number(ItemRes.SWeight1 || 0);
            newItemModel.SWght1Unit = ItemRes.SWght1Unit || 3;
            newItemModel.InvntItem = ItemRes.InvntItem || 'Y';
            newItemModel.ManBtchNum = ItemRes.ManBtchNum || 'M';
            newItemModel.Discount = ItemRes.Descuento || 0;
            newItemModel.PriceBefDi = ItemRes.PriceBefDi || 0;
            newItemModel.OpenQty = ItemRes.OpenQty ? ItemRes.OpenQty : 0;
            newItemModel.AvgPrice = ItemRes.AvgPrice || 0;
            newItemModel.Project = ItemRes.Project || '';

            // batch selection was changed to manually selection for errores in this automatization 
            // if (ItemRes.BatchNumbers) {
            //     let auxBatchObject = ItemRes.BatchNumbers[0] || null;
            //     if (auxBatchObject !== null) {
            //         auxBatchObject.Quantity = '0';
            //     }
            //     ItemRes.BatchNumbers = auxBatchObject !== null ? [auxBatchObject] : [];
            //     newItemModel.BatchNumbers = ItemRes.BatchNumbers ?? [];
            // }
            newItemModel.BatchNumbers = [];
            //#region CENTROS DE COSTOS

            //CENTRO DE COSTO 1
            newItemModel.OcrCode = ItemRes.OcrdCode || '';
            //CENTRO DE COSTO 2
            newItemModel.OcrCode2 = OrderModel.OcrCode2 || '';
            //CENTRO DE COSTO 3
            newItemModel.OcrCode3 = ItemRes.OcrCode3 || '';
            //CENTRO DE COSTO 4
            newItemModel.OcrCode4 = ItemRes.OcrCode4 || '';
            //CENTRO DE COSTO 5
            newItemModel.OcrCode5 = ItemRes.OcrCode5 || '';

            //#endregion CENTROS DE COSTOS

            auxItemsArray.push(newItemModel);

            // Nueva versión de devoluciones
            newItemModel.InvntSttus = (!ItemRes.InvntSttus || ItemRes?.InvntSttus === 'C') ? true : false;
            newItemModel.AuxLineNum = ItemRes?.AuxLineNum ?? '';

        }
        OrderModel.Items = auxItemsArray ?? [];

        return OrderModel;
    }

    ChangeQuantityRefund = async (index, item, event) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        let newQuantity = event.nativeEvent.target.value;

        if (Number(newQuantity) > Number(item.OpenQty)) {
            newQuantity = Number(item.OpenQty);
            newOrderModel.Items[index].newQuantity = Number(newQuantity);
            if (newOrderModel.Items[index].ManBtchNum && newOrderModel.Items[index].ManBtchNum === 'Y') {
                let auxBatchObject = newOrderModel.Items[index].BatchNumbers[0] || null;
                if (auxBatchObject !== null) {
                    auxBatchObject.Quantity = newQuantity;
                }
                newOrderModel.Items[index].BatchNumbers = auxBatchObject !== null ? [auxBatchObject] : [];
            }
            await this.setState({
                newOrderModel,
            });
            showAlert({ type: 'warning', message: 'No puedes devolver mas unidades', timeOut: 0 });
            return;
        } else {
            if (Number(newQuantity) <= Number(item.OpenQty) && Number(newQuantity) >= 0) {
                newOrderModel.Items[index].newQuantity = Number(newQuantity);
                if (newOrderModel.Items[index].ManBtchNum && newOrderModel.Items[index].ManBtchNum === 'Y') {
                    let auxBatchObject = newOrderModel.Items[index].BatchNumbers[0] || null;
                    if (auxBatchObject !== null) {
                        auxBatchObject.Quantity = newQuantity;
                    }
                    newOrderModel.Items[index].BatchNumbers = auxBatchObject !== null ? [auxBatchObject] : [];
                }
                await this.setState({
                    newOrderModel,
                });
            }
        }
    }

    ChangeQuanttityDelivery = async (index, item, event) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        let newQuantity = event.nativeEvent.target.value;

        if (Number(newQuantity) > Number(item.OpenQty)) {
            newQuantity = Number(item.OpenQty);
            newOrderModel.Items[index].newQuantity = Number(newQuantity);

            await this.setState({
                newOrderModel,
            });
            showAlert({ type: 'warning', message: 'No puedes devolver mas unidades', timeOut: 0 });
            return;
        } else {
            if (Number(newQuantity) <= Number(item.OpenQty) && Number(newQuantity) >= 0) {
                newOrderModel.Items[index].newQuantity = Number(newQuantity);
                await this.setState({
                    newOrderModel,
                });
            }
        }
    }

    ChangeComments = async (index, event) => {
        const {
            newOrderModel
        } = this.state;

        newOrderModel.Comments = event.nativeEvent.target.value;
        await this.setState({
            newOrderModel,
        });
    }

    CheckIfIsPartialReturn = async (newOrderModel, docEntryArray) => {
        if (Number(newOrderModel.Items.length) > Number(docEntryArray.length)) {
            return true;
        } else if (Number(newOrderModel.Items.length) === Number(docEntryArray.length)) {
            for (let i = 0; i < newOrderModel.Items.length; i++) {
                const Item = newOrderModel.Items[i];
                if (Number(Item.OpenQty) !== Number(Item.newQuantity)) {
                    return true;
                }
            }
        } else {
            return false;
        }
    }

    CheckIfIsCreditConditionPay = async () => {
        const { infoCondiPagoReturn } = this.state
        let flag = false;
        if (infoCondiPagoReturn.ExtraMonth > 0 || infoCondiPagoReturn.ExtraDays > 1) {
            flag = true;
        }
        return flag;
    }

    CloseOpenRefundOfPaymentsModal = async (show) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { actionSale, pedido, ourInfoForReturn, canCancelDocument, newOrderModel, relatedPayMethodsByDoc } = this.state;


        const itsCreditInvoice = relatedPayMethodsByDoc && relatedPayMethodsByDoc.length > 0 ? relatedPayMethodsByDoc.find(element => Number(element.typeMethod) === -1) : false;

        if (actionSale === 'cancel') {
            const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
            if (pedido === '') {
                return showAlert({ type: 'warning', message: 'No has solicitado ningún documento a cancelar.' });
            }
            if (infoFolio.folioID !== 'IV') {
                return showAlert({ type: 'warning', message: 'Solo es posible cancelar facturas de momento.' });
            }
            if (itsCreditInvoice && canCancelDocument) {
                return showAlert({ type: 'error', message: 'No se puede cancelar el documento, ya tiene una nota de crédito relacionada.' });
            }
        }

        if (actionSale === 'cancel' && ourInfoForReturn.isDeliveryInvoice === 'Y' && ourInfoForReturn.paidOut === 'N' && !itsCreditInvoice) {
            showAlert({ type: 'info', message: 'FACTURA A DOMICILIO NO PAGADA, SE CANCELARA EL CFDI' });
            await this.CloseDocument();
        } else if (actionSale === 'cancel' && itsCreditInvoice && newOrderModel.ReceiptNum !== null) {
            const wasPayedTotally = Number(newOrderModel.AbonadoTotal) === Number(newOrderModel.DocTotal) ? true : false;
            if (wasPayedTotally || newOrderModel.payWasCanceled === 'Y') {
                if (!this.state.ShowRefundOfPaymentsModal) {
                    await this.EnableShowRefundOfPaymentsModal();
                }
                newOrderModel.DocStatus = 'O';
                this.setState({
                    newOrderModel
                });
                if (show) {
                    $('#refundOfPaymentsModal').modal('show');
                } else {
                    $('#refundOfPaymentsModal').modal('hide');
                }
            } else if (!wasPayedTotally || newOrderModel.payWasCanceled === 'N') {
                await this.CloseDocument(); // nota de crédito no timbrada y no relacionada
            }

        } else {
            if (!this.state.ShowRefundOfPaymentsModal) {
                await this.EnableShowRefundOfPaymentsModal();
            }
            if (show) {
                $('#refundOfPaymentsModal').modal('show');
            } else {
                $('#refundOfPaymentsModal').modal('hide');
            }
        }
    }

    ConsultarEstatusCFDI = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { pedido } = this.state;
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        const data = {
            DocEntry: infoFolio.DocEntry,
            Table: {
                name: infoFolio.table,
            }
        }

        enableSpinner(true);
        let response = await apiClient.ConsultarEstatusCFDI(data);
        enableSpinner(false);
        if (response.paymentStatus.length > 0) {
            await this.setState({
                PaymentStatus: response.paymentStatus
            });
            $('#paymentStatusListModal').modal('show');
        }


        if (response.status === 1) { //Documento cancelado
            this.setState({
                isCancel: true,
                PaymentStatus: [],
            })
            return showAlert({ type: "success", message: `${pedido}: ${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) { //Cancelable 
            this.setState({
                isValidCFDI: true,
                PaymentStatus: response.paymentStatus || []
            })
            return showAlert({ type: "info", message: `${pedido}: ${response.message ?? ''}`, timeOut: 8000 });
        } else {
            return showAlert({ type: "warning", message: `${pedido}: ${response.message ?? ''}`, timeOut: 8000 });
        }


    }

    ConsultarEstatusPagoCFDI = async (DocEntry) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { PaymentModel } = this.state;
        let data = {
            DocEntry,
            Table: {
                name: 'ORCT',
            }
        }

        enableSpinner(true);
        let response = await apiClient.ConsultarEstatusCFDI(data);
        enableSpinner(false);
        if (response.paymentStatus.length > 0) {
            await this.setState({
                PaymentStatus: response.paymentStatus
            });
            $('#paymentStatusListModal').modal('show');
        }

        if (response.status === 1) { //Documento cancelado
            PaymentModel.IsCancelSAP = true;
            PaymentModel.StatusCFDI = true;
            await this.setState({
                PaymentModel
            })
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) { //Cancelable 
            PaymentModel.StatusCFDI = true;
            await this.setState({
                PaymentModel
            })
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            return showAlert({ type: "warning", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    }

    ShowCancelConfirm = async (isInvoice) => {
        $('#cancelCFDI').modal('show');
        let CancelFunction = null;
        if (isInvoice) {
            CancelFunction = this.CancelCFDI;
        } else {
            CancelFunction = this.CancelPaymentCFDI;
        }

        await this.setState({
            CancelFunction
        })

    }

    CancelCFDI = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { pedido } = this.state;

        $('#cancelCFDI').modal('hide');
        const motivo = document.getElementById("selectCancelCFDI").value;
        const U_FMB_UUID_RELACIONADO = document.getElementById("U_FMB_UUID_RELACIONADO") !== null && document.getElementById("U_FMB_UUID_RELACIONADO") !== undefined ? document.getElementById("U_FMB_UUID_RELACIONADO").value : '';

        if (motivo === '00') {
            return showAlert({ type: "warning", message: `Parámetro inválido. El motivo de cancelacion no es un valor válido`, timeOut: 8000 });
        } else if (motivo === '01' && U_FMB_UUID_RELACIONADO === '') {
            return showAlert({ type: "warning", message: `Parámetro inválido. Debes de colocar un UUID`, timeOut: 8000 });
        }


        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
        const data = {
            DocEntry: infoFolio.DocEntry,
            Table: {
                name: infoFolio.table,
            },
            Motivo: motivo || '02',
            U_FMB_UUID_RELACIONADO: U_FMB_UUID_RELACIONADO || '',
        }
        $('#cancelDocuments').modal('hide');

        enableSpinner(true);
        const response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        $('#cancelCFDI').modal('hide');
        if (response.status === 0) {
            return showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) {
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            this.setState({
                isCancel: true,
                isValidCFDI: false
            })
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    };

    CancelPaymentCFDI = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { PaymentModel } = this.state;
        $('#cancelCFDI').modal('hide');

        let motivo = document.getElementById("selectCancelCFDI").value;
        const U_FMB_UUID_RELACIONADO = document.getElementById("U_FMB_UUID_RELACIONADO") !== null && document.getElementById("U_FMB_UUID_RELACIONADO") !== undefined ? document.getElementById("U_FMB_UUID_RELACIONADO").value : '';

        if (motivo === '00') {
            return showAlert({ type: "warning", message: `Parámetro inválido. El motivo de cancelacion no es un valor válido`, timeOut: 8000 });
        } else if (motivo === '01' && U_FMB_UUID_RELACIONADO === '') {
            return showAlert({ type: "warning", message: `Parámetro inválido. Debes de colocar un UUID`, timeOut: 8000 });
        }

        let data = {
            DocEntry: PaymentModel.DocEntry,
            Table: {
                name: 'ORCT',
            },
            Motivo: motivo || '02',
            U_FMB_UUID_RELACIONADO: U_FMB_UUID_RELACIONADO || '',
        }

        $('#cancelDocuments').modal('hide');

        enableSpinner(true);
        let response = await apiClient.CancelCFDI(data);
        enableSpinner(false);

        $('#cancelCFDI').modal('hide');
        if (response.status === 0) {
            PaymentModel.IsCancelSAP = false;
            PaymentModel.StatusCFDI = false;
            await this.setState({
                PaymentModel
            })
            return showAlert({ type: "error", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else if (response.status === 2) {
            PaymentModel.IsCancelSAP = false;
            PaymentModel.StatusCFDI = false;
            await this.setState({
                PaymentModel
            })
            return showAlert({ type: "info", message: `${response.message ?? ''}`, timeOut: 8000 });
        } else {
            PaymentModel.IsCancelSAP = true;
            PaymentModel.StatusCFDI = true;
            await this.setState({
                PaymentModel
            })
            return showAlert({ type: "success", message: `${response.message ?? ''}`, timeOut: 8000 });
        }
    };

    CancelRelatedCFDI = async (DocEntry) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { PaymentStatus } = this.state;

        let motivo = document.getElementById("selectCancelCFDI").value;
        if (motivo === '00') {
            return showAlert({ type: "warning", message: `Seleccione un motivo de cancelación`, timeOut: 8000 });
        }

        if (PaymentStatus.length === 0) {
            return showAlert({ type: "warning", message: `Sin documentos por cancelar`, timeOut: 8000 });
        }

        $('#cancelCFDI').modal('hide');


        for (let index = 0; index < PaymentStatus.length; index++) {
            const document = PaymentStatus[index];
            document.Motivo = motivo;
        }

        enableSpinner(true);
        let response = await apiClient.cancelRelatedCFDI(PaymentStatus);
        setTimeout(async () => {
            enableSpinner(false);
            if (response.paymentStatus.length > 0) {
                await this.setState({
                    PaymentStatus: response.paymentStatus
                });
            }
        }, 1000);
    }

    CancelPaymentSAP = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PaymentModel } = this.state;

        enableSpinner(true);
        let response = await apiClient.CancelPayment({ DocEntry: PaymentModel.DocEntry });
        enableSpinner(false);
        if (response.status === -1) {
            PaymentModel.Canceled = 'Y';
            await this.setState({
                PaymentModel,
                showPaymentModal: !this.state.showPaymentModal,
            });
            $('#paymentModal').modal('hide');
            await this.ConsultarEstatusCFDI();
            return showAlert({ type: "success", message: `${response.message}`, timeOut: 8000 });
        } else {
            return showAlert({ type: "warning", message: `${response.message}`, timeOut: 8000 });
        }



    }

    CancelPayments = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PaymentStatus } = this.state;

        if (PaymentStatus.length === 0) {
            return showAlert({ type: "warning", message: `Sin documentos por cancelar`, timeOut: 8000 });
        }
        enableSpinner(true);
        let response = await apiClient.CancelPayments(PaymentStatus);
        setTimeout(async () => {
            enableSpinner(false);
            if (response.paymentStatus.length > 0) {
                await this.setState({
                    PaymentStatus: response.paymentStatus
                });
            }
        }, 1000);
    }

    SearchPayment = async (payment) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        if (payment.U_FMB_FOLIO_COUNTER === '') {
            showAlert({ type: 'warning', message: 'Documento no disponible' });
            return;
        }

        let datos = {
            folio: payment.U_FMB_FOLIO_COUNTER,
            cliente: payment.CardCode,
        }
        enableSpinner(true);
        let IncomingPayments = await apiClient.getIncomingPayments(datos);
        enableSpinner(false);
        if (IncomingPayments.status === SERVICE_RESPONSE.SUCCESS) {

            let newOrderModel = this.createNewOrderDetails(IncomingPayments);

            this.setState({
                PaymentModel: newOrderModel,
                showPaymentModal: !this.state.showPaymentModal,
            });

            $('#paymentModal').modal({ backdrop: 'static', keyboard: false }, 'show');
            return;
        } else {
            this.setState({
                showPaymentModal: false,
            });
        }
        showAlert({ type: 'error', message: IncomingPayments.message });
    }

    CloseModalPayment = () => {
        $('#paymentModal').modal('hide');
        this.setState({
            showPaymentModal: false,
        });
    }

    OpenShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: !this.state.showAreYouAgreeModal,
        });
        $('#areYouAgreeModal').modal('show');
    }

    CloseShowAreYouAgreeModal = async () => {
        await this.setState({
            showAreYouAgreeModal: false,
        });
    }

    CloseShowAreYouAgreeModal_Join_e_Wallet = async () => {
        await this.setState({
            showAreYouAgreeModal_Join_e_Wallet: false,
            PointsCardModel: new PointsCardModel(),
        });
    };

    Add_To_PointsCard = async () => {
        await this.setState({
            showNewCustomerModal: !this.state.showNewCustomerModal,
        });
        $("#newCustomer").modal({ backdrop: 'static', keyboard: false }, 'show');
    };

    change_U_FMB_Handel_Email = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;

        let value = event.nativeEvent.target.value;
        if (value.length > 100) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida.' });
        }
        PointsCardModel.Customer.U_FMB_Handel_Email = value;
        this.setState({
            PointsCardModel,
        })
    };

    change_U_FMB_Cellular = event => {
        const { notificationReducer: { showAlert } } = this.props;
        const { PointsCardModel } = this.state;

        let value = event.nativeEvent.target.value;
        if (isNaN(value)) {
            showAlert({ type: 'warning', message: 'Solo se permiten números.' });
            return
        }
        if (value.length > 20) {
            showAlert({ type: 'error', message: 'La cantidad de caracteres excede la permitida.' });
        }
        PointsCardModel.Customer.U_FMB_Cellular = value;
        this.setState({
            PointsCardModel,
        })
    };

    sendNewCustomer = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { PointsCardModel } = this.state;

        if (!PointsCardModel.Customer.U_FMB_Handel_Email) {
            showAlert({ type: "warning", message: "Es necesario registrar un correo electrónico.", timeOut: 5000 });
            return;
        };

        if (!EMAIL_FORMAT_REGEX.test(PointsCardModel.Customer.U_FMB_Handel_Email)) return showAlert({
            type: 'warning',
            message: 'Por favor, revisa el formato, Ejemplo: nombre@correo.com'
        });

        if (!PointsCardModel.Customer.U_FMB_Cellular) {
            showAlert({ type: "warning", message: "Es necesario registrar un número de teléfono.", timeOut: 5000 });
            return;
        };

        if (PointsCardModel.Customer.U_FMB_Cellular.length < 10) {
            showAlert({ type: "warning", message: "El número de teléfono debe de incluir al menos 10 caracteres.", timeOut: 5000 });
            return;
        };

        enableSpinner(true);
        let data = {
            Customer: PointsCardModel.Customer,
        }
        let response_NewCustomerPointsCard = await apiClient.NewCustomerPointsCard(data);

        if (response_NewCustomerPointsCard.status !== 1) {
            showAlert({ type: "error", message: `${response_NewCustomerPointsCard.message}` });
            enableSpinner(false);
            return;
        }
        showAlert({ type: "success", message: `${response_NewCustomerPointsCard.message}` });
        $("#newCustomer").modal("hide");
        await this.setState({
            showAreYouAgreeModal_Join_e_Wallet: false,
            showNewCustomerModal: false,
            PointsCardModel: new PointsCardModel(),
        });
        $("#newCustomer").modal("hide");
        enableSpinner(false);
    };

    createNewOrderDetails = (detailsResponse) => {
        let newOrderModel = new NewOrder();

        let header = detailsResponse.data.header;
        let items = detailsResponse.data.items || [];
        let checks = detailsResponse.data.paymentChecks;

        newOrderModel.OriginDocumentCreate = 'payment';
        newOrderModel.userFields = [];
        newOrderModel.ObjType = header.ObjType;
        newOrderModel.DocType = header.DocType;
        newOrderModel.DocumentType = "F";
        newOrderModel.WddStatus = header.WddStatus;
        newOrderModel.DocEntry = header.DocEntry || "";
        newOrderModel.DocEntryRel = header.DocEntryRel || "";
        newOrderModel.CardCode = header.CardCode;
        newOrderModel.Balance = header.Balance || 0;
        newOrderModel.UserID = 0;
        newOrderModel.DocStatus = header.DocStatus;
        newOrderModel.CardName = header.CardName;
        newOrderModel.NextFolio = header.DocNum;
        newOrderModel.DocNum = header.DocNum;
        newOrderModel.StatusDocument = '';
        newOrderModel.NumAtCard = header.NumAtCard;
        newOrderModel.SerieName = header.SeriesName;
        newOrderModel.SerieCode = header.Series;
        newOrderModel.ExtraDays = header.metodoPago;
        newOrderModel.SerieArray = [];
        newOrderModel.DocDate = moment(header.DocDate).format('YYYY-MM-DD');
        newOrderModel.DocDueDate = moment(header.DocDueDate).format('YYYY-MM-DD');
        newOrderModel.TaxDate = moment(header.TaxDate).format('YYYY-MM-DD');
        newOrderModel.ReqDate = moment(header.ReqDate).format('YYYY-MM-DD');
        newOrderModel.ReqType = header.ReqType;
        newOrderModel.Requester = header.Requester;
        newOrderModel.ReqName = header.ReqName;
        newOrderModel.Branch = header.Branch;
        newOrderModel.BranchName = header.BranchName;
        newOrderModel.Department = header.Department;
        newOrderModel.DepartmentName = header.DepartmentName;
        newOrderModel.Email = header.Email;
        newOrderModel.Notify = header.Notify;
        newOrderModel.SlpCode = header.SlpCode;
        newOrderModel.SlpName = header.SlpName;
        newOrderModel.CntctCode = header.CntctCode;
        newOrderModel.CntctName = header.CntntName;
        newOrderModel.OwnerCode = header.OwnerCode || "";
        newOrderModel.OwnerName = header.OwnerName || "";
        newOrderModel.Comments = header.Comments || "";
        newOrderModel.Status = '';
        newOrderModel.StepCode = '';
        newOrderModel.WtmName = '';
        newOrderModel.Subtotal = 0;
        newOrderModel.DiscountPercent = parseFloat(header.DiscPrcnt).toFixed(2);
        newOrderModel.Discount = 0;
        newOrderModel.Taxes = 0;
        newOrderModel.Total = 0;
        newOrderModel.Items = [];

        newOrderModel.GroupNum = header.GroupNum;
        newOrderModel.GroupName = header.condicionesPago;
        newOrderModel.GroupCode = header.GroupCode;
        newOrderModel.PymCode = header.PeyMethod;
        newOrderModel.PymName = header.payDescription;
        newOrderModel.indexRowDetails = '';

        //Direccion de entrega para documentos generales
        newOrderModel.Address2 = header.Address2;
        newOrderModel.ShipToCode = header.ShipToCode;
        // definido desde el usuario
        newOrderModel.TaxeDefaultPartner = header.TaxCode || '';
        newOrderModel.TaxeRateDefaultPartner = header.TaxCodeRate || '';
        newOrderModel.OcrCode2DefaultPartner = header.OcrCode2 || '';
        newOrderModel.AcctCodeDefaultPartner = header.AcctCodeItem || '';
        newOrderModel.CogsAcctDefaultPartner = header.CogsAcctItem || '';
        newOrderModel.AcctCodeNameDefaultPartner = header.AcctCodeItemName || '';
        newOrderModel.CogsAcctNameDefaultPartner = header.CogsAcctItemName || '';

        //Trasnfers
        newOrderModel.Address = header.Address;
        newOrderModel.Filler = header.Filler;
        newOrderModel.FillerName = "";
        newOrderModel.PickRmrk = header.PickRmrk || '';
        newOrderModel.ToWhsCode = header.ToWhsCode || '';
        newOrderModel.ToWhsCodeName = "";
        newOrderModel.JrnlMemo = header.JrnlMemo;
        newOrderModel.GroupNumTraslado = header.GroupNum;
        newOrderModel.GroupNumTrasladoName = header.ListName;
        //Pagos
        newOrderModel.TransId = header.TransId || "";
        newOrderModel.CounterRef = header.CounterRef || "";
        newOrderModel.NoDocSum = parseFloat(header.NoDocSum).toFixed(2) || 0;
        newOrderModel.BpAct = header.BpAct || "";
        newOrderModel.BpActFormatCode = header.BpActFormatCode || "";
        newOrderModel.BpActName = "";
        newOrderModel.PayNoDoc = header.PayNoDoc === 'Y' ? true : false;
        newOrderModel.CashSum = header.DocCurr === 'SOL' ? header.CashSum : header.CashSumFC;
        newOrderModel.CreditSum = header.DocCurr === 'SOL' ? header.CreditSum : header.CredSumFC;
        newOrderModel.CheckSum = header.DocCurr === 'SOL' ? header.CheckSum : header.CheckSumFC;
        newOrderModel.TrsfrSum = header.DocCurr === 'SOL' ? header.TrsfrSum : header.TrsfrSumFC;
        // trasferencias
        newOrderModel.TrsfrAcct = header.TrsfrAcct;
        newOrderModel.TrsfrAcctName = header.TrsfrAcctName;
        newOrderModel.TrsfrDate = moment(header.TrsfrDate).add(1, 'd').format('YYYY-MM-DD');
        newOrderModel.TrsfrRef = header.TrsfrRef;
        newOrderModel.TrsfrAcctFormatCode = header.TrsfrAcctFormatCode;
        // cheques
        newOrderModel.CheckAcct = header.CheckAcct;
        newOrderModel.CheckList = checks;
        newOrderModel.CheckAcctFormatCode = header.CheckAcctFormatCode;
        //cash
        newOrderModel.CashAcct = header.CashAcct;
        newOrderModel.CashAcctFormatCode = header.CashAcctFormatCode;

        //Lista de precios C100 /
        newOrderModel.PriceListNum = header.ListNum || "";
        //CreditLine
        newOrderModel.CreditLine = header.CreditLine || 0;
        newOrderModel.transactionId = header.TransId || '';
        newOrderModel.PaidToDate = header.PaidToDate || 0;
        newOrderModel.BackOrder = header.BackOrder || '';
        newOrderModel.PartDelivr = header.PartDelivr || '';
        newOrderModel.folio = header.folio;


        //Tipo cambiario
        newOrderModel.DocCur = header.DocCurr;
        newOrderModel.ChangeRate = header.DocRate || 1;
        let newService = [];
        let newItemsPayment = [];
        let lastLineNum = items.length;

        for (let index = 0; index < items.length; index++) {
            const item = items[index];

            let itemModelPayment = new NewItemPayment();

            if ((lastLineNum - 1) === index) {
                newOrderModel.LastLineNumItems = item.LineNum;
            }

            itemModelPayment.DocEntry = item.DocEntry;
            itemModelPayment.DocNum = item.DocNum;
            itemModelPayment.docType = item.ObjType;
            itemModelPayment.DocSubType = item.DocSubType;
            itemModelPayment.RefDate = moment(item.TaxDate).add(1, 'd').format('YYYY-MM-DD');
            itemModelPayment.daysLast = 0;
            itemModelPayment.total = item.DocCur === 'SOL' ? item.DocTotal : item.DocTotalFC;
            itemModelPayment.pastDueBalance = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidToDate) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.totalPago = item.DocCur === 'SOL' ? parseFloat(item.totalPago ? item.totalPago : item.PaidSum).toFixed(4) : item.totalPagoFC;
            itemModelPayment.DocCur = item.DocCur;
            itemModelPayment.totalOutgoing = item.DocCur === 'SOL' ? item.SumApplied : item.totalPagoFC;
            itemModelPayment.saldoVencido = item.DocCur === 'SOL' ? (item.DocTotal - item.PaidSum) : (item.DocTotalFC - item.PaidFC);
            itemModelPayment.OcrCode = item.OcrCode;
            itemModelPayment.OcrName = "";
            itemModelPayment.OcrCode2 = item.OcrCode2;
            itemModelPayment.OcrName2 = "";
            itemModelPayment.OcrCode3 = item.OcrCode3;
            itemModelPayment.OcrName3 = "";
            itemModelPayment.OcrCode4 = item.OcrCode4;
            itemModelPayment.OcrName4 = "";
            itemModelPayment.OcrCode5 = item.OcrCode5;
            itemModelPayment.OcrName5 = "";

            newItemsPayment.push(itemModelPayment);
        }

        newOrderModel.service = newService;
        newOrderModel.ItemsPayments = newItemsPayment;

        if (newOrderModel.WddStatus === "P") {
            newOrderModel.isDocumentWithAuthorization = true; // servicio 2 donde no actualiza los items solo el documento
        }

        //PAGOS
        newOrderModel.totalDocumento = 0;
        newOrderModel.totalPago = 0;
        newOrderModel.CheckSum = 0;

        newOrderModel.ItemsPayments.map(item => {
            newOrderModel.totalDocumento += Number(item.pastDueBalance); //item.total
            newOrderModel.totalPago += Number(item.totalPago);
        });

        newOrderModel.CheckList.map(item => {
            newOrderModel.CheckSum += Number(item.CheckSum);
        });

        if (newOrderModel.PayNoDoc) {
            newOrderModel.totalDocumento = newOrderModel.NoDocSum;
        }


        newOrderModel.totalRecibido = Number(newOrderModel.CashSum) + Number(newOrderModel.CreditSum) + Number(newOrderModel.CheckSum) + Number(newOrderModel.TrsfrSum);

        if (newOrderModel.DocCur != newOrderModel.DocCurDocumentsPayment) {
            let localCurrency = CURRENCY;
            let rate = 1;
            if (localCurrency == newOrderModel.DocCur) {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCurDocumentsPayment == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });

                newOrderModel.totalPago = Number((newOrderModel.totalPago * rate).toFixed(2));
            } else {
                newOrderModel.Currencies.map(currency => {
                    if (newOrderModel.DocCur == currency.CurrCode) {
                        rate = currency.Rate || 1;
                    }
                });
                newOrderModel.totalPago = Number((newOrderModel.totalPago / rate).toFixed(2));
            }
        }

        newOrderModel.totalPago = Number((newOrderModel.totalPago).toFixed(2));
        newOrderModel.totalRestante = newOrderModel.totalPago - newOrderModel.totalRecibido;
        return newOrderModel;

    };

    ContinueToCancel = async () => {
        $('#paymentStatusListModal').modal('hide');
        await this.setState({ PaymentStatus: [], isValidCFDI: true })
    }

    CancelReturnPayment = async () => {
        const { ShowRefundOfPaymentsModal } = this.state
        if (ShowRefundOfPaymentsModal) {
            this.setState({ ShowRefundOfPaymentsModal: false })
        }
    }

    CheckIfHaveSelectedReturnItems = async (myFunction, messageError) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { checkboxDataTables, newOrderModel, ShowRefundOfPaymentsModal, createdFromReserve, ItsReserveInvoice } = this.state
        let docEntryArray = [];
        if (createdFromReserve) {
            showAlert({ type: 'info', message: `ENTREGA DE FACTURA DE RESERVA. NO ES POSIBLE GENERAR DEVOLUCIONES` });
            return;
        }

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(newOrderModel.Items[id]);
            }
        }

        if (docEntryArray.length) {
            for (let index = 0; index < docEntryArray.length; index++) {
                const element = docEntryArray[index];
                if (element.newQuantity === 0) {
                    showAlert({ type: 'warning', message: 'La cantidad a devolver debe ser mayor a cero.' });
                    return;
                }
                element.Quantity = element.newQuantity;
                element.OpenLneQty = element.newQuantity;
                element.BatchNumbers = [];

            }
        }

        if (docEntryArray.length === 0) {
            showAlert({ type: 'warning', message: messageError });
            return;
        } else {
            // VALIDATE IF IS PARTIAL RETURN TO RETURN THE USER --- ISRAEL PIDIÓ QUE AHORA SI SE PUDIERA DEVOLVER LAS DE CREDITO NO PAGADAS DE FORMA PARCIAL
            // if (ourInfoForReturn.paidOut && ourInfoForReturn.paidOut === 'N') {
            //     const isPartial = await this.CheckIfIsPartialReturn(newOrderModel, docEntryArray);
            //     if (isPartial) {
            //         showAlert({ type: "info", message: "DEVOLUCIÓN PARCIAL DENEGADA", timeOut: 8000 });
            //         showAlert({ type: "info", message: "El documento aun no tiene registrado un pago, cancela este documento y levanta uno nuevo.", timeOut: 10000 });
            //         return
            //     }
            // }
            // -----------------------------------
            newOrderModel.Items = docEntryArray;
            let itemsBatch = newOrderModel.Items.filter((item) => item.ManBtchNum === 'Y');
            if (itemsBatch.length > 0) {
                let isBatchComplete = true;
                for (let index = 0; index < itemsBatch.length; index++) {
                    const item = itemsBatch[index];
                    item.SnBUoMQty = 0;
                    for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                        const batch = item.BatchNumbers[indez];
                        item.SnBUoMQty += Number(batch.newQuantity);
                    }
                    if (Number(item.SnBUoMQty) !== Number(item.newQuantity)) {
                        isBatchComplete = false;
                    }
                }
                if (!isBatchComplete) {
                    let batchItems = []
                    const docEntry = newOrderModel.NextFolio;
                    const counter = true;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        batchItems.push({ LineNum: item.LineNum, AuxLineNum: item.AuxLineNum, ItemCode: item.ItemCode, WhsCode: item.WhsCode, InvntSttus: item.InvntSttus })
                    }
                    const data = { batchItems, docEntry, counter, ItsReserveInvoice };
                    enableSpinner(true);
                    let batchsResponse = await apiClient.GetBatchsToReturn(data);
                    enableSpinner(false);

                    if (batchsResponse.status === 0) {
                        showAlert({ type: 'error', message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }
                    let isNewBatch = false;
                    for (let index = 0; index < newOrderModel.Items.length; index++) {
                        const item = newOrderModel.Items[index];
                        let deliveredQty = 0;
                        for (let index2 = 0; index2 < batchsResponse.data.length; index2++) {
                            const itemBatch = batchsResponse.data[index2];
                            if (item.LineNum === itemBatch.LineNum && item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) { isNewBatch = true; }
                                for (let index3 = 0; index3 < itemBatch.AvailableBatchNumbers.length; index3++) {
                                    const batch = itemBatch.AvailableBatchNumbers[index3];
                                    batch.Quantity = Number(batch.Quantity) ?? 0;
                                    deliveredQty += batch.Quantity;
                                }
                                item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                if (item.Quantity > deliveredQty) { item.AvailableBatchNumbers[0].Quantity += (item.Quantity - deliveredQty); }
                            }
                        }
                    }

                    if (isNewBatch) {
                        await this.setState({
                            newOrderModel,
                            showBatchSelectionModal: true,
                        });
                        $('#batchSelectionModal').modal('show');

                        await this.RefreshReturnTotal(newOrderModel);
                        if (!ShowRefundOfPaymentsModal) {
                            await this.EnableShowRefundOfPaymentsModal();
                        }

                    } else {
                        showAlert({ type: 'error', message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                        return;
                    }

                } else {
                    // no lo borro porque pueden meter autorizaciones para devoluciones
                    // const isAuthorization = await this.ValidateAuthorization();
                    const isAuthorization = false;
                    if (!isAuthorization) {
                        await this.RefreshReturnTotal(newOrderModel);
                        if (!ShowRefundOfPaymentsModal) {
                            await this.EnableShowRefundOfPaymentsModal();
                        }
                        myFunction();
                    }
                }
            } else {
                await this.RefreshReturnTotal(newOrderModel);
                if (!ShowRefundOfPaymentsModal) {
                    await this.EnableShowRefundOfPaymentsModal();
                }
                myFunction();
            }


            newOrderModel.AuxViewCounter = "RefundModal";
            await this.toggleDocumentSelectedAll(true);
            await this.refreshModel(newOrderModel)
            // -----------------------------------
            // ORIGINAL
            // newOrderModel.Items = docEntryArray;
            // await this.RefreshReturnTotal(newOrderModel);
            // if (!ShowRefundOfPaymentsModal) {
            //     await this.EnableShowRefundOfPaymentsModal();
            // }
            // myFunction();
        }
    }

    RefreshReturnTotal = async (newOrderModel) => {
        const { pedido } = this.state
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
        let linesVerified = [];
        let subTotal = 0;
        let impuestos = 0;
        let total = 0;

        for (let item of newOrderModel.Items) {
            if (infoFolio.folioID !== 'IV') item.PriceBefDi = Number(item.Price);
            const discount = Number(item.PriceBefDi) * Number(item.Discount) / 100;
            const price = Number(item.PriceBefDi) - discount;
            const total = Number((price * item.newQuantity).toFixed(2));
            const taxLine = Number((total * Number(item.TaxRate) / 100).toFixed(3));

            item.Total = total.toFixed(2);
            item.TaxeResult = taxLine.toFixed(2);
            item.VatSum = Number(item.TaxeResult);

            const lineVerified = linesVerified.find(line => Number(line) === Number(item.AuxLineNum));
            if (isNaN(lineVerified)) {
                subTotal += Number(item.Total);
                impuestos += taxLine;
                linesVerified.push(isNaN(item.AuxLineNum) || item.AuxLineNum === '' ? -1 : item.AuxLineNum);
            }
        }

        total = Number(subTotal.toFixed(2)) + Number(impuestos.toFixed(2));
        newOrderModel.Subtotal = Number(subTotal).toFixed(2);
        newOrderModel.Taxes = Number(impuestos).toFixed(2);
        newOrderModel.Total = Number(total);

        this.setState({ newOrderModel });
    }

    Devolver = async (validReturn = true) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, idWorkShift, newOrderModelCopia, _user, infoCondiPagoReturn, pedido, ourInfoForReturn, actionSale, ItsReserveInvoice } = this.state;
        if (actionSale === 'cancelSale') { // TO PASS A CANCELLATION ACTION AS A NORMAL RETURN ACTION
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                let item = newOrderModel.Items[index];
                item.newQuantity = item.OpenQty;
            }
        }
        await this.setState({
            showrefund: true
        });
        let ObjType = '';
        let series = '';
        let newItems = [];
        let today = moment(new Date()).format('YYYY-MM-DD');

        if (infoCondiPagoReturn === undefined && infoCondiPagoReturn === '') {
            showAlert({ type: "info", message: "NO SE PUEDE DETERMINAR CUAL FUE EL MÉTODO DE PAGO DE ESTE DOCUMENTO", timeOut: 8000 });
            return
        }

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const element = newOrderModel.Items[index];
            if (!element.newQuantity) {
                showAlert({ type: "warning", message: "El artículo " + element.ItemCode + " no tiene cantidad a devolver ", timeOut: 5000 });
                return;
            }
        }

        if (newOrderModel.DocStatus === 'O' && (newOrderModel.NextFolio.slice(3, 5) === "DH" || this.state.ourInfoForReturn.isDeliveryInvoice === 'Y') && ourInfoForReturn.paidOut === 'N') {
            showAlert({ type: "info", message: "ESTE DOCUMENTO ES DE UNA VENTA A DOMICILIO SIN PAGAR", timeOut: 8000 });
            return
        }

        let OpenQty = 0;
        let Quantity = 0;

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const item = newOrderModel.Items[index];
            item.Quantity = Number(item.newQuantity);

            OpenQty += Number(item.OpenQty);
            Quantity += Number(item.newQuantity);
            newItems.push(item);
        }
        newOrderModel.NumAtCard = OpenQty !== Quantity ? '' : newOrderModel.folio;
        if (newOrderModel.DocStatus === 'C') {
            newOrderModel.U_FMB_RelatedFolio = newOrderModel.NumAtCard;
        }

        if (Number(newOrderModel.ObjType) === 15) {
            ObjType = 'return';
            series = _user?.U_FMB_ValidateSeriesORDN;
        }

        if (Number(newOrderModel.ObjType) === 13) {
            ObjType = 'creditNote';
            series = _user?.U_FMB_ValidateSeriesORIN;
            if (newOrderModel.U_UDF_UUID) {
                newOrderModel.U_FMB_UUID_RELACIONADO = [newOrderModel.U_UDF_UUID];
                newOrderModel.U_FMB_TIPO_REL = '01';
            }
        }

        if (Number(newOrderModel.OutstandingBalance) !== 0 && Number(newOrderModel.ObjType) === 13 && Number(newOrderModel.AbonadoTotal) !== 0) {
            if (Number(newOrderModel.Total) > Number(newOrderModel.AbonadoTotal)) {
                showAlert({ type: "error", message: "EL MONTO DE DEVOLUCIÓN ES MAYOR AL TOTAL DEL PAGO RECIBIDO. NO ES POSIBLE DEVOLVER", timeOut: 50000 });
                return;
            } else if (Number(newOrderModel.Total) <= Number(newOrderModel.AbonadoTotal)) {
                // const totalDeuda = Number(newOrderModel.AbonadoTotal) - Number(newOrderModel.Total);
                showAlert({ type: "info", message: `SU DEUDA DE ESTE DOCUMENTO SE HA REDUCIDO `, timeOut: 50000 });
            }
        }

        let seriesUsers = series.split("|");
        let table = this.selectTable(ObjType);
        newOrderModel.SerieCode = seriesUsers[0];
        newOrderModel.idSession = idWorkShift;


        newOrderModel.DocDueDate = today;
        newOrderModel.TaxDate = today;
        newOrderModel.validReturn = newOrderModel.PaymentsToReturn.length > 0 ? false : validReturn;

        if (table.name === 'ORIN') {
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const element = newOrderModel.Items[index];
                if (element.PriceBefDi) {
                    element.Price_2 = element.Price;
                    element.Price = element.PriceBefDi;
                }
            }
        }
        // to fix the error "BASE DOCUMENT" HAS ALREADY BEEN CLOSED
        if (newOrderModel.DocStatus === 'C') {
            await this.BrakeRelationDoc();
        }

        newOrderModel.auxDeliveriSerie = await this.GetSeriesByCurrentUserProp('U_FMB_ValidateSeriesODLN');
        newOrderModel.OriginDoc = 'Counter-Devolver';

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: newOrderModel,
            Time: moment().format(),
            UserTime: moment().format("HH:mm:ss"),
            ReturnReservInvoice: ItsReserveInvoice,
            TempPartner: true,
            ClientVersion: currentVersion
        };
        enableSpinner(true);
        const createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud, " + createDocumentResponse.message, timeOut: 5000 });
            return;
        } else if (createDocumentResponse.status === 8) {
            showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 50000 });
            $('#newUpdateModal').modal('show');
            return
        }

        //TRY CANCEL PAYMENT REQUEST
        const reqPayData = newOrderModel.PaymentRequestAmbassadorData
        reqPayData.Comments = newOrderModel?.Comments || null
        reqPayData.newTotalCancel = newOrderModel?.Total || 0
        apiClient.cancelPaymentRequest(reqPayData)


        const document = createDocumentResponse.data;

        if (table.name === 'ORIN') {
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const element = newOrderModel.Items[index];
                element.Price = element.Price_2;
            }
        }
        for (let x = 0; x < document.serviceLayeResponse.DocumentLines.length; x++) {
            const newservice = document.serviceLayeResponse.DocumentLines[x];
            for (let index = 0; index < newOrderModel.Items.length; index++) {
                const service = newOrderModel.Items[index];
                if (newservice.ItemCode === service.ItemCode) {
                    newservice.ItemDescription = service.Dscription ?? '';
                }
            }
        }

        this.CloseOpenRefundOfPaymentsModal(false)
        newOrderModel.DocDate = document.serviceLayeResponse.DocDate;
        newOrderModel.DocTime = data.UserTime || document.serviceLayeResponse.DocTime;
        newOrderModel.folio = document.createdFolio;
        newOrderModel.next_Folio_Cons = document.next_Folio_Cons;

        newOrderModelCopia.next_Folio_Cons = document.next_Folio_Cons;
        newOrderModel.folio = document.createdFolio;
        newOrderModelCopia.CardCode = document.serviceLayeResponse.CardCode;
        newOrderModelCopia.CardName = document.serviceLayeResponse.CardName;
        newOrderModelCopia.Items = document.serviceLayeResponse.DocumentLines;
        newOrderModelCopia.DocDate = document.serviceLayeResponse.DocDate;
        newOrderModelCopia.DocTime = document.serviceLayeResponse.DocTime;
        newOrderModelCopia.folio = document.createdFolio;
        newOrderModelCopia.VatSum = document.serviceLayeResponse.VatSum;
        newOrderModelCopia.DocTotal = document.serviceLayeResponse.DocTotal;

        $('#refundModal').modal('hide');
        // all IV docId always be payed
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);
        if (infoFolio.folioID === 'IV') {
            const creditNoteCreated = createDocumentResponse.data.createdFolio;
            const dataToPrint = {
                docsToPrintIds: [creditNoteCreated],
                typeDoc: 14
            }
            enableSpinner(true);
            const responseApi = await apiClient.getPrintDocsInfo(dataToPrint);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                return;
            }

            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: 'ORIN',
                ordersToAction: document,
                EnableEditButton: false,
                showPDFViewer: !this.state.showPDFViewer,
                ShowExtraActions: false
            });

            $("#pdfViewer").modal("show");

        } else {
            $('#refundTicketModal').modal('show');
            this.PrintDocuments("Devolucion", "80", newOrderModel);
        }

        await this.setState({
            newOrderModel: new NewOrderSales(),
            checkboxDataTables: (new Map()),
            newOrderModelCopia,
            pedido: '',
            ShowRefundOfPaymentsModal: false
        });
    }

    CashOut = async (movement) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docNum: movement.docNum, // folio
            docDate: movement.docDate,
            docTime: movement.docTime,
            comments: movement.comments,
            type: movement.type, // 1 equal to cashIn, 0 for cashOut
            cashSum: movement.cashSum,
            codeAutorization: movement.codeAutorization,
            idSession: movement.idSession,
            userID: movement.userID,
        }
        enableSpinner(true);
        let createMovementCashResponse = await apiClient.createMovementCash(data);
        enableSpinner(false);


        if (!createMovementCashResponse.status) {
            showAlert({ type: "error", message: createMovementCashResponse.message });
            return;
        }

        if (createMovementCashResponse.data.length === 0) {
            showAlert({ type: "info", message: "No hay Información por mostrar" });
            return;
        }
        await this.setState({
            showWithdrawalModal: true,
        });
    }

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id));
            return { checkboxDataTables };
        });
    }

    toggleDocumentSelectedAll = (action) => {
        const { newOrderModel } = this.state;
        let newCheckbox = (new Map());

        for (let index = 0; index < newOrderModel.Items.length; index++) {
            const register = newOrderModel.Items[index];
            if (Number(register.OpenQty) !== 0) {
                newCheckbox.set(index, action)
            }
        }

        this.setState({
            checkboxDataTables: newCheckbox
        });
    }

    ShowCreatedDevolutionDoc = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { newOrderModel } = this.state;

        let data = {
            docsToPrintIds: [folio],
            typeDoc: 16
        }

        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            // this.CloseCreatedInvoiceActions();
            return;
        }

        this.SetDefaultPartner();
        this.setState({
            showrefund: true
        })
        // temporal

        newOrderModel.Items = responseApi.data[0].docLines;
        newOrderModel.DocTotal = responseApi.data[0].docHeader.responseHeader.DocTotal;
        newOrderModel.folio = responseApi.data[0].docHeader.infoByFolio.folio
        newOrderModel.VatSum = responseApi.data[0].docHeader.responseHeader.VatSum;


        this.RefreshOrder(newOrderModel)
        $('#refundModal').modal('hide');
        $('#refundTicketModal').modal('show');

        // await this.setState({
        //   docsToPrint: responseApi.data ?? [],
        //   typeDocPrint: 'ORDN',
        //   ordersToAction: folio,
        //   EnableEditButton: false,
        //   newOrderModel,
        //   itemSelected: {},
        // });

        // await this.ShowPDFViewer();
        // $("#pdfViewer").modal("show");
    }

    ShowCreatedAcuseReturn = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { newOrderModel } = this.state;
        newOrderModel.CashSum = 0;
        newOrderModel.TotalRestante = 0;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 14
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            this.CloseCreatedInvoiceActions();
            return;
        }

        this.SetDefaultPartner();

        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'ORIM',
            ordersToAction: folio,
            EnableEditButton: false,
            newOrderModel,
            itemSelected: {},
        });

        await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    ShowClientsModalReBilling = async () => {
        if (!this.state.showClientsModal) {
            await this.EnableClientsModal();
        }
        if (!this.state.ItsComingOfRebilling) {
            await this.setState({
                ItsComingOfRebilling: !this.state.ItsComingOfRebilling,

            })
        }

        await this.setState({
            NextStepFunction: async () => {

                const { notificationReducer: { showAlert } } = this.props;
                let isUniversal = await this.CheckIfItsUniversalPartner();

                if (!isUniversal) {
                    $('#detailClientModal').modal('hide');
                    this.UploadInvoice();
                } else {
                    showAlert({ type: "error", message: `NO PUEDES FACTURAR A CON EL CLIENTE DE MOSTRADOR` });
                }
            }
        })

        $('#refundModal').modal('hide');
        $('#detailClientModal').modal('hide');
        $('#clientsModal').modal('show');
    }

    ChoosePartnerToReBilling = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state
        enableSpinner(true);
        let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
        enableSpinner(false);

        if (getPartnersResponse.status !== 1) {
            showAlert({ type: "error", message: `${getPartnersResponse.message}` });
            return;
        }

        await this.setState({
            newOrderModel,
            requireInvoice: false,
            updatebusinessPartner: getPartnersResponse.data[0],
            NextStepFunction: async () => {

                const { notificationReducer: { showAlert } } = this.props;
                let isUniversal = await this.CheckIfItsUniversalPartner();

                if (!isUniversal) {
                    $('#detailClientModal').modal('hide');
                    this.UploadInvoice();
                } else {
                    showAlert({ type: "error", message: `NO PUEDES FACTURAR A CON EL CLIENTE DE MOSTRADOR` });
                }

            }
        });

        // agregar lo de buscar la informacion de ahora el cliente seleccioando

        $('#clientsModal').modal('hide');
        $('#refundModal').modal('show');
        $('#detailClientModal').modal('show');
    }
    //#endregion

    //#region ########## CANCELATIONS ####################################################
    CancelDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { pedido } = this.state
        const infoFolio = await _generalFunctions.getDocInfoByFolio(pedido);

        const data = {
            DocEntry: infoFolio.DocEntry,
            table: {
                name: infoFolio.table
            }
        }
        enableSpinner(true);
        const cancelDocument = await apiClient.cancelDocumentCounter(data);
        enableSpinner(false);

        if (cancelDocument.status !== 1) {
            showAlert({ type: "error", message: cancelDocument.message, timeOut: 5000 });
            return;
        }
        showAlert({ type: "success", message: cancelDocument.message, timeOut: 5000 });
    }
    //#endregion

    //#region ########## SAVED SALES #####################################################
    GetSavedSales = async (value) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        const data = {
            Action: value,
            CodeBranchOffice: _user?.Branch.CodeBranchOffice
        }

        enableSpinner(true)
        const responseApi = await apiClient.getSavedSales(data)
        enableSpinner(false)

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            await this.setState({
                savedSales: [],
            })
            return
        }
        if (Array.isArray(responseApi.data) && responseApi.data.length === 0) {
            showAlert({ type: 'info', message: `NO SE ENCONTRARON REGISTROS PERTENECIENTES A SU ID DE CUENTA` });
        }
        await this.setState({
            savedSales: responseApi.data || [],
            TypeRecover: value
        })
    }

    OnchangeSaleSearchCode = (value) => {
        this.setState({ savedSaleSearchCode: value })
    }

    OnchangeChooseSale = (value, isAuthorization) => {
        this.setState({ chooseSavedSale: value, isAuthorization })
    }

    ChangeRecoverInterOpEntry = async value => {
        await this.setState({
            recoverInterOpEntry: value
        })
    }

    ChangeRecoverInterOpTypeDoc = async value => {
        this.setState({
            recoverInterOpTypeDoc: value
        })
    }

    ChangeRecoverInterOpDoc = async () => {

        await this.setState({
            recoverInterOpDoc: !this.state.recoverInterOpDoc
        })
    }

    SearchSavedByCode = async () => {
        const { savedSaleSearchCode, recoverInterOpDoc } = this.state
        const { notificationReducer: { showAlert } } = this.props
        document.getElementById('recuperarFolio').disabled = true;
        if (recoverInterOpDoc) {
            await this.setState({ chooseSavedSale: savedSaleSearchCode })
            await this.MountItemsFromDraft();
        } else {
            const folio = savedSaleSearchCode.substring(3, 5)
            if (folio === 'QT' || folio === 'OR') {
                await this.setState({
                    chooseSavedSale: savedSaleSearchCode,
                    recoveredQuote: folio === "QT"
                });
                await this.MountItemsFromDraft();
            } else {
                showAlert({ type: "info", message: "BUSQUE CON UN FOLIO VÁLIDO", timeOut: 2000 });
            }
        }

    }

    SetBranchOfficeTaxes = async newOrderModel => {
        const { enableSpinner } = this.props;
        const { _user, taxList } = this.state
        let auxTaxList = [];

        if (taxList && Array.isArray(taxList) && taxList.length > 0) {
            auxTaxList = taxList;
        } else {

            enableSpinner(true);
            const getTaxesResponse = await apiClient.getTaxesList('AR');
            enableSpinner(false);
            auxTaxList = getTaxesResponse.data || [];
        }

        let auxTaxes = [];
        if (auxTaxList.length > 0 && _user?.Branch.IsBorder !== '') {
            if (_user?.Branch.IsBorder === 'Y') { // si eres frontera
                // I did that because not everybody afiliate with 8% tax in border
                // auxTaxes = await auxTaxList.filter((element) => Number(element.Rate) !== 16);
            } else if (_user?.Branch.IsBorder === 'N') { // si no eres frontera
                auxTaxes = await auxTaxList.filter((element) => Number(element.Rate) !== 8);
            }
        }
        const findAttribute = _user?.Branch.IsBorder === 'Y' ? GlobalTaxes['Border'] : GlobalTaxes['BaseTax'];
        const arrayToFind = auxTaxes.length === 0 ? auxTaxList : auxTaxes;
        const findTaxElement = await arrayToFind.find((element) => Number(element.Rate) === findAttribute)

        if (findTaxElement) {
            newOrderModel.TaxCode = findTaxElement.Code;
            newOrderModel.TaxRate = Number(findTaxElement.Rate);
            newOrderModel.TaxName = findTaxElement.Name || '';
        }
        await this.setState({
            newOrderModel,
            taxList: auxTaxes.length === 0 ? auxTaxList : auxTaxes
        })
    }

    SetBranchOfficeBillingCatalogs = async () => {
        const { enableSpinner } = this.props;
        const { operationList, typeOperationList, igvOperationList } = this.state;
        let _OperationList = [];
        let _TypeOperationList = [];
        let _igvOperationList = [];

        if (!operationList?.length || !Array.isArray(operationList) || !igvOperationList?.length || !Array.isArray(igvOperationList) || !typeOperationList?.length || !Array.isArray(typeOperationList)) {
            enableSpinner(true);
            const apiResponse = await apiClient.getBillingCatalogs();
            enableSpinner(false);

            if (apiResponse?.status === 1) {
                _OperationList = Array.isArray(apiResponse?.data?.operationList) ? apiResponse.data.operationList : [];
                _TypeOperationList = Array.isArray(apiResponse?.data?.typeOperationList) ? apiResponse.data.typeOperationList : [];
                _igvOperationList = Array.isArray(apiResponse?.data?.igvOperationList) ? apiResponse.data.igvOperationList : [];
            }
        } else { _OperationList = operationList; _igvOperationList = igvOperationList; _TypeOperationList = typeOperationList; }

        await this.setState({ operationList: _OperationList, igvOperationList: _igvOperationList, typeOperationList: _TypeOperationList })
    }
    //#region ################## POINTS CARD ################ ✔
    searchPointsCard = async newOrderModel => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        enableSpinner(true);
        const getInfoCustomer = await apiClient.getOneCustomersPoints(newOrderModel.CardCode);
        let valorPunto = await apiClient.GetAllConfiguration();

        enableSpinner(false);
        if (getInfoCustomer.status !== 1) {
            newOrderModel.flagPointsCard = false;
            this.refreshModel(newOrderModel);
            return;
        }
        if (valorPunto.status !== 1) {
            showAlert({ type: "error", message: `${valorPunto.message}` });
        }

        let points = getInfoCustomer.data[0] || '';

        newOrderModel.flagPointsCard = true;
        newOrderModel.totalPoints = points.totalPoints || 0;
        if (newOrderModel.totalPoints !== 0) {
            showAlert({ type: "info", message: `El socio tiene ${newOrderModel.totalPoints} Puntos`, timeOut: 4000 });
        }
        newOrderModel.valorPunto = valorPunto.data ? (valorPunto.data[0].Point_Value || 0) : 0;

        this.refreshModel(newOrderModel);
    }
    //#endregion ################## POINTS CARD ################ ✔

    MountItemsFromDraft = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { chooseSavedSale, newOrderModel, disableRecover, disableRecoverNM, disableRecoverQT, requireInvoice, isAuthorization, savedSaleSearchCode, TypeRecover, recoverInterOpDoc, ItsRecoverAuthoriInvoice, RecoverHouseDoc, _user, CO1UserFields, configHeaderUserFields } = this.state;


        if (newOrderModel.Items.length > 0) {
            showAlert({ type: "info", message: "HAY ARTÍCULOS AGREGADOS, GUARDA LA VENTA O ELIMÍNELOS PARA CONTINUAR", timeOut: 2000 });
            this.CleanSavesSale()
            document.getElementById('recuperarFolio').disabled = false;
            return;
        }

        if (chooseSavedSale === '') {
            showAlert({ type: "info", message: "SELECCIONA UN DOCUMENTO PARA CONTINUAR", timeOut: 2000 });
            document.getElementById('recuperarFolio').disabled = false;
            return;
        };

        const infoFolio = await _generalFunctions.getDocInfoByFolio(chooseSavedSale);

        const data = {
            infoFolio: infoFolio,
            chooseSavedSale,
            isAuthorization: isAuthorization,
            savedSaleSearchCode: Number(TypeRecover) === 1 ? '' : savedSaleSearchCode,
            TypeRecover: TypeRecover,
            recoverInterOpDoc,
        }
        //############################## region REPROCESAR CU //##############################
        //VA DE 1 EN 1 PORQUE LA IDEA ES QUE TODOS DEBEN PASAR,
        //  ESTE REPROCESAMIENTO SOLO ES PARA CASOS EXTRAORDINARIOS
        if (TypeRecover === 5) {
            data.DocEntry = chooseSavedSale
            data.isCounter = true
            enableSpinner(true);
            const responseApi = await apiClient.reProcessCU(data);
            enableSpinner(false);
            if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
                $("#savedSalesModal").modal("hide");
                return showAlert({ type: 'success', message: `Documento Reprocesado correctamente` });
            } else {
                return showAlert({ type: 'error', message: `${responseApi.message}`, timeOut: 10000 });
            }
        }
        //############################## end region REPROCESAR CU //##############################

        enableSpinner(true);
        const responseApi = await apiClient.getDataFromDraft(data);
        enableSpinner(false);

        if (responseApi.status === 0) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            document.getElementById('recuperarFolio').disabled = false;
            return
        }

        if (responseApi.status === 2) {
            showAlert({ type: 'info', message: `${responseApi.message}` });
            document.getElementById('recuperarFolio').disabled = false;
            return
        }

        this.ChangePartnerSearch(responseApi.data.recoverHeader.CardCode);
        await this.SearchPartners();

        let userFields = new UserFields();
        try {
            let header = responseApi?.data?.recoverHeader || {};
            let userFieldsService = responseApi?.data?.userFields || [];
            if (CO1UserFields?.length) {
                CO1UserFields.forEach((item, index) => {
                    userFieldsService.forEach(userfieldItem => {
                        if (item.fieldId === userfieldItem.header.FieldID) {

                            configHeaderUserFields[index].name = userfieldItem.header.Descr;
                            item.name = userfieldItem.header.Descr;
                            item.fieldType = userfieldItem.options.length !== 0 ? 2 : 1;
                            item.options = userfieldItem.options;
                            item.IdValue = index;
                            let newUserFields = this.setUserFieldValue(userFields, index, header);
                            if (item.fieldType === 2) {
                                item.options.push({ FldValue: "", Descr: "" });
                            }
                            userFields = newUserFields;
                        }
                    });
                });
            }
            newOrderModel.userFields = userFields;
        } catch (error) {
        }

        this.FillAddressesUpdatePartner(responseApi.data.recoverHeader.AddressExt, '', false)
        const recoverLines = responseApi.data.recoverLines;
        let listNum = responseApi?.data?.recoverHeader?.U_FMB_ListNum || null;

        if (Array.isArray(recoverLines) && recoverLines.length > 0) {
            for (let i = 0; i < recoverLines.length; i++) {
                if (!listNum) { listNum = recoverLines[i]?.ListNum || null; }
                if (infoFolio.folioID === 'QT' || infoFolio.folioID === 'OR') {
                    this.AddItem(recoverLines[i], false, true, i)
                } else {
                    this.AddItem(recoverLines[i], true, true, i)
                }
            }
        }

        if (isAuthorization) {
            newOrderModel.isDocumentWithAuthorization = true;
            newOrderModel.infoAuthorization = infoFolio;
            disableRecover = true;
        }
        // docs comments 
        newOrderModel.Comments = responseApi.data.recoverHeader?.Comments ?? '';
        newOrderModel.U_SO1_02METODOPAGO = responseApi.data.recoverHeader.U_FMB_METODO_PAGO ?? '';
        newOrderModel.U_SO1_02FORMAPAGO = responseApi.data.recoverHeader.U_FMB_FORMA_PAGO ?? '';
        newOrderModel.PriceListNum = listNum;

        //#region ########## Billing Fields ##########
        newOrderModel.U_STR_AfctoDtr = responseApi.data.recoverHeader.U_STR_AfctoDtr || "";
        newOrderModel.U_STR_CodBnSs = responseApi.data.recoverHeader.U_STR_CodBnSs || "";
        newOrderModel.U_STR_TazaDtr = responseApi.data.recoverHeader.U_STR_TazaDtr || "";
        //#endregion

        if (infoFolio.folioID !== 'IV' && infoFolio.folioID !== 'DH') {
            requireInvoice = false
            if (infoFolio.folioID === 'QT' || infoFolio.folioID === 'OR') {
                newOrderModel.NumAtCard = responseApi.data.recoverHeader.folio;
                newOrderModel.Comments = `${newOrderModel.Comments}. ${' Basado en '}${data.infoFolio.folioID === 'QT' ? 'Cotización: ' : 'Pedido: '}${data.infoFolio.DocEntry}`;
            }
            await this.ChangeObjectype(newOrderModel, 'deliveries', requireInvoice);

            if (infoFolio.folioID === 'NM') {
                disableRecoverNM = true;
            }
            if (infoFolio.folioID === 'DH') RecoverHouseDoc = true;

        } else {
            disableRecover = true;
            newOrderModel.NumAtCard = responseApi.data.recoverHeader.folio;
            newOrderModel.RecoverIdSale = responseApi.data.recoverHeader.idSale;
            newOrderModel.DocTime = this.DocTimeFormat(responseApi.data.recoverHeader.DocTime) + ':00';
            newOrderModel.Address = responseApi.data.recoverHeader.Address;
            newOrderModel.Address2 = responseApi.data.recoverHeader.Address2;
            newOrderModel.AuxDocTotal = responseApi.data.recoverHeader.PaidToDate ?? responseApi.data.recoverHeader.DocTotal;
            //#region ################## POINTS CARD ################ ✔
            if (points_Card && infoFolio.table === 'OINV') {
                await this.searchPointsCard(newOrderModel);
            }
            //#endregion ################## POINTS CARD ################ ✔

            //perro
            if (isAuthorization && infoFolio.folioID === 'IV') {
                requireInvoice = true;

                await this.GetDownPaymentsByPartner(newOrderModel.CardCode);

                ItsRecoverAuthoriInvoice = true;
                if (responseApi.data.recoverHeader.isIns === 'Y') {
                    await this.ChangeObjectype(newOrderModel, 'invoiceReserve', requireInvoice);
                } else if (responseApi.data.recoverHeader.isDeliveryInvoice === 'Y') {
                    await this.ChangeObjectype(newOrderModel, 'deliveries2', requireInvoice);
                } else {
                    await this.ChangeObjectype(newOrderModel, 'deliveries', requireInvoice);
                }
            } else if (isAuthorization && infoFolio.folioID === 'DH') {
                requireInvoice = false;
                await this.ChangeObjectype(newOrderModel, 'deliveries2', requireInvoice);
            } else {
                if (infoFolio.folioID === 'IV') {
                    requireInvoice = true;
                } else {
                    requireInvoice = false;
                }
                await this.ChangeObjectype(newOrderModel, 'deliveries', requireInvoice);

            }
            if (responseApi.data.recoverHeader.isDeliveryInvoice === 'Y') RecoverHouseDoc = true;
        }
        // this its only to UPDATE INV12 in back
        if (infoFolio.folioID === 'QT') {
            newOrderModel.DocEntryQT = responseApi.data.recoverHeader?.DocEntry; // Guardar DocEntry recuperado
            newOrderModel.idSale = responseApi.data.recoverHeader?.idSale; // Guardar id PSOS
            newOrderModel.ComingFromRecoverQT = true;
        }

        newOrderModel.RelatedPayMethodsByDoc = responseApi.data.relatedPayMethods ? responseApi.data.relatedPayMethods : [];
        await this.setState({
            disableRecover,
            disableRecoverNM,
            requireInvoice,
            isAuthorization: false,
            TypeRecover: '',
            RelatedPayMethodsByDoc: responseApi.data.relatedPayMethods || [],
            ItsRecoverAuthoriInvoice,
            RecoverHouseDoc,
            recoverDocument: true,
            showTemporalData: true,
            editModePartner: true,
        });

        newOrderModel.isDeliveryInvoice = responseApi.data.recoverHeader.isDeliveryInvoice && responseApi.data.recoverHeader.isDeliveryInvoice === 'Y' ? true : false;
        await this.refreshModel(newOrderModel);
        if (_user?.Branch.IsBorder !== '') {
            if (_user?.Branch.IsBorder === 'Y') { // si eres frontera y
                const TaxCode = responseApi.data.TaxInfo && responseApi.data.TaxInfo.TaxCode && responseApi.data.TaxInfo.TaxCode !== '' ? responseApi.data.TaxInfo.TaxCode : '';
                if (TaxCode !== '') await this.ChangeTaxCode(TaxCode)
            }
        } else {
            await this.SetBranchOfficeTaxes(newOrderModel);
        }

        $("#savedSalesModal").modal("hide");
        document.getElementById('recuperarFolio').disabled = false;
        const wasModified = responseApi.data.recoverHeader.U_FMB_Socio_Modificado || null;

        if (wasModified !== null && Number(wasModified) === 1) {
            enableSpinner(true);
            const getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
            this.GetPartnerAddresses(newOrderModel.CardCode);
            enableSpinner(false);

            let updatePartner = getPartnersResponse.data[0];
            updatePartner.CardName = responseApi.data.recoverHeader.CardName || '';
            updatePartner.LicTradNum = responseApi.data.recoverHeader.LicTradNum || '';

            newOrderModel.CardName = responseApi.data.recoverHeader.CardName || '';
            newOrderModel.LicTradNum = responseApi.data.recoverHeader.LicTradNum || '';

            if (responseApi.data.recoverHeader.AddressExt !== null) {
                newOrderModel.ComingFromRecoverModifiedDoc = true;
                await this.FillAddressesUpdatePartner(responseApi.data.recoverHeader.AddressExt);
            }

            let continueFunction = () => { };
            let nextStepFunction = () => { };
            if (await this.CheckIfItsUniversalPartner === true) {
                nextStepFunction = () => {

                    $("#detailClientModal").modal("hide");
                    $("#billModal").modal("show");
                }
                continueFunction = () => {
                    $("#detailClientModal").modal("hide");
                    $("#billModal").modal("show");
                }
            } else {
                nextStepFunction = () => {

                    $("#detailClientModal").modal("hide");
                    $("#billModal").modal("show");
                }
                continueFunction = () => {
                    $("#detailClientModal").modal("hide");
                    $("#billModal").modal("show");
                }
            }

            await this.setState({
                updatebusinessPartner: updatePartner,
                NextStepFunction: nextStepFunction,
                ContinueWithoutSave: continueFunction,
                auxRecoverDocData: responseApi.data || null,
                newOrderModel,
                showTemporalData: true,
                editModePartner: true,
            });
        }
        await this.RefreshTotal(newOrderModel);
    }

    FillAddressExtensionShipTo = async (Address) => {
        const { newOrderModel } = this.state
        const auxStateData = await this.GetStateCodeByStateName(Address.County);
        //SHIP
        newOrderModel.AddressExtension.ShipToStreet = Address.Street || '';
        newOrderModel.AddressExtension.ShipToBlock = Address.Block || '';
        newOrderModel.AddressExtension.ShipToCity = Address.City || '';
        newOrderModel.AddressExtension.ShipToZipCode = Address.ZipCode || '';
        newOrderModel.AddressExtension.ShipToCounty = Address.County || '';
        newOrderModel.AddressExtension.ShipToCountry = Address.Country || '';
        newOrderModel.AddressExtension.ShipToState = auxStateData !== null ? auxStateData.Name : Address.State || ''//State  auxbillAddresses.State || ''//State
        // newOrderModel.AddressExtension.ShipToState = Address.State || '';
        newOrderModel.Project = Address?.U_FMB_Project || ''; // NEW PROJECT LOGIC

        await this.refreshModel(newOrderModel)
    }

    FillAddressExtensionBillTo = async (Address) => {
        const { newOrderModel } = this.state
        const auxStateData = await this.GetStateCodeByStateName(Address.County);
        //BILL
        newOrderModel.AddressExtension.BillToStreet = Address.Street || '';
        newOrderModel.AddressExtension.BillToBlock = Address.Block || '';
        newOrderModel.AddressExtension.BillToCity = Address.City || '';
        newOrderModel.AddressExtension.BillToZipCode = Address.ZipCode || '';
        newOrderModel.AddressExtension.BillToCounty = Address.County || '';
        newOrderModel.AddressExtension.BillToCountry = Address.Country || '';
        newOrderModel.AddressExtension.BillToState = auxStateData !== null ? auxStateData.Name : Address.State || ''//State  auxbillAddresses.State || ''//State
        await this.refreshModel(newOrderModel)
    }

    FillAddressesUpdatePartner = async (AddressExt, ShipToCode = "", returnDoc = false) => {
        const { newOrderModel } = this.state
        if (returnDoc) { // specially if for returns documents
            //SHIP
            let AuxAddressExtension = {};
            AuxAddressExtension.ShipToStreet = AddressExt.ShipToStreet || '';
            AuxAddressExtension.ShipToBlock = AddressExt.ShipToBlock || '';
            AuxAddressExtension.ShipToCity = AddressExt.ShipToCity || '';
            AuxAddressExtension.ShipToZipCode = AddressExt.ShipToZipCode || '';
            AuxAddressExtension.ShipToCounty = AddressExt.ShipToCounty || '';
            AuxAddressExtension.ShipToCountry = AddressExt.ShipToCountry || '';
            AuxAddressExtension.ShipToState = AddressExt.ShipToState || '';

            AuxAddressExtension.BillToStreet = AddressExt.BillToStreet || '';
            AuxAddressExtension.BillToBlock = AddressExt.BillToBlock || '';
            AuxAddressExtension.BillToCity = AddressExt.BillToCity || '';
            AuxAddressExtension.BillToZipCode = AddressExt.BillToZipCode || '';
            AuxAddressExtension.BillToCounty = AddressExt.BillToCounty || '';
            AuxAddressExtension.BillToCountry = AddressExt.BillToCountry || '';
            AuxAddressExtension.BillToState = AddressExt.BillToState || '';
            const auxExtension = Object.assign({}, AuxAddressExtension)
            // await this.refreshModel(newOrderModel)
            return auxExtension;
        } else {
            if (ShipToCode !== "" && (newOrderModel.ShipToCode === '' || newOrderModel.ShipToCode === null || newOrderModel.ShipToCode === undefined)) {
                newOrderModel.ShipToCode = ShipToCode || '';
            }
            //SHIP
            newOrderModel.AddressExtension.ShipToStreet = AddressExt.StreetS || '';
            newOrderModel.AddressExtension.ShipToBlock = AddressExt.BlockS || '';
            newOrderModel.AddressExtension.ShipToCity = AddressExt.CityS || '';
            newOrderModel.AddressExtension.ShipToZipCode = AddressExt.ZipCodeS || '';
            newOrderModel.AddressExtension.ShipToCounty = AddressExt.CountyS || '';
            newOrderModel.AddressExtension.ShipToCountry = AddressExt.CountryS || '';
            newOrderModel.AddressExtension.ShipToState = AddressExt.StateS || '';
            //BILL
            newOrderModel.AddressExtension.BillToStreet = AddressExt.StreetB || '';
            newOrderModel.AddressExtension.BillToBlock = AddressExt.BlockB || '';
            newOrderModel.AddressExtension.BillToCity = AddressExt.CityB || '';
            newOrderModel.AddressExtension.BillToZipCode = AddressExt.ZipCodeB || '';
            newOrderModel.AddressExtension.BillToCounty = AddressExt.CountyB || '';
            newOrderModel.AddressExtension.BillToCountry = AddressExt.CountryB || '';
            newOrderModel.AddressExtension.BillToState = AddressExt.StateB || '';
            await this.refreshModel(newOrderModel)
        }
    }

    DocTimeFormat = (docTime) => {
        let time = (docTime || '').toString();
        if (time.length > 2) {
            let position = time.length - 2;
            time = time.slice(0, position) + ":" + time.slice(position, time.length)
        } else {
            time = `00:${time}`;
        }

        return time;
    }

    CleanSavesSale = () => {
        this.OnchangeSaleSearchCode('');
        this.OnchangeChooseSale('');
    }

    DeleteDraft = async (value, action) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { showSavedSalesModal } = this.state;
        let data = {
            DeleteFolio: value
        }

        enableSpinner(true)
        let responseApi = await apiClient.deleteDraft(data)
        enableSpinner(false)

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: `${responseApi.message}` });
            return
        }
        if (value.substring(3, 5) === 'NM') {
            showAlert({ type: 'success', message: `${responseApi.message}` });
        }
        if (showSavedSalesModal === true) {
            this.GetSavedSales(action);
        }
    }

    RecoverFirmeDocument = async () => {
        const { savedSaleSearchCode, recoverInterOpEntry, recoverInterOpTypeDoc, wareHouseTransaction } = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (recoverInterOpTypeDoc === '') {
            showAlert({ type: 'warning', message: `NO HAS SELECCIONADO EL TIPO DE DOCUMENTO QUE VAS A BUSCAR` });
            return;
        }

        if (!savedSaleSearchCode) {
            showAlert({ type: 'warning', message: `NO HAS INGRESADO EL NÚMERO DE DOCUMENTO QUE VAS A BUSCAR` });
            return;
        }

        const data = {
            docNum: savedSaleSearchCode,
            destiny: recoverInterOpTypeDoc,
            firmeEntry: recoverInterOpEntry,
            currentWhsType: wareHouseTransaction?.TipoAlmacen ?? ''
        }

        enableSpinner(true);
        const responseApi = await apiClient.getDataFromFirmeDoc(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: responseApi.message });
            return;
        }

        if (Array.isArray(responseApi.data)) {
            await this.setState({
                suggestions: responseApi.data || []
            })
            $('#duplicatesDocsModal').modal('show');
        } else {
            await this.FillInfoByRecoverFirmeDoc(responseApi.data);
            $("#savedSalesModal").modal("hide");
        }
    }

    FillInfoByRecoverFirmeDoc = async responseModel => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        const _generalFunctions = new GeneralFunctions();

        if (newOrderModel.Items.length > 0) {
            showAlert({ type: "info", message: "HAY ARTÍCULOS AGREGADOS, GUARDA LA VENTA O ELIMÍNELOS PARA CONTINUAR", timeOut: 2000 });
            this.CleanSavesSale()
            return;
        }

        const recoverLines = responseModel.itemsDocument;
        const recoverHeader = responseModel.headerDocument;
        if (recoverHeader.DocStatus === 'C') {
            showAlert({ type: 'warning', message: `EL DOCUMENTO RECUPERADO ESTA CERRADO SI CONTINUA SE CREARÁ UN DOCUMENTO SIN RELACIÓN`, timeOut: 5000 });
        }

        this.ChangePartnerSearch(recoverHeader.CardCode)
        await this.SearchPartners();
        const keepOriginalLines = await _generalFunctions.keepInterOpLines({ objType: responseModel?.headerDocument?.ObjType ?? '' })

        if (Array.isArray(recoverLines) && recoverLines.length > 0) {
            for (let i = 0; i < recoverLines.length; i++) {
                let item = recoverLines[i];
                item.DiscountPercent = item.Descuento;
                item.DocEntry = recoverHeader.DocEntry;
                item.ObjType = recoverHeader.ObjType;

                if (recoverHeader.DocStatus === 'O') {
                    await this.AddItem(item, false, true, i, keepOriginalLines)
                } else {
                    await this.AddItem(item, true, true, i, keepOriginalLines)
                }

            }
        }
        let currentModel = this.state.newOrderModel;
        currentModel.DocEntry = recoverHeader.DocEntry;
        currentModel.Comments = `Basado en recuperación de documento Cotización ${recoverHeader.DocNum}. Serie ${recoverHeader.Series}`;
        currentModel.PriceListNum = recoverHeader?.U_FMB_ListNum || null;
        currentModel.U_FMB_RelatedFolio = recoverHeader.U_FMB_RelatedFolio ?? '';

        await this.refreshModel(currentModel);
        await this.ChangeObjectype(currentModel, 'deliveries', false);

        let finalModel = this.state.newOrderModel;
        if (!finalModel.userFields) finalModel.userFields = {};

        const HEADER_USERFIELDS = [
            'userFields1', 'userFields2', 'userFields3', 'userFields4',
            'userFields5', 'userFields6', 'userFields7', 'userFields8',
            'userFields9', 'userFields10', 'userFields11', 'userFields12',
            'userFields13', 'userFields14', 'userFields15', 'userFields16',
            'userFields17', 'userFields18', 'userFields19', 'userFields20',
            'userFields21', 'userFields22', 'userFields23', 'userFields24',
            'userFields25', 'userFields26', 'userFields27', 'userFields28',
            'userFields29', 'userFields30', 'userFields31', 'userFields32',
            'userFields33', 'userFields34', 'userFields35', 'userFields36',
            'userFields37', 'userFields38', 'userFields39',
        ];

        for (const key of HEADER_USERFIELDS) {
            if (recoverHeader[key] !== undefined) {
                finalModel.userFields[key] = recoverHeader[key];
            }
        }

        finalModel.U_FMB_RelatedFolio = recoverHeader.U_FMB_RelatedFolio ?? '';

        await this.setState({
            newOrderModel: finalModel,
            recoverInterOpDoc: false,
            recoverInterOpEntry: '',
            itsInterOpDoc: true
        })
        await this.refreshModel(finalModel);

        if (keepOriginalLines) {//CUANDO SE RECUPERA UN DOCUMENTO DEBE CARGAR CONCEPTOS CEUSO Y GASTO ADMINISTRATIVO SI APLICA
            for (let index = 0; index < finalModel?.Items?.length; index++) {
                const element = finalModel?.Items?.[index];
                await this.changeContract(index, element.U_RML_TIPO_CU, keepOriginalLines)
            }
            // this.reorderItems(newOrderModel)
        }

    }

    BrakeRelationDoc = async () => {
        const { newOrderModel } = this.state
        let copyItems = [...newOrderModel.Items]
        for (let i = 0; i < copyItems.length; i++) {
            let item = copyItems[i];
            item.BaseLine = '';
            item.BaseEntry = '';
            item.BaseLine = '';
            item.BaseType = '-1';
        }
        newOrderModel.Items = copyItems;
        newOrderModel.DocEntry = '';
        newOrderModel.ComingFromRecoverQT = false;
        this.setState({
            chooseSavedSale: '',
            auxRecoverDocData: null,
            recoverDocument: false,
            showTemporalData: false,
            editModePartner: false,
            disableRecover: false,
            disableRecoverNM: false,
            handedCasco: 1,
        });
        await this.refreshModel(newOrderModel);
    }
    //#endregion

    ShowRequiredInvoiceModal = async () => {
        if (this.state.showBillModal === false) {
            await this.ShowBillModal();
        }

        $("#billModal").modal("hide");
        $("#detailClientModal").modal("hide");
        $("#vmInvoice").modal("show");
    }

    //#region ########## INVOICE IN NORMAL SALE PROCESS ##################################
    NeedInvoice = async (requireInvoice) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, _user, auxRecoverDocData, updatebusinessPartner, recoverDocument } = this.state
        const isUniversal = await this.CheckIfItsUniversalPartner();
        let document = newOrderModel.ObjType;
        let serieCode = '';
        newOrderModel.DeliveryAuthorization = 'N'
        if (document === 'deliveries' || document === 'deliveries2' || document === 'deliveries4' || document === 'directDelivery') {
            if (!requireInvoice) {
                serieCode = _user?.U_FMB_ValidateSeriesODLN.split("|");
            } else {
                serieCode = _user?.U_FMB_ValidateSeriesOINV.split("|");
            }
        } else if (document === 'quotations') {
            serieCode = _user?.U_FMB_ValidateSeriesOQUT.split("|");
        } else if (document === 'orderSales') {
            serieCode = _user?.U_FMB_ValidateSeriesORDR.split("|");
        } else if (document === 'invoiceReserve') {
            serieCode = _user?.U_FMB_ValidateSeriesOINV.split("|");
        } else if (document === 'creditNote') {
            serieCode = _user?.U_FMB_ValidateSeriesORIN.split("|");
        }
        for (let index = 0; index < serieCode.length; index++) {
            const serie = serieCode[index];
            if (index === 0) {
                newOrderModel.SerieCode = serie;
                break;
            }
        }

        let updatePartner = null;
        if (auxRecoverDocData !== null) {
            updatePartner = updatebusinessPartner;
            updatePartner.CardName = auxRecoverDocData.recoverHeader.CardName || '';
            updatePartner.LicTradNum = auxRecoverDocData.recoverHeader.LicTradNum || '';

            newOrderModel.CardName = auxRecoverDocData.recoverHeader.CardName || '';
            newOrderModel.LicTradNum = auxRecoverDocData.recoverHeader.LicTradNum || '';

            if (auxRecoverDocData !== null) {
                await this.FillAddressesUpdatePartner(auxRecoverDocData.recoverHeader.AddressExt);
            }

        } else {
            enableSpinner(true);
            const getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
            enableSpinner(false);
            updatePartner = getPartnersResponse?.data[0];
            newOrderModel.USOCFDI = getPartnersResponse.data[0].U_FMB_USO_CFDI || '';
            newOrderModel.RegimenFiscal = getPartnersResponse.data[0].U_FMB_REGIMEN_FISCAL || '';
        }

        await this.setState({
            newOrderModel,
            requireInvoice,
            updatebusinessPartner: updatePartner,
        });

        //if the partner doesn't have deliveries address
        if (!requireInvoice) {
            const data = {
                cardCode: newOrderModel.CardCode
            }
            enableSpinner(true);
            const responseApi = await apiClient.ValidateBPToDH(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: 'warning', message: 'ALGO SALIO MAL AL VALIDAR LAS DIRECCIONES DISPONIBLES' });
                return;
            }
            if (responseApi.data.deliveriesAddress && responseApi.data.deliveriesAddress.length === 0) {
                showAlert({ type: 'warning', message: 'ESTE SOCIO NO TIENE DIRECCIONES DE ENVIÓ, ANTES DE CONTINUAR REGISTRA UNA DIRECCIÓN PARA CALCULAR EL TOTAL DE VENTA', timeOut: 50000 });
                return
            }
        } else {
            for (let i = 0; i < newOrderModel.Items.length; i++) {
                const DocItem = newOrderModel.Items[i];
                if (requireInvoice && !DocItem.isTemporary) {
                    if (!DocItem.U_BPP_OPER || DocItem.U_BPP_OPER === "-") { return showAlert({ type: "warning", message: `Selecciona la operacion para la linea ${i + 1}: ${DocItem.ItemCode}`, timeOut: 2000 }); }
                    if (!DocItem.U_tipoOpT12 || DocItem.U_tipoOpT12 === "-") { return showAlert({ type: "warning", message: `Selecciona el tipo de operación para la linea ${i + 1}: ${DocItem.ItemCode}`, timeOut: 2000 }); }
                    if (!DocItem.U_STR_FECodAfect) { return showAlert({ type: "warning", message: `Selecciona el código de afectación para la linea ${i + 1}: ${DocItem.ItemCode}`, timeOut: 2000 }); }
                    //#region GALLONS CONVERSION
                    if (Granel?.includes(Number(DocItem?.ItmsGrpCod)) && DocItem?.U_RS_UMED === 'GLN' && (!DocItem?.U_RS_PRECIOGL || Number(DocItem?.U_RS_PRECIOGL) <= 0)) {
                        return showAlert({ type: "warning", message: `La cantidad de galones debe de ser mayor a 0 para la linea ${i + 1}: ${DocItem.ItemCode}`, timeOut: 2000 });
                    }
                    if (Granel?.includes(Number(DocItem?.ItmsGrpCod)) && DocItem?.U_RS_UMED === 'GLN' && (!DocItem?.U_RS_PRECIOGL || Number(DocItem?.U_RS_PRECIOGL) <= 0)) {
                        return showAlert({ type: "warning", message: `El precio por galón no es valido para la linea ${i + 1}: ${DocItem.ItemCode}`, timeOut: 2000 });
                    }
                    //#endregion GALLONS CONVERSION
                }
            }
        }

        if (isUniversal && requireInvoice && (document === 'deliveries' || document === 'deliveries2' || document === 'deliveries4' || document === 'directDelivery')) {
            $('#vmInvoice').modal('hide');
            const isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                if (this.state.showBillModal === false) {
                    await this.ShowBillModal();
                }
                $('#billModal').modal('show');
            }
        } else if (!isUniversal && !requireInvoice && document === 'deliveries2') {//NO REQUIERE FACTURA -VENTA A DOMICILIO
            newOrderModel.DeliveryAuthorization = 'I';
            enableSpinner(true);
            this.GetPartnerAddresses(newOrderModel.CardCode);
            enableSpinner(false);
            $('#detailClientModal').modal('show');
            this.setState({
                NextStepFunction: async () => {
                    if (Number(newOrderModel.GroupNum || 0) !== -1) {
                        return showAlert({ type: "warning", message: "No se puede hacer venta domicilio con condición de pago diferente a Contado" });
                    }
                    let isAuthorization = await this.ValidateAuthorization();
                    $('#detailClientModal').modal('hide');
                    if (!isAuthorization) { this.CreateDocument(); }
                },
                ContinueWithoutSave: async () => {
                    if (Number(newOrderModel.GroupNum || 0) !== -1) {
                        return showAlert({ type: "warning", message: "No se puede hacer venta domicilio con condición de pago diferente a Contado" });
                    }
                    let isAuthorization = await this.ValidateAuthorization();
                    $('#detailClientModal').modal('hide');
                    if (!isAuthorization) { this.CreateDocument(); }
                }
            })
        } else if (!isUniversal && !requireInvoice && document === 'deliveries') {//NO REQUIERE FACTURA -VENTA NORMAL
            newOrderModel.DeliveryAuthorization = 'I'
            let isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                if (this.state.showBillModal === false) {
                    await this.ShowBillModal();
                }
                $('#billModal').modal('show');
            } else {
                $('#billModal').modal('hide');
            }
            await this.setState({
                NextStepFunction: async () => {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                },
                ContinueWithoutSave: async () => {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                }

            })
        } else if (!isUniversal && requireInvoice && document === 'deliveries') {// REQUIERE FACTURA - VENTA NORMAL
            $('#billModal').modal('hide');
            $('#detailClientModal').modal('show');

            this.GetPartnerAddresses(newOrderModel.CardCode);
            this.setState({
                NextStepFunction: async () => {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        if (this.state.showBillModal === false) {
                            await this.ShowBillModal();
                        }
                        $('#detailClientModal').modal('hide');
                        $('#billModal').modal('show');
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                },
                ContinueWithoutSave: async () => {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        if (this.state.showBillModal === false) {
                            await this.ShowBillModal();
                        }
                        $('#detailClientModal').modal('hide');
                        $('#billModal').modal('show');
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                }

            })

        } else if (!isUniversal && requireInvoice && document === 'deliveries2') {// REQUIERE FACTURA - VENTA A DOMICILIO
            $('#detailClientModal').modal('hide');
            $('#billModal').modal('hide');
            $('#detailClientModal').modal('show');
            this.GetPartnerAddresses(newOrderModel.CardCode);
            this.setState({
                NextStepFunction: async () => {
                    if (Number(newOrderModel.GroupNum || 0) !== -1) {
                        return showAlert({ type: "warning", message: "No se puede hacer venta domicilio con condición de pago diferente a Contado" });
                    }
                    const isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                },
                ContinueWithoutSave: async () => {
                    if (Number(newOrderModel.GroupNum || 0) !== -1) {
                        return showAlert({ type: "warning", message: "No se puede hacer venta domicilio con condición de pago diferente a Contado" });
                    }
                    const isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        $('#detailClientModal').modal('hide');
                        this.CreateDocument();
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                }
            })
        } else if (requireInvoice && document === 'invoiceReserve') {// FACTURA DE RESERVA
            $('#billModal').modal('hide');
            $('#detailClientModal').modal('show');

            this.GetPartnerAddresses(newOrderModel.CardCode);
            this.setState({
                requireInvoice: false,
                NextStepFunction: async () => {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        if (this.state.showBillModal === false) {
                            await this.ShowBillModal();
                        }
                        $('#detailClientModal').modal('hide');
                        $('#billModal').modal('show');
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                },
                ContinueWithoutSave: async () => {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        if (this.state.showBillModal === false) {
                            await this.ShowBillModal();
                        }
                        $('#detailClientModal').modal('hide');
                        $('#billModal').modal('show');
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                }
            })
        }

        if (!isUniversal && requireInvoice) {
            await this.GetDownPaymentsByPartner(newOrderModel.CardCode);
        }
        if (!isUniversal) {
            await this.GetDataPartner();
        }

        // New integration 
        if (!newOrderModel.ComingFromRecoverModifiedDoc && !recoverDocument) {
            await this.SearchAndFillDefDirections();
        }
    }

    SearchAndFillDefDirections = async () => {
        const { billAddresses, updatebusinessPartner, deliveryAddresses } = this.state
        if (billAddresses.length === 0 || deliveryAddresses.length === 0) return

        for (let index = 0; index < billAddresses.length; index++) {
            const billDirection = billAddresses[index];
            if (billDirection.Address === updatebusinessPartner.BillToDef) {
                await this.SetIndexBillDirection(index, billDirection);
            }
        }

        for (let index = 0; index < deliveryAddresses.length; index++) {
            const shipAddress = deliveryAddresses[index];
            if (shipAddress.Address === updatebusinessPartner.ShipToDef) {
                await this.SetIndexDeliveryDirection(index, shipAddress, true)
            }
        }
    }

    ValidateCylinderAgreement = () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        const items = newOrderModel.Items || [];

        for (let index = 0; index < items.length; index++) {
            const item = items[index];

            if (item?.isTemporary) {
                continue;
            }

            if (Envasados?.includes(Number(item?.ItmsGrpCod))) {
                const itemName = item.ItemCode || item.ItemName || item.ItemDescription || '';
                const entregaCilindro = String(item.U_RML_ENTCLNDRO || '');
                const tipoConvenio = String(item.U_RML_TIPO_CU || '');

                if (entregaCilindro !== '1' && entregaCilindro !== '2') {
                    showAlert({ type: 'warning', message: `Debes indicar Entrega de Cilindro para el artículo ${itemName}.`, timeOut: 6000 });
                    return false;
                }

                if (entregaCilindro === '2' &&
                    (tipoConvenio === '' || tipoConvenio === '-')) {
                    showAlert({ type: 'warning', message: `Debes seleccionar el Tipo de Convenio para el artículo ${itemName}.`, timeOut: 6000 });
                    return false;
                }
            }
        }

        return true;
    };

    CheckIfItems = async (Funct) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, disableRecover } = this.state
        const view = newOrderModel?.ObjType;

        const arrItems = newOrderModel.Items || [];
        if (arrItems.length === 0) {
            showAlert({ type: 'info', message: 'AGREGA ARTÍCULOS PARA CONTINUAR', timeOut: 5000 });
            return;
        }

        if (!this.ValidateCylinderAgreement()) {
            return;
        }

        for (let index = 0; index < arrItems.length; index++) {
            const element = arrItems[index];
            if (element.HomePrice === 0 || element.HomePrice === null) {
                showAlert({ type: 'error', message: 'HAY UNO O MÁS ARTICULO CON UN PRECIO EN 0, COMUNÍCATE CON EL ADMINISTRADOR', timeOut: 50000 });
                return;
            }
        }

        //#region GALLONS CONVERSION
        for (let index = 0; index < arrItems.length; index++) {
            const element = arrItems[index];
            if (Granel?.includes(Number(element?.ItmsGrpCod)) && element?.U_RS_UMED === 'GLN' && (!element?.U_RS_CANTG || Number(element?.U_RS_CANTG) <= 0)) {
                showAlert({ type: "warning", message: `La cantidad de galones debe de ser mayor a 0 para la linea ${index + 1}: ${element.ItemCode}`, timeOut: 50000 });
                return;
            }
            if (Granel?.includes(Number(element?.ItmsGrpCod)) && element?.U_RS_UMED === 'GLN' && (!element?.U_RS_PRECIOGL || Number(element?.U_RS_PRECIOGL) <= 0)) {
                showAlert({ type: "warning", message: `El precio por galón no es valido para la linea ${index + 1}: ${element.ItemCode}`, timeOut: 50000 });
                return;
            }
        }
        //#endregion GALLONS CONVERSION

        //#region Precio Llamagas
        for (let index = 0; index < arrItems.length; index++) {
            const element = arrItems[index];
            const envasado = Envasados?.includes(Number(element?.ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(element?.ItmsGrpCod));
            if (!element?.isTemporary && (envasado || glpGranel)) {
                if (Number(element?.Price) <= 0) {
                    showAlert({ type: "warning", message: `El precio debe de ser mayor a 0 para la linea ${index + 1}: ${element.ItemCode}`, timeOut: 50000 });
                    return;
                }
            }
        }
        //#endregion Precio Llamagas

        //#region DIMENSIONS
        let flagD = false;

        const validations = [
            { field: 'OcrCode', label: 'CANAL' },
            { field: 'OcrCode2', label: 'SEDES' },
            { field: 'OcrCode3', label: 'SUCURSAL' },
            { field: 'OcrCode4', label: 'NEGOCIO' },
            { field: 'OcrCode5', label: 'CECO' },
        ];

        for (const item of newOrderModel.Items) {
            if (!item.isTemporary) {
                const invalid = validations?.find(v => !item[v.field]);
                if (invalid) {
                    flagD = true;
                    showAlert({ type: "warning", message: `Es necesario un valor para  el campo "${invalid.label}" para el artículo ${item.ItemCode || item.ItemName}`, timeOut: 5000 });
                    return;
                }
            }
        }

        if (flagD) {
            return;
        }
        //#endregion DIMENSIONS

        //#region Validar artículo como anticipo
        if (newOrderModel?.DocType === 'I'
            && (
                ['deliveries', 'deliveries2', 'deliveries3', 'deliveries4', 'directDelivery', 'invoice', 'creditNote', 'debitNote']?.includes(view)
            )
        ) {
            let isAnticipo = false;
            for (const item of newOrderModel?.Items) {
                if (item?.U_RS_GRUPO === 'ANT') {
                    isAnticipo = true;
                    showAlert({ type: "warning", message: `El artículo ${item.ItemCode || item.ItemName} está configurado como Anticipo y debe ser removido para poder crear el documento.`, timeOut: 5000 });
                }
            }
            if (isAnticipo) {
                return;
            }
        }
        if (newOrderModel?.DocType === 'I'
            && (
                ['downPayments']?.includes(view)
            )
        ) {
            let isntAnticipo = false;
            for (const item of newOrderModel?.Items) {
                if (item?.U_RS_GRUPO !== 'ANT') {
                    isntAnticipo = true;
                    showAlert({ type: "warning", message: `El artículo ${item.ItemCode || item.ItemName} NO está configurado como Anticipo y debe ser removido para poder crear el documento.`, timeOut: 5000 });
                }
            }
            if (isntAnticipo) {
                return;
            }
        }
        //#endregion Validar artículo como anticipo

        if (newOrderModel.TaxCode === '' || newOrderModel.TaxCode === null) {
            showAlert({ type: 'error', message: 'SELECCIONA EL CÓDIGO DE IMPUESTOS, POR FAVOR', timeOut: 50000 });
            return
        }

        if (isNaN(newOrderModel.Total)) {
            showAlert({ type: 'error', message: 'ALGO SALIO MAL AL CALCULAR EL TOTAL, REVISA QUE EL CLIENTE TENGA DIRECCIONES DE ENVIÓ AGREGADAS Y REINICIA LA OPERACIÓN, POR FAVOR', timeOut: 50000 });
            return
        }

        if (newOrderModel.ObjType === 'downPayments') {
            if (newOrderModel.Items.length === 0) {
                showAlert({ type: "error", message: "AGREGA EL ARTICULO 'ANTICIPO' PARA PODER CONTINUAR", timeOut: 5000 });
                return;
            }
            let flag = false;
            for (let xyz = 0; xyz < newOrderModel.Items.length; xyz++) {
                const item = newOrderModel.Items[xyz];
                if (!isAnticipo(item.ItemCode)) {
                    flag = true;
                    showAlert({ type: "info", message: `ELIMINA EL ARTICULO ${item.ItemCode} PARA PODER CONTINUAR`, timeOut: 5000 });
                    return;
                }
            }
            if (flag) {
                showAlert({ type: "info", message: `SOLO ES POSIBLE DEJAR LA ORDEN CON EL ARTICULO 'ANTICIPO'`, timeOut: 5000 });
                return;
            }
            Funct();

        } else {
            if (newOrderModel.Items.length === 0) {
                showAlert({ type: "error", message: "AGREGA ARTÍCULOS PARA CONTINUAR", timeOut: 5000 });
                return;
            } else if (newOrderModel.Items.length > 0) {

                if (newOrderModel.ObjType !== 'quotations' && newOrderModel.ObjType !== 'invoiceReserve' && newOrderModel.ObjType !== 'orderSales' && !disableRecover && !newOrderModel.isDocumentWithAuthorization) {
                    let onHandZero = [];
                    for (let index = 0; index < newOrderModel.Items.length; index++) {
                        const item = newOrderModel.Items[index];
                        if (item.InvntItem && item.InvntItem === 'N') continue
                        if (Number(item.OnHand) <= 0) onHandZero.push(item);

                    }
                    if (onHandZero.length > 0) {
                        for (let index = 0; index < onHandZero.length; index++) {
                            const itemZero = onHandZero[index];
                            showAlert({ type: "info", message: `EL ARTICULO ${itemZero.ItemCode} NO TIENE EXISTENCIA FAVOR DE ELIMINAR PARA CONTINUAR LA OPERACIÓN`, timeOut: 5000 });
                        }
                        return
                    }
                }

                Funct();
            } else {
                Funct();
            }
        }

    }

    SendInvoiceValidation = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, disableRecover, requireInvoice } = this.state;
        if (newOrderModel.DocType === 'I') {
            if ((newOrderModel.ObjType === 'deliveries' && !disableRecover) || newOrderModel.isDocumentWithAuthorization) {
                let items = newOrderModel.Items || [];
                let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                if (await this.CheckIfItsUniversalPartner() === true && !newOrderModel.isDocumentWithAuthorization) {
                    newOrderModel.DeliveryAuthorization = 'I'
                    await this.refreshModel(newOrderModel)
                }
                if (itemsBatch.length > 0) {
                    let isBatchComplete = true;
                    for (let index = 0; index < itemsBatch.length; index++) {
                        const item = itemsBatch[index];
                        item.SnBUoMQty = 0;
                        for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                            const batch = item.BatchNumbers[indez];
                            item.SnBUoMQty += Number(batch.Quantity);
                        }
                        if (Number(item.SnBUoMQty) !== Number(item.Quantity)) {
                            isBatchComplete = false;
                        }
                    }
                    if (!isBatchComplete) {
                        let itemCode = {};
                        let whs = {}
                        itemsBatch.sort((a, b) => {
                            if (a.ItemCode > b.ItemCode) {
                                return 1;
                            } else if (b.ItemCode > a.ItemCode) {
                                return -1;
                            } else {
                                if (a.WhsCode > b.WhsCode) {
                                    return 1;
                                } else if (b.WhsCode > a.WhsCode) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }
                        });
                        itemsBatch = itemsBatch.filter((item) => {
                            if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                                return false
                            } else {
                                itemCode[item.ItemCode] = true;
                                whs[item.WhsCode] = true;
                                return true;
                            }
                        });
                        let newItemsBatchArray = []
                        for (let index = 0; index < itemsBatch.length; index++) {
                            const item = itemsBatch[index];
                            newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                        }
                        enableSpinner(true);
                        const batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                        enableSpinner(false);

                        if (batchsResponse.status === 0) {
                            showAlert({ type: 'error', message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }
                        let isNewBatch = false;
                        for (let index = 0; index < newOrderModel.Items.length; index++) {
                            let item = newOrderModel.Items[index];
                            for (let index = 0; index < batchsResponse.data.length; index++) {
                                const itemBatch = batchsResponse.data[index];
                                if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                    if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                        isNewBatch = true;
                                    }
                                    item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                }
                            }
                        }

                        if (isNewBatch) {
                            await this.setState({
                                newOrderModel,
                                showBatchSelectionModal: true,
                            });
                            $('#batchSelectionModal').modal('show');
                        } else {
                            showAlert({ type: 'error', message: `Ocurrió un error al consultar Lotes`, timeOut: 8000 });
                            return;
                        }

                    } else {
                        let isAuthorization = await this.ValidateAuthorization();
                        if (!isAuthorization) {
                            await this.ShowBillModal();
                            if (await this.CheckIfItsUniversalPartner() === true) {
                                $("#billModal").modal("show");
                            } else {
                                if (disableRecover) {
                                    $("#billModal").modal("show");
                                } else {
                                    $("#vmInvoice").modal("show");
                                }
                            }
                        }
                    }
                } else {
                    await this.ShowBillModal();
                    if (await this.CheckIfItsUniversalPartner() === true) {
                        let isAuthorization = await this.ValidateAuthorization();
                        if (!isAuthorization) {
                            $("#billModal").modal("show"); // antes
                        }
                    } else {
                        if (disableRecover) {
                            let isAuthorization = await this.ValidateAuthorization();
                            if (!isAuthorization) {
                                $("#billModal").modal("show");
                            }
                        } else {
                            $("#vmInvoice").modal("show");
                        }
                    }
                }
            } else {
                if (disableRecover) {
                    const isUniversal = await this.CheckIfItsUniversalPartner();
                    if (!isUniversal && requireInvoice) {
                        await this.GetDownPaymentsByPartner(newOrderModel.CardCode);
                    }
                    await this.ShowBillModal();
                    $("#billModal").modal("show");
                } else {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        await this.ShowBillModal();
                        if (await this.CheckIfItsUniversalPartner() === true) {
                            $("#billModal").modal("show");
                        } else {
                            if (disableRecover) {
                                $("#billModal").modal("show");
                            } else {
                                $("#vmInvoice").modal("show");
                            }
                        }
                    }
                }

            }
        } else {
            let isAuthorization = await this.ValidateAuthorization();
            if (!isAuthorization) {
                await this.ShowBillModal();
                if (await this.CheckIfItsUniversalPartner() === true) {
                    $("#billModal").modal("show");
                } else {
                    if (disableRecover) {
                        $("#billModal").modal("show");
                    } else {
                        $("#vmInvoice").modal("show");
                    }

                }
            }
        }
    }

    ValidateInvntItem = async (items) => {
        const { notificationReducer: { showAlert } } = this.props;
        let passValidation = true;
        for (let x = 0; x < items.length; x++) {
            const item = items[x];
            if (item.InvntItem === "N") {
                showAlert({ type: "info", message: `El articulo ${item.ItemCode} es de tipo no inventariable no es posible continuar con la operación.`, timeOut: 8000 });
                passValidation = false
            }
        }
        return passValidation;
    }

    SendReserveInvoice = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { disableRecover, newOrderModel } = this.state;
        await this.ShowBillModal();
        const universalPartner = await this.CheckIfItsUniversalPartner()
        if (!universalPartner) {
            if (disableRecover) {
                await this.NeedInvoice(true);
            } else {
                const items = newOrderModel.Items || [];
                const InvntItemValidation = await this.ValidateInvntItem(items)
                if (!InvntItemValidation) return
                // let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                // if (itemsBatch.length > 0) {
                //     let isBatchComplete = true;
                //     for (let index = 0; index < itemsBatch.length; index++) {
                //         const item = itemsBatch[index];
                //         item.SnBUoMQty = 0;
                //         for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                //             const batch = item.BatchNumbers[indez];
                //             item.SnBUoMQty += Number(batch.Quantity);
                //         }
                //         if (Number(item.SnBUoMQty) !== Number(item.Quantity)) {
                //             isBatchComplete = false;
                //         }
                //     }
                //     // if shoppingCart had ites without batchs setted
                //     if (!isBatchComplete) {
                //         let itemCode = {};
                //         let whs = {}
                //         itemsBatch.sort((a, b) => {
                //             if (a.ItemCode > b.ItemCode) {
                //                 return 1;
                //             } else if (b.ItemCode > a.ItemCode) {
                //                 return -1;
                //             } else {
                //                 if (a.WhsCode > b.WhsCode) {
                //                     return 1;
                //                 } else if (b.WhsCode > a.WhsCode) {
                //                     return -1;
                //                 } else {
                //                     return 0;
                //                 }
                //             }
                //         });
                //         itemsBatch = itemsBatch.filter((item) => {
                //             if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                //                 return false
                //             } else {
                //                 itemCode[item.ItemCode] = true;
                //                 whs[item.WhsCode] = true;
                //                 return true;
                //             }
                //         });
                //         let newItemsBatchArray = []
                //         for (let index = 0; index < itemsBatch.length; index++) {
                //             const item = itemsBatch[index];
                //             newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                //         }
                //         enableSpinner(true);
                //         const batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                //         enableSpinner(false);

                //         if (batchsResponse.status === 0) {
                //             showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                //             return;
                //         }
                //         let isNewBatch = false;
                //         for (let index = 0; index < newOrderModel.Items.length; index++) {
                //             const item = newOrderModel.Items[index];
                //             for (let index = 0; index < batchsResponse.data.length; index++) {
                //                 const itemBatch = batchsResponse.data[index];
                //                 if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                //                     if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                //                         isNewBatch = true;
                //                     }
                //                     item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                //                 }
                //             }
                //         }

                //         if (isNewBatch) {
                //             await this.setState({
                //                 newOrderModel,
                //                 showBatchSelectionModal: true,
                //             });
                //             $('#batchSelectionModal').modal('show');
                //         } else {
                //             showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                //             return;
                //         }

                //     } else { // batch was set
                //         $("#vmReserveInvoice").modal("show");
                //     }
                // } else {
                await this.NeedInvoice(true);
                // }
            }

        } else {
            showAlert({ type: "info", message: "No se puede generar una factura de reserva a un cliente de mostrador", timeOut: 8000 });
        }

    }

    OrderValidation = async () => {
        $("#vmOrderSale").modal("show");
    }

    fieldsValidation = () => {
        const { newOrderModel } = this.state;

        if (newOrderModel.NeedScopCode && !newOrderModel.ScopCode) { // Cambiar por condicion de articulos que requieren codigo SCOP
            $("#fieldsForOrderSale").modal("show");
        } else {
            this.ValidateOrderSale();
        }
    }

    validateModalFields = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;

        if (!newOrderModel.U_FMB_SCOP_CODE) {
            showAlert({ type: "warning", message: "Ingresa la información solicitada" });
            return;
        }

        const whsCode = newOrderModel.Items.length > 0 ? newOrderModel.Items[0]?.WhsCode : '';
        if (whsCode === '') {
            showAlert({ type: 'error', timeOut: 5000, message: 'Debe de cargar al menos un articulo con almacen seleccionado' });
            return;
        }

        const data = {
            scopCode: newOrderModel.U_FMB_SCOP_CODE,
            whsCode: whsCode,
            objType: newOrderModel.ObjectType
        }

        enableSpinner(true);
        const responseApi = await apiClient.ValidateScopCode(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', timeOut: 5000, message: responseApi?.message ?? '' });
            return
        }

        if (!responseApi?.data?.FMB_ValidScoop) {
            showAlert({ type: 'error', timeOut: 5000, message: `Este codigo SCOP no es valido ` });
            showAlert({ type: 'info', timeOut: 5000, message: `Estatus: ${responseApi?.data?.estado ?? ''} ` });
            return
        }

        showAlert({ type: 'success', timeOut: 5000, message: responseApi?.message ?? '' });
        let copyOrderModel = { ...newOrderModel }

        copyOrderModel.ValidSCOP = responseApi.data.FMB_ValidScoop ? responseApi.data.FMB_ValidScoop : false;
        copyOrderModel.U_LLG_ESTADO_SCOP = responseApi?.data?.estado ?? '';
        copyOrderModel.U_LLG_PLACA_SCOP = responseApi?.data?.detalle?.camion?.placa ?? '';
        copyOrderModel.U_LLG_CAPACIDAD_SCOP = responseApi?.data?.detalle?.camion?.capacidadKg ?? '';
        copyOrderModel.U_LLG_FPEDIDO_SCOP = responseApi?.data?.fechaPedido ?? '';
        await this.refreshModel(copyOrderModel)


        $("#fieldsForOrderSale").modal("hide");

        this.ValidateOrderSale();
    };

    ValidateOrderSale = async () => {
        let isAuthorization = await this.ValidateAuthorization();
        if (!isAuthorization) {
            this.CreateDocument();
        }
    }

    ShowPrinterConfiguration = () => {
        $("#printerConfigurationModal").modal("show");
    }

    PrintCreatedInvoiceTicket = async (document) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state;
        printerService.rememberLastTicket(_user, document);
        this.hasTicketInCurrentSession = true;

        try {
            const result = await printerService.printInvoice(_user, document, { automatic: true });
            if (!result.skipped) {
                showAlert({ type: "success", message: "Ticket enviado a la impresora.", timeOut: 4000 });
            }
        } catch (error) {
            showAlert({
                type: "warning",
                message: `La venta fue creada, pero el ticket no se imprimio: ${error.message}`,
                timeOut: 10000
            });
        }
    }

    ReprintLastTicket = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state;

        if (!this.hasTicketInCurrentSession) {
            showAlert({ type: "info", message: "Aun no has realizado ninguna venta. No hay ningun ticket disponible para reimprimir.", timeOut: 7000 });
            return;
        }

        try {
            const lastTicket = await printerService.printLastTicket(_user);
            const savedAt = lastTicket.savedAt ? new Date(lastTicket.savedAt).toLocaleString() : "";
            showAlert({
                type: "success",
                message: `Ultimo ticket enviado a la impresora${savedAt ? ` (${savedAt})` : ""}.`,
                timeOut: 6000
            });
        } catch (error) {
            showAlert({ type: "error", message: error.message, timeOut: 8000 });
        }
    }

    ShowCreatedInvoice = async (document, beforeEdit, timbraResponse = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (!beforeEdit) {
            const data = {
                docsToPrintIds: [document],
                typeDoc: 13
            }
            enableSpinner(true);
            const responseApi = await apiClient.getPrintDocsInfo(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                this.CloseCreatedInvoiceActions();
                return;
            }

            for (let index = 0; index < responseApi.data.length; index++) {
                const document = responseApi.data[index];
                if (timbraResponse && index === 0 && timbraResponse.status) {
                    showAlert({ type: "success", message: `${timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(timbraResponse.XML);
                } else if (timbraResponse && !timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${timbraResponse.message}`, timeOut: 10000 });
                }
            }

            let resOxxoData = new OxxoReferenceModel();
            if (Modules['oxxoReferences'] && (responseApi.data[0] && responseApi.data[0]?.docHeader?.responseHeader?.U_FMB_PriKeyOxRef && responseApi.data[0]?.docHeader?.responseHeader?.U_FMB_PriKeyOxRef !== -1)) {
                const data = {
                    DocEntry: responseApi.data[0]?.docHeader?.responseHeader?.DocEntry,
                    ObjType: responseApi.data[0]?.docHeader?.responseHeader?.ObjType,
                    IdOxxoRef: responseApi.data[0]?.docHeader?.responseHeader?.U_FMB_PriKeyOxRef
                }

                enableSpinner(true);
                resOxxoData = await apiClient.GetInfoOxxoReference(data);
                enableSpinner(false);
            }

            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: 'OINV',
                ordersToAction: document,
                EnableEditButton: false,
                showPDFViewer: !this.state.showPDFViewer,
                ShowExtraActions: timbraResponse && timbraResponse.status ? true : false,
                OxxoRefData: resOxxoData.data?.ModelReference,
            });
            if (responseApi.data && responseApi.data[0]) {
                this.PrintCreatedInvoiceTicket(responseApi.data[0]);
            }
            $("#pdfViewer").modal("show");
        } else {
            await this.setState({
                docsToPrint: [document] ?? [],
                typeDocPrint: 'OINV',
                ordersToAction: ''
            });

            await this.ShowPDFViewer();
            $("#pdfViewer").modal("show");
        }
    }

    FillExtraDocsShow = async (DebNotCreNot, OriginFolio, timbraResponse) => {

        let model = new DocToPDFViewer();
        // let auxModel = new DocToPDFViewer();
        let originDoc = new DocToPDFViewer();

        originDoc.Folio = OriginFolio || '';
        originDoc.TypeDoc = 'OINV';
        originDoc.DocObjectType = 13;
        originDoc.timbraResponse = timbraResponse || {};

        model.Folio = DebNotCreNot.folioCN;
        model.TypeDoc = 'ORIN';
        model.DocObjectType = 14;
        model.timbraResponse = DebNotCreNot.timbraResponse || {};

        // auxModel.Folio = DebNotCreNot.folioDN;
        // auxModel.TypeDoc = 'OINV';
        // auxModel.DocObjectType = 13;

        this.setState({
            extraDocsToShow: [originDoc, model]
        })
    }

    SaveChangesInvoice = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { EditableDocModel, ordersToAction } = this.state
        let data = { EditableDocModel, ordersToAction }
        enableSpinner(true)
        let responseApi = await apiClient.SaveChangesOrderInvoice(data);
        enableSpinner(false)
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        showAlert({ type: "success", message: `DOCUMENTO Y SOCIO ACTUALIZADOS CORRECTAMENTE` });
        this.ChangeEditableMode()
        await this.setState({ docsToPrint: responseApi.data ?? [] });
    }

    CloseCreatedInvoiceActions = async () => {
        let { newOrderModel, isCancel, _user, PointsCardModel } = this.state;
        let partner = _user?.Partner;
        newOrderModel = new NewOrderSales();
        newOrderModel.TaxCode = partner.TaxCode;
        newOrderModel.TaxName = partner.TaxName;
        newOrderModel.TaxRate = partner.Rate;
        newOrderModel.CardCode = partner.CardCode;
        newOrderModel.CardName = partner.CardName;
        newOrderModel.PriceListNum = partner.ListNum;
        newOrderModel.ShipToDef = partner.ShipToDef;
        newOrderModel.BillToDef = partner.BillToDef;
        newOrderModel.ObjType = 'deliveries';
        newOrderModel.userFields = this.resetUserFields();

        await this.ShowPDFViewer();
        await this.setState({
            newOrderModel,
            docsToPrint: [],
            typeDocPrint: '',
            ordersToAction: 0,
            requireInvoice: false,
            itemSelected: {},
            showBillModal: isCancel || !this.state.showBillModal,
            extraDocsToShow: [],
            indexTypeDocShow: 0,
            ShowExtraActions: false
        })
        await this.SetBranchOfficeInfo();
        await this.SetCounterPermissions();
        await this.SetDefaultPartner();
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open").css("padding-right", "");
        if (PointsCardModel && PointsCardModel.Customer && PointsCardModel.Customer.LostPoints && (PointsCardModel.Customer.LostPoints.puntos !== 0 || PointsCardModel.Customer.LostPoints.isCredit) && points_Card) {
            await this.setState({
                showAreYouAgreeModal_Join_e_Wallet: !this.state.showAreYouAgreeModal_Join_e_Wallet,
            });
            $('#areYouAgreeModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        }
    };

    //#endregion

    //#region ########## GrossProfit #####################################################
    ShowGrossProfitModal = async () => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { newOrderModel } = this.state

        if (Array.isArray(newOrderModel.Items) && newOrderModel.Items.length === 0) {
            showAlert({ type: 'warning', message: 'AGREGA ARTÍCULOS PARA CONTINUAR' });
            return;
        }
        enableSpinner(true)
        await this.EnableGrossProfitModal(true);
        await this.setState({
            InitialGrossProfitPriceList: newOrderModel.PriceListNum
        })

        await this.FillPricesList();
        this.CalculateGrossProfit();
        enableSpinner(false)
        $('#grossProfitModal').modal('show');
    }

    OnchangePriceList = async (value) => {
        const { InitialGrossProfitPriceList } = this.state
        if (value === '-2') {
            await this.setState({ ChoosePriceList: Number(value) });
            await this.ChangePriceList(InitialGrossProfitPriceList, true);
            this.CalculateGrossProfit();
        } else {
            await this.setState({ ChoosePriceList: Number(value) });
            await this.ChangePriceList(value, true);
            this.CalculateGrossProfit();
        }
    }

    FillPricesList = async () => {
        const { _user } = this.state;
        const priceListResponse = await apiClient.getPriceList();
        if (priceListResponse.data.length) {
            let filteredPriceList = [];
            if (_user?.Branch?.U_FMB_DEF_PLBasePrice && _user.Branch.U_FMB_DEF_PLBasePrice !== '') {
                filteredPriceList = priceListResponse.data.filter((element) => Number(element.ListNum) === Number(_user.Branch.U_FMB_DEF_PLBasePrice))
            }
            await this.setState({
                priceList: filteredPriceList.length > 0 ? filteredPriceList : priceListResponse.data
            });
        }
    }


    CalculateGrossProfit = () => {
        const { newOrderModel, ChoosePriceList } = this.state
        let auxArray = [], auxTotProfit = 0, auxTotPrctProfit = 0, salesTotal = 0;
        for (let i = 0; i < newOrderModel.Items.length; i++) {
            const Item = newOrderModel.Items[i];
            let comparativePrice = Item.AvgPrice;
            const priceTaken = (Number(Item.Price) - (Number(Item.Price) * (Number(Item.DiscountPercent) / 100)));
            if (Number(ChoosePriceList) !== -2) { // precio promedio
                comparativePrice = Item.AlternativePriceGP;
            }
            const GRPF = GROSSPROFIT.new(priceTaken, comparativePrice);
            auxArray.push({
                ItemCode: Item.ItemCode,
                Description: Item.ItemName,
                BasePrice: Item.AvgPrice || 0 /*auxSalePrice*/, //lista de precios
                SalePrice: priceTaken, // it was before 
                Quantity: Item.Quantity,
                Profit: GRPF.GrossProfit * Number(Item.Quantity),
                PrctProfit: GRPF.PrcntProfit || '',
            });
            auxTotProfit = auxTotProfit + (GRPF.GrossProfit * Number(Item.Quantity));
            // auxTotPrctProfit = auxTotPrctProfit + GRPF.PrcntProfit;
            salesTotal += Number((Number(priceTaken) * Number(Item.Quantity)).toFixed(2));
        }
        auxTotPrctProfit = (auxTotProfit / salesTotal * 100).toFixed(2);

        this.setState({
            LinesGrossProfit: auxArray || [],
            TotPrctGrossProfit: auxTotPrctProfit || 0,
            TotalGrossProfit: auxTotProfit || 0,
        })
    }

    HideGrossProfitModal = async () => {
        const { InitialGrossProfitPriceList } = this.state
        await this.ChangePriceList(InitialGrossProfitPriceList, true);
        await this.setState({
            InitialGrossProfitPriceList: '',
            ChoosePriceList: '-2'
        })
        await this.EnableGrossProfitModal(false);
        $('#grossProfitModal').modal('hide');
    }

    //#endregion

    //#region ########## DELIVERY HOUSE CREATE DOC AND RECOVER SELL ######################
    ValidateBusinessPartner = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;

        if (newOrderModel.DocType === 'I') {
            // Validación para autorizaciones en ventas normales y a domicilio
            if (newOrderModel.ObjType === 'deliveries' || newOrderModel.ObjType === 'deliveries2') {
                if (!newOrderModel.isDocumentWithAuthorization) {
                    let items = newOrderModel.Items || [];
                    let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                    if (itemsBatch.length > 0) {
                        let isBatchComplete = true;
                        for (let index = 0; index < itemsBatch.length; index++) {
                            const item = itemsBatch[index];
                            item.SnBUoMQty = 0;
                            for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                                const batch = item.BatchNumbers[indez];
                                item.SnBUoMQty += Number(batch.Quantity);
                            }
                            if (Number(item.SnBUoMQty) !== Number(item.Quantity)) {
                                isBatchComplete = false;
                            }
                        }
                        if (!isBatchComplete) {
                            newOrderModel.DeliveryAuthorization = 'N';
                            let itemCode = {};
                            let whs = {}
                            itemsBatch.sort((a, b) => {
                                if (a.ItemCode > b.ItemCode) {
                                    return 1;
                                } else if (b.ItemCode > a.ItemCode) {
                                    return -1;
                                } else {
                                    if (a.WhsCode > b.WhsCode) {
                                        return 1;
                                    } else if (b.WhsCode > a.WhsCode) {
                                        return -1;
                                    } else {
                                        return 0;
                                    }
                                }
                            });
                            itemsBatch = itemsBatch.filter((item) => {
                                if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                                    return false
                                } else {
                                    itemCode[item.ItemCode] = true;
                                    whs[item.WhsCode] = true;
                                    return true;
                                }
                            });
                            let newItemsBatchArray = []
                            for (let index = 0; index < itemsBatch.length; index++) {
                                const item = itemsBatch[index];
                                newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                            }
                            enableSpinner(true);
                            let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                            enableSpinner(false);

                            if (batchsResponse.status === 0) {
                                showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                                return;
                            }
                            let isNewBatch = false;
                            for (let index = 0; index < newOrderModel.Items.length; index++) {
                                const item = newOrderModel.Items[index];
                                for (let index = 0; index < batchsResponse.data.length; index++) {
                                    const itemBatch = batchsResponse.data[index];
                                    if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                        if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                            isNewBatch = true;
                                        }
                                        item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                    }
                                }
                            }

                            if (isNewBatch) {
                                await this.setState({
                                    newOrderModel,
                                    showBatchSelectionModal: true,
                                });
                                $('#batchSelectionModal').modal('show');
                            } else {
                                showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                                return;
                            }

                        } else {
                            if (await this.CheckIfItsUniversalPartner()) {
                                enableSpinner(true);
                                let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                                this.GetPartnerAddresses(newOrderModel.CardCode);
                                newOrderModel.DeliveryAuthorization = 'I';
                                await this.refreshModel(newOrderModel)
                                enableSpinner(false);
                                await this.setState({
                                    updatebusinessPartner: getPartnersResponse.data[0],
                                    NextStepFunction: async () => {
                                        $('#detailClientModal').modal('hide');
                                        let isAuthorization = await this.ValidateAuthorization();
                                        if (!isAuthorization) { this.CreateDocument(); }
                                    },
                                    ContinueWithoutSave: async () => {
                                        $('#detailClientModal').modal('hide');
                                        let isAuthorization = await this.ValidateAuthorization();
                                        if (!isAuthorization) { this.CreateDocument(); }
                                    }
                                });
                                $("#detailClientModal").modal("show");
                            } else {
                                await this.ShowBillModal();
                                $("#vmInvoice").modal("show");

                            }
                        }
                    } else {
                        if (await this.CheckIfItsUniversalPartner()) {
                            enableSpinner(true);
                            let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                            this.GetPartnerAddresses(newOrderModel.CardCode);
                            newOrderModel.DeliveryAuthorization = 'I';
                            await this.refreshModel(newOrderModel)
                            enableSpinner(false);
                            await this.setState({
                                updatebusinessPartner: getPartnersResponse.data[0],
                                NextStepFunction: async () => {
                                    $('#detailClientModal').modal('hide');
                                    const isAuthorization = await this.ValidateAuthorization();
                                    if (!isAuthorization) { this.CreateDocument(); }
                                },
                                ContinueWithoutSave: async () => {
                                    $('#detailClientModal').modal('hide');
                                    let isAuthorization = await this.ValidateAuthorization();
                                    if (!isAuthorization) { this.CreateDocument(); }
                                }
                            });
                            $("#detailClientModal").modal("show");
                        } else {
                            await this.ShowBillModal();
                            $("#vmInvoice").modal("show");
                        }
                    }
                } else {
                    let items = newOrderModel.Items || [];
                    let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
                    if (itemsBatch.length > 0) {
                        let isBatchComplete = true;
                        for (let index = 0; index < itemsBatch.length; index++) {
                            const item = itemsBatch[index];
                            item.SnBUoMQty = 0;
                            for (let indez = 0; indez < item.BatchNumbers.length; indez++) {
                                const batch = item.BatchNumbers[indez];
                                item.SnBUoMQty += Number(batch.Quantity);
                            }
                            if (Number(item.SnBUoMQty) !== Number(item.Quantity)) {
                                isBatchComplete = false;
                            }
                        }
                        if (!isBatchComplete) {
                            let itemCode = {};
                            let whs = {}
                            itemsBatch.sort((a, b) => {
                                if (a.ItemCode > b.ItemCode) {
                                    return 1;
                                } else if (b.ItemCode > a.ItemCode) {
                                    return -1;
                                } else {
                                    if (a.WhsCode > b.WhsCode) {
                                        return 1;
                                    } else if (b.WhsCode > a.WhsCode) {
                                        return -1;
                                    } else {
                                        return 0;
                                    }
                                }
                            });
                            itemsBatch = itemsBatch.filter((item) => {
                                if (itemCode[item.ItemCode] && whs[item.WhsCode]) {
                                    return false
                                } else {
                                    itemCode[item.ItemCode] = true;
                                    whs[item.WhsCode] = true;
                                    return true;
                                }
                            });
                            let newItemsBatchArray = []
                            for (let index = 0; index < itemsBatch.length; index++) {
                                const item = itemsBatch[index];
                                newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode })
                            }
                            enableSpinner(true);
                            let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                            enableSpinner(false);

                            if (batchsResponse.status === 0) {
                                showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                                return;
                            }
                            let isNewBatch = false;
                            for (let index = 0; index < newOrderModel.Items.length; index++) {
                                const item = newOrderModel.Items[index];
                                for (let index = 0; index < batchsResponse.data.length; index++) {
                                    const itemBatch = batchsResponse.data[index];
                                    if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                                        if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) {
                                            isNewBatch = true;
                                        }
                                        item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                                    }
                                }
                            }

                            if (isNewBatch) {
                                await this.setState({
                                    newOrderModel,
                                    showBatchSelectionModal: true,
                                });
                                $('#batchSelectionModal').modal('show');
                            } else {
                                showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                                return;
                            }

                        } else {

                            enableSpinner(true);
                            let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                            this.GetPartnerAddresses(newOrderModel.CardCode);
                            enableSpinner(false);
                            await this.setState({
                                updatebusinessPartner: getPartnersResponse.data[0],
                                NextStepFunction: async () => {
                                    $('#detailClientModal').modal('hide');
                                    this.CreateDocument();
                                },
                                ContinueWithoutSave: async () => {
                                    $('#detailClientModal').modal('hide');
                                    this.CreateDocument();
                                }
                            });
                            $("#detailClientModal").modal("show");
                        }

                    } else {

                        enableSpinner(true);
                        let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                        this.GetPartnerAddresses(newOrderModel.CardCode);
                        enableSpinner(false);
                        await this.setState({
                            updatebusinessPartner: getPartnersResponse.data[0],
                            NextStepFunction: async () => {
                                $('#detailClientModal').modal('hide');
                                // this.CreateDocument();
                                await this.setState({ showBillModal: true });
                                $("#billModal").modal("show");
                            },
                            ContinueWithoutSave: async () => {
                                $('#detailClientModal').modal('hide');
                                $('#vmDeliveryHouse').modal('show');
                                // this.CreateDocument();
                                // await this.setState({ showBillModal: true });
                                // $("#billModal").modal("show");
                            }
                        });
                        $("#detailClientModal").modal("show");
                    }


                }
            } else {
                if (await this.CheckIfItsUniversalPartner()) {
                    enableSpinner(true);
                    let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                    this.GetPartnerAddresses(newOrderModel.CardCode);
                    enableSpinner(false);
                    await this.setState({
                        updatebusinessPartner: getPartnersResponse.data[0],
                        NextStepFunction: async () => {

                            let isAuthorization = await this.ValidateAuthorization();
                            if (!isAuthorization) {
                                $('#detailClientModal').modal('hide');
                                this.CreateDocument();
                            } else {
                                $('#detailClientModal').modal('hide');
                            }
                        }
                    });
                    $("#detailClientModal").modal("show");
                } else {
                    await this.ShowBillModal();
                    $("#vmInvoice").modal("show");

                }
            }
        } else {
            if (await this.CheckIfItsUniversalPartner()) {
                enableSpinner(true);
                const getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
                this.GetPartnerAddresses(newOrderModel.CardCode);
                enableSpinner(false);
                await this.setState({
                    updatebusinessPartner: getPartnersResponse.data[0],
                    NextStepFunction: async () => {
                        let isAuthorization = await this.ValidateAuthorization();
                        if (!isAuthorization) {
                            $('#detailClientModal').modal('hide');
                            this.CreateDocument();
                        } else {
                            $('#detailClientModal').modal('hide');
                        }
                    }
                });
                $("#detailClientModal").modal("show");
            } else {
                await this.ShowBillModal();
                $("#vmInvoice").modal("show");

            }
        }

    }

    FillAddressesByBP = async (deliveriesAddress, billAddresseses) => {
        let deliveryAddresses = [];
        let billAddresses = [];
        for (const address of deliveriesAddress) {
            let addressModel = new Addresses();
            addressModel.Address = address.Address;
            addressModel.Street = address.Street;
            addressModel.Block = address.Block;
            addressModel.City = address.City;
            addressModel.ZipCode = address.ZipCode;
            addressModel.County = address.County;
            addressModel.State = address.State;
            addressModel.Country = address.Country;
            addressModel.TaxCode = address.TaxCode;
            addressModel.StreetNo = address.StreetNo;

            addressModel.Building = address.Building;
            addressModel.GlblLocNum = address.GlblLocNum;
            addressModel.TaxOffice = address.TaxOffice;
            addressModel.TypeOfAddress = address.AdresType;
            addressModel.LineNum = address.LineNum;
            addressModel.U_FMB_Project = address.U_FMB_Project || '';
            deliveryAddresses.push(addressModel);
        }

        for (const billAddress of billAddresseses) {
            let addressModel = new Addresses();
            addressModel.Address = billAddress.Address;
            addressModel.Street = billAddress.Street;
            addressModel.Block = billAddress.Block;
            addressModel.City = billAddress.City;
            addressModel.ZipCode = billAddress.ZipCode;
            addressModel.County = billAddress.County;
            addressModel.State = billAddress.State;
            addressModel.Country = billAddress.Country;
            addressModel.TaxCode = billAddress.TaxCode;
            addressModel.StreetNo = billAddress.StreetNo;

            addressModel.Building = billAddress.Building;
            addressModel.GlblLocNum = billAddress.GlblLocNum;
            addressModel.TaxOffice = billAddress.TaxOffice;
            addressModel.TypeOfAddress = billAddress.AdresType;
            addressModel.LineNum = billAddress.LineNum;
            billAddresses.push(addressModel);
        }
        await this.setState({ deliveryAddresses, billAddresses });
    }

    ChangeActionMode = async (value, editMode) => {
        await this.setState({
            Action: value,
            editableMode: editMode
        })
    }

    RefreshAddressModel = async (addressModel) => {
        await this.setState({ addressModel });
    }

    SetIndexDirection = (index) => {
        this.setState({ setDHIndex: index })
    }

    //#endregion

    //#region ########## UPDATE BUSINESS PARTNER #########################################
    EditBusinessPartner = async () => {
        const { updatebusinessPartner, newOrderModel, auxNewOrderModel, showTemporalData } = this.state

        await this.setState({
            editModePartner: !this.state.editModePartner,
        });
        if (this.state.editModePartner) {
            this.setAddress(this.state.setBillIndex, this.state.setDeliveryIndex)
            newOrderModel.LicTradNum = updatebusinessPartner.LicTradNum;
            newOrderModel.CardName = updatebusinessPartner.CardName;
            newOrderModel.USOCFDI = updatebusinessPartner.U_FMB_USO_CFDI;
            newOrderModel.RegimenFiscal = updatebusinessPartner.U_FMB_REGIMEN_FISCAL;
            newOrderModel.TaxCode = updatebusinessPartner.TaxCode;
            newOrderModel.TaxName = updatebusinessPartner.TaxName;
            newOrderModel.TaxRate = updatebusinessPartner.TaxRate;
            newOrderModel.GroupNum = updatebusinessPartner.GroupNum;
            newOrderModel.CreditLine = updatebusinessPartner.CreditLine;
            newOrderModel.Cellular = updatebusinessPartner.Cellular;
            newOrderModel.E_mail = updatebusinessPartner.E_mail;
            const auxOrderModelCopy = Object.assign({}, newOrderModel)
            await this.setState({
                auxNewOrderModel: auxOrderModelCopy,
                newOrderModel
            })
        }
        if (!this.state.editModePartner && this.state.auxNewOrderModel !== null) {
            // back info to origin
            newOrderModel.LicTradNum = auxNewOrderModel.LicTradNum;
            updatebusinessPartner.LicTradNum = this.state.auxNewOrderModel.LicTradNum;
            newOrderModel.CardName = auxNewOrderModel.CardName;
            updatebusinessPartner.CardName = this.state.auxNewOrderModel.CardName;
            newOrderModel.USOCFDI = auxNewOrderModel.USOCFDI;
            updatebusinessPartner.USOCFDI = this.state.auxNewOrderModel.USOCFDI;
            newOrderModel.RegimenFiscal = auxNewOrderModel.RegimenFiscal;
            updatebusinessPartner.U_FMB_REGIMEN_FISCAL = this.state.auxNewOrderModel.RegimenFiscal;

            newOrderModel.TaxCode = auxNewOrderModel.TaxCode;
            updatebusinessPartner.TaxCode = this.state.auxNewOrderModel.TaxCode;
            newOrderModel.TaxName = auxNewOrderModel.TaxName;
            updatebusinessPartner.TaxName = this.state.auxNewOrderModel.TaxName;
            newOrderModel.TaxRate = auxNewOrderModel.TaxRate;
            updatebusinessPartner.TaxRate = this.state.auxNewOrderModel.TaxRate;

            newOrderModel.GroupNum = auxNewOrderModel.GroupNum;
            updatebusinessPartner.GroupNum = this.state.auxNewOrderModel.GroupNum;
            newOrderModel.CreditLine = auxNewOrderModel.CreditLine;
            updatebusinessPartner.CreditLine = this.state.auxNewOrderModel.CreditLine;
            newOrderModel.Cellular = auxNewOrderModel.Cellular;
            updatebusinessPartner.Cellular = this.state.auxNewOrderModel.Cellular;
            newOrderModel.E_mail = auxNewOrderModel.E_mail;
            updatebusinessPartner.E_mail = this.state.auxNewOrderModel.E_mail;

            await this.setState({
                updatebusinessPartner,
                newOrderModel: newOrderModel
            })
        }
        if (showTemporalData) {
            await this.setState({
                showTemporalData: !this.state.showTemporalData
            })
        }
        await this.SetBranchOfficeTaxes(newOrderModel);
    };

    RefreshBusinessModel = async (updatebusinessPartner) => {
        await this.setState({ updatebusinessPartner })
    };

    AddPay = () => {
        this.setState({
            PaymentSaleModel: new PayMethodCounter(),
            addingPay: !this.state.addingPay,
        });
    };

    AddMove = () => {
        this.setState({
            addingMove: !this.state.addingMove,
        });
    };

    UpdateBusinessPartner = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { updatebusinessPartner } = this.state;
        // edicion partner
        const data = {
            updatebusinessPartner,
        };
        enableSpinner(true);
        let updateBusinessPartnerResponse = await apiClient.updateBusinessPartnerPS(data);
        enableSpinner(false);

        if (!updateBusinessPartnerResponse.status) {
            showAlert({ type: "error", message: updateBusinessPartnerResponse.message, timeOut: 5000 });
            return;
        }

        showAlert({ type: "success", message: updateBusinessPartnerResponse.message, timeOut: 5000 });
        updatebusinessPartner.ShipToDef = ''
        updatebusinessPartner.BillToDef = ''
        await this.setState({
            editModePartner: false,
            WasUpdatedPartner: true,
            setDeliveryIndex: '',
            setBillIndex: '',
            updatebusinessPartner
        })
    }

    GetStateCodeByStateName = async (stateName) => {
        const { states } = this.state
        let responseState = null;
        if ((states && states.length === 0) || stateName === '' || stateName === null || stateName === undefined) {
            return responseState;
        }

        const findState = states.find((state) => state.Name === stateName)

        if (findState) {
            return findState
        } else {
            return responseState;
        }
    }

    setAddress = async (BillIndex, ShipIndex) => {
        const { newOrderModel, billAddresses, deliveryAddresses } = this.state

        if (billAddresses.length > 0 && Number(BillIndex) >= 0) {
            const auxbillAddresses = billAddresses[Number(BillIndex)];
            const auxStateData = await this.GetStateCodeByStateName(auxbillAddresses.County);
            newOrderModel.AddressExtension.BillToStreet = auxbillAddresses.Street || '' //Calle y numero
            newOrderModel.AddressExtension.BillToBlock = auxbillAddresses.Block || '' //Colonia
            newOrderModel.AddressExtension.BillToCity = auxbillAddresses.City || '' //Ciudad
            newOrderModel.AddressExtension.BillToZipCode = auxbillAddresses.ZipCode || '' //C.P.
            newOrderModel.AddressExtension.BillToState = auxStateData !== null ? auxStateData.Name : auxbillAddresses.State || ''//State  auxbillAddresses.State || ''//State
            newOrderModel.AddressExtension.BillToCountry = auxbillAddresses.Country || ''//Country
        }

        if (deliveryAddresses.length > 0 && Number(ShipIndex) >= 0) {
            const auxShipAddress = deliveryAddresses[Number(ShipIndex)];
            const auxStateData = await this.GetStateCodeByStateName(auxShipAddress.County);
            newOrderModel.AddressExtension.ShipToStreet = auxShipAddress.Street || ''//Calle y numero
            newOrderModel.AddressExtension.ShipToBlock = auxShipAddress.Block || ''//Colonia
            newOrderModel.AddressExtension.ShipToCity = auxShipAddress.City || ''//Ciudad
            newOrderModel.AddressExtension.ShipToZipCode = auxShipAddress.ZipCode || ''//C.P.
            newOrderModel.AddressExtension.ShipToState = auxStateData !== null ? auxStateData.Name : auxShipAddress.State || ''//State 
            newOrderModel.AddressExtension.ShipToCountry = auxShipAddress.Country || ''//Country
        }

        await this.refreshModel(newOrderModel)

    }

    //#endregion

    //#region ########## SEARCH STOCK ####################################################
    SearchStockByItem = async (ItemCode) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        await this.ShowSearchStockModal(true);

        let data = {
            ItemCode
        }
        enableSpinner(true);
        let responseApi = await apiClient.SearchStockByItem(data);
        enableSpinner(false);


        if (responseApi.status !== 1) {
            showAlert({ type: 'warning', message: `${responseApi.message}` });
            await this.ShowSearchStockModal(false);
            return;
        }
        this.setState({
            stockByItem: responseApi.data || []
        })
        $("#searchStockModal").modal("show");
    }

    //#endregion

    //#region ########## QUOTATIONS ######################################################

    ShowVMQuotation = async () => {
        const { enableSpinner } = this.props;
        const { newOrderModel } = this.state
        if (await this.CheckIfItsUniversalPartner() === true) {
            await this.ChangeVMQuotation();
            $("#vmQuotation").modal("show");
        } else {
            enableSpinner(true);
            let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
            this.GetPartnerAddresses(newOrderModel.CardCode);
            enableSpinner(false);
            let updatePartner = getPartnersResponse.data[0];
            updatePartner.billAddress = new BillAddress()
            updatePartner.shipAddress = new ShipAddress()

            await this.setState({
                updatebusinessPartner: updatePartner,
                NextStepFunction: () => {

                    $('#detailClientModal').modal('hide');
                    this.CreateDocument();
                },
                ContinueWithoutSave: () => {

                    this.CreateDocument();
                }
            });

            $("#detailClientModal").modal("show");
        }
    }

    ShowCreatedQuotation = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let { newOrderModel } = this.state;
        newOrderModel.CashSum = 0;
        newOrderModel.TotalRestante = 0;
        let docsToPrintIds = [folio];
        const data = {
            docsToPrintIds: docsToPrintIds,
            typeDoc: 23
        }
        enableSpinner(true);
        const responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            this.CloseCreatedInvoiceActions();
            return;
        }

        this.SetDefaultPartner();

        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'OQUT',
            ordersToAction: folio,
            EnableEditButton: false,
            newOrderModel,
            itemSelected: {},
        });

        await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }
    //#endregion

    //#region ########## ORDERS ##########################################################
    ShowCreatedOrder = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 17
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            this.CloseCreatedInvoiceActions();
            return;
        }

        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'ORDR',
            ordersToAction: folio,
            EnableEditButton: false,
        });
        await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }

    //#endregion

    //#region ########## DELIVERY ########################################################
    ShowCreatedDeliveryDoc = async (folio) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 15
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            // this.CloseCreatedInvoiceActions();
            return;
        }
        let resOxxoData = new OxxoReferenceModel();
        if (Modules['oxxoReferences'] && (responseApi.data[0] && responseApi.data[0]?.docHeader?.responseHeader?.U_FMB_PriKeyOxRef && responseApi.data[0]?.docHeader?.responseHeader?.U_FMB_PriKeyOxRef !== -1)) {
            const data = {
                DocEntry: responseApi.data[0]?.docHeader?.responseHeader?.DocEntry,
                ObjType: responseApi.data[0]?.docHeader?.responseHeader?.ObjType,
                IdOxxoRef: responseApi.data[0]?.docHeader?.responseHeader?.U_FMB_PriKeyOxRef
            }

            enableSpinner(true);
            resOxxoData = await apiClient.GetInfoOxxoReference(data);
            enableSpinner(false);
        }


        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'ODLD',
            ordersToAction: folio,
            EnableEditButton: false,
            OxxoRefData: resOxxoData.data?.ModelReference,
        });
        await this.ShowPDFViewer();
        $("#pdfViewer").modal("show");
    }
    //#endregion

    //#region ########## DOWN PAYMENTS ####################################################
    ShowAdvancePayment = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, editModePartner, updatebusinessPartner } = this.state
        if (await this.CheckIfItsUniversalPartner()) {
            showAlert({ type: "error", message: `NO PUEDES CREAR FACTURAS DE ANTICIPO CON CLIENTES UNIVERSALES` });
            return
        } else {
            enableSpinner(true);
            let getPartnersResponse = await apiClient.SearchPartner(newOrderModel.CardCode);
            if (editModePartner) {
                getPartnersResponse.data[0] = updatebusinessPartner
            }
            this.GetPartnerAddresses(newOrderModel.CardCode);
            enableSpinner(false);
            await this.setState({
                updatebusinessPartner: getPartnersResponse.data[0],
                NextStepFunction: async () => {

                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        if (this.state.showBillModal === false) {
                            await this.ShowBillModal();
                        }
                        $('#detailClientModal').modal('hide');
                        $('#billModal').modal('show');
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                },
                ContinueWithoutSave: async () => {
                    let isAuthorization = await this.ValidateAuthorization();
                    if (!isAuthorization) {
                        if (this.state.showBillModal === false) {
                            await this.ShowBillModal();
                        }
                        $('#detailClientModal').modal('hide');
                        $('#billModal').modal('show');
                    } else {
                        $('#detailClientModal').modal('hide');
                    }
                }
            });
            $(`#detailClientModal`).modal("show");
        }

    }

    ShowCreatedDownPayment = async (folio, timbraResponse = null) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        let data = {
            docsToPrintIds: [folio],
            typeDoc: 203
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }
        for (let index = 0; index < responseApi.data.length; index++) {
            const document = responseApi.data[index];
            if (timbraResponse && index === 0) {
                if (timbraResponse && index === 0 && timbraResponse.status) {
                    showAlert({ type: "success", message: `${timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(timbraResponse.XML);
                } else if (timbraResponse && !timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${timbraResponse.message}`, timeOut: 10000 });
                }
            }
            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: 'ODPI',
                ordersToAction: folio,
                EnableEditButton: false,
            });
            await this.ShowPDFViewer();
            $("#pdfViewer").modal("show");
        }
    }
    //#endregion

    //#region ########## MAIL FUNCTIONS  #################################################

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state
        // var value = docsStruct.innerHTML;
        // var objToSend = JSON.stringify(value);
        let infoFolio = await _generalFunctions.getDocInfoByFolio(docsToPrint[0].docHeader.infoByFolio.folio ?? '')
        sendMailModel.docEntry = infoFolio.DocEntry
        let data = {
            sendMailModel,
            // docsStruct: objToSend,
            typeDoc: typeDocPrint,
            objType: infoFolio.num,
            infoDoc: [{
                cardCode: docsToPrint[0].docHeader.responseHeader.CardCode ?? '',
                folio: docsToPrint[0].docHeader.infoByFolio.folio ?? '',
                slpInfo: {
                    slpCode: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpCode : docsToPrint[0].docHeader.SlpCode || '',
                    slpName: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpName : docsToPrint[0].docHeader.SlpName || '',
                }
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }
    //#endregion

    //#region ########## PDF VIEWER ACTIONS  #############################################
    ShowNextDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { extraDocsToShow, indexTypeDocShow } = this.state;

        let indexDoc = indexTypeDocShow + 1;
        if (indexDoc === extraDocsToShow.length) {
            indexDoc = 0; // back to origin
        }

        const data = {
            docsToPrintIds: [extraDocsToShow[indexDoc].Folio],
            typeDoc: extraDocsToShow[indexDoc].DocObjectType
        }
        enableSpinner(true);
        let responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        for (let index = 0; index < responseApi.data.length; index++) {
            const document = responseApi.data[index];
            if (extraDocsToShow[indexDoc].timbraResponse && index === 0 && extraDocsToShow[indexDoc].timbraResponse.status) {
                if (extraDocsToShow[indexDoc].timbraResponse && index === 0 && extraDocsToShow[indexDoc].timbraResponse.status) {
                    // showAlert({ type: "success", message: `${extraDocsToShow[indexDoc].timbraResponse.message}` });
                    document.docHeader.responseHeader.U_FMB_XMLTIMBRA = JSON.stringify(extraDocsToShow[indexDoc].timbraResponse.XML);
                } else if (extraDocsToShow[indexDoc].timbraResponse && !extraDocsToShow[indexDoc].timbraResponse.status) {
                } else if (extraDocsToShow[indexDoc].timbraResponse && !extraDocsToShow[indexDoc].timbraResponse.status) {
                    showAlert({ type: "error", message: `Documento no timbrado` });
                    showAlert({ type: "info", message: `${extraDocsToShow[indexDoc].timbraResponse.message}`, timeOut: 10000 });
                }
            }
            await this.setState({
                docsToPrint: responseApi.data ?? [],
                typeDocPrint: extraDocsToShow[indexDoc].TypeDoc,
                EnableEditButton: false,
                indexTypeDocShow: indexDoc
            });
        }
    }
    //#endregion

    //#region ########## DELIVERY RESERVE INVOICES #######################################  
    SearchReserveInvoiceDoc = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state
        const infoByFolio = await _generalFunctions.getDocInfoByFolio(newOrderModel.NumAtCard);

        if (newOrderModel.NumAtCard === '' || infoByFolio.folioID !== 'IV') {
            showAlert({ type: "info", message: `Ingresa un folio de factura de reserva valido. ` });
            return;
        }
        const data = {
            Folio: newOrderModel.NumAtCard || '',
            infoByFolio
        }

        enableSpinner(true);
        const responseApi = await apiClient.SearchReserveInvoiceDoc(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            await this.ReturnToOrigin();
            return;
        }
        if ((!responseApi.data.headerDocument || responseApi.data.headerDocument === null) || (!responseApi.data.docLines || responseApi.data.docLines.length === 0)) return;
        const newOrder = await this.FillInfoReserveInvoice(responseApi.data, true);
        await this.setState({
            newOrderModel: newOrder,
        })
    }

    ReturnToOrigin = async () => {
        await this.setState({
            checkboxDataTables: (new Map()),
        });
        await this.SetDefaultPartner();
        await this.CheckWorkSession();
        await this.SetBranchOfficeInfo();
        await this.SetCounterPermissions();

    }

    FillInfoReserveInvoice = async (infoData, needRelation) => {
        const { notificationReducer: { showAlert } } = this.props;
        let anotherOrderModel = new NewOrderSales();

        // Advertencia de socio de negocio inactivo
        if (infoData.headerDocument.validFor && infoData.headerDocument.validFor === 'N') {
            showAlert({ type: "warning", message: `El socio de negocios se encuentra inactivo, solicite habilitarlo para continuar` });
        }

        // const infoFolio = await _generalFunctions.getDocInfoByFolio(infoData.headerDocument.NumAtCard);
        anotherOrderModel.CardCode = infoData.headerDocument.CardCode;
        anotherOrderModel.NumAtCard = infoData.headerDocument.NumAtCard;
        anotherOrderModel.CardName = infoData.headerDocument.CardName;
        anotherOrderModel.Comments = '';
        anotherOrderModel.Comments = '';
        anotherOrderModel.ObjType = 'deliveries'
        anotherOrderModel.ReserveDelivery = true;
        anotherOrderModel.NextFolio = infoData.headerDocument.NumAtCard;

        for (let i = 0; i < infoData.docLines.length; i++) {
            const ItemRes = infoData.docLines[i];
            let newItemModel = new NewItem();
            if (needRelation) {
                newItemModel.BaseEntry = infoData.headerDocument.DocEntry || '';
                newItemModel.BaseType = 13;
                newItemModel.BaseLine = ItemRes.LineNum;
            }
            newItemModel.LineStatus = ItemRes.LineStatus === 'O' ? true : false;
            newItemModel.LineNum = ItemRes.LineNum;
            newItemModel.ItemCode = ItemRes.ItemCode;
            newItemModel.ItemName = ItemRes.ItemName || ItemRes.Dscription;
            newItemModel.Description = ItemRes.Dscription
            newItemModel.UserText = ItemRes.UserText;
            newItemModel.CodeBars = ItemRes.CodeBars || "";
            newItemModel.HomePrice = Number(ItemRes.Price);
            newItemModel.Price = Number(ItemRes.Price);
            newItemModel.Total = Number(ItemRes.LineTotal)
            newItemModel.TaxCode = ItemRes.TaxCode;
            newItemModel.TaxRate = ItemRes.Impuesto;
            newItemModel.NumInSale = Number(ItemRes.NumInSale || 0);
            newItemModel.OnHand = Number(ItemRes.OnHand || 0);
            newItemModel.Quantity = Number(ItemRes.Quantity || 1);
            newItemModel.newQuantity = Number(ItemRes.OpenQty || 1);
            newItemModel.RevenuesAc = ItemRes.RevenuesAc;
            newItemModel.SWeight1 = Number(ItemRes.SWeight1 || 0);
            newItemModel.SWght1Unit = ItemRes.SWght1Unit || 3;
            newItemModel.InvntItem = ItemRes.InvntItem || 'Y';
            newItemModel.ManBtchNum = ItemRes.ManBtchNum || 'M';
            newItemModel.OpenQty = ItemRes.OpenQty ? ItemRes.OpenQty : 0;
            newItemModel.AvgPrice = ItemRes.AvgPrice || 0;
            newItemModel.WhsStock = ItemRes.WhsStock || 0;
            newItemModel.WhsCode = ItemRes.WhsCode || '';
            if (ItemRes.BatchNumbers) {
                newItemModel.BatchNumbers = ItemRes.BatchNumbers ?? [];
            }
            anotherOrderModel.Items.push(newItemModel);
        }
        return anotherOrderModel;
    }

    MakeReserveDelivery = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel, checkboxDataTables, idWorkShift, _user } = this.state

        let ItemsToDeliver = [];

        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                ItemsToDeliver.push(newOrderModel.Items[id]);
            }
        }
        if (ItemsToDeliver.length === 0) {
            showAlert({ type: 'warning', message: 'No has seleccionado ninguna linea a entregar', timeOut: 1000 });
            return;
        }

        let serieCode = _user?.U_FMB_ValidateSeriesODLN.split("|");

        for (let index = 0; index < serieCode.length; index++) {
            const serie = serieCode[index];
            if (index === 0) {
                newOrderModel.SerieCode = serie;
                break;
            }
        }

        for (let x = 0; x < ItemsToDeliver.length; x++) {
            const item = ItemsToDeliver[x];
            if (Number(item.newQuantity) === 0) {
                showAlert({ type: 'warning', message: 'No puedes crear entregas de 0 unidades', timeOut: 1000 });
                return;
            }
            item.Quantity = Number(item.newQuantity);
        }

        newOrderModel.Items = ItemsToDeliver;
        const table = this.selectTable(newOrderModel.ObjType);
        newOrderModel.idSession = idWorkShift;
        newOrderModel.OriginDoc = 'Counter-MakeReserveDelivery';
        await this.toggleDocumentSelectedAll(true);
        const batchValidation = await this.ValidateBatchToDelivery();
        if (!batchValidation) {
            showAlert({ type: 'info', message: 'Seleccione los lotes correspondientes a cada artículo', timeOut: 1000 });
            return;
        }

        const data = {
            destino: table.name,
            docSubType: table.docSubType,
            reserveInvoice: table.reserveInvoice,
            model: newOrderModel,
            Time: moment().format(),
            UserTime: moment().format("HH:mm:ss"),
            ClientVersion: currentVersion,
        };

        enableSpinner(true);
        const createDocumentResponse = await apiClient.createNewDocumentPS(data);
        enableSpinner(false);

        if (!createDocumentResponse.status) {
            showAlert({ type: "error", message: "Ocurrió un problema a procesar la solicitud, " + createDocumentResponse.message, timeOut: 5000 });
            return;
        } else if (createDocumentResponse.status === 8) {
            showAlert({ type: "info", message: createDocumentResponse.message, timeOut: 50000 });
            $('#newUpdateModal').modal('show');
            return
        }

        const createdDoc = createDocumentResponse.data;
        showAlert({ type: "success", message: "Entrega realizada con exito " + createdDoc.createdFolio, timeOut: 5000 });

        newOrderModel.Total = createDocumentResponse.data.serviceLayeResponse.DocTotal;
        newOrderModel.folio = createDocumentResponse.data.createdFolio;
        newOrderModel.DocTime = data.UserTime || createDocumentResponse.data.serviceLayeResponse.DocTime;

        newOrderModel.CardCode = createDocumentResponse.data.serviceLayeResponse.CardCode;
        newOrderModel.CardName = createDocumentResponse.data.serviceLayeResponse.CardName;
        newOrderModel.LicTradNum = createDocumentResponse.data.serviceLayeResponse.FederalTaxID;
        newOrderModel.Comments = createDocumentResponse.data.serviceLayeResponse.Comments;
        newOrderModel.Address = createDocumentResponse.data.serviceLayeResponse.Address;
        newOrderModel.Address2 = createDocumentResponse.data.serviceLayeResponse.Address2;
        // newOrderModel.Items = createDocumentResponse.data.serviceLayeResponse.DocumentLines;

        // let user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        await this.ShowCreatedReserveDelivery(newOrderModel.folio);
        await this.setState({ showBillModal: true });
    }

    ShowCreatedReserveDelivery = async (document) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const data = {
            docsToPrintIds: [document],
            typeDoc: 15
        }
        enableSpinner(true);
        const responseApi = await apiClient.getPrintDocsInfo(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        await this.setState({
            docsToPrint: responseApi.data ?? [],
            typeDocPrint: 'ERDR',
            ordersToAction: document,
            EnableEditButton: false,
            showPDFViewer: !this.state.showPDFViewer,
            ShowExtraActions: false
        });
        $("#deliverModal").modal("hide");
        $("#pdfViewer").modal("show");

    }

    ValidateBatchToDelivery = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;
        let items = newOrderModel.Items || [];
        let itemsBatch = items.filter((item) => item.ManBtchNum === 'Y');
        if (itemsBatch.length > 0) {
            let isBatchComplete = true;
            for (let index = 0; index < itemsBatch.length; index++) {
                const item = itemsBatch[index];
                item.SnBUoMQty = 0;
                item.BatchNumbers.map((batch) => { item.SnBUoMQty += Number(batch.Quantity); });
                item.OpenLneQty = Number(item.Quantity) - Number(item.SnBUoMQty);
                if (Number(item.SnBUoMQty) !== Number(item.Quantity)) { isBatchComplete = false; }
            }
            if (!isBatchComplete) {
                let newItemsBatchArray = []
                itemsBatch.map(item => { newItemsBatchArray.push({ ItemCode: item.ItemCode, WhsCode: item.WhsCode }) })

                enableSpinner(true);
                let batchsResponse = await apiClient.getBatchItems({ newItemsBatchArray });
                enableSpinner(false);

                if (batchsResponse.status === 0) {
                    showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                    return;
                }
                let isNewBatch = false;
                for (let index = 0; index < newOrderModel.Items.length; index++) {
                    const item = newOrderModel.Items[index];
                    for (let index = 0; index < batchsResponse.data.length; index++) {
                        const itemBatch = batchsResponse.data[index];
                        if (item.ItemCode === itemBatch.ItemCode && item.WhsCode === itemBatch.WhsCode) {
                            if (itemBatch.AvailableBatchNumbers && itemBatch.AvailableBatchNumbers.length > 0) { isNewBatch = true; }
                            item.AvailableBatchNumbers = itemBatch.AvailableBatchNumbers;
                        }
                    }
                }

                if (isNewBatch) {
                    await this.setState({
                        newOrderModel,
                        showBatchSelectionModal: true,
                    });
                    $('#batchSelectionModal').modal('show');
                } else {
                    showAlert({ type: 'error', message: `Ocurrio un error al consultar Lotes`, timeOut: 8000 });
                }
                return false;
            }
        }
        return true;
    }

    //#endregion

    //#region ########## PAY WITH TERMINAL METHODS #######################################
    DeterminatePayWithTerminalPermission = async () => {
        const { _user } = this.state
        let flag = false;
        if (_user?.M_user !== "" || _user?.M_pass !== "") {
            flag = true;
        }

        await this.setState({
            FlagPayWithSantander: flag
        })
    }

    CheckTerminalConnection = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state

        if (_user?.M_user === "" || _user?.M_pass === "") {
            showAlert({ type: 'error', message: "TU USUARIO NO ES VALIDO PARA PAGAR CON TARJETA, CONTACTA CON TU ADMINISTRADOR PARA HABILITAR ESTA OPCION.", timeOut: 8000 });
            return;
        }

        const data = {
            test_enviroment: development,
            product: "Counter",
            data: {
                user: _user.M_user, // 9249INUA29
                password: _user.M_pass, // H5ZJAXT1HV
                salesAmount: '0.0',
                userTransaction: (_user?.U_NAME ?? '').substring(0, 30) ?? "--"
            }
        };
        enableSpinner(true);
        const checkConnection = await apiClient.CheckConnection(data);
        enableSpinner(false);
        //$("#terminalFunctions").modal("show");
        if (Number(checkConnection.status) !== 1) {
            showAlert({ type: 'error', message: checkConnection.message, timeOut: 5000 });
            return;
        }

        showAlert({ type: 'success', message: checkConnection.message, timeOut: 5000 });
        const auxMessage = `${checkConnection.data.TerminalEMVFull ?? ""}\n ${checkConnection.data.TerminalVersion ?? ""}\n ${checkConnection.data.TerminalPrinter ?? ""}`;
        showAlert({ type: 'info', message: auxMessage, timeOut: 8000 });
        $("#terminalFunctions").modal("show");

    }

    LaunchPaymentWithTerminalQuestion = async () => {
        const { notificationReducer: { showAlert } } = this.props;
        $("#billModal").modal("hide");
        $("#vmPayWithTerminal").modal("show");
        showAlert({ type: "info", message: "Hemos detectado que seleccionaste tarjeta como método de pago.", timeOut: 5000 });
    }

    PayWithCreditTerminal = async () => {
        const { newOrderModel, PaymentSaleModel, _user } = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (_user?.M_user === "" || _user?.M_pass === "") {
            showAlert({ type: 'error', message: "TU USUARIO NO ES VALIDO PARA PAGAR CON TARJETA, CONTACTA CON TU ADMINISTRADOR PARA HABILITAR ESTA OPCION.", timeOut: 8000 });
            return;
        }
        if (PaymentSaleModel.Amount === "" || Number(PaymentSaleModel.Amount) === 0) {
            showAlert({ type: 'error', message: "La cantidad a cobrar se registro en 0, esto es imposible reinicia el proceso de cobro del documento para continuar con el cobro por terminal.", timeOut: 8000 });
            return;
        }

        const data = {
            test_enviroment: development,
            product: "Counter",
            data: {
                user: _user.M_user,
                password: _user.M_pass,
                salesAmount: PaymentSaleModel.Amount,
                userTransaction: (_user?.U_NAME ?? '').substring(0, 30) ?? "--"
            }
        };

        enableSpinner(true);
        const payWithTerminal = await apiClient.PayWithCreditTerminal(data);
        enableSpinner(false);

        if (Number(payWithTerminal.status) !== 1) {
            showAlert({ type: 'error', message: payWithTerminal.message, timeOut: 8000 });
            $("#billModal").modal("show");
            return;
        }

        showAlert({ type: 'success', message: payWithTerminal.message, timeOut: 8000 });

        // if the pay was successfully it payment added to payments to sale
        let newArray = newOrderModel.PaymentsToSale;
        PaymentSaleModel.SuccessTerminal = true;
        newArray.push(PaymentSaleModel);
        newOrderModel.PaymentsToSale = newArray;
        await this.refreshModel(newOrderModel); // it was put here because this.SumOfAmounts will be use newOrderModel
        this.RefreshPaymentSaleModel(new PayMethodCounter());
        await this.SumOfAmounts();
        this.AddPay();


        // that fields are mine
        const payTerminalInfo = await this.FillCardInfoPayment(payWithTerminal.data);
        newOrderModel.flagPayWithTerminal = true;
        newOrderModel.payWithTerminalInfo.push(payTerminalInfo);
        await this.refreshModel(newOrderModel);
        $("#billModal").modal("show");
        await this.PrintVoucherMIT(null, await this.ReorganiceVoucher(payWithTerminal.data.VoucherCliente), "voucherCliente");
        await this.PrintVoucherMIT(null, await this.ReorganiceVoucher(payWithTerminal.data.VoucherComercio), "voucherComercio");
    }

    ReorganiceVoucher = (voucherInfo) => {
        const arrayInfoVoucher = [];
        const notDesireWords = ["@lsn", "@br", "@bc", "@cnb", "@lnn", "@cnn"];
        // Crea una expresión regular que coincida con cualquiera de las palabras no deseadas
        const regex = new RegExp(notDesireWords.join("|"), "gi");

        // Reemplaza todas las ocurrencias de las palabras no deseadas con una cadena vacía
        const nuevoTexto = voucherInfo.replace(regex, "");

        const newArray = nuevoTexto.split('\n');
        newArray.forEach(linea => {
            if (linea !== " ") arrayInfoVoucher.push(linea);
        });

        return arrayInfoVoucher;
    }

    FillCardInfoPayment = (response) => {
        let model = new PaymentCardsInfo();

        model.statusOp = response?.statusOp ?? "";
        model.NOperacion = response?.NOperacion ?? "";
        model.NAutorizacion = response?.NAutorizacion ?? "";
        model.CDResp = response?.CDResp ?? "";
        model.Ref = response?.Ref ?? "";
        model.Arqc = response?.Arqc ?? "";
        model.Aid = response?.Aid ?? "";
        model.AidLabel = response?.AidLabel ?? "";
        model.getRspDsOperationType = response?.getRspDsOperationType ?? "";

        return model;
    }

    CancelPayWithTerminal = () => {
        const { notificationReducer: { showAlert } } = this.props;

        showAlert({ type: "info", message: "Seleccionaste NO pagar con tarjeta, debes de seleccionar métodos de pago distintos a tarjeta para continuar", timeOut: 8000 });
        $("#vmPayWithTerminal").modal("hide");
        $("#billModal").modal("show");

    }

    PrintVoucherMIT = async (objectToPrint, voucherArray, typeVoucher) => {
        const user = JSON.parse(localStorage.getItem('Timbra1currentUser'));
        const data = {
            Config: {
                TicketType: typeVoucher,
                PaperSize: "50"
            },
            Store: {
                Name: Datos_Empresa.Nombre + ' ' + Datos_Empresa.Sociedad,
                Address: (user?.Branch?.Address ?? '').substring(0, 70) || "",
                RFC: user.Timbra.RFC || "",
                Phone: user.Branch.Phone || "",
                Logo: development === true ? ImageVoucherMIT_dev : ImageVoucherMIT_prod,
                Footer: `ESTE ES UN VOUCHER VALIDO ${development ? 'DE PRUEBAS' : ''} GENERADO POR LA TRANSACCIÓN ANTES MOSTRADA. CUALQUIER DEVOLUCIÓN DEBE DE SER SOLICITADA EL DIA DE EXPEDICIÓN DE ESTA TRANSACCIÓN ANTES DE LAS 11 DE LA NOCHE HORA CDMX, DE LO CONTRARIO NO SERA POSIBLE GENERAR LA DEVOLUCIÓN/CANCELACIÓN DE ESTA TRANSACCIÓN`,
            },
            Document: objectToPrint ?? null,
            Voucher: voucherArray ?? []

        }
        await apiClient.PrintVouchersMIT(data);
    };

    //#endregion

    //#region ########## SET DELIVERY #######################################
    ShowDoc2Delivery = async () => {
        await this.UpdateStateField('showDeliveryDocsModal', true)
        $("#deliveryDocs").modal("show");

    }

    CloseDocsToDelivery = async () => {
        $("#deliveryDocs").modal("hide");
        await this.UpdateStateField('showDeliveryDocsModal', false)

    }


    //#endregion

    //#region ########## SET DELIVERY #######################################
    ShowDoc2Delivery = async () => {
        await this.UpdateStateField('showDeliveryDocsModal', true)
        $("#deliveryDocs").modal("show");

    }

    CloseDocsToDelivery = async () => {
        $("#deliveryDocs").modal("hide");
        await this.UpdateStateField('showDeliveryDocsModal', false)

    }


    //#endregion

    //#region ########## SET CO1UserFields #######################################
    ShowCO1UserFields = async () => {
        await this.UpdateStateField('showCO1UserFieldsModal', true);
        $("#CO1UserFields").modal("show");
    }

    CloseDocsToDelivery = async () => {
        $("#CO1UserFields").modal("hide");
        await this.UpdateStateField('showCO1UserFieldsModal', false);
    }
    //#endregion

    //#region ########## CASCOS ##########################################################
    validateCasco = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        const { newOrderModel } = this.state;

        this.setState({ handedCasco: value });
        if (value) {
            for (let i = 0; i < newOrderModel.Items.length; i++) {
                if (newOrderModel.Items[i].ItemCode === cascoItem) {
                    newOrderModel.Items.splice(i, 1);
                    i--;
                }
            }

            await this.RefreshTotal(newOrderModel);
        } else {
            const hasCasco = newOrderModel.Items.find(({ ItemCode }) => ItemCode === cascoItem);
            if (!hasCasco) {
                await this.setState({ itemSearch: cascoItem });
                this.SearchItems();
            } else {
                return showAlert({ type: "info", message: "Ya cuentas con este articulo agregado" });
            }
        }
    }
    //#endregion

    //#region ########## FISE ##########################################################
    clearFise = () => {
        this.setState({
            FISE: null
        })
    }
    refreshFISE = (FISE) => {
        this.setState({
            FISE
        })
    }
    getFiseInfoByCode = async (code) => {
        const { newOrderModel } = this.state
        const { enableSpinner, notificationReducer: { showAlert } } = this.props
        enableSpinner(true);
        const response = await apiClient.getFiseInfoByCode(code, newOrderModel?.CardCode ?? null);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                FISE: response?.data ?? {}
            }, () => {
                const { FISE, PaymentSaleModel } = this.state;
                PaymentSaleModel.ID_FISE_APP = FISE?.ID_FISE_APP || "";
                PaymentSaleModel.ID_FISE_UDO = FISE?.ID_FISE_UDO || "";
                PaymentSaleModel.Amount = Number(FISE?.U_importe || 0).toFixed(2);
                this.RefreshPaymentSaleModel(PaymentSaleModel);
            })
        } else {
            showAlert({ type: "warning", message: response?.message || 'Error FISE' });
        }
    }
    //#endregion

    //#region ########## Gas Cylinder Management ##########################################################
    deliveredGasCylinder = async (index, value) => {
        const { notificationReducer: { showAlert } } = this.props;
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        const parentLineNum = newOrderModel.Items[index].LineNum;
        item.U_RML_ENTCLNDRO = value;
        item.U_RML_TIPO_CU = "-";

        if (Number(value || 0) === 1) {
            item.U_RML_CU = Number(item.Quantity || 0).toString();
        } else if (Number(value || 0) === 2) {
            item.U_RML_CU = "0";
            showAlert({ type: 'info', message: `Puedes especificar la cantidad de cilindros vacíos devueltos para el artículo ${item.ItemCode || item.ItemName || ''} si aplica.`, timeOut: 6000 });
        } else {
            item.U_RML_CU = "0";
        }

        if (item.isAdministrativeExpenseParent) {
            newOrderModel.Items = newOrderModel.Items.filter(
                item => item.ParentLineNum !== parentLineNum
            );
            item.isAdministrativeExpenseParent = '';
        }
        this.RefreshTotal(newOrderModel);
    }

    changeContract = async (index, value, keepOrLines = false) => {
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        const parentLineNum = newOrderModel.Items[index].LineNum;
        item.U_RML_TIPO_CU = value;

        if (item.isAdministrativeExpenseParent) {
            newOrderModel.Items = newOrderModel.Items.filter(
                item => item.ParentLineNum !== parentLineNum
            );
        }

        item.isAdministrativeExpenseParent = '';
        if (Number(item.U_RML_TIPO_CU) === 1) {
            await this.SearchAdministrativeExpenses(item);
        }
        this.RefreshTotal(newOrderModel, keepOrLines);
    }

    changeCU = async (index, value) => {
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        if (isNaN(value)) return;
        if (Number(value || 0) < 0) return;

        item.U_RML_CU = value;
        this.RefreshTotal(newOrderModel);
    }

    validateCU = async (index) => {
        const { notificationReducer: { showAlert } } = this.props;
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        item.U_RML_CU = Number(item.U_RML_CU || 0).toString();

        if (item.U_RML_ENTCLNDRO === "2") {
            const quantity = Number(item.Quantity || 0);
            const cilindrosValue = Number(item.U_RML_CU || 0);

            if (cilindrosValue >= quantity) {
                item.U_RML_ENTCLNDRO = "1";
                item.U_RML_CU = quantity.toString();
                await this.changeContract(index, "-", true);

                showAlert({ type: 'info', message: 'Como la cantidad de cilindros vacíos devueltos es igual o mayor a la cantidad del artículo, se cambió "¿Entrega Cilindro?" a SI y se igualó la cantidad.', timeOut: 6000 });
            }
        }

        const parentLineNum = newOrderModel.Items[index].LineNum;
        const childItems = newOrderModel.Items.filter(i => i.ParentLineNum === parentLineNum);

        childItems.forEach(child => {
            child.Quantity = Number(item.Quantity) - Number(item.U_RML_CU);
        });

        this.RefreshTotal(newOrderModel);
    }
    //#endregion

    //#region ########## Billing Fields ##########
    changeOperation = (index, value) => {
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        item.U_BPP_OPER = value;
        item = this.setItemIgvOptions(item);
        this.RefreshTotal(newOrderModel);
    }

    changeTypeOperation = (index, value) => {
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        item.U_tipoOpT12 = value;
        this.RefreshTotal(newOrderModel);
    }

    changeTaxStatus = async (index, value) => {
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        item.TaxStatus = value;
        setTimeout(() => {
            this.RefreshTotal(newOrderModel);
        }, 100);
    }

    setItemIgvOptions = (item, auxCode = null) => {
        /**
         * TIPO VENTA *************** INDICADOR DE IMPUESTO  **** TIPO DE OPERACION **** CODIGO DE AFECTACION   **** ESTATUS
         * GRAVADA                      IGV                             AFECTA                  10                     OK 
         * GRATUITA GRAVADA             IGV                             GRATUITA                11-17                  OK 
         * 
         * GRATUITA                     EXO                             GRATUITA                11-16                  OK
         * EXONERADA                    EXO                             EXONERADA               20                     OK 
         * EXONERADA GRATUITA           EXO                             GRATUITA                21                     OK 
         * INAFECTA                     EXO                             INAFECTA                30                     OK 
         * INAFECTA RETIROS             EXO                             INAFECTA                31-36                  OK 
         * INAFECTA GRATUITA            EXO                             INAFECTA GRATUITO       37                     OK 
         * EXPORTACION                  EXO                             EXPORTACION             40                     OK 
         */
        let { igvOperationList = [] } = this.state;
        let availableIgvOperationList = [];
        let isIGV = !item.TaxCode?.includes("EXO") && (item.TaxCode?.includes("IGV") || item.TaxName?.toUpperCase()?.includes("IGV"));
        let isEXO = item.TaxCode?.includes("EXO") || item.TaxName?.toUpperCase()?.includes("EXO") || item.TaxName?.toUpperCase()?.includes("EXENTO");

        // if (item.TaxCode?.includes("IGV")) {
        if (isIGV) {
            switch (item.U_BPP_OPER) {
                case "A":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 10);
                    break;
                case "G":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) > 10 && Number(Code) < 18);
                    break;
                default:
                    break;
            }
            // } else if (item.TaxCode?.includes("EXO")) {
        } else if (isEXO) {
            switch (item.U_BPP_OPER) {
                case "E":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 20);
                    break;
                case "I":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) > 29 && Number(Code) < 37);
                    break;
                case "G":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => (Number(Code) > 10 && Number(Code) < 17) || Number(Code) === 21);
                    break;
                case "EX":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 40);
                    break;
                case "IG":
                    availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === 37);
                    break;
                default:
                    break;
            }
        }

        item.availableIgvOperationList = availableIgvOperationList;
        if (availableIgvOperationList.length === 1) {
            item.U_STR_FECodAfect = availableIgvOperationList[0].Code;
        } else if (isEXO && item.U_BPP_OPER === 'G' && auxCode) {
            availableIgvOperationList = igvOperationList.filter(({ Code }) => Number(Code) === auxCode);
            item.U_STR_FECodAfect = availableIgvOperationList?.[0]?.Code || '';
        } else {
            item.U_STR_FECodAfect = "";
        }

        return item;
    }

    changeIgvOperation = (index, value) => {
        let { newOrderModel } = this.state;
        let item = newOrderModel.Items[index];
        item.U_STR_FECodAfect = value;
        this.RefreshTotal(newOrderModel);
    }

    openTaxByItem = (index) => {
        this.setState({ iItemTax: index });
        $("#taxesModal").modal("show");
        $("#taxesModal").on("hidden.bs.modal", async () => { await this.setState({ iItemTax: null }); });
    }

    //#region GALLONS CONVERSION
    changeUserUM = async (index, event) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        const { newOrderModel } = this.state;

        newOrderModel.Items[index].U_RS_UMED = event?.target?.value || '';
        let checkPrice = false;
        //#region Precio Llamagas
        try {
            const envasado = Envasados?.includes(Number(newOrderModel.Items[index]?.ItmsGrpCod));
            const glpGranel = Granel?.includes(Number(newOrderModel.Items[index]?.ItmsGrpCod));

            if (!newOrderModel.Items[index].isTemporary && (envasado || glpGranel)) {
                let data = {
                    CardCode: newOrderModel?.CardCode || "",
                    ItemCode: newOrderModel.Items[index]?.ItemCode || "",
                    WhsCode: newOrderModel.Items[index]?.WhsCode || "",
                    ShipToCode: newOrderModel?.ShipToCode || newOrderModel?.ShipToDef || "", // Se manda el por defecto por la selección se hace al cobrar o crear el docuento
                    userFields: newOrderModel?.userFields || {},
                    Quantity: newOrderModel.Items[index]?.Quantity || 0,
                    U_RS_CANTG: newOrderModel.Items[index]?.U_RS_CANTG || 0,
                    U_RS_UMED: newOrderModel.Items[index]?.U_RS_UMED || "",
                    U_RS_PRECIOGL: newOrderModel.Items[index]?.U_RS_PRECIOGL || 0,
                    gallonsPrice: true,
                };

                //#region GALLON PRICE
                enableSpinner(true);
                let apiGallonsResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);
                const U_RS_PRECIO = apiGallonsResponse?.status === 1 ? Number(apiGallonsResponse?.data?.U_RS_PRECIO || 0) : 0;
                data.U_RS_PRECIOGL = U_RS_PRECIO;
                data.gallonsPrice = false;
                newOrderModel.Items[index].U_RS_PRECIOGL = U_RS_PRECIO;
                newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                //#endregion GALLON PRICE

                enableSpinner(true);
                const apiResponse = await apiClient.getPriceListLlama(data);
                enableSpinner(false);

                checkPrice = true;
                if (apiResponse.status === 1) {
                    newOrderModel.Items[index].Price = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                    newOrderModel.Items[index].HomePrice = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                    showAlert({ type: 'info', message: `El precio del artículo ${newOrderModel.Items[index].ItemCode || newOrderModel.Items[index].ItemName} ha sido ajustado al cambiar la unidad de medida`, timeOut: 5000 });
                } else {
                    newOrderModel.Items[index].Price = 0;
                    newOrderModel.Items[index].HomePrice = 0;
                    showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + newOrderModel.Items[index]?.ItemCode, timeOut: 10000 });
                }
            }
        } catch (err) { }
        //#endregion Precio Llamagas
        if (checkPrice) {
            await this.RefreshTotal(newOrderModel);
        } else {
            await this.refreshModel(newOrderModel);
        }
        if (!newOrderModel.Items[index].U_RS_UMED || newOrderModel.Items[index].U_RS_UMED === 'KGM') {
            let cantG = false
            if (Number(newOrderModel.Items[index].U_RS_CANTG) > 0 && newOrderModel.Items[index]?.Gallons) {
                cantG = true;
            }
            // newOrderModel.Items[index].U_RS_DENS = 0;
            newOrderModel.Items[index].U_RS_CANTG = 0;
            newOrderModel.Items[index].U_RS_TOTALGL = 0;
            newOrderModel.Items[index].Gallons = false;
            newOrderModel.Items[index].Price = newOrderModel.Items[index].HomePrice;
            await this.refreshModel(newOrderModel);
            setTimeout(async () => {
                if (cantG) {
                    await this.ChangeQuantity(index, 1);
                    showAlert({ type: 'info', message: `La cantidad y precio del artículo ${newOrderModel.Items[index]?.ItemCode} ha sido ajustada al quitar la conversión de galones.`, timeOut: 10000 });
                    await this.CheckQuantity(index);
                    await this.deliveredGasCylinder(index, newOrderModel.Items[index].U_RML_ENTCLNDRO || '');
                    if (newOrderModel.Items[index].U_RML_ENTCLNDRO) {
                        showAlert({ type: 'info', message: `La cantidad de cilindros vacíos devueltos para el artículo ${newOrderModel.Items[index]?.ItemCode} ha sido modificada por la conversión de galones, favor de revisar.`, timeOut: 10000 });
                    }
                }
            }, 100);
        } else
            if (newOrderModel.Items[index].U_RS_UMED === 'GLN' && Number(newOrderModel.Items[index].U_RS_CANTG) > 0) {
                newOrderModel.Items[index] = await this.checkGallons(newOrderModel.Items[index], index)
                await this.refreshModel(newOrderModel);
                if (newOrderModel.Items[index]?.Gallons) {
                    setTimeout(async () => {
                        await this.ChangeQuantity(index, Number(newOrderModel.Items[index]?.Quantity || 0), newOrderModel.Items[index].Gallons);
                        await this.CheckQuantity(index);
                        await this.deliveredGasCylinder(index, newOrderModel.Items[index].U_RML_ENTCLNDRO || '');
                        if (newOrderModel.Items[index].U_RML_ENTCLNDRO) {
                            showAlert({ type: 'info', message: `La cantidad de cilindros vacíos devueltos para el artículo ${newOrderModel.Items[index]?.ItemCode} ha sido modificada por la conversión de galones, favor de revisar.`, timeOut: 10000 });
                        }
                    }, 100);
                }
            }
    };

    normalizeNumber = (value) => {
        value = String(value ?? "").replace(/[^0-9.]/g, "");

        if (value.includes(".")) {
            const [i, d] = value.split(".");
            return `${i}.${d}`;
        }
        if (value.startsWith(".")) {
            return `0${value}`;
        }
        return value;
    };

    changeGalonesCant = async (index, event) => {
        const { newOrderModel } = this.state;
        const value = this.normalizeNumber(event.target.value);

        newOrderModel.Items[index].U_RS_CANTG = value;
        await this.refreshModel(newOrderModel);
    };

    changeDensidad = async (index, event) => {
        const { newOrderModel } = this.state;
        const value = this.normalizeNumber(event.target.value);

        newOrderModel.Items[index].U_RS_DENS = value;
        await this.refreshModel(newOrderModel);
    };

    changeQuantityBlur = async (index, event, field = '') => {
        if (!field) {
            return;
        };
        const { newOrderModel } = this.state;
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        newOrderModel.Items[index][field] = Number(Number(event?.nativeEvent?.target?.value || 0)?.toFixed(3));

        let U_RS_CANTG = field === 'U_RS_CANTG' ? Number(newOrderModel.Items[index][field]) : Number(newOrderModel.Items[index].U_RS_CANTG);
        newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));

        //#region Precio Llamagas
        if (field === 'U_RS_CANTG') {
            try {
                const envasado = Envasados?.includes(Number(newOrderModel.Items[index]?.ItmsGrpCod));
                const glpGranel = Granel?.includes(Number(newOrderModel.Items[index]?.ItmsGrpCod));

                if (!newOrderModel.Items[index]?.isTemporary && (envasado || glpGranel)) {
                    let data = {
                        CardCode: newOrderModel?.CardCode || "",
                        ItemCode: newOrderModel.Items[index]?.ItemCode || "",
                        WhsCode: newOrderModel.Items[index].WhsCode || "",
                        ShipToCode: newOrderModel?.ShipToCode || newOrderModel?.ShipToDef || "", // Se manda el por defecto por la selección se hace al cobrar o crear el docuento
                        userFields: newOrderModel?.userFields || {},
                        Quantity: Number(newOrderModel.Items[index][field] ?? 0),
                        U_RS_CANTG: newOrderModel.Items[index]?.U_RS_CANTG || 0,
                        U_RS_UMED: newOrderModel.Items[index]?.U_RS_UMED || "",
                        U_RS_PRECIOGL: newOrderModel.Items[index]?.U_RS_PRECIOGL || 0,
                        gallonsPrice: true,
                    };

                    //#region GALLON PRICE
                    enableSpinner(true);
                    let apiGallonsResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);
                    const U_RS_PRECIO = apiGallonsResponse?.status === 1 ? Number(apiGallonsResponse?.data?.U_RS_PRECIO || 0) : 0;
                    data.U_RS_PRECIOGL = U_RS_PRECIO;
                    data.gallonsPrice = false;
                    newOrderModel.Items[index].U_RS_PRECIOGL = U_RS_PRECIO;
                    newOrderModel.Items[index].U_RS_TOTALGL = Number((Number(newOrderModel.Items[index]?.U_RS_PRECIOGL || 0) * Number(newOrderModel.Items[index]?.U_RS_CANTG || 0))?.toFixed(priceDecimalPrecision));
                    //#endregion GALLON PRICE

                    enableSpinner(true);
                    const apiResponse = await apiClient.getPriceListLlama(data);
                    enableSpinner(false);

                    if (apiResponse.status === 1) {
                        newOrderModel.Items[index].Price = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                        newOrderModel.Items[index].HomePrice = Number(apiResponse?.data?.U_RS_CALCULADO || 0);
                        showAlert({ type: 'info', message: `El precio del artículo ${newOrderModel.Items[index].ItemCode || newOrderModel.Items[index].ItemName} ha sido ajustado al cambiar la cantidad`, timeOut: 5000 });
                    } else {
                        newOrderModel.Items[index].Price = 0;
                        newOrderModel.Items[index].HomePrice = 0;
                        showAlert({ type: 'error', message: 'No se pudo determinar el precio del artículo ' + newOrderModel.Items[index]?.ItemCode, timeOut: 10000 });
                    }
                }
            } catch (err) { }
        }
        //#endregion Precio Llamagas

        await this.refreshModel(newOrderModel);
        if (field === 'U_RS_CANTG') {
            newOrderModel.Items[index] = await this.checkGallons(newOrderModel.Items[index], index)
            await this.refreshModel(newOrderModel);
            if (newOrderModel.Items[index]?.Gallons) {
                setTimeout(async () => {
                    await this.ChangeQuantity(index, Number(newOrderModel.Items[index]?.Quantity || 0), newOrderModel.Items[index]?.Gallons);
                    await this.CheckQuantity(index);
                    await this.deliveredGasCylinder(index, newOrderModel.Items[index].U_RML_ENTCLNDRO || '');
                    if (newOrderModel.Items[index].U_RML_ENTCLNDRO) {
                        showAlert({ type: 'info', message: `La cantidad de cilindros vacíos devueltos para el artículo ${newOrderModel.Items[index]?.ItemCode} ha sido modificada por la conversión de galones, favor de revisar.`, timeOut: 10000 });
                    }
                }, 100);
            }
        }
    };

    checkGallons = async (item, index) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (!item?.WhsCode || !item?.ItemCode || item?.U_RS_UMED !== 'GLN' || (Number(item?.U_RS_CANTG || 0) === 0) || (!Granel?.includes(Number(item?.ItmsGrpCod)))) {
            return item;
        };

        let checkItem = {
            ItemCode: item.ItemCode,
            U_RS_UMED: item.U_RS_UMED,
            U_RS_CANTG: item.U_RS_CANTG,
            WhsCode: item.WhsCode
        }
        enableSpinner(true);
        let gallons = await apiClient.getGallonsConversion(checkItem);
        enableSpinner(false);
        item.Gallons = true;
        if (gallons?.status && gallons?.data) {
            item.Quantity = Number(gallons.data?.Quantity || 0);
            showAlert({ type: 'info', message: `La cantidad y precio del artículo ${item?.ItemCode} ha sido ajustada por la conversión a galones.`, timeOut: 10000 });
        } else {
            item.Quantity = 0;
            showAlert({ type: 'warning', message: gallons?.message || `La cantidad y precio del artículo ${item?.ItemCode} ha sido ajustada por la conversión a galones.`, timeOut: 10000 });
        }
        return item;
    }
    //#endregion GALLONS CONVERSION
    //#endregion

    openConfigUserFieldsHeaders = () => {
        // let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        // let userFields = user ? user.U_FMB_UserFields ? JSON.parse(user.U_FMB_UserFields) : json.allEnableUserFields : json.allEnableUserFields;
        // $('#configUserFieldsModal').modal({ backdrop: 'static', keyboard: false }, 'show');
        // this.setState({
        //     configHeaderUserFields: userFields,
        // })
    }

    hanldeUserFields = async (index, event) => {
        // const { showAlert, enableSpinner, newOrderModel, view } = this.props;
        // let newView = newOrderModel.newView || view;

        // this.setState({
        //     newOrderModel,
        // });
    }

    setUserFieldValueDefault = (userFields, index, field) => {
        const key = `userFields${index + 1}`;
        if (userFields?.hasOwnProperty(key)) {
            userFields[key] = this.validateNull(field.Dflt);
        }
        return userFields;
    };

    setUserFieldValue = (userFields, index, header) => {
        const { newOrderModel } = this.state;
        const view = newOrderModel?.ObjType;

        const fieldName = `userFields${index + 1}`;
        const headerValue = header[fieldName];

        const excludeViews = [ // Vistas para las que NO aplican '99'
            'inventoryRevaluation',
            'bussinesPartner',
            'administratorUsers',
            'figuresTransport',
            'transports',
            'consignmentNote',
            'adminUsersMVentas'
        ];

        const special99Cases = [20, 22, 24];
        const isSpecial = special99Cases?.includes(index);

        if (isSpecial) {
            if (!excludeViews?.includes(view)) {
                userFields[fieldName] =
                    headerValue !== '' ? this.validateNull(headerValue) : '99';
            } else {
                userFields[fieldName] = this.validateNull(headerValue);
            }
        } else {
            userFields[fieldName] = this.validateNull(headerValue);
        }

        return userFields;
    };

    validateNull = (value) => {
        if (value === 0) {
            return value;
        }
        if (!value) {
            return "";
        }

        return (value || '')?.toString()?.trim();
    };

    resetUserFields = () => {
        const { CO1UserFields, newOrderModel } = this.state;
        let userFields = new UserFields();

        for (let index = 0; index < CO1UserFields.length; index++) {
            const item = CO1UserFields[index];
            const userfield = newOrderModel.userFieldsHeader?.find(
                (uf) => uf.header.FieldID === item.fieldId
            );
            if (userfield) {
                userFields = this.setUserFieldValueDefault(userFields, index, userfield.header);
            }
        }

        return userFields;
    };

    setUserFields = async () => {
        try {
            const CO1UserFields = json.allUserFields; // Se puede cambiar por otro que contenga los validos para counter

            //#region ########## USER FIELDS #########################################
            let { newOrderModel } = this.state;
            const table = {
                complement: "RDR1",
                complement2: "",
                docSubType: "--",
                docSubType2: "",
                docType: "17",
                docType2: "",
                name: "ORDR",
                name2: ""
            };

            let userFieldsResponse = await apiClient.getUserFields(table);
            let userFieldsHeader = [];
            let userFieldsBody = [];
            if (userFieldsResponse?.status) {
                userFieldsHeader = userFieldsResponse?.data?.header || [];
                userFieldsBody = userFieldsResponse?.data?.body || [];
            }

            let userFields = new UserFields();

            for (let index = 0; index < CO1UserFields.length; index++) {
                const item = CO1UserFields[index];
                for (let indez = 0; indez < userFieldsHeader?.length; indez++) {
                    const userfield = userFieldsHeader[indez];
                    if (item.fieldId === userfield.header.FieldID) {
                        // json.allEnableUserFields[index].name = userfield.header.Descr;
                        item.name = userfield.header.Descr;
                        item.fieldType = userfield.options.length != 0 ? 2 : 1;
                        item.options = userfield.options;
                        item.IdValue = index;
                        let newUserFields = this.setUserFieldValueDefault(userFields, index, userfield.header);
                        if (item.fieldType === 2) {
                            item.options.push({ FldValue: "", Descr: "" });
                        }
                        userFields = newUserFields;
                    }
                }
            }

            let configHeaderUserFields = json.allEnableUserFields;

            this.setState(prevState => ({
                configHeaderUserFields,
                CO1UserFields,
                newOrderModel: {
                    ...prevState.newOrderModel,
                    userFields,
                    userFieldsHeader,
                }
            }));
        } catch (error) {
        }
    }

    setWhsByRouteDocs = () => {
        const { disWhs } = this.props;
        const { newOrderModel, _user } = this.state;
        if (newOrderModel.userFields.userFields28 == 'RCF') {
            newOrderModel.Items.forEach(item =>
                item.WhsCode = disWhs.WhsCode
            )
        } else {
            newOrderModel.Items.forEach(item =>
                item.WhsCode = _user.Branch.ProjectCode
            )
        }
        this.refreshModel(newOrderModel);
    }

    openCentroCoste = async (index, centro) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;
        enableSpinner(true);
        let getCentroCosteResponse = await apiClient.getCentroCosteList(centro);
        enableSpinner(false);

        if (!Array.isArray(getCentroCosteResponse?.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getCentroCosteResponse?.data?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            centroCostes: getCentroCosteResponse?.data || [],
            itemOrderModelUpdate: index,
            centroCosteId: centro,
        });

        $('#CentroCoste').modal('show');
    };

    selectCentroCoste = action => {
        const { centroCostes, itemOrderModelUpdate, centroCosteId } = this.state;
        const { newOrderModel } = this.state;
        const view = newOrderModel?.ObjType;
        let centroCoste = centroCostes[action.index];

        let docType = newOrderModel.DocType;
        switch (centroCosteId) {
            case 1:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName = centroCoste.OcrName || '';
                }

                break;
            case 2:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode2 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName2 = centroCoste.OcrName || '';
                }

                break;
            case 3:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode3 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName3 = centroCoste.OcrName || '';
                }

                break;
            case 4:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode4 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName4 = centroCoste.OcrName || '';
                }

                break;
            case 5:
                if (docType === 'I') {
                    if (view === 'payment' || view === 'outgoingPayment') {
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                        newOrderModel.ItemsPayments[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                    } else {
                        newOrderModel.Items[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                        newOrderModel.Items[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                    }

                } else {
                    newOrderModel.service[itemOrderModelUpdate].OcrCode5 = centroCoste.OcrCode || '';
                    newOrderModel.service[itemOrderModelUpdate].OcrName5 = centroCoste.OcrName || '';
                }

                break;
            default:
        }

        this.refreshModel(newOrderModel);
        $('#CentroCoste').modal('hide');
        setTimeout(() => {
            this.setState({
                centroCostes: [],
            });
        }, 100);
    };

    getUserFieldHeaderValue = (alias, newOrderModel) => {
        const { CO1UserFields, sellType } = this.state;
        if (!alias) return '';

        if (alias === 'U_FMB_AttentionType' && sellType === 'VPU') {
            return sellType;
        }

        const headers = newOrderModel?.userFieldsHeader || [];
        const cleanAlias = alias?.startsWith('U_') ? alias.slice(2) : alias;

        const headerMatch = headers?.find(h => h.header?.AliasID === cleanAlias);
        if (!headerMatch) return '';

        const fieldId = headerMatch.header.FieldID;
        const allFields = CO1UserFields || [];
        const foundIndex = allFields?.findIndex(f => f.fieldId === fieldId);
        if (foundIndex === -1) return '';

        const fieldNumber = foundIndex + 1;
        return newOrderModel?.userFields?.[`userFields${fieldNumber}`] || '';
    };

    //#region DIMENSIONS
    getDimension1 = async (newOrderModel, U_FMB_AttentionType = null, U_FMB_AttentionChannel = null) => {
        const { GroupCode, GroupCodeName } = newOrderModel;

        let Dimension1 = '';
        const group = GroupCode;
        const name = GroupCodeName?.toUpperCase() || '';

        const groupCodes = [
            { code: 146, tag: 'C03', dimension: 'C05' }, // C03 - Canalizado
            { code: 147, tag: 'C04', dimension: 'C02' }, // C04 - Distribuidor
            { code: 148, tag: 'C05', dimension: 'C02' }, // C05 - Punto de venta
            { code: 149, tag: 'C06', dimension: 'C01' }, // C06 - Corporativo
            { code: 151, tag: 'C07', dimension: 'C07' }, // C07 - Estaciones de servicio
            { code: 152, tag: 'C08', dimension: 'C06' }, // C08 - Granel Clasico
        ];

        Dimension1 = groupCodes?.find(m => Number(m.code) === Number(group) || name?.includes(m.tag))?.dimension || '';

        if (Dimension1) { return Dimension1; }

        //#region C01 - Consumidor Final - CF | C02 - Horeca
        let isC01 = Number(GroupCode) === 100 || GroupCodeName?.toUpperCase()?.includes('C01');
        let isC02 = Number(GroupCode) === 145 || GroupCodeName?.toUpperCase()?.includes('C02');
        if (isC01 || isC02) {
            U_FMB_AttentionType = U_FMB_AttentionType ? U_FMB_AttentionType : await this.getUserFieldHeaderValue('U_FMB_AttentionType', newOrderModel); // Tipo de atención
            U_FMB_AttentionChannel = U_FMB_AttentionChannel ? U_FMB_AttentionChannel : await this.getUserFieldHeaderValue('U_FMB_AttentionChannel', newOrderModel); // Canal de atención

            if (U_FMB_AttentionType === 'VPU') {
                Dimension1 = 'C04';
            } else if (U_FMB_AttentionType === 'RCF') {
                if (U_FMB_AttentionChannel === 'CALL' || U_FMB_AttentionChannel === 'CAL') {
                    Dimension1 = 'C08';
                } else if (U_FMB_AttentionChannel === 'VED') {
                    Dimension1 = 'C03';
                }
            }
        }
        //#endregion C01 - Consumidor Final - CF | C02 - Horeca

        return Dimension1
    }

    getDimension1ByUserField = async (U_FMB_AttentionType = null, U_FMB_AttentionChannel = null) => {
        const { notificationReducer: { showAlert } } = this.props
        const { newOrderModel } = this.state;
        const isU_FMB_AttentionType = U_FMB_AttentionType ? true : false;

        if (U_FMB_AttentionType !== null) { // Se busca el canal
            U_FMB_AttentionChannel = await this.getUserFieldHeaderValue('U_FMB_AttentionChannel', newOrderModel); // Canal de atención
        } else { // Se busca el tipo
            U_FMB_AttentionType = await this.getUserFieldHeaderValue('U_FMB_AttentionType', newOrderModel); // Tipo de atención
        }

        if (
            ((U_FMB_AttentionType === 'VPU')
                || (U_FMB_AttentionType === 'RCF' && (U_FMB_AttentionChannel === 'CALL' || U_FMB_AttentionChannel === 'CAL' || U_FMB_AttentionChannel === 'VED'))
            )
            && newOrderModel?.Items?.length
            && (
                (Number(newOrderModel?.GroupCode) === 100 || newOrderModel?.GroupCodeName?.includes('C01')) // C01 - Consumidor Final - CF
                || (Number(newOrderModel?.GroupCode) === 145 || newOrderModel?.GroupCodeName?.includes('C02')) // C02 - Horeca
            )
        ) { // Es Consumidor Final o es de Horeca y tiene valor en tipo de atencion o canal de atencion
            let Dimension1 = await this.getDimension1(newOrderModel, U_FMB_AttentionType, U_FMB_AttentionChannel);
            if (Dimension1 && newOrderModel?.Items?.length) {
                const otherDimension1 = newOrderModel.Items?.some(item => item.OcrCode !== Dimension1);
                if (otherDimension1) {
                    for (const item of newOrderModel?.Items) {
                        item.OcrCode = Dimension1;
                        item.Dimension1 = true;
                    }

                    showAlert({ type: 'info', message: `La dimensión 1 llamada "CANAL" de los artículos ha cambiado conforme al ${isU_FMB_AttentionType ? 'Tipo de Atención' : 'Canal de Atención'}`, timeOut: 6000 });
                    await this.refreshModel(newOrderModel);
                }
            }
        }
    }
    //#region DIMENSIONS

    openProjects = async index => {
        const { showAlert, enableSpinner } = this.props;

        enableSpinner(true);
        let data = {
            isLine: true,
        }

        let getProjectsResponse = await apiClient.getProjectsList(data);

        enableSpinner(false);

        if (!Array.isArray(getProjectsResponse?.data)) {
            showAlert({ type: 'error', message: 'Ocurrió un error al consultar la Información' });
            return;
        }

        if (getProjectsResponse?.data?.length === 0) {
            showAlert({ type: 'info', message: 'No hay Información por mostrar' });
            return;
        }

        this.setState({
            projects: getProjectsResponse?.data || [],
            itemProjectIndex: index,
        });

        $('#codeProjectsModal').modal('show');
    };

    selectProjects = action => {
        const { projects, itemProjectIndex } = this.state;
        const { newOrderModel } = this.state;
        let project = projects[action.index];
        newOrderModel.Items[itemProjectIndex].Project = project.PrjCode || '';

        $('#codeProjectsModal').modal('hide');
        setTimeout(() => {
            this.setState({
                projects: [],
            });
        }, 100);
    };
    closeCalculatorModal() {
        this.setState({
            showPriceModal: false,
            itemIndex: null,
            totalPriceInput: null
        })
    }

    changeTaxOnly = async (event, index) => {
        const { newOrderModel } = this.state;
        newOrderModel.Items[index].TaxOnly = event.nativeEvent.target.checked === true ? 'Y' : 'N';
        await this.RefreshTotal(newOrderModel);
    }

    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const isMobile = window.innerWidth <= 991;
        const {
            itemSearch,
            suggestions,
            itemIndexSuggestion,
            newOrderModel,
            itemSelected,
            itemIndex,
            partnerSearch,
            businessPartners,
            partnerIndex,
            businessPartner,
            groupNumList,
            priceList,
            groupCodeList,

            showBillModal,
            showRefundModal,
            showWithdrawalModal,
            showInventoryModal,
            showSalesModal,
            showCashCutModal,
            showSavedSalesModal,
            showSearchModal,
            showClientsModal,
            showInitialCashModal,
            showFormatQuotationModal,
            showFormatOrderSaleModal,
            showFormatInvoiceModal,
            showSearchStockModal,
            showVMQuotation,
            showCommentsModal,
            showAdvancePaymentInvoicesModal,
            showFormatAdvancePayment,
            showRefMoveCashModal,
            showDeliverModal,

            _user,
            cashCut,
            extraPaymentsCashCut,
            objCharge,
            totalCashCut,
            TotalAmountSales,
            numSalesCashCut,
            moneyOuts,
            moneyEntries,

            initialDate,
            finalDate,
            inventoryData,
            inventoryDataTotalRows,
            movements,

            taxList,
            ordersToAction,
            ordersDocs,
            ordersSearchModel,
            showPDFViewer,
            docsToPrint,
            editableMode,
            EditableDocModel,
            detailDoc,
            //#region #### RETURNS ###
            pedido,
            returnPay,
            checkboxDataTables,
            showSaveForLater,
            showBeforeExit,
            showDeleteAll,
            CanChangePartner,
            relatedPayMethodsByDoc,
            ShowRefundOfPaymentsModal,
            //#endregion

            requireInvoice,
            typeDocPrint,
            EnableEditButton,
            //#region #### savedSalesTools ###
            savedSales,
            savedSaleSearchCode,
            chooseSavedSale,
            //#endregion
            editModePartner,

            LinesGrossProfit,
            TotalGrossProfit,
            TotPrctGrossProfit,

            deliveryAddresses,
            billAddresses,
            Action,
            addressModel,
            setDHIndex,
            setBillIndex,
            setDeliveryIndex,
            stockByItem,
            CounterRol,
            AvailablePayments,
            creditPay,
            creditNotesPay,
            PaymentSaleModel,
            enableMoneyMovements,
            BankAccounts,
            EditDiscount,
            EditTaxCode,
            EditPrice,
            FlowDestiny,
            FlowOrigin,
            disableRecover,
            disableRecoverQT,
            DocCommentsModel,
            CommentLineIndex,
            DownPayments,
            CreditNotes,
            NextStepFunction,
            showBatchSelectionModal,
            sendMailModel,
            idWorkShift,
            lastDaySession,
            ItsComingOfRebilling,
            ItsReturnBill,
            returnFolioAmount,
            extraDocsToShow,
            ShowExtraActions,
            cashMovementModel,
            CFDI,
            states,
            RegimenFiscal,
            AuthorizationComments,
            viewOption,
            isCancel,
            isValidCFDI,
            PaymentStatus,
            CancelFunction,
            ItsCreditInvoice,
            printhide,
            createdFromReserve,
            showPaymentModal,
            PaymentModel,
            showAreYouAgreeModal,
            blindCashCut,
            ReturnedBlindCut,
            ShowWithStock,
            ContinueWithoutSave,
            RelatedPayMethodsByDoc,
            itsCancelCFDIAvailable,
            pointer,
            taxes,
            recoverInterOpDoc,
            recoverInterOpEntry,
            recoverInterOpTypeDoc,
            ItsRecoverAuthoriInvoice,
            updatebusinessPartner,
            ChoosePriceList,
            AuxAddressModel,
            maxDiscount,
            FlagPayWithSantander,
            ItsReserveInvoice,
            PointsCardModel,
            showNewCustomerModal,
            showAreYouAgreeModal_Join_e_Wallet,
            relatedDocs,
            showWarningModal,
            recoveredQuoteOperation,
            handedCasco,
            FISE,
            operationList,
            typeOperationList,
            iItemTax,
            sellType,
            configHeaderUserFields,
            CO1UserFields,
            centroCostes,
            sellTypeSelection,
            wareHouseTransaction,
            TypeRecover,
            projects = [],
            showPriceModal,
            bankOptions = [],
            toleranceInfo = [],
        } = this.state;
        AvailablePayments.sort((a, b) => (a.type > b.type) ? 1 : ((b.type > a.type) ? -1 : 0));
        //#region ########## OBJECTS TOOLS #################################################
        let salesTools = {
            initialDate,
            finalDate,
            ordersSearchModel,
            ordersDocs,
            ordersToAction,
            showPDFViewer,
            docsToPrint,
            editableMode,
            EditableDocModel,
            detailDoc,
            groupNumList,
            ChangeInitialDate: this.ChangeInitialDate,
            ChangeFinalDate: this.ChangeFinalDate,
            RefreshSearchOrdersModel: this.RefreshSearchOrdersModel,
            SearchOrders: this.SearchOrders,
            GetDocFolio: this.GetDocFolio,
            SendDocsToPdfViewer: this.SendDocsToPdfViewer,
            ChangeEditableMode: this.ChangeEditableMode,
            RefreshDocModel: this.RefreshDocModel,
            SaveChangesOrderInvoice: this.SaveChangesOrderInvoice,
            ShowDocInfo: this.ShowDocInfo,
            CloseDocument: this.CloseDocument,
            UploadInvoice: this.UploadInvoice,
            CloseModalActions: this.CloseModalActions,
            ShowPDFViewer: () => {
                this.ShowPDFViewer();
                this.CloseRefundModal();
            },
        }

        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }

        let savedSalesTools = {
            savedSales: savedSales,
            savedSaleSearchCode: savedSaleSearchCode,
            chooseSavedSale: chooseSavedSale,
            RecoverInterOpDoc: recoverInterOpDoc,
            suggestions: suggestions,
            recoverInterOpEntry,
            recoverInterOpTypeDoc,
            OnchangeSaleSearchCode: this.OnchangeSaleSearchCode,
            OnchangeChooseSale: this.OnchangeChooseSale,
            GetSavedSales: this.GetSavedSales,
            SearchSavedByCode: this.SearchSavedByCode,
            MountItemsFromDraft: this.MountItemsFromDraft,
            DeleteDraft: this.DeleteDraft,
            CleanSavesSale: this.CleanSavesSale,
            ChangeRecoverInterOpDoc: this.ChangeRecoverInterOpDoc,
            RecoverFirmeDocument: this.RecoverFirmeDocument,
            ChangeRecoverInterOpEntry: this.ChangeRecoverInterOpEntry,
            ChangeRecoverInterOpTypeDoc: this.ChangeRecoverInterOpTypeDoc,
            GetCommentsAuthorization: this.GetCommentsAuthorization,
            GetBreakAuthoModel: this.GetBreakAuthoModel
        }

        let grossProfitTools = {
            Action: 1,
            LinesGrossProfit: LinesGrossProfit,
            PricesList: priceList,
            TotalGrossProfit: TotalGrossProfit,
            TotPrctGrossProfit: TotPrctGrossProfit,
            HideGrossProfitModal: this.HideGrossProfitModal,
            OnchangePriceList: this.OnchangePriceList,
            ChoosePriceList: ChoosePriceList,
        }

        let delivHouseTools = {
            Action: Action,
            editableMode: editableMode,
            deliveryAddresses: deliveryAddresses,
            addressModel: addressModel,
            setDHIndex: setDHIndex,
            ChangeActionMode: this.ChangeActionMode,
            NewAddress: this.NewAddress,
            RefreshAddressModel: this.RefreshAddressModel,
            SendAddress: this.SendAddress,
            SetIndexDirection: this.SetIndexDirection,
            SetOrderAddress: this.SetOrderAddress,
            EditAddress: this.EditAddress
        }

        let DetailPartnerTools = {
            deliveryAddresses,
            billAddresses,
            setBillIndex,
            setDeliveryIndex,
            addressModel,
            AuxAddressModel,
            Action,
            FlowDestiny,
            FlowOrigin,
            pointer,
            taxes,
            NewAddress: this.NewAddress,
            SetIndexBillDirection: this.SetIndexBillDirection,
            SetIndexDeliveryDirection: this.SetIndexDeliveryDirection,
            EditAddress: this.EditAddress,
            RefreshAddressModel: this.RefreshAddressModel,
            SendAddress: this.SendAddress,
        }

        const mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        //#endregion 

        return (
            <div className="content">
                {showPriceModal &&
                    <CalculatorModal
                        title="Precio total"
                        placeholder="Ingrese el precio"
                        btnAccept="Guardar"
                        btnCancel="Cancelar"
                        accept={(value) => { this.ChangeItemPrice(this.state.itemIndex, value, false); this.closeCalculatorModal(); }}
                        acceptAmount={(value) => { this.changeVatPrice(this.state.itemIndex, value) }}
                        cancel={() => { this.closeCalculatorModal() }}
                        newOrderModel={newOrderModel}
                        itemIndex={this.state.itemIndex}
                    />}
                <TerminalFunctions />
                <MultipleValidationModal
                    idValidation="sellTypeModal"
                    message="SELECCIONE SU TIPO DE VENTA"
                    sellTypeSelection={sellTypeSelection}
                />
                <ValidationModal
                    idValidation="vmPayWithTerminal"
                    message="Iniciar proceso de pago con tarjeta?"
                    button1="Si"
                    button2="No"
                    eventOnclick={async () => await this.PayWithCreditTerminal()}
                    eventOnclick2={async () => await this.CancelPayWithTerminal()}
                />
                <SeriesAndConsecutiveModal
                    newOrderModel={newOrderModel}
                    eventOnclick={() => { $("#validationModal").modal("show"); }}
                    eventOnclick2={() => { }}
                    onSelectSeries={this.changeSerieConsecutive}
                    sellType={sellType}
                />

                <CentroCosteModal
                    data={centroCostes}
                    selectCentroCoste={this.selectCentroCoste}
                    cleanData={() => this.setState({ centroCostes: [] })}
                />
                <PrinterConfigurationModal
                    user={_user}
                    showAlert={showAlert}
                />
                <NavBarCashierResponsive
                    newOrderModel={newOrderModel}
                    props={this.props}
                    itemSearch={itemSearch}
                    ChangeSearchItem={this.ChangeSearchItem}
                    SearchItems={this.SearchItems}
                    ShowCashCutModal={this.ShowCashCutModal}
                    ShowSavedSalesModal={this.ShowSavedSalesModal}
                    ShowPrinterConfiguration={this.ShowPrinterConfiguration}
                    ReprintLastTicket={this.ReprintLastTicket}
                    ShowSearchModal={this.ShowSearchModal}
                    EnableClientsModal={this.EnableClientsModal}
                    GetMovementsCash={this.GetMovementsCash}
                    ChangeObjectype={this.ChangeObjectype}
                    ShowTaxesModal={this.ShowTaxesModal}
                    ShowRefSaleModal={this.ShowRefSaleModal}
                    ShowBeforeExit={this.ShowBeforeExit}
                    ChangeIconSaveSale={this.ChangeIconSaveSale}
                    _user={_user}
                    SendInvoiceValidation={this.SendInvoiceValidation}
                    SendReserveInvoice={this.SendReserveInvoice}
                    CheckIfItems={this.CheckIfItems}
                    ValidateBusinessPartner={this.ValidateBusinessPartner}
                    ShowVMQuotation={this.ShowVMQuotation}
                    OrderValidation={this.OrderValidation}
                    CounterRol={CounterRol}
                    ShowDeleteAll={this.ShowDeleteAll}
                    DisableRecover={disableRecover}
                    DisableRecoverQT={disableRecoverQT}
                    ShowAdvancePayment={this.ShowAdvancePayment}
                    ChangeCreditCheck={this.ChangeCreditCheck}
                    GetReportSalesPayments={this.GetReportSalesPayments}
                    CheckTerminalConnection={this.CheckTerminalConnection}
                    recoveredQuoteOperation={recoveredQuoteOperation}
                    globalTax={globalTax}
                    EditTaxCode={EditTaxCode}
                    sellType={sellType}
                    wareHouseTransaction={wareHouseTransaction}
                    itemIndex={itemIndex}
                    EditPrice={EditPrice}
                    maxDiscount={maxDiscount}
                    EditDiscount={EditDiscount}
                    operationList={operationList}
                    typeOperationList={typeOperationList}
                    points_Card={points_Card}
                    ToolTips={ToolTips}
                    TypeDiscounts={TypeDiscounts}
                    ShowCO1UserFields={this.ShowCO1UserFields}
                    ShowSetDeliveries={this.ShowDoc2Delivery}
                    SelectItem={this.SelectItem}
                    ChangeItemName={this.ChangeItemName}
                    ShowCommentsModal={this.ShowCommentsModal}
                    DeleteItem={this.DeleteItem}
                    SearchStockByItem={this.SearchStockByItem}
                    CheckQuantity={this.CheckQuantity}
                    ChangeQuantity={this.ChangeQuantity}
                    ChangeItemPrice={this.ChangeItemPrice}
                    ChangeDiscountPercent={this.ChangeDiscountPercent}
                    openTaxByItem={this.openTaxByItem}
                    changeOperation={this.changeOperation}
                    changeIgvOperation={this.changeIgvOperation}
                    deliveredGasCylinder={this.deliveredGasCylinder}
                    changeContract={this.changeContract}
                    validateCU={this.validateCU}
                    changeCU={this.changeCU}
                    changeTypeOperation={this.changeTypeOperation}
                    openCentroCoste={this.openCentroCoste}
                    changeTaxStatus={this.changeTaxStatus}
                    changeUserUM={this.changeUserUM}
                    changeGalonesCant={this.changeGalonesCant}
                    changeQuantityBlur={this.changeQuantityBlur}
                    ClearTypeDiscount={this.ClearTypeDiscount}
                    ShowGrossProfitModal={this.ShowGrossProfitModal}
                    openProjects={this.openProjects}
                    changeTaxOnly={this.changeTaxOnly}
                />

                <NavBarCashier
                    newOrderModel={newOrderModel}
                    props={this.props}
                    itemSearch={itemSearch}
                    ChangeSearchItem={this.ChangeSearchItem}
                    SearchItems={this.SearchItems}
                    ShowRefundModal={this.ShowRefundModal}
                    ShowWithdrawalModal={this.ShowWithdrawalModal}
                    ShowInventoryModal={this.ShowInventoryModal}
                    ShowSalesModal={this.ShowSalesModal}
                    ShowCashCutModal={this.ShowCashCutModal}
                    ShowFormatOrderSaleModal={this.ShowFormatOrderSaleModal}
                    ShowFormatInvoiceModal={this.ShowFormatInvoiceModal}
                    ShowSavedSalesModal={this.ShowSavedSalesModal}
                    ShowPrinterConfiguration={this.ShowPrinterConfiguration}
                    ReprintLastTicket={this.ReprintLastTicket}
                    ShowSearchModal={this.ShowSearchModal}
                    ShowSearchStockModal={this.ShowSearchStockModal}
                    EnableClientsModal={this.EnableClientsModal}
                    ShowBeforeExit={this.ShowBeforeExit}
                    _user={_user}
                    GetInventoryData={this.GetInventoryData}
                    GetMovementsCash={this.GetMovementsCash}
                    ChangeObjectype={this.ChangeObjectype}
                    ShowTaxesModal={this.ShowTaxesModal}
                    ChangePriceList={this.ChangePriceList}
                    ChangeIconSaveSale={this.ChangeIconSaveSale}
                    ShowRefSaleModal={this.ShowRefSaleModal}
                    CreateDocument={this.CreateDocument}
                    SendInvoiceValidation={this.SendInvoiceValidation}
                    SendReserveInvoice={this.SendReserveInvoice}
                    OrderValidation={this.OrderValidation}
                    CheckIfItems={this.CheckIfItems}
                    ValidateBusinessPartner={this.ValidateBusinessPartner}
                    ShowVMQuotation={this.ShowVMQuotation}
                    CounterRol={CounterRol}
                    ShowDeleteAll={this.ShowDeleteAll}
                    DisableRecover={disableRecover}
                    DisableRecoverQT={disableRecoverQT}
                    ShowAdvancePayment={this.ShowAdvancePayment}
                    ShowAdvancePaymentInvoicesModal={this.ShowAdvancePaymentInvoicesModal}
                    ShowFormatAdvancePayment={this.ShowFormatAdvancePayment}
                    ShowBatchSelectionModal={this.ShowBatchSelectionModal}
                    ChangeCreditCheck={this.ChangeCreditCheck}
                    ShowDeliverModal={this.ShowDeliverModal}
                    GetReportSalesPayments={this.GetReportSalesPayments}
                    CheckTerminalConnection={this.CheckTerminalConnection}
                    recoveredQuoteOperation={recoveredQuoteOperation}
                    validateCasco={this.validateCasco}
                    handedCasco={handedCasco}
                    ShowSetDeliveries={this.ShowDoc2Delivery}
                    globalTax={globalTax}
                    EditTaxCode={EditTaxCode}
                    sellType={sellType}
                    ShowCO1UserFields={this.ShowCO1UserFields}
                    ShowCO1AttachmentsFields={this.ShowCO1AttachmentsFields}
                    wareHouseTransaction={wareHouseTransaction}
                />

                {Sections['CO1UserFields'] &&
                    <CO1UserFieldsModal
                        newOrderModel={newOrderModel}
                        // action={action}
                        action={1}
                        refreshModel={this.refreshModel}
                        // view={view}
                        view={newOrderModel?.ObjType}
                        hanldeUserFields={this.hanldeUserFields}
                        newView={newOrderModel?.newView}
                        // editMode={editMode}
                        editMode={false}
                        openConfigUserFieldsHeaders={this.openConfigUserFieldsHeaders}
                        configHeaderUserFields={configHeaderUserFields}
                        CO1UserFields={CO1UserFields}
                        // setWhsByRouteDocs={this.setWhsByRouteDocs}
                        getDimension1ByUserField={this.getDimension1ByUserField}
                        checkItemPrices={this.checkItemPrices}
                    />
                }

                <ProjectsModal
                    data={projects}
                    selectTaxe={this.selectProjects}
                    cleanData={() => this.setState({ projects: [] })}
                />

                <TimeOut />
                <div className="ml-2" style={{ marginBottom: "12rem", marginTop: "5rem" }}>
                    <div className="row">
                        <div className="columImg" />
                        {/* <DetailsItemSale item={itemSelected} /> */}

                        <ValidateDocFieldsModal
                            newOrderModel={newOrderModel}
                            CFDI={CFDI}
                            RegimenFiscal={RegimenFiscal}
                            states={states}
                            updatebusinessPartner={updatebusinessPartner}
                            CreateDocument={this.CreateDocument}
                            refreshModel={this.refreshModel}
                            RefreshBusinessModel={this.RefreshBusinessModel}
                            showAlert={showAlert}
                            ChangeRegimenFiscal={this.ChangeRegimenFiscal}
                            ChangeUSOCFDI={this.ChangeUSOCFDI}
                        />

                        <div className="col-12 nav-cashier-web">
                            <div className="mt-5">
                                <div className="row">
                                    <div className="mt-3 col-12" style={{ boxShadow: "1px 1px 5px rgb(0 0 0 / 0%)" }}>
                                        <div className="w-100" style={{ overflow: "auto" }}>
                                            <table className="table table-hover table-striped table-items mt-3">
                                                <thead>
                                                    <tr style={{ background: "#ffc107" }}>
                                                        <th className="text-center" colSpan={2} scope="col">
                                                            <i className="fa fa-line-chart" aria-hidden="true" onClick={() => this.ShowGrossProfitModal()}></i>
                                                        </th>
                                                        <th className="col-2 text-center">Código</th>
                                                        <th className="col-4 text-center">Nombre</th>
                                                        <th className="col-1 text-center">Disp.</th>
                                                        <th className="col-1 text-center">Almacén</th>
                                                        {/* <th className="col-1 text-center">Peso</th> */}
                                                        {/* <th className="col-1 text-center">UMV</th> */}
                                                        <th className="col-1 text-center">Cantidad</th>
                                                        <th className="col-1 text-center">Precio</th>
                                                        <th className="col-1 text-center">Descuento</th>
                                                        {!globalTax && <th className="text-center" style={{ whiteSpace: "nowrap" }}>I. Impuesto</th>}
                                                        <th className="text-center">Operación</th>
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}>Cod. Afectación</th>
                                                        {/* <th className="text-center">AVG</th>
                                                        <th className="text-center">Precio de referencia</th>
                                                        <th className="text-center" >G.Bruta</th> */}
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}>¿Entrega Cilindro?</th>
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}>Tipo Convenio</th>
                                                        <th className="text-center">Cilindros Vacíos Devueltos</th>
                                                        <th className="text-center">Tipo de Operación</th>
                                                        {Modules.CostCenter && <>
                                                            <th className="text-center" style={{ whiteSpace: "nowrap" }}>CANAL</th>
                                                            <th className="text-center" style={{ whiteSpace: "nowrap" }}>SEDES</th>
                                                            <th className="text-center" style={{ whiteSpace: "nowrap" }}>SUCURSAL</th>
                                                            <th className="text-center" style={{ whiteSpace: "nowrap" }}>NEGOCIO</th>
                                                            <th className="text-center" style={{ whiteSpace: "nowrap" }}>CECO</th>
                                                        </>}
                                                        <th className="text-center">Proyecto/Placa</th>
                                                        <th className="text-center">Sujeto a Impuesto</th>
                                                        <th className="text-center">Solo Impuesto</th>
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}> UND Med. </th>
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}> Cant. Galones </th>
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}> Precio Galones </th>
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}> Total Linea<br></br>Galones </th>
                                                        <th className="text-center" style={{ whiteSpace: "nowrap" }}> Densidad </th>
                                                        <th className="col-2 text-center">Importe</th>
                                                        {!globalTax && <th className="text-center">Total</th>}
                                                        <th className="col-1 text-center"></th>
                                                        {(_user.Partner.CardCode !== newOrderModel.CardCode) && points_Card && <th className="col-2 text-center">Aplica Monedero</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {newOrderModel.Items && newOrderModel.Items.map((item, index) => {
                                                        const showPriceCalculate = isAnticipo(item.ItemCode) && newOrderModel.ObjType == 'downPayments'
                                                        let arrToolTipDiscount = [];
                                                        if (item.U_FMB_TypeDiscount) {
                                                            const auxToolTips = ToolTips.CounterTips.Discounts.map((tip) => ({ ...tip }));
                                                            auxToolTips[0].message = auxToolTips[0].message = `${ToolTips.CounterTips.Discounts[0].message.replace('DISC_TYPE', TypeDiscounts[item?.U_FMB_TypeDiscount || ''] || '')}`;
                                                            arrToolTipDiscount = auxToolTips;
                                                        }
                                                        let itemDescription = '';
                                                        if (item.InvntItem === 'Y') {
                                                            itemDescription = item.ItemName;
                                                        } else {
                                                            itemDescription =
                                                                <input
                                                                    className="input-descripcion "
                                                                    placeholder='Nombre o descripción'
                                                                    value={item.ItemName || ''}
                                                                    onChange={(event) => { this.ChangeItemName(event.target.value, index) }} />
                                                        }
                                                        return (
                                                            <tr key={`PointSalesItem${index}`}
                                                                onClick={() => { this.SelectItem(index) }}
                                                                style={{
                                                                    background: index === itemIndex && "#FFF8D2",
                                                                    opacity: item.isTemporary ? 0.5 : 1,
                                                                    pointerEvents: item.isTemporary ? "none" : "auto"
                                                                }}>
                                                                <td onClick={() => disableRecover ? () => { } : this.ShowCommentsModal(index)} style={{ background: "#f9f9f9", color: "#6c757d", verticalAlign: "middle" }}>
                                                                    <i className="fa fa-ellipsis-v " />
                                                                </td>
                                                                <td style={{ background: "white", color: "#dc3545", verticalAlign: "middle" }}>
                                                                    {!item.isTemporary && <i className="fa fa-trash-o m-2 cursor-pointer"
                                                                        onClick={() => disableRecover ? () => { } : this.DeleteItem(index)}
                                                                    />}
                                                                </td>
                                                                <th className="text-center" scope="row">
                                                                    <span onClick={() => this.SearchStockByItem(item.ItemCode)} style={{ textDecoration: 'underline', cursor: 'pointer' }} >{item.ItemCode}</span>
                                                                </th>
                                                                <td>{itemDescription && itemDescription}</td>
                                                                {/* DISPONIBLE */}
                                                                <td className="text-center">{item.OnHand ? item.OnHand : '0'}</td>
                                                                {/* Almacén */}
                                                                <td>{item?.WhsCode ?? ''}</td>
                                                                {/* PESO */}
                                                                {/* <td className="text-center">{item.SWeight1 && item.SWeight1.toFixed(0) + '' + this.UnitType(item.SWght1Unit)}</td> */}
                                                                {/* UMV */}
                                                                {/* <td className="text-center">{item.SalUnitMsr || ''}</td> */}
                                                                {/* CANTIDAD */}
                                                                <td className="text-center">
                                                                    <input
                                                                        type="number"
                                                                        disabled={disableRecover || item.Gallons}
                                                                        min={1}
                                                                        max={recoveredQuoteOperation === 1 ? '' : (item.OpenQty ? item.OpenQty : '')}
                                                                        className="text-right input-cantidad w-100"
                                                                        value={item.Quantity && item.Quantity}
                                                                        onBlur={() => this.CheckQuantity(index)}
                                                                        onChange={(event) => { this.ChangeQuantity(index, event.nativeEvent.target.value) }}
                                                                    />
                                                                </td>
                                                                {/* PRECIO */}
                                                                <td
                                                                    className={`text-center ${item.U_FMB_TypeDiscount ? 'text-success' : ''}`}
                                                                >

                                                                    <div
                                                                        className="d-flex align-items-center justify-content-center"
                                                                        style={{ gap: '4px' }}
                                                                    >

                                                                        <input
                                                                            type="number"
                                                                            min={0}
                                                                            disabled={
                                                                                item.Gallons
                                                                                    ? true
                                                                                    : EditPrice
                                                                                        ? disableRecover
                                                                                            ? true
                                                                                            : false
                                                                                        : true
                                                                            }
                                                                            className={`text-center input-cantidad ${item.U_FMB_TypeDiscount ? 'text-success' : ''}`}
                                                                            value={item.Price || ''}
                                                                            style={{
                                                                                minWidth: '8vh'
                                                                            }}
                                                                            onChange={(event) => {
                                                                                this.ChangeItemPrice(
                                                                                    index,
                                                                                    event.nativeEvent.target.value,
                                                                                    false
                                                                                );
                                                                            }}
                                                                            onBlur={(event) => {
                                                                                this.ChangeItemPrice(
                                                                                    index,
                                                                                    event.nativeEvent.target.value,
                                                                                    true
                                                                                );
                                                                            }}
                                                                        />

                                                                        {
                                                                            showPriceCalculate &&
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    minWidth: '32px',
                                                                                    height: '32px',
                                                                                    padding: 0
                                                                                }}
                                                                                onClick={() => {

                                                                                    this.setState({
                                                                                        showPriceModal: true,
                                                                                        itemIndex: index,
                                                                                        totalPriceInput: ''
                                                                                    });

                                                                                }}
                                                                            >
                                                                                <i className="fa fa-calculator"></i>

                                                                            </button>
                                                                        }
                                                                    </div>
                                                                </td>
                                                                {/* DESCUENTO */}
                                                                <td
                                                                    className={`text-center ${item.U_FMB_TypeDiscount ? 'text-success' : ''}`}
                                                                    style={{
                                                                        whiteSpace: 'nowrap',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        gap: '4px',
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="number"
                                                                        className={`text-center input-descuento ${item.U_FMB_TypeDiscount ? 'text-success' : ''}`}
                                                                        value={item.DiscountPercent || 0}
                                                                        min="0" max={maxDiscount}
                                                                        disabled={EditDiscount ? disableRecover ? true : false : true}
                                                                        onChange={(event) => { this.ChangeDiscountPercent(index, event.nativeEvent.target.value, false) }}
                                                                        onBlur={(event) => { this.ChangeDiscountPercent(index, event.nativeEvent.target.value, true) }}
                                                                        style={{
                                                                            width: '60px',
                                                                            margin: '0 4px',
                                                                            textAlign: 'center',
                                                                        }}
                                                                    />%
                                                                    {item.U_FMB_TypeDiscount && (
                                                                        <ToolTip tips={arrToolTipDiscount} position="up" />
                                                                    )}
                                                                </td>
                                                                {/* Indicador de Impuestos */}
                                                                {!globalTax &&
                                                                    <td title={item.TaxName || ""} style={{ cursor: EditTaxCode ? "pointer" : "", maxWidth: 120, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} onClick={() => { if (EditTaxCode) { this.openTaxByItem(index); } }}>
                                                                        {item?.TaxName?.replace('Percepción', '') || ""}
                                                                    </td>
                                                                }
                                                                {/* Tipo de Operación */}
                                                                <td className="text-center">
                                                                    <select
                                                                        disabled={disableRecover}
                                                                        value={item.U_BPP_OPER || ""}
                                                                        style={{ maxWidth: 100 }}
                                                                        onChange={({ target: { value } }) => this.changeOperation(index, value)}>
                                                                        {operationList.map((option, subindex) => <option key={`operationList-${index}-${subindex}`} value={option.Code}> {option.Name} </option>)}
                                                                    </select>
                                                                </td>
                                                                {/* Código de Afectación IGV */}
                                                                <td className="text-center">
                                                                    <select
                                                                        disabled={disableRecover}
                                                                        value={item.U_STR_FECodAfect || ""}
                                                                        style={{ maxWidth: 120 }}
                                                                        onChange={({ target: { value } }) => this.changeIgvOperation(index, value)}>
                                                                        <option value={""}> Seleccionar </option>
                                                                        {item.availableIgvOperationList.map((option, subindex) => <option key={`igvOperationList-${index}-${subindex}`} value={option.Code}> {option.Code} - {option.Name} </option>)}
                                                                    </select>
                                                                </td>
                                                                {/* AVG PRICE */}
                                                                {/* <td className="text-center">{FORMAT_NUMBER.new(item.AvgPrice)}</td> */}
                                                                {/* Precio de referencia */}
                                                                {/* <td className="text-center">{FORMAT_NUMBER.new(item.PriceByPLMin)}</td> */}
                                                                {/* GANANCIA BRUTA */}
                                                                {/* <td className="text-center">{FORMAT_NUMBER.new(GROSSPROFIT.new(item.Total,(Number(item.AvgPrice))).GrossProfit * Number(item.Quantity))}</td> */}
                                                                {/* <td className="text-center">{FORMAT_NUMBER.new(GROSSPROFIT.new((Number(item.Price) - (Number(item.Price) * (Number(item.DiscountPercent) / 100))), item.AvgPrice).GrossProfit * Number(item.Quantity))}</td> */}

                                                                {/* ¿Entrega Cilindro? */}
                                                                <td className="text-center">
                                                                    <select
                                                                        disabled={disableRecover || (Granel?.includes(Number(item?.ItmsGrpCod)))}
                                                                        value={item.U_RML_ENTCLNDRO || ""}
                                                                        onChange={({ target: { value } }) => this.deliveredGasCylinder(index, value)}>
                                                                        <option value={""}> </option>
                                                                        <option value={"1"}> Si </option>
                                                                        <option value={"2"}> No </option>
                                                                    </select>
                                                                </td>
                                                                {/* Tipo Convenio */}
                                                                <td className="text-center">
                                                                    <select
                                                                        disabled={disableRecover || (Number(item.U_RML_ENTCLNDRO || 0) !== 2) || (Granel?.includes(Number(item?.ItmsGrpCod)))}
                                                                        value={item.U_RML_TIPO_CU || ""}
                                                                        onChange={({ target: { value } }) => this.changeContract(index, value)}>
                                                                        <option value={"-"}> </option>
                                                                        <option value={"1"}> CESION DE USO </option>
                                                                        <option value={"2"}> PRESTAMO </option>
                                                                        <option value={"3"}> COMODATO </option>
                                                                    </select>
                                                                </td>
                                                                {/* C.U. */}
                                                                <td>
                                                                    <input
                                                                        type="number"
                                                                        className="text-right input-cantidad w-100"
                                                                        style={{ minWidth: 50 }}
                                                                        disabled={disableRecover || (Number(item.U_RML_ENTCLNDRO || 0) !== 2) || (Granel?.includes(Number(item?.ItmsGrpCod)))}
                                                                        value={item.U_RML_CU || ""}
                                                                        onBlur={() => this.validateCU(index)}
                                                                        onChange={({ target: { value } }) => this.changeCU(index, value)} />
                                                                </td>
                                                                {/* Tipo de Operación */}
                                                                <td className="text-center">
                                                                    <select
                                                                        name='type-operation'
                                                                        disabled={disableRecover}
                                                                        value={item.U_tipoOpT12 || ""}
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            gap: '4px',
                                                                            maxWidth: 140
                                                                        }}
                                                                        onChange={({ target: { value } }) => this.changeTypeOperation(index, value)}>
                                                                        <option value={"-"}> </option>
                                                                        {typeOperationList
                                                                            // ?.filter(option => {
                                                                            //     if (item.TaxCode === 'IGV') {
                                                                            //         return option.Name?.toUpperCase()?.includes('VENTA NACIONAL');
                                                                            //     }
                                                                            //     return true;
                                                                            // })
                                                                            ?.map((option, subindex) => (
                                                                                <option key={`typeOperationList-${index}-${subindex}`} value={option.Code}>
                                                                                    {option.Name}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </td>
                                                                {Modules.CostCenter && <>
                                                                    {/* CANAL */}
                                                                    <td>
                                                                        <div className="input-group"
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                maxWidth: 160,
                                                                                minWidth: 125
                                                                            }}>
                                                                            <input
                                                                                className="form-control"
                                                                                disabled
                                                                                readOnly
                                                                                value={item.OcrCode || ""} />

                                                                            {(!disableRecover && !item.Dimension1) && (
                                                                                <div className="input-group-append" >
                                                                                    <button
                                                                                        type="button"
                                                                                        style={{
                                                                                            backgroundColor: 'transparent',
                                                                                            color: '#EABF28',
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            border: "1px solid #ced4da"
                                                                                        }}
                                                                                        className="btn btn-outline-secondary"
                                                                                        onClick={() => this.openCentroCoste(index, 1)}>
                                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    {/* SEDES */}
                                                                    <td>
                                                                        <div className="input-group"
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                maxWidth: 160,
                                                                                minWidth: 125
                                                                            }}>
                                                                            <input
                                                                                className="form-control"
                                                                                disabled
                                                                                readOnly
                                                                                value={item.OcrCode2 || ""} />

                                                                            {(!disableRecover && !item.Dimension2) && (
                                                                                <div className="input-group-append" >
                                                                                    <button
                                                                                        type="button"
                                                                                        style={{
                                                                                            backgroundColor: 'transparent',
                                                                                            color: '#EABF28',
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            border: "1px solid #ced4da"
                                                                                        }}
                                                                                        className="btn btn-outline-secondary"
                                                                                        onClick={() => this.openCentroCoste(index, 2)}>
                                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    {/* SUCURSAL */}
                                                                    <td>
                                                                        <div className="input-group"
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                maxWidth: 160,
                                                                                minWidth: 125
                                                                            }}>
                                                                            <input
                                                                                className="form-control"
                                                                                disabled
                                                                                readOnly
                                                                                value={item.OcrCode3 || ""} />

                                                                            {(!disableRecover && !item.Dimension3) && (
                                                                                <div className="input-group-append" >
                                                                                    <button
                                                                                        type="button"
                                                                                        style={{
                                                                                            backgroundColor: 'transparent',
                                                                                            color: '#EABF28',
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            border: "1px solid #ced4da"
                                                                                        }}
                                                                                        className="btn btn-outline-secondary"
                                                                                        onClick={() => this.openCentroCoste(index, 3)}>
                                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    {/* NEGOCIO */}
                                                                    <td>
                                                                        <div className="input-group"
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                maxWidth: 160,
                                                                                minWidth: 125
                                                                            }}>
                                                                            <input
                                                                                className="form-control"
                                                                                disabled
                                                                                readOnly
                                                                                value={item.OcrCode4 || ""} />

                                                                            {(!disableRecover && !item.Dimension4) && (
                                                                                <div className="input-group-append" >
                                                                                    <button
                                                                                        type="button"
                                                                                        style={{
                                                                                            backgroundColor: 'transparent',
                                                                                            color: '#EABF28',
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            border: "1px solid #ced4da"
                                                                                        }}
                                                                                        className="btn btn-outline-secondary"
                                                                                        onClick={() => this.openCentroCoste(index, 4)}>
                                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    {/* CECO */}
                                                                    <td>
                                                                        <div className="input-group"
                                                                            style={{
                                                                                whiteSpace: 'nowrap',
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                                maxWidth: 160,
                                                                                minWidth: 125
                                                                            }}>
                                                                            <input
                                                                                className="form-control"
                                                                                disabled
                                                                                readOnly
                                                                                value={item.OcrCode5 || ""} />

                                                                            {(!disableRecover && !item.Dimension5) && (
                                                                                <div className="input-group-append" >
                                                                                    <button
                                                                                        type="button"
                                                                                        style={{
                                                                                            backgroundColor: 'transparent',
                                                                                            color: '#EABF28',
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            border: "1px solid #ced4da"
                                                                                        }}
                                                                                        className="btn btn-outline-secondary"
                                                                                        onClick={() => this.openCentroCoste(index, 5)}>
                                                                                        <i className="fa fa-list" aria-hidden="true" />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </>}
                                                                {/* Proyecto/Placa */}
                                                                <td>
                                                                    <div className="input-group"
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            maxWidth: 170,
                                                                            minWidth: 140
                                                                        }}>
                                                                        <input
                                                                            className="form-control"
                                                                            disabled
                                                                            readOnly
                                                                            value={item.Project || ""} />

                                                                        {!disableRecover && (
                                                                            <div className="input-group-append" >
                                                                                <button
                                                                                    type="button"
                                                                                    style={{
                                                                                        backgroundColor: 'transparent',
                                                                                        color: '#EABF28',
                                                                                        paddingTop: 2,
                                                                                        paddingBottom: 2,
                                                                                        border: "1px solid #ced4da"
                                                                                    }}
                                                                                    className="btn btn-outline-secondary"
                                                                                    onClick={() => this.openProjects(index)}>
                                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                {/* Sujeto a Impuesto */}
                                                                <td className="text-center">
                                                                    <select
                                                                        disabled={disableRecover}
                                                                        value={item.TaxStatus || 'N'}
                                                                        style={{ maxWidth: 100 }}
                                                                        onChange={({ target: { value } }) => this.changeTaxStatus(index, value)}>
                                                                        {item.TaxCode === 'EXO' ?
                                                                            <>
                                                                                <option value="N">No</option>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <option value="Y">Sí</option>
                                                                                <option value="N">No</option>
                                                                            </>
                                                                        }
                                                                    </select>
                                                                </td>

                                                                {/* Solo Impuesto */}
                                                                <td style={{ textAlign: 'center' }}>
                                                                    <input
                                                                        disabled={disableRecover}
                                                                        type="checkbox"
                                                                        checked={item.TaxOnly === 'Y'}
                                                                        onChange={event => this.changeTaxOnly(event, index)}
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                    />
                                                                </td>

                                                                {/* UND Med. */}
                                                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                                                    this.emptyField()
                                                                    :
                                                                    <>
                                                                        <td style={{ textAlign: 'center' }}>
                                                                            <select
                                                                                disabled={disableRecover}
                                                                                onChange={event => this.changeUserUM(index, event)}
                                                                                value={item.U_RS_UMED || ''}
                                                                                style={{ minWidth: '110px' }}
                                                                            >
                                                                                <option value={''}> {'Seleccionar'}</option>
                                                                                <option value={'KGM'}> {'Kilogramos'}</option>
                                                                                <option value={'GLN'}> {'Galones'}</option>
                                                                            </select>
                                                                        </td>
                                                                    </>
                                                                }
                                                                {/* Cant. Galones */}
                                                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                                                    this.emptyField()
                                                                    :
                                                                    <>
                                                                        <td style={{ textAlign: 'center' }}>
                                                                            <input
                                                                                type="text"
                                                                                id={`CANTG-${index}`}
                                                                                className="form-control btn-outline-secondary"
                                                                                disabled={item.U_RS_UMED !== 'GLN' || disableRecover}
                                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                                value={item.U_RS_CANTG || ''}
                                                                                onChange={event => item.U_RS_UMED === 'GLN' && this.changeGalonesCant(index, event)}
                                                                                onBlur={event => item.U_RS_UMED === 'GLN' && this.changeQuantityBlur(index, event, 'U_RS_CANTG')}
                                                                            />
                                                                        </td>
                                                                    </>
                                                                }
                                                                {/* Precio Galones */}
                                                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                                                    this.emptyField()
                                                                    :
                                                                    <>
                                                                        <td style={{ textAlign: 'center' }}>
                                                                            <input
                                                                                type="text"
                                                                                id={`PRECIOGL-${index}`}
                                                                                className="form-control btn-outline-secondary"
                                                                                disabled={true} readOnly={true}
                                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                                value={item.U_RS_PRECIOGL || ''}
                                                                            />
                                                                        </td>
                                                                    </>
                                                                }
                                                                {/* Total Linea Galones */}
                                                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                                                    this.emptyField()
                                                                    :
                                                                    <>
                                                                        <td style={{ textAlign: 'center' }}>
                                                                            <input
                                                                                type="text"
                                                                                id={`TOTALGL-${index}`}
                                                                                className="form-control btn-outline-secondary"
                                                                                disabled={true} readOnly={true}
                                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                                value={item.U_RS_TOTALGL || ''}
                                                                            />
                                                                        </td>
                                                                    </>
                                                                }
                                                                {/* Densidad */}
                                                                {!Granel?.includes(Number(item?.ItmsGrpCod)) ?
                                                                    this.emptyField()
                                                                    :
                                                                    <>
                                                                        <td style={{ textAlign: 'center' }}>
                                                                            <input
                                                                                type="text"
                                                                                id={`DENS-${index}`}
                                                                                className="form-control btn-outline-secondary"
                                                                                // disabled={disableRecover}
                                                                                disabled={true} readOnly={true}
                                                                                style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000', paddingTop: 1, paddingBottom: 2, minWidth: 80, textAlign: "center" }}
                                                                                value={item.U_RS_DENS || ''}
                                                                            // onChange={event => this.changeDensidad(index, event)}
                                                                            // onBlur={event => this.changeQuantityBlur(index, event, 'U_RS_DENS')}
                                                                            />
                                                                        </td>
                                                                    </>
                                                                }

                                                                {/* SUBTOTAL ITEM */}
                                                                <td className="text-right" style={{ background: "#d5f7d94a", color: "rgb(76, 123, 76)", whiteSpace: "nowrap" }}>
                                                                    {CURRENCY + ' ' + FORMAT_NUMBER.new(item.Total)}
                                                                </td>

                                                                {/* TOTAL ITEM */}
                                                                {!globalTax &&
                                                                    <td className="text-right" style={{ background: "#d5f7d94a", color: "rgb(76, 123, 76)", whiteSpace: "nowrap" }}>
                                                                        {CURRENCY + ' ' + FORMAT_NUMBER.new(item.TotalAndTax)}
                                                                    </td>
                                                                }

                                                                {/* EDITAR ITEM BLOQUEADO POR DESCUENTO */}
                                                                {item.U_FMB_TypeDiscount && false ?
                                                                    <td style={{ background: "#d5f7d94a", color: "rgb(76, 123, 76)", verticalAlign: "middle" }}>
                                                                        <i
                                                                            className="fa fa-pencil m-2 cursor-pointer"
                                                                            onClick={() => item.U_FMB_TypeDiscount ? this.ClearTypeDiscount(index) : () => { }}
                                                                        />
                                                                    </td> : <td style={{ background: "#d5f7d94a", color: "rgb(76, 123, 76)", verticalAlign: "middle" }}></td>
                                                                }
                                                                {(_user.Partner.CardCode !== newOrderModel.CardCode) && points_Card &&
                                                                    <td className="text-center input-cantidad">
                                                                        {item.U_FMB_AplicaMonedero === 'Y' ? 'SI' : 'NO'}
                                                                    </td>
                                                                }
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.state.showDeliveryDocsModal &&
                            <SetDocsToDelivery
                                showAlert={showAlert}
                                enableSpinner={this.props.enableSpinner}
                                closeDocsToDelivery={this.CloseDocsToDelivery}
                            />
                        }

                        {showInitialCashModal && (
                            <InitialCashModal
                                InsertWorkShiftT={this.InsertWorkShiftT}
                                CancelWorkShift={this.CancelWorkShift}
                            />
                        )}


                        {showBillModal && (
                            <BillModal
                                ShowBillModal={this.ShowBillModal}
                                CloseBillModal={this.CloseBillModal}
                                showAlert={showAlert}
                                enableSpinner={enableSpinner}
                                newOrderModel={newOrderModel}
                                Items={newOrderModel.Items}
                                RefreshOrder={this.RefreshOrder}
                                CancelPayment={this.CancelPayment}
                                ValidateDocument={this.ValidateDocument}
                                ValidateDelivery={this.ValidateDelivery}
                                ValidateInvoice={this.ValidateInvoice}
                                ShowPDFViewer={this.ShowPDFViewer}
                                RefreshPaymentSaleModel={this.RefreshPaymentSaleModel}
                                AvailablePayments={AvailablePayments}
                                creditPay={creditPay}
                                creditNotesPay={creditNotesPay}
                                PaymentSaleModel={PaymentSaleModel}
                                BankAccounts={BankAccounts}
                                GetBankAccounts={this.GetBankAccounts}
                                currencyRate={this.state.currencyRate}
                                CreateDocument={() => this.CreateDocument()}
                                addingPay={this.state.addingPay}
                                AddPay={this.AddPay}
                                DownPayments={DownPayments}
                                CreditNotes={CreditNotes}
                                GetDownPaymentsByPartner={this.GetDownPaymentsByPartner}
                                CheckIfItsUniversalPartner={this.CheckIfItsUniversalPartner}
                                Print={this.PrintDocuments}
                                ReturnFolioAmount={returnFolioAmount}
                                SearchReturnFolioAmount={this.SearchReturnFolioAmount}
                                RefreshReturnFolioAmount={this.RefreshReturnFolioAmount}
                                requireInvoice={requireInvoice}
                                RelatedPayMethodsByDoc={RelatedPayMethodsByDoc}
                                disableRecover={disableRecover}
                                _user={_user}
                                ItsRecoverAuthoriInvoice={ItsRecoverAuthoriInvoice}
                                LaunchPaymentWithTerminalQuestion={this.LaunchPaymentWithTerminalQuestion}
                                FlagPayWithSantander={FlagPayWithSantander}
                                ItemsGroupEWallet={this.state.ItemsGroupEWallet}
                                RefreshTotal={this.RefreshTotal}
                                getFiseInfoByCode={this.getFiseInfoByCode}
                                clearFise={this.clearFise}
                                FISE={FISE}
                                refreshFISE={this.refreshFISE}
                                bankOptions={bankOptions}
                                toleranceInfo={toleranceInfo}
                            />

                        )}

                        {showRefundModal && (
                            <RefundModal
                                ShowRefundModal={this.ShowRefundModal}
                                newOrderModel={newOrderModel}
                                pedido={pedido}
                                returnPay={returnPay}
                                addingPay={this.state.addingPay}
                                ChangePedido={this.ChangePedido}
                                ChangeReturnPay={this.ChangeReturnPay}
                                SearchSale={this.SearchSale}
                                ChangeQuantityRefund={this.ChangeQuantityRefund}
                                ChangeComments={this.ChangeComments}
                                Devolver={this.Devolver}
                                checkbox={checkbox}
                                showAlert={showAlert}
                                CloseRefundModal={this.CloseRefundModal}
                                showrefund={this.state.showrefund}
                                newOrderModelCopia={this.state.newOrderModelCopia}
                                CloseBillModal={this.CloseRefundModal}
                                SalesTools={salesTools}
                                user={_user}
                                action={this.state.actionSale}
                                ChangeActionSale={this.ChangeActionSale}
                                Print={this.PrintDocuments}
                                ItsReturnBill={ItsReturnBill}
                                AvailablePayments={AvailablePayments}
                                PaymentSaleModel={PaymentSaleModel}
                                ShowRefundOfPaymentsModal={ShowRefundOfPaymentsModal}
                                EnableShowRefundOfPaymentsModal={this.EnableShowRefundOfPaymentsModal}
                                AddPay={this.AddPay}
                                RefreshOrder={this.RefreshOrder}
                                CloseOpenRefundOfPaymentsModal={this.CloseOpenRefundOfPaymentsModal}
                                CheckIfHaveSelectedReturnItems={this.CheckIfHaveSelectedReturnItems}
                                RefreshPaymentSaleModel={this.RefreshPaymentSaleModel}
                                RelatedPayMethodsByDoc={relatedPayMethodsByDoc}
                                CancelReturnPayment={this.CancelReturnPayment}
                                MailTools={mailTools}
                                viewOption={viewOption}
                                ChangeViewReturnOption={this.ChangeViewReturnOption}
                                ConsultarEstatusCFDI={this.ConsultarEstatusCFDI}
                                isCancel={isCancel}
                                isValidCFDI={isValidCFDI}
                                CancelCFDI={this.ShowCancelConfirm}
                                ItsCreditInvoice={ItsCreditInvoice}
                                createdFromReserve={createdFromReserve}
                                CancelDocument={this.CancelDocument}
                                OpenMailModal={this.OpenSendMailModal}
                                printhide={printhide}
                                ShowFormatToPrint={this.ShowFormatToPrint}
                                ourInfoForReturn={this.state.ourInfoForReturn}
                                itsCancelCFDIAvailable={itsCancelCFDIAvailable}
                                CloseDocument={this.CloseDocument}
                                ValidateCloseDocument={this.ValidateCloseDocument}
                                ItsReserveInvoice={ItsReserveInvoice}
                                relatedDocs={relatedDocs}
                            />
                        )}

                        {showWithdrawalModal && (
                            <WithdrawalModal
                                ShowWithdrawalModal={this.ShowWithdrawalModal}
                                Movements={movements}
                                idWorkShift={idWorkShift}
                                _user={_user}
                                GetMovementsCash={this.GetMovementsCash}
                                ShowRefMoveCashModal={this.ShowRefMoveCashModal}
                                PrintCashMovements={this.PrintCashMovements}
                                showAlert={showAlert}
                                showRefMoveCashModal={showRefMoveCashModal}
                                cashMovementModel={cashMovementModel}
                                RefreshCashMovementModel={this.RefreshCashMovementModel}
                                ShowTicketCashMovement={this.ShowTicketCashMovement}
                                ShowCashInModal={this.ShowCashInModal}
                                ShowCashOutModal={this.ShowCashOutModal}
                                ChangeComment={this.ChangeComment}
                                ChangeAmount={this.ChangeAmount}
                                SendCashMovement={this.SendCashMovement}
                                //new implementation
                                addingPay={this.state.addingMove}
                                PaymentSaleModel={PaymentSaleModel}
                                newOrderModel={newOrderModel}
                                enableMoneyMovements={enableMoneyMovements}
                                AvailablePayments={AvailablePayments}
                                Action={Action}
                                BankAccounts={BankAccounts}
                                ShowHideMoneyMovements={this.ShowHideMoneyMovements}
                                AddPay={this.AddMove}
                                GetBankAccounts={this.GetBankAccounts}
                                CancelMoneyMovement={this.CancelMoneyMovement}
                                ChangeActionMoneyMovements={this.ChangeActionMoneyMovements}
                                RefreshPaymentSaleModel={this.RefreshPaymentSaleModel}
                                RefreshOrder={this.RefreshOrder}

                            />
                        )}

                        {showInventoryModal && (
                            <InventoryModal
                                ShowInventoryModal={this.ShowInventoryModal}
                                InventoryData={inventoryData}
                                InventoryDataTotalRows={inventoryDataTotalRows}
                                GetInventoryData={this.GetInventoryData} />
                        )}

                        {showCashCutModal && (
                            <CashCutModal
                                ShowCashCutModal={this.ShowCashCutModal}
                                CashCut={cashCut}
                                ObjCharge={objCharge}
                                TotalCashCut={totalCashCut}
                                TotalAmountSales={TotalAmountSales}
                                NumVentas={numSalesCashCut}
                                extraPaymentsCashCut={extraPaymentsCashCut}
                                moneyEntries={moneyEntries}
                                moneyOuts={moneyOuts}
                                headerCashCut={{ U_NAME: "", docUpdate: "", endSession: "" }}
                                BranchOfficeGeneralCut={() => { }}
                                CloseWorkShift={this.CloseWorkShift}
                                GotoDashboard={this.SendToLogin}
                                lastDaySession={lastDaySession}
                                _user={_user}
                                blindCashCut={blindCashCut}
                                ShowBlindCashCut={this.ShowBlindCashCut}
                                ReturnedBlindCut={ReturnedBlindCut}
                                BlindCutByIdSession={[]}
                                bankOptions={bankOptions}
                            />
                        )}

                        {/* {showReportSaleModal && (
                            <ReportSaleModal
                                ShowReportSaleModal={this.ShowReportSaleModal}
                                ReportsFunctions={reportsFunctions}
                            />
                        )} */}

                        {showSalesModal && (
                            <SalesModal
                                ShowSalesModal={this.ShowSalesModal}
                                SalesTools={salesTools}
                                user={_user}
                            />
                        )}

                        {showSearchModal && (
                            <SearchModal
                                ShowSearchModal={this.ShowSearchModal}
                                ChangeQuantitySuggestions={this.ChangeQuantitySuggestions}
                                AddItem={this.AddItem}
                                suggestions={suggestions}
                                SelectItemSuggestion={this.SelectItemSuggestion}
                                itemIndexSuggestion={itemIndexSuggestion}
                                itemSearch={itemSearch}
                                ChangeSearchItem={this.ChangeSearchItem}
                                SearchItemsModal={this.SearchItemsModal}
                                ShowSearchStockModal={this.ShowSearchStockModal}
                                SearchStockByItem={this.SearchStockByItem}
                                ShowWithStock={ShowWithStock}
                                ChangeShowWithStock={this.ChangeShowWithStock}
                                cleanData={() =>
                                    this.setState({
                                        suggestions: [],
                                        itemIndexSuggestion: null,
                                        itemSearch: "",
                                    })
                                }
                            />
                        )}

                        {showClientsModal && (
                            <ClientsModal
                                partnerSearch={partnerSearch}
                                EnableClientsModal={this.EnableClientsModal}
                                ChangePartnerSearch={this.ChangePartnerSearch}
                                SearchPartners={this.SearchPartners}
                                partnerIndex={partnerIndex}
                                businessPartners={businessPartners}
                                SelectBusinessPartner={this.SelectBusinessPartner}
                                SelectPartnerIndex={this.SelectPartnerIndex}
                                businessPartner={businessPartner}
                                RefreshBusinessPartner={this.RefreshBusinessPartner}
                                showAlert={showAlert}
                                GetDataPartner={this.GetDataPartner}
                                groupNumList={groupNumList}
                                priceList={priceList}
                                groupCodeList={groupCodeList}
                                CreateBusinessPartner={this.CreateBusinessPartner}
                                clearData={() => this.setState({ groupNumList: [], businessPartner: {}, businessPartners: [], partnerSearch: '', })}
                                EditBusinessPartner={this.EditBusinessPartner}
                                editMode={editModePartner}
                                ChangeCardName={this.ChangeCardName}
                                ChangeCellular={this.ChangeCellular}
                                ChangeCreditLine={this.ChangeCreditLine}
                                ChangeExtraDays={this.ChangeExtraDays}
                                ChangeE_mail={this.ChangeE_mail}
                                UpdateBusinessPartner={this.UpdateBusinessPartner}
                                updatebusinessPartner={updatebusinessPartner}
                                DetailPartnerTools={DetailPartnerTools}
                                ShowDetailClientModal={this.ShowDetailClientModal}
                                NextStepFunction={NextStepFunction}
                                ContinueWithoutSave={ContinueWithoutSave}
                                ItsComingOfRebilling={ItsComingOfRebilling}
                                RefreshBusinessModel={this.RefreshBusinessModel}
                                GroupNumList={groupNumList}
                                newOrderModel={newOrderModel}
                                CFDI={CFDI}
                                RegimenFiscal={RegimenFiscal}
                                ChangeUSOCFDI={this.ChangeUSOCFDI}
                                ChangeRegimenFiscal={this.ChangeRegimenFiscal}
                                Change_MetodoPago={this.Change_MetodoPago}
                                Change_FormaPago={this.Change_FormaPago}
                                Change_Tipo_Relacion_CFDI={this.Change_Tipo_Relacion_CFDI}
                                ChangeTaxes={this.ChangeTaxes}
                                refreshModel={this.refreshModel}
                                states={this.state.states}
                                countries={this.state.countries}
                                ChangeShowTemporalData={this.ChangeShowTemporalData}
                                showTemporalData={this.state.showTemporalData}
                                ChanceTemporalDataToFalse={this.ChanceTemporalDataToFalse}
                                taxes={this.state.taxes}
                                RecoverDoc={this.state.recoverDocument}
                                ChangeOfUUIDRelation={this.ChangeOfUUIDRelation}
                            />
                        )}

                        <DetailClientModal
                            businessPartners={businessPartners}
                            GroupNumList={groupNumList}
                            partnerIndex={partnerIndex}
                            editMode={editModePartner}
                            updatebusinessPartner={updatebusinessPartner}

                            showAlert={showAlert}
                            DetailPartnerTools={DetailPartnerTools}
                            EditBusinessPartner={this.EditBusinessPartner}
                            RefreshBusinessModel={this.RefreshBusinessModel}
                            UpdateBusinessPartner={this.UpdateBusinessPartner}
                            refreshModel={this.refreshModel}
                            NextStepFunction={NextStepFunction}
                            actionButton={true}
                            CanChangePartner={CanChangePartner}
                            ShowClientsModalReBilling={this.ShowClientsModalReBilling}
                            CFDI={CFDI}
                            RegimenFiscal={RegimenFiscal}
                            ChangeUSOCFDI={this.ChangeUSOCFDI}
                            ChangeRegimenFiscal={this.ChangeRegimenFiscal}
                            Change_MetodoPago={this.Change_MetodoPago}
                            Change_FormaPago={this.Change_FormaPago}
                            Change_Tipo_Relacion_CFDI={this.Change_Tipo_Relacion_CFDI}
                            ChangeTaxes={this.ChangeTaxes}
                            newOrderModel={newOrderModel}
                            ContinueWithoutSave={ContinueWithoutSave}
                            states={this.state.states}
                            countries={this.state.countries}
                            ChangeShowTemporalData={this.ChangeShowTemporalData}
                            showTemporalData={this.state.showTemporalData}
                            ChanceTemporalDataToFalse={this.ChanceTemporalDataToFalse}
                            taxes={this.state.taxes}
                            RecoverDoc={this.state.recoverDocument}
                            changeOrderField={this.changeOrderField}
                            prioridadVtaCatalog={this.state.prioridadVtaCatalog}
                            ChangeOfUUIDRelation={this.ChangeOfUUIDRelation}
                        />

                        {/* {showTaxesModal && ( */}
                        <TaxesModal
                            ShowTaxesModal={this.ShowTaxesModal}
                            taxList={taxList}
                            ChangeTaxCode={this.ChangeTaxCode}
                            newOrderModel={newOrderModel}
                            iItemTax={iItemTax} />
                        {/* )} */}

                        {/* {showSelectAddressModal && ( */}

                        <SelectAddressModal
                            ShowSelectAddressModal={this.ShowSelectAddressModal}
                            ShowFormatInvoiceModal={this.ShowFormatInvoiceModal}
                            DelivHouseTools={delivHouseTools}
                        />

                        {showSavedSalesModal && (
                            <SavedSalesModal
                                ShowSavedSalesModal={this.ShowSavedSalesModal}
                                SavedSalesTools={savedSalesTools}
                                CounterRol={CounterRol}
                                TypeRecover={TypeRecover}
                            />
                        )}

                        {showFormatQuotationModal && (
                            <FormatQuotationModal
                                ShowFormatQuotationModal={this.ShowFormatQuotationModal}
                            />
                        )}

                        {showFormatOrderSaleModal && (
                            <FormatOrderSaleModal
                                ShowFormatOrderSaleModal={this.ShowFormatOrderSaleModal}
                                orderModel={newOrderModel}
                            />
                        )}

                        {showFormatInvoiceModal && (
                            <FormatInvoiceModal
                                ShowFormatInvoiceModal={this.ShowFormatInvoiceModal}
                                newOrderModel={this.newOrderModel}
                            />
                        )}

                        <ValidationModal
                            idValidation="vmDeliveryHouse"
                            message="¿Esta seguro que quiere continuar?"
                            eventOnclick={() => this.CreateDocument()}
                        />

                        <ValidationModal
                            idValidation="vmInvoice"
                            message="¿Va a requerir factura?"
                            button1="Si"
                            hideButton2={true}
                            eventOnclick={async () => {
                                await this.NeedInvoice(true);
                            }}
                        />

                        {showVMQuotation &&
                            <ValidationModal
                                idValidation="vmQuotation"
                                message="¿Esta seguro de generar la cotización?"
                                button1="Si"
                                button2="No"
                                eventOnclick={() => this.ValidateQuatations()}
                                eventOnclick2={() => this.ChangeVMQuotation()}
                            />
                        }

                        {showSaveForLater && (
                            <ValidationModal
                                idValidation="vmSaveSale"
                                message="¿Guardar la venta para después?"
                                eventOnclick={() => this.SaveForLater()}
                                eventOnclick2={() => this.ChangeIconSaveSale(false)}
                            />
                        )}
                        {showBeforeExit && (
                            <ValidationModal
                                idValidation="vmBeforeExit"
                                message={"Hay operaciones sin completar, ¿Desea salir?"}
                                button1={newOrderModel.ObjType === 'deliveries' ? "Guardar" : "Cancelar"}
                                button2="Salir"
                                eventOnclick={newOrderModel.ObjType === 'deliveries' ? () => this.OpenDashBoard(true) : ""}
                                eventOnclick2={() => this.OpenDashBoard(false)}
                            />
                        )}

                        {showDeleteAll && (
                            <ValidationModal
                                idValidation="vmDeleteAll"
                                message={"¿Eliminar todo? "}
                                // button1="Guardar"
                                // button2="Salir"
                                eventOnclick={() => this.RestartCounter()}
                                eventOnclick2={() => this.ShowDeleteAll()}
                            />
                        )}

                        {true && (
                            <ValidationModal
                                idValidation="vmOrderSale"
                                message={"¿Quiere generar un pedido? "}
                                eventOnclick={() => this.fieldsValidation()}
                            />
                        )}

                        <FieldsForPS
                            idValidation="fieldsForOrderSale"
                            message={"Ingrese la siguiente información"}
                            eventOnclick={this.validateModalFields}
                            newOrderModel={newOrderModel}
                            refreshModel={this.refreshModel}
                        />

                        <ValidationModal
                            idValidation="vmReserveInvoice"
                            message={"¿Quiere generar una factura de reserva? "}
                            eventOnclick={async () => await this.NeedInvoice(true)}

                        />

                        <ValidationModal
                            idValidation="vmUpdatePage"
                            message={"Hay una nueva versión de sistema actualice. Seras redireccionado al Login."}
                            button1="REINICIAR"
                            button2="REINICIAR"
                            eventOnclick={() => this.SendToLogin()}
                            eventOnclick2={() => this.SendToLogin()}

                        />

                        <InvoiceDataModal
                            eventOnclick={this.ShowBillModal}
                        />

                        <RefSaleModal
                            ShowRefSaleModal={this.ShowRefSaleModal}
                            Folio={newOrderModel.folio}
                            PrintRefSale={this.PrintRefSale}
                            _user={_user}
                            CloseBillModal={this.CloseBillModal}
                        />

                        <RefundTicketModal
                            newOrderModel={newOrderModel}
                            CloseBillModal={this.CloseBillModal}
                            Print={() => this.PrintDocuments("Devolucion", "80", newOrderModel)}
                            _user={_user}
                        />

                        {showAreYouAgreeModal_Join_e_Wallet &&
                            <AreYouAgreeModal
                                mensaje={'¿Te gustaría pertenecer al monedero electrónico?'}
                                accept={this.Add_To_PointsCard}
                                cancel={this.CloseShowAreYouAgreeModal_Join_e_Wallet}
                            />
                        }

                        {showNewCustomerModal &&
                            <NewCustomerModal
                                PointsCardModel={PointsCardModel}
                                cleanData={() => this.setState({ showNewCustomerModal: !this.state.showNewCustomerModal, showAreYouAgreeModal_Join_e_Wallet: false })}
                                change_CardName={() => { }}
                                change_U_FMB_Handel_Email={this.change_U_FMB_Handel_Email}
                                change_U_FMB_Cellular={this.change_U_FMB_Cellular}
                                change_U_FMB_Handel_Pass={() => { }}

                                sendNewCustomer={this.sendNewCustomer}
                                activeShowAreYouAgree_Update={() => { }}
                                showAreYouAgreeModal_Update={false}
                                action={1}
                            />
                        }

                        {showPDFViewer &&
                            <PdfViewer
                                DocsToPrint={docsToPrint}
                                TypeDoc={typeDocPrint}
                                EnableEditButton={EnableEditButton}
                                Editable={false}
                                ChangeEditableMode={() => { }}
                                EditableDocModel={salesTools.EditableDocModel}
                                RefreshDocModel={salesTools.RefreshDocModel}
                                SaveChanges={this.SaveChangesInvoice}
                                UploadDoc={salesTools.UploadInvoice}
                                EditParam1={false}
                                ShowPDFViewer={this.CloseCreatedInvoiceActions}
                                CreateDocument={this.CreateDocument}
                                OpenMailModal={this.OpenSendMailModal}
                                ItsFirme={true}
                                user={_user}
                                Counter={true}
                                MailTools={mailTools}
                                ExtraDocsToShow={extraDocsToShow}
                                ShowNextDocument={this.ShowNextDocument}
                                ShowExtraActions={ShowExtraActions}
                                printhide={printhide}
                                ShowFormatToPrint={this.ShowFormatToPrint}
                                reprint={false}
                                PointsCardModel={PointsCardModel}
                                OxxoRefData={this.state.OxxoRefData}
                            />
                        }

                        {showSearchStockModal && (
                            <SearchStockModal
                                ShowSearchStockModal={this.ShowSearchStockModal}
                                suggestions={stockByItem}
                                cleanData={() =>
                                    this.setState({
                                        stockByItem: [],
                                    })
                                }
                            />)
                        }

                        {/* {EnableGrossProfitModal && */}
                        <GrossProfitModal
                            GrossProfitTools={grossProfitTools}
                            PointOfSale={true}
                        />
                        {/* } */}

                        <FormatDeliveryModal
                        // newOrderModel={newOrderModel}
                        />

                        <FormatCanceledTicketModal
                            newOrderModel={newOrderModel}
                        />

                        {showDeliverModal &&
                            <DeliverModal
                                showAlert={showAlert}
                                newOrderModel={newOrderModel}
                                checkbox={checkbox}
                                ShowDeliverModal={this.ShowDeliverModal}
                                RefreshOrder={this.RefreshOrder}
                                SearchReserveInvoiceDoc={this.SearchReserveInvoiceDoc}
                                CloseRefundModal={this.CloseRefundModal}
                                MakeReserveDelivery={this.MakeReserveDelivery}
                            />
                        }

                        {showFormatAdvancePayment &&
                            <FormatAdvancePaymentModal
                                ShowFormatAdvancePayment={this.ShowFormatAdvancePayment}
                                Print={this.PrintDocuments}
                            />
                        }

                        {showCommentsModal &&
                            <CommentsModal
                                newOrderModel={newOrderModel}
                                DocCommentsModel={DocCommentsModel}
                                CommentLineIndex={CommentLineIndex}
                                showAlert={showAlert}
                                RefreshCommentsModel={this.RefreshCommentsModel}
                                RefreshOrder={this.RefreshOrder}
                                ShowCommentsModal={this.ShowCommentsModal}
                                CleanDocCommentsActions={this.CleanDocCommentsActions}
                                EnableCommentsModal={this.EnableCommentsModal}
                            />
                        }

                        {showAdvancePaymentInvoicesModal &&
                            <AdvancePaymentInvoicesModal
                                ShowAdvancePaymentInvoicesModal={this.ShowAdvancePaymentInvoicesModal}
                            />
                        }

                        {showBatchSelectionModal &&
                            <BatchSelectionModal
                                newOrderModel={newOrderModel}
                                showAlert={showAlert}
                                ShowBatchSelectionModal={this.ShowBatchSelectionModal}
                                refreshModel={this.refreshModel}
                                CloseOpenRefundOfPaymentsModal={this.CloseOpenRefundOfPaymentsModal}
                            />
                        }

                        {AuthorizationComments.length > 0 &&
                            <AuthorizationModel
                                newOrderModel={newOrderModel}
                                comments={AuthorizationComments}
                                updateComments={this.updateCommentsAuthorizationModel}
                                createDocument={() => this.CreateDocument(true)}
                            />
                        }

                        {PaymentStatus.length > 0 &&
                            <PaymentStatusListModal
                                data={PaymentStatus}
                                SearchPayment={this.SearchPayment}
                                CancelRelatedCFDI={this.ShowCancelConfirm}
                                ContinueToCancel={this.ContinueToCancel}
                                CancelPayments={this.CancelPayments}
                                cleanData={() => this.setState({ PaymentStatus: [] })}
                            />
                        }

                        {showPaymentModal > 0 &&
                            <PaymentModal
                                newOrderModel={PaymentModel}
                                CancelPayment={this.CancelPaymentSAP}
                                CloseModalPayment={this.CloseModalPayment}
                                OpenShowAreYouAgreeModal={this.OpenShowAreYouAgreeModal}
                                CloseShowAreYouAgreeModal={this.CloseShowAreYouAgreeModal}
                                ConsultarEstatusPagoCFDI={this.ConsultarEstatusPagoCFDI}
                                CancelCFDI={this.ShowCancelConfirm}
                                showAreYouAgreeModal={showAreYouAgreeModal}
                            />
                        }
                        <CancelCFDI
                            CancelDocuments={CancelFunction} />

                        <PriceWithTaxesModal
                            newOrderModel={newOrderModel}
                        />
                        <NewUpdateModal />
                    </div>
                </div>

                {showWarningModal && (
                    <WarningModal
                        title='Advertencia'
                        message={"¿Requiere generar otra cotización apartir de la recuperada o actualizarla?"}
                        size='modal-dialog w-75'
                        btnAccept={'Actualizar'}
                        accept={() => this.handleQuote(1)}
                        btnCancel={'Generar'}
                        cancel={() => this.handleQuote(2)}
                        btnClose={false}
                    />
                )}
            </div>
        );
    }

    selectTableCounter = (view = null, docTypeMiddleware = null) => {
        let name = "";
        let complement = "";
        let docSubType = "";
        let docType = "";
        let name2 = "";
        let complement2 = "";
        let docSubType2 = "";
        let docType2 = "";
        switch (view) {
            case 'quotations':
                name = "OQUT";
                complement = "QUT1";
                docSubType = "--";
                docType = "23";
                break;
            case 'orderSales':
                name = "ORDR";
                complement = "RDR1";
                docSubType = "--";
                docType = "17";
                break;
            case 'deliveries':
                name = "ODLN";
                complement = "DLN1";
                docSubType = "--";
                docType = "15";
                break;
            case 'invoice':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'return':
                name = "ORDN";
                complement = "RDN1";
                docSubType = "--";
                docType = "16";
                break;
            case 'purchaseReturn':
                name = "ORPD";
                complement = "RPD1";
                docSubType = "--";
                docType = "21";
                break;
            case 'payment':
                name = "ORCT";
                complement = "RCT1";
                docSubType = "--";
                docType = "24";
                break;
            case 'transfers':
                name = "OWTR";
                complement = "WTR1";
                docSubType = "--";
                docType = "67";
                break;
            case 'transfersRequest':
                name = "OWTQ";
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case 'transfersEntry':
                name = "OIGN";
                complement = "IGN1";
                docSubType = "--";
                docType = "59";
                break;
            case 'transfersOutput':
                name = "OIGE";
                complement = "IGE1";
                docSubType = "--";
                docType = "60";
                break;
            case 'debitNote':
                name = "OINVDN";
                complement = "INV1";
                docSubType = "DN";
                docType = "13";
                break;
            case 'creditNote':
                name = "ORIN";
                complement = "RIN1";
                docSubType = "--";
                docType = "14";
                break;
            case 'PurchaseOrder':
                name = "OPOR";
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case 'GoodsReceipt':
                name = "OPDN";
                complement = "PDN1";
                docSubType = "--";
                docType = "20";
                break;

            case 'PurchaseRequest':
                name = "OPRQ";
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;

            case 'invoiceBorrador':
                name = "ODRF";
                complement = "DRF1";
                docSubType = "--";
                break;
            case 'invoiceAuthorization':
                name = "OWDD";
                complement = "OWDD";
                docSubType = "--";
                break;
            case 'bussinesPartner':
                name = "OCRD";
                complement = "CRD1";
                docSubType = "--";
                break;
            case 'inventoryRevaluation':
                name = "OMRV";
                complement = "MRV1";
                docSubType = "--";
                docType = "162";
                break;
            case 'SalesHelmets':
                name = "OIGN";
                name2 = "ORIN";
                complement = "IGN1";
                complement2 = "RIN1";
                docSubType = "--";
                docSubType2 = "--";
                docType = "59";
                docType2 = "14"
                break;
            case 'ExitHelmets':
                name = "OIGE";
                name2 = "OINVDN";
                complement = "IGE1";
                complement2 = "INV1"
                docSubType = "--";
                docSubType2 = "DN";
                docType = "60";
                docType2 = "13"
                break;
            case 'purchaseInvoice':
                name = "OPCH";
                complement = "PCH1";
                docSubType = "--";
                docType = "18";
                break;
            case 'purchaseCreditNotes':
                name = "ORPC";
                complement = "RPC1";
                docSubType = "--";
                docType = "19";
                break;
            case 'outgoingPayment':
                name = "OVPM";
                complement = "VPM1";
                docSubType = "--";
                docType = "46";
                break;
            case 'invoiceReserve':
                name = "OINV";
                complement = "INV1";
                docSubType = "--";
                docType = "13";
                break;
            case 'middleware':
                if (docTypeMiddleware === '22') {
                    name = "OPOR";
                    complement = "POR1";
                    docSubType = "--";
                    docType = "22";
                } else if (docTypeMiddleware === '18') {
                    name = "OPCH";
                    complement = "PCH1";
                    docSubType = "--";
                    docType = "18";
                }

                break;
            default:
                name = "";
                complement = "";
                docSubType = "";
                docType = "13";
        }

        return { name, complement, docSubType, docType, name2, complement2, docSubType2, docType2 }
    };

    emptyField = () => {
        return (
            <td style={{ textAlign: 'center' }}>
                <input
                    type="text"
                    className="form-control btn-outline-secondary"
                    disabled={true}
                    readOnly={true}
                    style={{
                        backgroundColor: 'transparent',
                        borderColor: '#ced4da',
                        color: '#000',
                        paddingTop: 1,
                        paddingBottom: 2,
                        minWidth: 80,
                        textAlign: "center",
                    }}
                    value={''}
                />
            </td>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PointOfSaleView);

